webpackJsonp([26],{

/***/ "+9L4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var src_api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/components/tool/customForm.vue + 2 modules
var customForm = __webpack_require__("uuH9");

// EXTERNAL MODULE: ./src/components/tool/inputTag.vue + 2 modules
var inputTag = __webpack_require__("6EFu");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/dataTag.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var dataTag = ({
  props: {
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tagWidth: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagHeight: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    needInfo: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tagDisplay: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    replace: {
      type: Function,
      default: function _default(x) {
        return x.name;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    emptyMsg: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    };
  },

  computed: {
    filtedDatas: function filtedDatas() {
      return Object(util["i" /* groupBy */])(this.data.items, function (item) {
        return item.type || 'default';
      }, true);
    },
    types: function types() {
      return keys_default()(this.filtedDatas);
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.data.items.length - 1) % this.data.items.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.data.items.length;
            break;
          }
        default:
          {}
      }
      this.$refs['tag-block'].scrollTop = 25.5 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.data.items[this.tagIndex];
      this.onCompelete = true;
      this.content = this.replace(curTag, this.content);
      this.$emit('tag', curTag);
      this.commentOnInput();
      this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7b817c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/dataTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"data-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)}],"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return (_vm.data.items || []).length < 1 || _vm.onCompelete ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)},"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),(_vm.data.items && !_vm.onCompelete && _vm.display && _vm.content && (_vm.data.items.length > 0 || _vm.emptyMsg))?_c('div',{staticClass:"data-tag",style:(_vm.tagWidth ? { 'min-width': _vm.tagWidth } : {})},[_c('div',{staticClass:"tag-block"},[(_vm.data.items.length > 0)?[(_vm.needInfo && _vm.data.info && Object.values(_vm.data.info).filter(function (x) { return x; }).length)?_c('div',{staticClass:"tag-info-container"},[_c('div',{staticClass:"tag-info-block"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.types.map(function (type) { return (_vm.data.info[type].displayed ? _vm.data.info[type].displayed + '/' + _vm.data.info[type].total + ' ' + _vm.data.info[type].subTitle + 's' : ''); }).filter(function (x) { return x; }).join(', ').replace(/,(?!.*,)/, ', and') + '.')}})])]):_vm._e(),_vm._v(" "),_c('div',{ref:"tag-block",staticClass:"tag-group-container",style:(_vm.tagHeight ? { 'max-height': _vm.tagHeight } : {})},_vm._l((_vm.types),function(key,index){return _c('div',{key:index,staticClass:"tag-group-block"},[(Object.keys(_vm.filtedDatas).length > 1)?_c('div',{staticClass:"tag-title"},[_vm._v(_vm._s(_vm.data.info ? _vm.data.info[key].title : ''))]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtedDatas[key]),function(tag,tindex){return _c('div',{key:tindex - -_vm.types.slice(0, index).reduce(function (s, type) { return s + (_vm.filtedDatas[type] || []).length; }, 0),staticClass:"tag",class:{ selected: _vm.tagIndex === tindex - -_vm.types.slice(0, index).reduce(function (s, type) { return s + (_vm.filtedDatas[type] || []).length; }, 0) },on:{"mousemove":function (e) { return _vm.tagIndex = tindex - -_vm.types.slice(0, index).reduce(function (s, type) { return s + (_vm.filtedDatas[type] || []).length; }, 0); },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s((_vm.tagDisplay || (function (tag) { return tag.name; }))(tag).replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2)}),0)]:[_c('div',{staticClass:"tab-empty"},[_vm._v(_vm._s(_vm.emptyMsg))])]],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_dataTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/dataTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("CQ/M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  dataTag,
  tool_dataTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_dataTag = (Component.exports);

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// EXTERNAL MODULE: ./src/components/tool/pageButtons.vue + 2 modules
var pageButtons = __webpack_require__("+kXL");

// EXTERNAL MODULE: ./src/components/tool/scrollBottom.vue + 2 modules
var scrollBottom = __webpack_require__("/2uW");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// EXTERNAL MODULE: ./src/mixins/routeLoading.vue + 1 modules
var routeLoading = __webpack_require__("zVZS");

// EXTERNAL MODULE: ./src/mixins/responsitive.vue + 1 modules
var responsitive = __webpack_require__("E4co");

// EXTERNAL MODULE: ./src/mixins/customTimeout.vue + 1 modules
var customTimeout = __webpack_require__("WBdv");

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dataset/base.vue












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ var base = ({
  components: {
    customForm: customForm["a" /* default */],
    inputTag: inputTag["a" /* default */],
    dataTag: components_tool_dataTag,
    switchButton: switchButton["a" /* default */],
    pageButtons: pageButtons["a" /* default */],
    scrollBottom: scrollBottom["a" /* default */],
    borCor: newBorCor["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */], responsitive["a" /* default */], customTimeout["a" /* default */]],
  props: {
    scope: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    defaultData: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      allCases: [],
      displayIDs: {
        case: [],
        dataset: []
      },
      dataset: {
        pipeline: 'WES'
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      users: [],
      tags: {
        tag: []
      },
      onSubmit: false,
      // search tag
      map: {
        tag: {}
      },
      query: {
        tag: ''
      },
      tag: {
        tag: {}
      },
      curTag: {
        tag: null
      },
      loading: {
        tag: false,
        tagAdd: false
      },
      searchTimer: {
        tag: []
      },
      // sample
      sample: {
        query: '',
        viewType: 'detail',
        listType: 'case',
        datas: {
          case: null,
          dataset: null
        },
        results: {
          case: [],
          dataset: []
        },
        tableOverflow: {
          case: false,
          dataset: false
        },
        emptyText: {
          case: 'No sample was selected to the dataset.' /* ___ */
          , dataset: ''
        },
        // page
        pageData: {
          selectedPage: {
            case: 1,
            dataset: 1
          },
          display: {
            case: 20,
            dataset: 20
          },
          total: {
            case: null,
            dataset: null
          },
          buttonRange: {
            case: 7,
            dataset: 7
          },
          pageJumpTo: {
            case: '',
            dataset: ''
          }
        },
        // sort
        sort: {
          case: {
            value: ['updated_at'],
            order: ['-desc']
          },
          dataset: {
            value: ['updated_at'],
            order: ['-desc']
          }
        }
      },
      // picture
      selectedPictureID: null,
      pictures: [],
      customPicture: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['modal']), {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    userOptions: function userOptions() {
      return this.users.map(function (user) {
        return { title: [user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') + ')' : ''), value: user.id };
      });
    },
    pipelineOptions: function pipelineOptions() {
      return entries_default()(global_data["g" /* datasetPipelineMap */]).map(function (_ref3) {
        var _ref4 = slicedToArray_default()(_ref3, 2),
            value = _ref4[0],
            data = _ref4[1];

        return extends_default()({}, data, { value: value });
      });
    },
    totalPage: function totalPage() {
      var _this2 = this;

      this.sample.pageData.selectedPage = {
        case: 1,
        dataset: 1
      };
      return entries_default()(this.sample.pageData.total).reduce(function (s, _ref5) {
        var _ref6 = slicedToArray_default()(_ref5, 2),
            type = _ref6[0],
            total = _ref6[1];

        var display = _this2.sample.pageData.display[type];
        return extends_default()({}, s, defineProperty_default()({}, type, Math.ceil(Math.min(total, display * 5000) / display)));
      }, {});
    },

    // sample
    selectedSampleSize: function selectedSampleSize() {
      return this.sample.results['case'].length + this.sample.results['dataset'].reduce(function (s, dataset) {
        return s + (dataset.sample_size || 0);
      }, 0);
    },
    sampleFiltedDatas: function sampleFiltedDatas() {
      var _this3 = this;

      var filter = function filter(type) {
        var filtedData = _this3.sample.datas[type] || [];
        filtedData = filtedData.filter(function (data) {
          return !_this3.sampleSelectedDataMap[type][data.id] && _this3.displayIDs[type].includes(data.id);
        });
        return filtedData;
      };
      var filtedData = {
        case: filter('case'),
        dataset: filter('dataset')
      };
      return filtedData;
    },
    sampleTableDatas: function sampleTableDatas() {
      var _this4 = this;

      var generator = function generator(type) {
        var tableDatas = [].concat(toConsumableArray_default()(Object(util["m" /* sortData */])(values_default()(_this4.sampleSelectedDataMap[type]), _this4.sample.sort[type].value.map(function (x) {
          return _this4.sampleSortMap[type][x] || x;
        }), _this4.sample.sort[type].order.map(function (x) {
          return x.replace('-', '');
        }))), toConsumableArray_default()(_this4.sampleFiltedDatas[type]));
        return Object(util["i" /* groupBy */])(tableDatas, function () {
          return 'default';
        }).map(function (datas) {
          return { title: datas[0].group, isGroup: true, datas: datas };
        });
      };
      var tableDatas = {
        case: generator('case'),
        dataset: generator('dataset')
      };
      return tableDatas;
    },
    sampleSelectedDataMap: function sampleSelectedDataMap() {
      var _this5 = this;

      var generator = function generator(type) {
        return _this5.sample.results[type].reduce(function (map, data) {
          return extends_default()({}, map, defineProperty_default()({}, data.id, extends_default()({}, data, { selected: true })));
        }, {});
      };
      return {
        case: generator('case'),
        dataset: generator('dataset')
      };
    },
    sampleTableOptions: function sampleTableOptions() {
      return {
        case: [{
          value: '_SELECT',
          width: 50,
          class: function _class() {
            return ['center'];
          },
          sortMap: null
        }, {
          title: 'Case ID' /* ___ */
          , value: 'case_id',
          sortMap: { detail: undefined, list: null }[this.sample.viewType]
        }, {
          title: 'Sex' /* ___ */
          , value: 'sex',
          width: 66,
          class: function _class() {
            return ['center'];
          },
          display: function display(value) {
            return { Male: 'M', Female: 'F', Unknown: 'U' }[value];
          },
          style: function style(value) {
            return { Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value];
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: 'Age' /* ___ */
          , value: 'birth_year',
          width: 67,
          class: function _class() {
            return ['center'];
          },
          display: function display(value) {
            return value ? new Date().getFullYear() - value + '' : null;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: 'Create' /* ___ */
          , value: 'created_at',
          width: 167,
          display: function display(value) {
            return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: 'Modified' /* ___ */
          , value: 'updated_at',
          width: 167,
          display: function display(value) {
            return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }],
        dataset: [{
          value: '_SELECT',
          width: 50,
          class: function _class() {
            return ['center'];
          },
          sortMap: null
        }, {
          title: 'Dataset name' /* ___ */
          , value: 'name',
          sortMap: { detail: undefined, list: null }[this.sample.viewType]
        }, {
          title: 'Sample Size' /* ___ */
          , value: 'sample_size',
          width: 127,
          display: function display(value) {
            return value ? Object(util["p" /* toPriceString */])(value) : value;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: 'Owner' /* ___ */
          , value: 'user',
          width: 352,
          display: function display(value) {
            return value ? [value.first_name, value.last_name].filter(function (x) {
              return x;
            }).join(' ') + (value.email ? ' (' + [value.email].filter(function (x) {
              return x;
            }).join(' ') + ')' : '') : value;
          },
          sortValue: 'users.first_name',
          sortMap: function sortMap(dataset) {
            return dataset.user.first_name;
          },
          show: { detail: true, list: false }[this.sample.viewType]
        }, {
          title: 'Detail' /* ___ */
          , value: '_DETAIL',
          width: 78,
          class: function _class() {
            return ['center'];
          },
          sortMap: null,
          show: { detail: true, list: false }[this.sample.viewType]
        }]
      };
    },
    sampleSortMap: function sampleSortMap() {
      var _this6 = this;

      return keys_default()(this.sampleTableOptions).reduce(function (result, key) {
        return extends_default()({}, result, defineProperty_default()({}, key, _this6.sampleTableOptions[key].reduce(function (s, c) {
          return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
        }, {})));
      }, {});
    },
    sampleSortValue: function sampleSortValue() {
      var _this7 = this;

      return keys_default()(this.sampleTableOptions).reduce(function (result, key) {
        return extends_default()({}, result, defineProperty_default()({}, key, _this7.sampleTableOptions[key].reduce(function (s, c) {
          return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortValue || c.value));
        }, {})));
      }, {});
    },

    // static
    sampleListOptions: function sampleListOptions() {
      return [{
        title: 'My selected samples (' + this.sample.results['case'].length + ')' /* ___ */
        , value: 'case'
      }, {
        title: 'Community datasets' /* ___ */
        , value: 'dataset'
      }];
    },
    formOptions: function formOptions() {
      var _this8 = this;

      return {
        field0: [{
          title: 'Owner' /* ___ */
          , value: 'user_id',
          type: 'custom',
          grid: 3,
          options: this.userOptions,
          validate: 'required'
        }, {
          title: '　' /* ___ */
          , value: '',
          grid: 3
        }],
        field1: [
        // 1
        {
          title: 'Dataset name' /* ___ */
          , value: 'name',
          type: 'input',
          grid: 2,
          onChange: function onChange(value) {
            _this8.nameConfirm(value);
          },
          placeholder: function placeholder() {
            return 'Dataset name.';
          } /* ___ */
          , validate: 'required'
        }, {
          title: 'Add tags' /* ___ */
          , value: '_TAG',
          type: 'custom',
          grid: 1,
          placeholder: function placeholder() {
            return 'Name of tags';
          } /* ___ */
        }, {
          title: '' /* ___ */
          , value: '_TAGS',
          type: 'custom',
          grid: 3
        },
        // 2
        {
          title: 'Pipeline' /* ___ */
          , value: 'pipeline',
          type: this.dataset.id ? 'text' : 'select',
          grid: 2,
          options: this.pipelineOptions,
          placeholder: function placeholder() {
            return 'Pipeline';
          } /* ___ */
          , validate: this.dataset.id ? '' : 'required',
          inputFormat: function inputFormat(value) {
            return _this8.dataset.id ? (_this8.pipelineOptions.find(function (option) {
              return option.value === value;
            }) || {}).title : value;
          }
        }, {
          title: 'Dataset description' /* ___ */
          , value: 'description',
          type: 'textarea',
          row: 4,
          grid: 4,
          placeholder: function placeholder() {
            return 'Note any description of the dataset.';
          } /* ___ */
        }]
      };
    },

    // unload alert
    sendData: function sendData() {
      var sendData = {};
      sendData = extends_default()({}, sendData, entries_default()(this.result).reduce(function (s, _ref7) {
        var _ref8 = slicedToArray_default()(_ref7, 2),
            k = _ref8[0],
            v = _ref8[1];

        return extends_default()({}, s, k.startsWith('_') ? {} : defineProperty_default()({}, k, v));
      }, {}), {
        tags: this.tags['tag'],
        dataset_picture_file_id: this.selectedPictureID === 'custom' ? this.customPicture.id : this.selectedPictureID
      });
      if ((this.form || {}).sampleSelect) {
        sendData = extends_default()({}, sendData, {
          case_ids: this.sample.results['case'].map(function (result) {
            return result.id;
          }),
          community_dataset_ids: this.sample.results['dataset'].map(function (result) {
            return result.id;
          })
        });
      }
      return sendData;
    },

    // global
    fileTypeCheck: function fileTypeCheck() {
      return util["f" /* fileTypeCheck */];
    }
  }),
  watch: {
    'defaultData': function defaultData() {
      this.init(this.defaultData);
    },
    'sample.listType': function sampleListType() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this9.sample.datas[_this9.sample.listType]) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this9.sampleSearchDatas();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9);
      }))();
    },
    'result.name': function resultName() {
      this.customValidate([], ['name']);
    },

    // search tag
    'query.tag': function queryTag(nv) {
      this.getTag(nv, 'tag');
    },

    // sample
    'result.user_id': function resultUser_id(nv, ov) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, option;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(nv && ov)) {
                  _context2.next = 33;
                  break;
                }

                _this10.setLoadingAction(true);
                _context2.next = 4;
                return _this10.fetchDatasetCases();

              case 4:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 7;
                _iterator = get_iterator_default()(_this10.sampleListOptions);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 18;
                  break;
                }

                option = _step.value;

                _this10.sample.results[option.value] = [];
                _this10.displayIDs = {
                  case: [],
                  dataset: []
                };
                _context2.next = 15;
                return _this10.sampleSearchDatas(true, option.value);

              case 15:
                _iteratorNormalCompletion = true;
                _context2.next = 9;
                break;

              case 18:
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 24:
                _context2.prev = 24;
                _context2.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context2.prev = 27;

                if (!_didIteratorError) {
                  _context2.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context2.finish(27);

              case 31:
                return _context2.finish(24);

              case 32:
                _this10.setLoadingAction(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this10, [[7, 20, 24, 32], [25,, 27, 31]]);
      }))();
    },
    'result.pipeline': function resultPipeline(nv, ov) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, option;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!ov) {
                  _context3.next = 33;
                  break;
                }

                _this11.setLoadingAction(true);
                _context3.next = 4;
                return _this11.fetchDatasetCases();

              case 4:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 7;
                _iterator2 = get_iterator_default()(_this11.sampleListOptions);

              case 9:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 18;
                  break;
                }

                option = _step2.value;

                _this11.sample.results[option.value] = [];
                _this11.displayIDs = {
                  case: [],
                  dataset: []
                };
                _context3.next = 15;
                return _this11.sampleSearchDatas(true, option.value);

              case 15:
                _iteratorNormalCompletion2 = true;
                _context3.next = 9;
                break;

              case 18:
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](7);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 24:
                _context3.prev = 24;
                _context3.prev = 25;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 27:
                _context3.prev = 27;

                if (!_didIteratorError2) {
                  _context3.next = 30;
                  break;
                }

                throw _iteratorError2;

              case 30:
                return _context3.finish(27);

              case 31:
                return _context3.finish(24);

              case 32:
                _this11.setLoadingAction(false);

              case 33:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this11, [[7, 20, 24, 32], [25,, 27, 31]]);
      }))();
    },
    'sample.query': function sampleQuery() {
      var _this12 = this;

      this.customDelay(function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(_this12.sampleListOptions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var option = _step3.value;

            _this12.sampleSearchDatas(true, option.value);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }, 300, 'queryChange');
    },
    'sampleTableDatas.case': function sampleTableDatasCase() {
      this.getSampleTableOverflow('case');
    },
    'sampleTableDatas.dataset': function sampleTableDatasDataset() {
      this.getSampleTableOverflow('dataset');
    },

    // validate
    'selectedSampleSize': function selectedSampleSize() {
      this.customValidate([], ['sample']);
    },

    // unload alert
    'sendData': function sendData(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.$emit('unloadAlert', true);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction', 'setModal2Action']), {
    init: function init(data) {
      var _this13 = this;

      this.dataset = extends_default()({}, this.dataset, data, {
        dataset_picture_file_id: (data.dataset_picture_file || {}).id
      });
      this.selectedPictureID = this.dataset.dataset_picture_file_id || this.selectedPictureID;
      this.tags['tag'] = [].concat(toConsumableArray_default()(this.dataset.tags || []));
      setTimeout(function () {
        return _this13.$emit('unloadAlert', false);
      });
    },
    fetchData: function fetchData() {
      var _this14 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this14.init(_this14.defaultData);

                if (!(_this14.form || {}).roleSelect) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return _this14.fetchManagedUsers();

              case 4:
                if (!_this14.dataset.id) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 7;
                return _this14.fetchCustomPicture();

              case 7:
                _context4.next = 9;
                return _this14.fetchDatasetPictureFiles();

              case 9:
                if (!(_this14.form || {}).sampleSelect) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 12;
                return _this14.fetchDatasetCases();

              case 12:
                _context4.next = 14;
                return _this14.fetchSampleDatas(true, 'case');

              case 14:
                _context4.next = 16;
                return _this14.fetchSampleDatas(true, 'dataset');

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this14);
      }))();
    },
    fetchManagedUsers: function fetchManagedUsers() {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, response, users;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this15.$ls.get('userInfo');
                _context5.next = 4;
                return Object(src_api["_18" /* getManagedUsers */])(config);

              case 4:
                response = _context5.sent;
                users = response.data.data;

                _this15.users = users;
                _this15.result = extends_default()({}, _this15.result, {
                  user_id: users[0].id
                });
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0;

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this15, [[0, 10]]);
      }))();
    },
    fetchCustomPicture: function fetchCustomPicture() {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var config, id, response, customPicture;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                config = _this16.$ls.get('userInfo');
                id = _this16.dataset.id;
                _context6.next = 5;
                return Object(src_api["V" /* getDatasetPictureFile */])(id, config);

              case 5:
                response = _context6.sent;
                customPicture = response.data.data;

                _this16.customPicture = customPicture ? extends_default()({}, customPicture, {
                  url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + customPicture.id + '&class_name=' + customPicture.class_name + '&access_token=' + config['access_token']
                }) : _this16.customPicture;
                _context6.next = 13;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0;

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this16, [[0, 10]]);
      }))();
    },
    fetchDatasetPictureFiles: function fetchDatasetPictureFiles() {
      var _this17 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var config, response, pictures;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                config = _this17.$ls.get('userInfo');
                _context7.next = 4;
                return Object(src_api["W" /* getDatasetPictureFiles */])(config);

              case 4:
                response = _context7.sent;
                pictures = response.data.data;

                pictures = pictures.filter(function (picture) {
                  return picture.size && picture.id !== (_this17.customPicture || {}).id;
                }).map(function (picture) {
                  return extends_default()({}, picture, {
                    url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + picture.id + '&class_name=' + picture.class_name + '&access_token=' + config['access_token']
                  });
                });
                _this17.pictures = pictures;
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](0);
                throw _context7.t0;

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this17, [[0, 10]]);
      }))();
    },
    fetchDatasetCases: function fetchDatasetCases() {
      var _this18 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var config, params, response, cases;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                config = _this18.$ls.get('userInfo');
                params = {
                  q: _this18.sample.query || null,
                  pipeline: _this18.dataset.id ? _this18.dataset.pipeline : _this18.result.pipeline,
                  state: 'completed'
                };

                if ((_this18.form || {}).roleSelect) {
                  params.user_id = _this18.result.user_id;
                }
                _context8.next = 6;
                return Object(src_api["N" /* getCreateDatasetCases */])(params, config);

              case 6:
                response = _context8.sent;
                cases = response.data.data;

                cases = cases.map(function (caseData) {
                  var phenotypeDatas = [].concat(toConsumableArray_default()(caseData.phenotypes.hpo.map(function (phenotype) {
                    return {
                      id: phenotype.hpo_id,
                      name: phenotype.hpo_name,
                      query: phenotype.hpo_id + ' ' + phenotype.hpo_name,
                      type: 'hpo'
                    };
                  })), toConsumableArray_default()(caseData.phenotypes.disease_term.map(function (phenotype) {
                    return {
                      id: phenotype.disease_id,
                      name: phenotype.disease_name,
                      query: phenotype.disease_id + ' ' + phenotype.disease_name,
                      type: 'disease_term'
                    };
                  })));
                  return extends_default()({}, caseData, {
                    phenotypeDatas: phenotypeDatas
                  });
                });
                _this18.allCases = cases;
                _context8.next = 14;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8['catch'](0);

              case 14:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this18, [[0, 12]]);
      }))();
    },
    fetchSampleDatas: function fetchSampleDatas() {
      var _this19 = this;

      var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var type = arguments[1];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var config, api, params, response, sampleDatas, total;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                config = _this19.$ls.get('userInfo');
                api = {
                  case: _this19.getCreateDatasetCases,
                  dataset: src_api["_6" /* getFullAccessDatasets */]
                }[type];
                params = {
                  q: _this19.sample.query || null,
                  type: type,
                  pipeline: _this19.dataset.id ? _this19.dataset.pipeline : _this19.result.pipeline,
                  state: 'completed'
                };

                if ((_this19.form || {}).roleSelect) {
                  params.user_id = _this19.result.user_id;
                }
                _this19.sample.pageData.selectedPage[type] && (params.page = _this19.sample.pageData.selectedPage[type]);
                _this19.sample.pageData.display[type] && (params.items = _this19.sample.pageData.display[type]);
                _this19.sample.sort[type].value[0] && (params.order_by = (_this19.sampleSortValue[type][_this19.sample.sort[type].value[0]] || _this19.sample.sort[type].value[0]) + ':' + _this19.sample.sort[type].order[0].replace(/^-/, ''));
                _context9.next = 10;
                return api(params, config);

              case 10:
                response = _context9.sent;
                sampleDatas = response.data.data || [];
                total = response.data.count || 0;

                _this19.sample.datas[type] = [].concat(toConsumableArray_default()(_this19.sample.datas[type] || []), toConsumableArray_default()(sampleDatas));
                _this19.sample.pageData.total[type] = {
                  'case': _this19.sample.pageData.total[type],
                  'dataset': sampleDatas.length
                }[type];
                _this19.displayIDs[type] = {
                  'case': [],
                  'dataset': sampleDatas.map(function (data) {
                    return data.id;
                  })
                }[type];
                // this.sample.pageData.selectedPage[type] += (sampleDatas.length ? 1 : 0)
                return _context9.abrupt('return', !!(sampleDatas.length && total > _this19.sample.datas[type].length));

              case 19:
                _context9.prev = 19;
                _context9.t0 = _context9['catch'](0);

                if (!init) {
                  _context9.next = 25;
                  break;
                }

                throw _context9.t0;

              case 25:
                return _context9.abrupt('return', false);

              case 26:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this19, [[0, 19]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this20 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var id;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                id = _this20.dataset.dataset_picture_file_id || _this20.pictures[0].id;

                _this20.selectedPictureID = (_this20.pictures.find(function (picture) {
                  return picture.id === id;
                }) || {}).id || 'custom';
                setTimeout(function () {
                  return _this20.$emit('unloadAlert', false);
                });

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this20);
      }))();
    },
    getCreateDatasetCases: function getCreateDatasetCases(params, config) {
      var _this21 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        var response, results, order, pageData;
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                response = { data: {} };
                results = _this21.allCases;
                order = params.order_by ? params.order_by.split(':') : null;
                pageData = {
                  selectedPage: _this21.sample.pageData.selectedPage[params.type],
                  display: _this21.sample.pageData.display[params.type]
                };

                params.q && (results = results.filter(function (result) {
                  return result.case_id.includes(params.q);
                }));
                order && (results = Object(util["m" /* sortData */])(results, order[0], order[1]));
                results = results.filter(function (_, index) {
                  return index >= (pageData.selectedPage - 1) * pageData.display && index < (pageData.selectedPage - 0) * pageData.display;
                });
                response.data = {
                  data: results,
                  count: _this21.allCases.length
                };
                return _context11.abrupt('return', response);

              case 9:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this21);
      }))();
    },
    sampleSearchDatas: function sampleSearchDatas() {
      var _this22 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var type = arguments[1];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        var result;
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                reset && _this22.setLoadingAction(true);
                type = type || _this22.sample.listType;

                if (!reset) {
                  _context13.next = 12;
                  break;
                }

                _this22.sample.datas[type] = [];
                _this22.sample.pageData.selectedPage[type] = 1;
                _context13.next = 7;
                return new promise_default.a(function (resolve) {
                  setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                    var result;
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return _this22.fetchSampleDatas(false, type);

                          case 2:
                            result = _context12.sent;

                            resolve(result);

                          case 4:
                          case 'end':
                            return _context12.stop();
                        }
                      }
                    }, _callee12, _this22);
                  })), 300);
                });

              case 7:
                result = _context13.sent;

                reset && _this22.setLoadingAction(false);
                return _context13.abrupt('return', result);

              case 12:
                return _context13.abrupt('return', false);

              case 13:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this22);
      }))();
    },
    getSampleTableOverflow: function getSampleTableOverflow(type) {
      var _this23 = this;

      setTimeout(function () {
        try {
          var scrollContainer = _this23.$refs['custom-table-scroll-' + type][0].$el;
          if (scrollContainer) {
            _this23.sample.tableOverflow[type] = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
          }
        } catch (error) {}
      });
    },
    sampleTableOnSelect: function sampleTableOnSelect(type, datas, value) {
      var _this24 = this;

      if (value === 'all') {
        if (!this.sampleFiltedDatas[type].some(function (data) {
          return !_this24.sampleSelectedDataMap[type][data.id];
        })) {
          datas = this.sample.results[type];
          value = false;
        } else {
          datas = this.sampleFiltedDatas[type];
          value = true;
        }
      }
      var dataMap = datas.reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data.id, data));
      }, {});
      this.sample.results[type] = value ? [].concat(toConsumableArray_default()(datas.filter(function (data) {
        return !_this24.sampleSelectedDataMap[type][data.id];
      })), toConsumableArray_default()(this.sample.results[type])) : this.sample.results[type].filter(function (result) {
        return !dataMap[result.id];
      });
      this.displayIDs[type] = {
        case: this.sample.results[type].map(function (result) {
          return result.id;
        }),
        dataset: this.sample.datas[type].map(function (result) {
          return result.id;
        })
      }[type];
    },
    sampleTableSortBy: function sampleTableSortBy(value, type) {
      var position = this.sample.sort[type].value.indexOf(value);
      if (position === 0) {
        var order = this.sample.sort[type].order[position] === '-asc' ? '-desc' : '-asc';
        this.sample.sort[type].order.splice(position, 1);
        this.sample.sort[type].order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sample.sort[type].order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sample.sort[type].value.splice(position, 1);
        this.sample.sort[type].order.splice(position, 1);
        this.sample.sort[type].value.unshift(value);
        this.sample.sort[type].order.unshift(_order || '-asc');
      }
      this.sampleSearchDatas(true, type);
    },
    sampleOpenDatasetDetail: function sampleOpenDatasetDetail(dataset) {
      var _this25 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
        var action, config, id, response, cases;
        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                action = _this25.modal.action ? _this25.setModal2Action : _this25.setModalAction;
                _context14.prev = 1;
                config = _this25.$ls.get('userInfo');
                id = dataset.id;
                _context14.next = 6;
                return Object(src_api["R" /* getDatasetCases */])(id, config);

              case 6:
                response = _context14.sent;
                cases = response.data.data;

                cases = cases.map(function (caseData) {
                  return extends_default()({}, caseData.case);
                });
                action({
                  action: 'datasetDetail',
                  width: '912px',
                  height: _this25.windowHeight - 160 + 'px',
                  customStyles: {
                    'max-width': 'calc(100% - 40px)'
                  },
                  param: {
                    dataset: dataset,
                    cases: cases
                  }
                });
                _context14.next = 15;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14['catch'](1);

                _this25.addToast('error', !_context14.t0.response ? _context14.t0.message : _context14.t0.response.data.result.message);

              case 15:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this25, [[1, 12]]);
      }))();
    },
    sampleOpenDatasetSelectCase: function sampleOpenDatasetSelectCase() {
      var _this26 = this;

      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      var cases = this.allCases.filter(function (caseData) {
        return !_this26.displayIDs['case'].includes(caseData.id);
      }) || [];
      action({
        action: 'datasetSelectCase',
        width: '1208px',
        height: cases.length ? this.windowHeight - 160 + 'px' : 'auto',
        customStyles: {
          'max-width': 'calc(100% - 40px)'
        },
        param: {
          cases: cases
        },
        callback: function () {
          var _ref11 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15(result) {
            var displayIDs;
            return regenerator_default.a.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    if (result) {
                      displayIDs = [].concat(toConsumableArray_default()(_this26.displayIDs['case']), toConsumableArray_default()(result));

                      _this26.sample.pageData.total['case'] = displayIDs.length;
                      _this26.sampleTableOnSelect('case', _this26.allCases.filter(function (caseData) {
                        return displayIDs.includes(caseData.id);
                      }), true);
                    }

                  case 1:
                  case 'end':
                    return _context15.stop();
                }
              }
            }, _callee15, _this26);
          }));

          return function callback(_x3) {
            return _ref11.apply(this, arguments);
          };
        }()
      });
    },
    getTag: function getTag(query, target) {
      var _this27 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var queryMap;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                queryMap = {};

                query = (queryMap[target] || function (x) {
                  return x;
                })(query);
                if (_this27.curTag[target] !== query) {
                  _this27.tag[target] = {};
                  if (_this27.searchTimer[target]) {
                    clearTimeout(_this27.searchTimer[target]);
                  }
                  _this27.searchTimer[target] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
                    var datas;
                    return regenerator_default.a.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            if (!(!_this27.map[target][query] && query)) {
                              _context16.next = 15;
                              break;
                            }

                            _this27.loading[target] = true;
                            _this27.setLoadingAction(true);
                            _context16.prev = 3;
                            _context16.next = 6;
                            return _this27.getDataApi(query, target);

                          case 6:
                            datas = _context16.sent;

                            _this27.map[target] = extends_default()({}, _this27.map[target], defineProperty_default()({}, query, {
                              items: datas || []
                            }));
                            _context16.next = 13;
                            break;

                          case 10:
                            _context16.prev = 10;
                            _context16.t0 = _context16['catch'](3);

                            _this27.addToast('error', !_context16.t0.response ? _context16.t0.message : _context16.t0.response.data.result.message);

                          case 13:
                            _this27.loading[target] = false;
                            _this27.setLoadingAction(false);

                          case 15:
                            _this27.tag[target] = _this27.map[target][query] || {};

                          case 16:
                          case 'end':
                            return _context16.stop();
                        }
                      }
                    }, _callee16, _this27, [[3, 10]]);
                  })), 500);
                }

              case 3:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this27);
      }))();
    },
    getDataApi: function getDataApi(query, target) {
      var _this28 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18() {
        var seed, getRandomDatas, getData, result;
        return regenerator_default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                seed = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '2', '3', '4', '5', '6', '7', '8', '9'];

                getRandomDatas = function getRandomDatas() {
                  return query.length <= 5 ? new Array(10).fill('').map(function () {
                    var prefix = new Array(Math.floor(Math.random() * 5)).fill('').map(function () {
                      return seed[Math.floor(Math.random() * seed.length)];
                    }).join('');
                    var suffix = new Array(Math.floor(Math.random() * 5)).fill('').map(function () {
                      return seed[Math.floor(Math.random() * seed.length)];
                    }).join('');
                    return prefix + query + suffix;
                  }) : [];
                };

                getData = new promise_default.a(function (resolve) {
                  setTimeout(function () {
                    var datas = getRandomDatas();
                    resolve(datas);
                  }, 300);
                });
                _context18.next = 5;
                return getData;

              case 5:
                result = _context18.sent;
                return _context18.abrupt('return', result);

              case 7:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this28);
      }))();
    },
    addTag: function addTag(target, type) {
      var data = this.query[target];
      if (data && !this.loading[target + 'Add']) {
        this.loading[target + 'Add'] = true;
        switch (target) {
          case 'tag':
            {
              if (data) {
                this.tags[target].push(data);
                this.query[target] = '';
              } else if (!this.onError && !this.onSubmit && !data && type !== 'button') {}
              break;
            }
          default:
            {}
        }
        this.query[target] = '';
        this.loading[target + 'Add'] = false;
      }
    },
    selectCustomPicture: function selectCustomPicture(e) {
      var _this29 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20() {
        var action, file, url;
        return regenerator_default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                action = _this29.modal.action ? _this29.setModal2Action : _this29.setModalAction;
                file = e.target.files[0];
                _context20.next = 4;
                return Object(util["k" /* imageReader */])([file]);

              case 4:
                url = _context20.sent[0];

                action({
                  action: 'imageCropper',
                  width: '616px',
                  param: {
                    url: url
                  },
                  callback: function () {
                    var _ref13 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19(result) {
                      return regenerator_default.a.wrap(function _callee19$(_context19) {
                        while (1) {
                          switch (_context19.prev = _context19.next) {
                            case 0:
                              if (result) {
                                _this29.customPicture = {
                                  id: 'custom',
                                  name: file.name,
                                  url: result.url,
                                  file: result.file,
                                  class_name: 'DatasetPictureFile'
                                };
                              }

                            case 1:
                            case 'end':
                              return _context19.stop();
                          }
                        }
                      }, _callee19, _this29);
                    }));

                    return function callback(_x4) {
                      return _ref13.apply(this, arguments);
                    };
                  }()
                });
                e.target.value = '';

              case 7:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this29);
      }))();
    },
    onEvent: function onEvent(e, c) {
      if (['tag', 'send'].includes(e)) {
        if (c && c !== 'all') {
          var id = c.id || (this.users.find(function (user) {
            return c === [user.first_name, user.last_name].filter(function (x) {
              return x;
            }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
              return x;
            }).join(' ') + ')' : '');
          }) || {}).id;
          this.result.user_id = id || this.result.user_id;
        } else {
          this.result.user_id = -1;
        }
      }
    },
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(cols || keys_default()(this.dataset)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var col = _step4.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    nameConfirm: function nameConfirm(name) {
      var _this30 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21() {
        var config, params, response, result;
        return regenerator_default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                config = _this30.$ls.get('userInfo');
                params = {
                  name: name
                };

                if ((_this30.form || {}).roleSelect) {
                  params.user_id = _this30.result.user_id;
                }
                _context21.next = 6;
                return Object(src_api["T" /* getDatasetExistingState */])(params, config);

              case 6:
                response = _context21.sent;
                result = response.data.data;

                if (result) {
                  _context21.next = 12;
                  break;
                }

                _this30.alerts = extends_default()({}, _this30.alerts, {
                  name: null
                });
                _context21.next = 13;
                break;

              case 12:
                throw new Error();

              case 13:
                _context21.next = 18;
                break;

              case 15:
                _context21.prev = 15;
                _context21.t0 = _context21['catch'](0);

                _this30.alerts = extends_default()({}, _this30.alerts, {
                  name: {
                    type: 'error',
                    msg: 'Name has already been taken.' /* ___ */
                  }
                });

              case 18:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this30, [[0, 15]]);
      }))();
    },
    sampleValidate: function sampleValidate() {
      if (this.selectedSampleSize > 0) {
        return true;
      } else {
        this.alerts = extends_default()({}, this.alerts, {
          sample: {
            type: 'error',
            msg: 'Sample size is too small.' /* ___ */
          }
        });
        return false;
      }
    },
    validateSubmit: function validateSubmit() {
      var _this31 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
        var result, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, kv;

        return regenerator_default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                result = {};

                _this31.onSubmit = true;
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context22.prev = 5;
                _iterator5 = get_iterator_default()(entries_default()(_this31.validate));

              case 7:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context22.next = 15;
                  break;
                }

                kv = _step5.value;
                _context22.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context22.sent;

              case 12:
                _iteratorNormalCompletion5 = true;
                _context22.next = 7;
                break;

              case 15:
                _context22.next = 21;
                break;

              case 17:
                _context22.prev = 17;
                _context22.t0 = _context22['catch'](5);
                _didIteratorError5 = true;
                _iteratorError5 = _context22.t0;

              case 21:
                _context22.prev = 21;
                _context22.prev = 22;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 24:
                _context22.prev = 24;

                if (!_didIteratorError5) {
                  _context22.next = 27;
                  break;
                }

                throw _iteratorError5;

              case 27:
                return _context22.finish(24);

              case 28:
                return _context22.finish(21);

              case 29:
                result['custom'] = _this31.customValidate();
                if ((_this31.form || {}).sampleSelect) {
                  result['sample'] = _this31.sampleValidate();
                }

                if (values_default()(result).includes(false)) {
                  _context22.next = 33;
                  break;
                }

                return _context22.abrupt('return', true);

              case 33:
                _this31.onSubmit = false;

              case 34:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this31, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    submit: function submit() {
      var _this32 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23() {
        var data, customPicture;
        return regenerator_default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                data = _this32.sendData;
                customPicture = _this32.customPicture;
                return _context23.abrupt('return', { data: data, customPicture: customPicture });

              case 3:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this32);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b052b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataset/base.vue
var base_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-base-page col-block width-full"},[_c('div',{staticClass:"dataset-form-container col-block width-full"},[((_vm.form || {}).roleSelect)?[_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"init":_vm.dataset,"alerts":_vm.alerts,"scope":_vm.scope,"forms":_vm.formOptions['field0']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field0', result, validate, errors); }},scopedSlots:_vm._u([{key:"user_id",fn:function(props){return [_c('div',{staticClass:"input-group",style:({ width: '100%', padding: 0 }),attrs:{"name":props}},[_c('inputTag',{style:({
                width: '100%'
              }),attrs:{"inputStyle":{
                'padding-right': '40px'
              },"init":(_vm.userOptions.find(function (option) { return option.value === _vm.result.user_id; }) || {}).title,"emptyDisplay":true,"disabled":false,"placeholder":'all',"tags":_vm.users,"prefix":'(?:^)',"target":'^(.*?)$',"replace":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); },"filter":function (content) { return function (user) { return content && ([user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : '')).match(new RegExp(content.replace(/(\(|\)|\[|\]|\{|\}|\\)/g, '\\$1'), 'i')); }; },"tagDisplay":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); }},on:{"send":function (content) { return _vm.onEvent('send', content); },"tag":function (content) { return _vm.onEvent('tag', content); }}})],1)]}}])})]:_vm._e(),_vm._v(" "),_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"init":_vm.dataset,"alerts":_vm.alerts,"scope":_vm.scope,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }},scopedSlots:_vm._u([{key:"_TAG",fn:function(props){return [_c('div',{staticClass:"_TAG input-group",attrs:{"name":props}},[_c('dataTag',{style:({
              width: '100%'
            }),attrs:{"disabled":false,"placeholder":'Name of tags'/* ___ */,"needInfo":false,"init":_vm.query['tag'],"data":_vm.tag['tag'],"tagDisplay":function (tag) { return tag; },"emptyMsg":''/* ___ */,"replace":function (tag, content) { return tag; }},on:{"input":function (content) { _vm.query['tag'] = content },"tag":function (tag) { _vm.query['tag'] = tag; _vm.curTag['tag'] = tag },"send":function (content) { return _vm.addTag('tag'); }}})],1)]}},{key:"_TAGS",fn:function(props){return [_c('div',{staticClass:"_TAGS row-block stretch",attrs:{"name":props}},[_c('button',{staticClass:"white-gray-button circle-button",attrs:{"type":"button","disabled":!_vm.query['tag']},on:{"click":function (e) { return _vm.addTag('tag', 'button'); }}},[_c('span',[_vm._v(_vm._s('Add'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"tag-list-container row-block flex-start flex-wrap shrink"},_vm._l((_vm.tags['tag']),function(tag,index){return _c('div',{key:index,staticClass:"tag-block row-block"},[_c('div',{staticClass:"tag-title"},[_vm._v(_vm._s(tag))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{staticClass:"tag-remove-icon",attrs:{"src":__webpack_require__("Fg3B"),"alt":""},on:{"click":function (e) { return _vm.tags['tag'].splice(index, 1); }}})])}),0),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}}])})],2),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-picture-field col-block flex-start"},[_c('div',{staticClass:"dataset-picture-title"},[_vm._v(_vm._s('Picture of dataset'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '7px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-picture-container row-block flex-start flex-wrap"},[_c('div',{staticClass:"dataset-picture-list-container row-block flex-start flex-wrap"},_vm._l((_vm.pictures),function(picture,index){return _c('div',{key:index,staticClass:"dataset-picture-block",on:{"click":function (e) { return _vm.selectedPictureID = picture.id; }}},[_c('div',{staticClass:"dataset-picture",style:({ 'background-image': 'url(' + picture.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"dataset-picture-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedPictureID === picture.id ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"custom-picture-container col-block flex-start"},[_c('div',{staticClass:"custom-picture-title-container row-block",class:{ disabled: !_vm.customPicture },on:{"click":function (e) { return _vm.customPicture && (_vm.selectedPictureID = 'custom'); }}},[_c('div',{staticClass:"custom-picture-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedPictureID === 'custom' ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-picture-title"},[_vm._v(_vm._s('Custom picture'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-picture-main-container col-block"},[(_vm.customPicture)?_c('div',{staticClass:"custom-picture-image-block"},[_c('div',{staticClass:"custom-picture-image mask",style:({ 'background-image': 'url(' + _vm.customPicture.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"custom-picture-image",style:({ 'background-image': 'url(' + _vm.customPicture.url + ')' })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"custom-picture","accept":"image/*"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectCustomPicture(e); }, function () { return _vm.addToast('error', 'Please upload image file'/* ___ */); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":"custom-picture"}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),((_vm.form || {}).sampleSelect)?[_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '15px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-container col-block width-full"},[_c('div',{staticClass:"dataset-sample-title-container row-block"},[_c('borCor',{attrs:{"display":!!(_vm.alerts['sample'] && _vm.alerts['sample'].type === 'error'),"background":'white',"border":'#FA3D3D',"radius":'3px',"translate":'-120px 0px',"blockStyle":{
            padding: '5px 20px'
          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"dataset-sample-title-block row-block",class:{ alert: _vm.alerts['sample'] && _vm.alerts['sample'].type === 'error' }},[_c('div',{staticClass:"dataset-sample-title"},[_vm._v(_vm._s('Samples of the dataset'/* ___ */)),_c('span',{staticClass:"alert"},[_vm._v(" *")])]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-information"},[_vm._v(_vm._s('(' + _vm.selectedSampleSize + ' ' + (_vm.selectedSampleSize > 1 ? 'samples' : 'sample') + ' selected)'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-option-container row-block"},[_c('button',{staticClass:"white-gray-button circle-button",attrs:{"disabled":_vm.sample.listType !== 'case'},on:{"click":function (e) { return _vm.sampleOpenDatasetSelectCase(); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"dataset-sample-alert"},[_vm._v(_vm._s((_vm.alerts['sample'] || {}).msg))])])]),_vm._v(" "),_c('div',{staticClass:"dataset-sample-view-type-container row-block"},[_c('div',{staticClass:"dataset-sample-view-type-title",class:{ active: _vm.sample.viewType === 'detail' }},[_vm._v(_vm._s('Detail view'/* ___ */))]),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"active":true,"checked":_vm.sample.viewType === 'list'},on:{"input":function (c) { return _vm.sample.viewType = c ? 'list' : 'detail'; }}}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-view-type-title",class:{ active: _vm.sample.viewType === 'list' }},[_vm._v(_vm._s('List view'/* ___ */))])],1)],1),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '0' })}),_vm._v(" "),_c('div',{staticClass:"dataset-sample-list-container col-block width-full"},[_c('div',{staticClass:"dataset-sample-list-option-container row-block"},[_c('div',{staticClass:"dataset-sample-list-tab-list-container row-block"},_vm._l((_vm.sampleListOptions),function(option,tindex){return _c('div',{key:tindex,staticClass:"tab-field row-block height-full",class:{ active: option.value === _vm.sample.listType },on:{"click":function (e) { return _vm.sample.listType = option.value; }}},[_c('div',{staticClass:"tab-container col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"tab-block row-block"},[_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s(option.title))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}),0),_vm._v(" "),_c('div',{staticClass:"dataset-sample-list-search-container input-group",style:({ width: '280px' })},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sample.query),expression:"sample.query"}],style:({ 'padding-right': '40px' }),attrs:{"type":"text","placeholder":{ case: 'Case ID of the samples'/* ___ */, dataset: 'Keywords of dataset'/* ___ */ }[_vm.sample.listType]},domProps:{"value":(_vm.sample.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sample, "query", $event.target.value)}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"dataset-sample-table-field col-block width-full"},[_vm._l((_vm.sampleListOptions),function(sampleOption){return [_c('div',{key:sampleOption.value,staticClass:"dataset-sample-table-container custom-table",class:{ 'auto-height': false, active: _vm.sample.listType === sampleOption.value }},[_c('div',{staticClass:"table-field col-block",style:({ width: '100%' })},[_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.sampleTableOptions[sampleOption.value].filter(function (option) { return option.show !== false; })),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:(option.width ? { width: option.width + 'px' } : { flex: 1 }),on:{"click":function (e) { return !_vm.sample.sort[sampleOption.value].disabled && option.sortMap !== null && _vm.sampleTableSortBy(option.sortValue || option.value, sampleOption.value); }}},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":_vm.sample.results[sampleOption.value].length ? !_vm.sampleFiltedDatas[sampleOption.value].some(function (data) { return !_vm.sampleSelectedDataMap[sampleOption.value][data.id]; }) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.sampleTableOnSelect(sampleOption.value, null, 'all'); }}})])]:[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sample.sort[sampleOption.value].order[_vm.sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()]],2)}),0)])]),_vm._v(" "),_c('scrollBottom',{ref:'custom-table-scroll-' + sampleOption.value,refInFor:true,staticClass:"table-group-container col-block width-full",attrs:{"containerKey":sampleOption.value,"deviation":800,"onScrollBottom":function () { return _vm.sampleSearchDatas(false, sampleOption.value); }}},[(_vm.sample.pageData.total[sampleOption.value] || Object.keys(_vm.sampleSelectedDataMap[sampleOption.value]).length)?_c('div',{staticClass:"col-block"},_vm._l((_vm.sampleTableDatas[sampleOption.value]),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody",class:{ 'list-view': ['list'].includes(_vm.sample.viewType) }},[_c('div',{staticClass:"tr group row-block",class:{ selected: false },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.sampleTableOptions[sampleOption.value].filter(function (option) { return option.show !== false; })),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:(option.width ? { width: option.width - (!_vm.sampleTableOptions[sampleOption.value][index + 1] && _vm.sample.tableOverflow[sampleOption.value] ? _vm.scrollbarSize : 0) + 'px' } : { flex: 1 })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sample.sort[sampleOption.value].order[_vm.sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: false }},[(['detail'].includes(_vm.sample.viewType))?_c('a',{staticClass:"container-block row-block",style:({ flex: 1 })},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.sampleTableOptions[sampleOption.value].filter(function (option) { return option.show !== false; })),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:(option.width ? { width: option.width - (!_vm.sampleTableOptions[sampleOption.value][index + 1] && _vm.sample.tableOverflow[sampleOption.value] ? _vm.scrollbarSize : 0) + 'px' } : { flex: 1 })},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":data.selected ? __webpack_require__("7kqe") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.sampleTableOnSelect(sampleOption.value, [data], !data.selected); }}})])]:(option.value === '_DETAIL')?[_c('div',{staticClass:"_DETAIL center-block"},[_c('img',{attrs:{"src":__webpack_require__("OlcD"),"alt":""},on:{"click":function (e) { return _vm.sampleOpenDatasetDetail(data); }}})])]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sample.sort[sampleOption.value].order[_vm.sample.sort[sampleOption.value].value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2):_c('div',{staticClass:"list-block row-block"},[_c('img',{attrs:{"src":data.selected ? __webpack_require__("7kqe") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.sampleTableOnSelect(sampleOption.value, [data], !data.selected); }}}),_vm._v(" "),_c('span',{staticClass:"ellipsis",style:({ flex: 1 }),attrs:{"title":((_vm.sampleTableOptions[sampleOption.value][1].display || (function (x) { return x; }))(data[_vm.sampleTableOptions[sampleOption.value][1].value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((_vm.sampleTableOptions[sampleOption.value][1].display || (function (x) { return x; }))(data[_vm.sampleTableOptions[sampleOption.value][1].value], dindex, data) || _vm.sampleTableOptions[sampleOption.value][1].empty || '- -')}})])])})],2)])}),0):_c('div',{staticClass:"table-empty-container col-block"},[_c('div',{style:({ flex:1 })}),_vm._v(" "),_c('div',{staticClass:"table-empty-content",class:[sampleOption.value]},[_vm._v(_vm._s(_vm.sample.emptyText[sampleOption.value] || ''))]),_vm._v(" "),_c('div',{style:({ flex:1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-page-container row-block sub-shadow",style:({ height: '50px' })},[_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"display-container row-block"},[_c('div',{staticClass:"display-title"},[_vm._v(_vm._s('Items per page'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sample.pageData.display[_vm.sample.listType]),expression:"sample.pageData.display[sample.listType]"}],staticClass:"display",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sample.pageData.display, _vm.sample.listType, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"200"}},[_vm._v("200")])])])])]),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block"},[_c('pageButtons',{style:({ flex: 1 }),attrs:{"default":_vm.sample.pageData.selectedPage[_vm.sample.listType],"display":_vm.sample.pageData.display[_vm.sample.listType] - 0,"total":_vm.totalPage * _vm.sample.pageData.display[_vm.sample.listType],"buttonRange":_vm.sample.pageData.buttonRange[_vm.sample.listType]},on:{"selectPage":function (page) { _vm.sample.pageData.selectedPage[_vm.sample.listType] = page }}})],1),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{staticClass:"jump-container row-block"},[_c('div',{staticClass:"jump-title"},[_vm._v(_vm._s('Go to'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sample.pageData.pageJumpTo[_vm.sample.listType]),expression:"sample.pageData.pageJumpTo[sample.listType]"}],staticClass:"jump",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sample.pageData.pageJumpTo, _vm.sample.listType, $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return _vm.sample.pageData.selectedPage[_vm.sample.listType] = _vm.sample.pageData.pageJumpTo[_vm.sample.listType] - 0; }]}},_vm._l(((new Array(_vm.totalPage[_vm.sample.listType])).fill('').map(function (_, i) { return i + 1; })),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])],1)])]})],2)])]:_vm._e()],2)}
var base_staticRenderFns = []
var base_esExports = { render: base_render, staticRenderFns: base_staticRenderFns }
/* harmony default export */ var dataset_base = (base_esExports);
// CONCATENATED MODULE: ./src/components/dataset/base.vue
var base_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var base___vue_template_functional__ = false
/* styles */
var base___vue_styles__ = null
/* scopeId */
var base___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var base___vue_module_identifier__ = null
var base_Component = base_normalizeComponent(
  base,
  dataset_base,
  base___vue_template_functional__,
  base___vue_styles__,
  base___vue_scopeId__,
  base___vue_module_identifier__
)

/* harmony default export */ var components_dataset_base = __webpack_exports__["a"] = (base_Component.exports);


/***/ }),

/***/ "+kXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/pageButtons.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var pageButtons = ({
  props: {
    default: {
      type: Number,
      default: 1
    },
    display: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    buttonRange: {
      type: Number,
      default: 5
    },
    showFirst: {
      type: Boolean,
      default: true
    },
    showLast: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      page: this.default
    };
  },

  watch: {
    'page': function page(val) {
      this.fixRange();
    },
    'total': function total(val) {
      this.fixRange();
    },
    'display': function display(val) {
      this.fixRange();
    },
    'default': function _default(val) {
      if (val) {
        this.page = val;
      }
    }
  },
  computed: {
    first: function first() {
      return 1;
    },
    last: function last() {
      return this.total > 0 && this.display > 0 ? Math.ceil(this.total / this.display) : 1;
    },
    nowList: function nowList() {
      var _this = this;

      return from_default()(new Array(this.buttonRange), function (v, i) {
        return i + _this.page - Math.floor(_this.buttonRange / 2);
      }).filter(function (n) {
        return n >= _this.first && n <= _this.last;
      });
    }
  },
  methods: {
    selectPage: function selectPage(page) {
      this.page = page !== 'pre' ? page !== 'next' ? page : Math.min(this.page + 1, this.last) : Math.max(this.page - 1, this.first);
      this.$emit('selectPage', this.page);
    },
    fixRange: function fixRange() {
      this.selectPage(this.page >= this.first ? this.page <= this.last ? this.page : this.last : this.first);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abbddbf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/pageButtons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-group"},[_c('div',{staticClass:"pre"},[_c('a',{on:{"click":function($event){_vm.selectPage('pre')}}},[_c('img',{style:({ transform: 'rotate(270deg)' }),attrs:{"src":__webpack_require__("n3Bz"),"alt":""}})])]),_vm._v(" "),(_vm.nowList[0] !== _vm.first)?_c('div',{staticClass:"first"},[(_vm.showFirst)?_c('a',{on:{"click":function($event){_vm.selectPage(_vm.first)}}},[_vm._v(_vm._s(_vm.first))]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"ellipsis"},[_vm._v("...")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"now"},_vm._l((_vm.nowList),function(n,i){return _c('a',{key:i,class:{ 'active': _vm.page === n, 'first': n === _vm.first, 'last': n === _vm.last },on:{"click":function($event){_vm.selectPage(n)}}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),(_vm.nowList[_vm.nowList.length - 1] !== _vm.last)?_c('div',{staticClass:"last"},[_c('a',{staticClass:"ellipsis"},[_vm._v("...")]),_vm._v(" "),(_vm.showLast)?_c('a',{on:{"click":function($event){_vm.selectPage(_vm.last)}}},[_vm._v(_vm._s(_vm.last))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"next"},[_c('a',{on:{"click":function($event){_vm.selectPage('next')}}},[_c('img',{style:({ transform: 'rotate(90deg)' }),attrs:{"src":__webpack_require__("n3Bz"),"alt":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_pageButtons = (esExports);
// CONCATENATED MODULE: ./src/components/tool/pageButtons.vue
function injectStyle (ssrContext) {
  __webpack_require__("i0HQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pageButtons,
  tool_pageButtons,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_pageButtons = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+lE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var src_api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/components/tool/customForm.vue + 2 modules
var customForm = __webpack_require__("uuH9");

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// EXTERNAL MODULE: ./src/components/tool/inputTag.vue + 2 modules
var inputTag = __webpack_require__("6EFu");

// EXTERNAL MODULE: ./src/components/tool/phenotypeTag.vue + 2 modules
var phenotypeTag = __webpack_require__("sdWU");

// EXTERNAL MODULE: ./src/components/tool/geneTag.vue + 2 modules
var geneTag = __webpack_require__("H3ds");

// EXTERNAL MODULE: ./src/mixins/routeLoading.vue + 1 modules
var routeLoading = __webpack_require__("zVZS");

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/base.vue











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var base = ({
  components: {
    customForm: customForm["a" /* default */],
    switchButton: switchButton["a" /* default */],
    borCor: newBorCor["a" /* default */],
    inputTag: inputTag["a" /* default */],
    phenotypeTag: phenotypeTag["a" /* default */],
    geneTag: geneTag["a" /* default */]
  },
  mixins: [routeLoading["a" /* default */]],
  props: {
    mode: {
      type: String,
      required: true
    },
    isUpdate: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    layoutBlocks: {
      type: Array,
      default: function _default() {
        return ['form', 'analysis', 'file'];
      }
    },
    dataset: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    scope: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    defaultData: {
      type: Object,
      required: true
    },
    projects: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      // form
      caseData: {},
      analysisData: {
        report_phenovardb: true
      },
      alerts: {},
      result: {
        'case': {},
        'analysis': {},
        'view': {}
      },
      validate: {},
      error: {},
      onSubmit: false,
      // options
      users: [],
      genePanels: [],
      divisions: [],
      omicss: {},
      // tag
      tagData: {
        map: {
          phenotype: {},
          gene: {}
        },
        query: {
          phenotype: '',
          gene: ''
        },
        tag: {
          phenotypes: {},
          genes: {}
        },
        curTag: {
          gene: null
        },
        searchTimer: {
          phenotype: [],
          gene: []
        }
      },
      // phenotype
      phenotypePanels: [],
      searchedPhenotypes: {
        phenotypes: [],
        genes: []
      },
      selectedPhenotypes: {
        panelPhenotypes: [],
        phenotypes: [],
        genes: []
      },
      // file
      fromCloud: false,
      cloudFilePaths: [],
      cloudFileCurrentPath: null,
      vcfSets: [{
        vcf: null
      }],
      fileSets: [{
        r1: null,
        r2: null
      }],
      // display
      display: {
        phenotypePanel: false,
        alleleFrequencyThreshold: false,
        scoreThreshold: false
      },
      // loading
      loading: {
        addToSearch: false
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'modal', 'userSetting']), {
    onError: function onError() {
      var _this = this;

      var result = values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
      this.$emit('onError', result);
      return result;
    },
    selectedLimit: function selectedLimit() {
      return {
        phenotypes: values_default()(this.sendData.project.phenotypes || {}).filter(function (x) {
          return x;
        }).reduce(function (s, c) {
          return s + c.length;
        }, 0) >= 30,
        genes: (this.sendData.project.gene_panels || []).length >= 10
      };
    },
    reportDatabaseable: function reportDatabaseable() {
      var _this2 = this;

      return !['analysis'].includes(this.mode) || !this.result['analysis'].report_phenovardb || this.projects.filter(function (project) {
        return _this2.analysisData.id === project.id ? _this2.result['analysis'].report_phenovardb : project.report_phenovardb;
      }).length > 1;
    },

    // options
    userOptions: function userOptions() {
      return this.users.map(function (user) {
        return { title: [user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') + ')' : ''), value: user.id };
      });
    },
    sexOptions: function sexOptions() {
      return [{ title: 'Male' /* ___ */, value: 'Male' }, { title: 'Female' /* ___ */, value: 'Female' }, { title: 'Unknown' /* ___ */, value: 'Unknown' }];
    },
    populationOptions: function populationOptions() {
      return [{ title: 'African/African-American' /* ___ */, value: 'African/African-American' }, { title: 'Latino/Admixed American' /* ___ */, value: 'Latino/Admixed American' }, { title: 'Ashkenazi Jewish' /* ___ */, value: 'Ashkenazi Jewish' }, { title: 'East Asian' /* ___ */, value: 'East Asian' }, { title: 'Koreans' /* ___ */, value: 'Koreans' }, { title: 'Japanese' /* ___ */, value: 'Japanese' }, { title: 'Other East Asian' /* ___ */, value: 'Other East Asian' }, { title: 'Finnish' /* ___ */, value: 'Finnish' }, { title: 'Non-Finnish European' /* ___ */, value: 'Non-Finnish European' }, { title: 'Bulgarian' /* ___ */, value: 'Bulgarian' }, { title: 'Estonian' /* ___ */, value: 'Estonian' }, { title: 'North-Western European' /* ___ */, value: 'North-Western European' }, { title: 'Southern European' /* ___ */, value: 'Southern European' }, { title: 'Swedish' /* ___ */, value: 'Swedish' }, { title: 'Other non-Finnish European' /* ___ */, value: 'Other non-Finnish European' }, { title: 'South Asian' /* ___ */, value: 'South Asian' }, { title: 'Other' /* ___ */, value: 'Other' }];
    },
    omicsOptions: function omicsOptions() {
      return keys_default()(this.omicss.omics || {}).map(function (key) {
        return { title: key, value: key };
      });
    },
    pipelineOptions: function pipelineOptions() {
      var curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {};
      return keys_default()(curOmics.pipeline || {}).map(function (key) {
        return { title: key, value: key };
      });
    },
    libraryTypeOptions: function libraryTypeOptions() {
      var curOmics = (this.omicss.omics || {})[this.result['case'].omics_name] || {};
      var curPipeline = (curOmics.pipeline || {})[this.result['case'].pipeline_name] || {};
      return (curPipeline.library_type || []).map(function (key) {
        return { title: key, value: key };
      });
    },

    // static
    formOptions: function formOptions() {
      var _this3 = this;

      return {
        'field0': [{
          title: 'Owner' /* ___ */
          , value: 'USER_ID',
          type: 'custom',
          grid: {
            'create': 3,
            'edit': 4
          }[this.mode],
          disabled: function disabled() {
            return false;
          },
          validate: 'required'
        }],
        'field1': [{
          title: 'Case ID' /* ___ */
          , value: 'case_id',
          type: {
            'create': 'input',
            'edit': 'input',
            'analysis': 'text'
          }[this.mode],
          grid: 2,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'Case ID';
          } /* ___ */
          , validate: {
            'create': 'required',
            'edit': 'required',
            'analysis': ''
          }[this.mode]
        }, {
          title: 'Sample type' /* ___ */
          , value: 'AFFECTED',
          type: {
            'create': 'custom',
            'edit': 'custom',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          style: {
            'true': { color: '#83C91E' },
            'false': { color: '#999999' }
          }[this.caseData.affected + ''],
          disabled: function disabled() {
            return false;
          },
          inputFormat: function inputFormat() {
            return {
              'true': 'Affected' /* ___ */
              , 'false': 'Unaffected' /* ___ */
            }[_this3.caseData.affected + ''];
          }
        }, {
          title: 'Name' /* ___ */
          , value: 'subject_name',
          type: {
            'create': 'input',
            'edit': 'input',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'John';
          } /* ___ */
        }, {
          title: 'Sex' /* ___ */
          , value: 'sex',
          type: {
            'create': 'select',
            'edit': 'select',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          options: this.sexOptions,
          style: {
            Male: { color: '#003679' },
            Female: { color: '#FA3D3D' },
            Unknown: { color: '#333333' }
          }[this.result['case'].sex],
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'Sex';
          } /* ___ */
          , validate: {
            'create': 'required',
            'edit': 'required',
            'analysis': ''
          }[this.mode]
        }, {
          title: 'Year of Birth' /* ___ */
          , value: 'birth_year',
          type: {
            'create': 'select',
            'edit': 'select',
            'analysis': 'text'
          }[this.mode],
          grid: 1,
          wrap: true,
          options: [{ title: 'Unknown' /* ___ */, value: 'Unknown' }].concat(toConsumableArray_default()(new Array(new Date().getYear() + 1).fill('').map(function (_, i) {
            return { title: i + 1900, value: i + 1900 };
          }).reverse())),
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'Year';
          } /* ___ */
          , validate: {
            'create': 'required',
            'edit': 'required',
            'analysis': ''
          }[this.mode],
          inputFormat: function inputFormat(value) {
            return value || 'Unknown';
          },
          outputFormat: function outputFormat(value) {
            return value && value !== 'Unknown' ? value : undefined;
          }
        }, {
          title: 'Population' /* ___ */
          , value: 'population',
          type: {
            'create': 'select',
            'edit': 'select',
            'analysis': 'text'
          }[this.mode],
          grid: 2,
          wrap: true,
          options: this.populationOptions,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'Population';
          } /* ___ */
        }, {
          title: 'Note' /* ___ */
          , value: 'note',
          type: {
            'create': 'textarea',
            'edit': 'textarea',
            'analysis': 'text'
          }[this.mode],
          grid: 4,
          row: 4,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'Ex: Compassbioinfomatics. Inc';
          } /* ___ */
          , validate: 'max:900'
        }],
        'field2': [{
          title: 'Analysis Name' /* ___ */
          , value: 'name',
          type: 'input',
          grid: 2,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'breast cancer panel';
          } /* ___ */
          , validate: 'required'
        }, {
          title: 'Analysis Note' /* ___ */
          , value: 'note',
          type: 'textarea',
          grid: 3,
          row: 4,
          wrap: true,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'Ex: Compassbioinfomatics. Inc';
          } /* ___ */
          , validate: 'max:300'
        }, {
          title: 'Report to PhenoVarDB' /* ___ */
          , value: 'REPORT_PHENOVARDB',
          type: 'custom',
          grid: 1,
          disabled: function disabled() {
            return false;
          }
        }],
        'field3_1': [{
          title: 'Autosomal dominant (AD)' /* ___ */
          , value: 'ad_cutoff',
          type: 'number',
          errorTitle: 'AD' /* ___ */
          , grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return '0.001';
          } /* ___ */
          , outputFormat: function outputFormat(value) {
            return value || 0.001;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: 'Autosomal recessive (AR)' /* ___ */
          , value: 'ar_cutoff',
          type: 'number',
          errorTitle: 'AR' /* ___ */
          , grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return '0.05';
          } /* ___ */
          , outputFormat: function outputFormat(value) {
            return value || 0.05;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: 'Compound heterozygosity' /* ___ */
          , value: 'comp_het_cutoff',
          type: 'number',
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return '0.05';
          } /* ___ */
          , outputFormat: function outputFormat(value) {
            return value || 0.05;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: 'Exclude LQ variants' /* ___ */
          , value: 'exclude_low_quality_variants',
          type: 'boolean',
          grid: 2,
          inputFormat: function inputFormat(value) {
            return ![undefined, null].includes(value) ? value : false;
          }
        }, {
          title: 'Lower priority for known benign variants' /* ___ */
          , value: 'enable_clinvar_benign_filter',
          type: 'boolean',
          grid: 2,
          inputFormat: function inputFormat(value) {
            return ![undefined, null].includes(value) ? value : true;
          }
        }, {}],
        'field3_2': [{
          title: 'Phenotype score' /* ___ */
          , value: 'phenotype_score_cutoff',
          type: 'number',
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return '0.3';
          } /* ___ */
          , outputFormat: function outputFormat(value) {
            return (value || 0.3) - 0;
          },
          validate: 'min_value:0|max_value:1'
        }, {
          title: 'Variant score' /* ___ */
          , value: 'variant_score_cutoff',
          type: 'number',
          grid: 2,
          inputWidth: '126px',
          step: 0.01,
          placeholder: function placeholder() {
            return '0.7';
          } /* ___ */
          , outputFormat: function outputFormat(value) {
            return (value || 0.7) - 0;
          },
          validate: 'min_value:0.6|max_value:1'
        }, {}],
        'field4': [{
          title: 'Pipeline' /* ___ */
          , errorTitle: 'Omics' /* ___ */
          , value: 'omics_name',
          type: 'select',
          grid: 1,
          options: this.omicsOptions,
          placeholder: function placeholder() {
            return 'Omics';
          } /* ___ */
          , validate: values_default()(this.fileSets[0]).some(function (file) {
            return file;
          }) ? 'required' : ''
        }, {
          title: '　' /* ___ */
          , errorTitle: 'Pipeline' /* ___ */
          , value: 'pipeline_name',
          type: 'select',
          grid: 2,
          options: this.pipelineOptions,
          placeholder: function placeholder() {
            return 'Types, eg: WGS';
          } /* ___ */
          , display: function display(result) {
            return result.omics_name;
          },
          validate: values_default()(this.fileSets[0]).some(function (file) {
            return file;
          }) ? 'required' : ''
        }, {
          title: '　' /* ___ */
          , errorTitle: 'Library type' /* ___ */
          , value: 'library_type_name',
          type: 'select',
          grid: 3,
          options: this.libraryTypeOptions,
          placeholder: function placeholder() {
            return 'Library kit eg: Roche KAPA HyperExome kit';
          } /* ___ */
          , display: function display(result) {
            return result.pipeline_name;
          }
        }]
      };
    },

    // global
    priceMap: function priceMap() {
      return global_data["r" /* priceMap */];
    },
    fileTypeCheck: function fileTypeCheck() {
      return util["f" /* fileTypeCheck */];
    },

    // unload alert
    sendData: function sendData() {
      var caseData = {
        dataset: this.dataset
      };
      var projectData = {};
      if (this.layoutBlocks.includes('form')) {
        caseData = extends_default()({}, caseData, this.result['case'], {
          affected: this.result['case'].affected || false
        });
        delete caseData.AFFECTED;
        delete caseData.USER_ID;
      }
      if (this.layoutBlocks.includes('analysis')) {
        // analysis
        projectData = extends_default()({}, projectData, this.result['analysis'], {
          report_phenovardb: this.result['analysis'].report_phenovardb || false
        });
        delete projectData.REPORT_PHENOVARDB;
        // phenotype
        var selectedPhenotypes = [].concat(toConsumableArray_default()(this.selectedPhenotypes['panelPhenotypes']), toConsumableArray_default()(this.selectedPhenotypes['phenotypes']));
        if (selectedPhenotypes.length) {
          var phenotypes = Object(util["i" /* groupBy */])(Object(util["i" /* groupBy */])(selectedPhenotypes, function (phenotype) {
            return phenotype.id;
          }).map(function (group) {
            return group[0];
          }), function (phenotype) {
            return phenotype.type;
          }, true);
          phenotypes.hpo = phenotypes.hpo ? phenotypes.hpo.map(function (hpo) {
            return {
              hpo_id: hpo.id,
              hpo_name: hpo.name,
              query: hpo.query
            };
          }) : phenotypes.hpo;
          phenotypes.disease_term = phenotypes.disease_term ? phenotypes.disease_term.map(function (disease) {
            return {
              disease_id: disease.id,
              disease_name: disease.name,
              query: disease.query
            };
          }) : phenotypes.disease_term;
          projectData.phenotypes = phenotypes;
        }
        // gene panel
        var selectedGenes = this.selectedPhenotypes['genes'];
        if (selectedGenes.length) {
          var genePanels = [];
          genePanels = selectedGenes.map(function (gene) {
            return {
              name: gene.name,
              data: gene.data,
              category: gene.category
            };
          });
          projectData.gene_panels = genePanels;
        }
      }
      caseData = extends_default()({}, caseData, {
        project: projectData
      });
      return caseData;
    },
    sendFileSets: function sendFileSets() {
      var fileSets = {
        vcf: this.vcfSets.filter(function (set) {
          return set.vcf;
        }),
        fastq: this.fileSets.filter(function (set) {
          return set.r1 && set.r2;
        })
      }[this.dataset];
      return fileSets;
    }
  }),
  watch: {
    'defaultData': function defaultData() {
      var _this4 = this;

      this.init();
      setTimeout(function () {
        return _this4.$emit('unloadAlert', false);
      });
    },

    // unload alert
    'sendData': function sendData(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.$emit('unloadAlert', true);
      }
    },
    'sendFileSets': function sendFileSets(nv, ov) {
      if (stringify_default()(nv) !== stringify_default()(ov)) {
        this.$emit('unloadAlert', true);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction', 'setModal2Action', 'setLoadingAction', 'setUserSettingAction']), {
    preSetData: function preSetData() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.init();

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    fetchData: function fetchData() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!['supervisor'].includes(_this6.user.role)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this6.fetchCloudFilePaths();

              case 3:
                if (!(['supervisor', 'manager'].includes(_this6.user.role) && ['create', 'edit'].includes(_this6.mode))) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return _this6.fetchManagedUsers();

              case 6:
                _context2.next = 8;
                return _this6.fetchOmicss();

              case 8:
                _context2.next = 10;
                return _this6.fetchPhenotypePanels();

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    fetchCloudFilePaths: function fetchCloudFilePaths() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, response, cloudFilePaths;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this7.$ls.get('userInfo');
                _context3.next = 4;
                return Object(src_api["J" /* getCloudFilePaths */])(config);

              case 4:
                response = _context3.sent;
                cloudFilePaths = response.data.data;

                _this7.cloudFilePaths = cloudFilePaths;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 9]]);
      }))();
    },
    fetchManagedUsers: function fetchManagedUsers() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, response, users;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this8.$ls.get('userInfo');
                _context4.next = 4;
                return Object(src_api["_18" /* getManagedUsers */])(config);

              case 4:
                response = _context4.sent;
                users = response.data.data;

                _this8.users = users;
                _this8.caseData = extends_default()({}, _this8.caseData, {
                  user_id: _this8.caseData.user ? _this8.caseData.user.id : users[0].id
                });
                _this8.result['case'].user_id = _this8.caseData.user_id;
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0;

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[0, 11]]);
      }))();
    },
    fetchOmicss: function fetchOmicss() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, response, omicss;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this9.$ls.get('userInfo');
                _context5.next = 4;
                return Object(src_api["_22" /* getOmicss */])(config);

              case 4:
                response = _context5.sent;
                omicss = response.data.data;

                _this9.omicss = omicss;
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0;

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9, [[0, 9]]);
      }))();
    },
    fetchPhenotypePanels: function fetchPhenotypePanels() {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var config, response, phenotypePanels;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                config = _this10.$ls.get('userInfo');
                _context6.next = 4;
                return Object(src_api["_24" /* getPhenotypePanels */])(config);

              case 4:
                response = _context6.sent;
                phenotypePanels = response.data.data;

                _this10.phenotypePanels = phenotypePanels.map(function (panel) {
                  return extends_default()({}, panel, {
                    phenotypes: [].concat(toConsumableArray_default()(panel.hpo.map(function (phenotype) {
                      return {
                        id: phenotype.hpo_id,
                        name: phenotype.hpo_name,
                        query: phenotype.hpo_id + ' ' + phenotype.hpo_name,
                        panel: panel,
                        type: 'hpo'
                      };
                    })), toConsumableArray_default()(panel.disease_term.map(function (phenotype) {
                      return {
                        id: phenotype.disease_id,
                        name: phenotype.disease_name,
                        query: phenotype.disease_id + ' ' + phenotype.disease_name,
                        panel: panel,
                        type: 'disease_term'
                      };
                    })))
                  });
                });
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0;

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[0, 9]]);
      }))();
    },
    fetchSubData: function fetchSubData(funcs) {
      var _this11 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref4, index, func;

        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                funcs = funcs || ['fetchGenePanelDivisions', 'fetchGenePanels'];
                _this11.setLoadingAction(true);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context7.prev = 5;
                _iterator = get_iterator_default()(entries_default()(funcs));

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context7.next = 23;
                  break;
                }

                _ref3 = _step.value;
                _ref4 = slicedToArray_default()(_ref3, 2);
                index = _ref4[0];
                func = _ref4[1];
                _context7.prev = 12;
                _context7.next = 15;
                return _this11[func](params[index] || params[0]);

              case 15:
                _context7.next = 20;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7['catch'](12);

                _this11.addToast('error', !_context7.t0.response ? _context7.t0.message : _context7.t0.response.data.result.message);

              case 20:
                _iteratorNormalCompletion = true;
                _context7.next = 7;
                break;

              case 23:
                _context7.next = 29;
                break;

              case 25:
                _context7.prev = 25;
                _context7.t1 = _context7['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context7.t1;

              case 29:
                _context7.prev = 29;
                _context7.prev = 30;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 32:
                _context7.prev = 32;

                if (!_didIteratorError) {
                  _context7.next = 35;
                  break;
                }

                throw _iteratorError;

              case 35:
                return _context7.finish(32);

              case 36:
                return _context7.finish(29);

              case 37:
                _this11.setLoadingAction(false);

              case 38:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this11, [[5, 25, 29, 37], [12, 17], [30,, 32, 36]]);
      }))();
    },
    fetchGenePanelDivisions: function fetchGenePanelDivisions() {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var config, response, divisions;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                config = _this12.$ls.get('userInfo');
                _context8.next = 4;
                return Object(src_api["_13" /* getGenePanelDivisions */])(config);

              case 4:
                response = _context8.sent;
                divisions = response.data.data;

                _this12.divisions = divisions;
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);
                throw _context8.t0;

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this12, [[0, 9]]);
      }))();
    },
    fetchGenePanels: function fetchGenePanels() {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var config, params, response, genePanels;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                config = _this13.$ls.get('userInfo');
                params = {};
                _context9.next = 5;
                return Object(src_api["_16" /* getGenePanels */])(params, config);

              case 5:
                response = _context9.sent;
                genePanels = response.data.data;

                genePanels = genePanels.map(function (panel) {
                  return extends_default()({}, panel, {
                    count: [(panel.data['free_typing'] || []).length, (panel.data['user_defined'] || []).length, (panel.data['panel'] || []).reduce(function (s, panelData) {
                      return s + panelData.data.length;
                    }, 0), (panel.data['hpo'] || []).reduce(function (s, panelData) {
                      return s + panelData.data.length;
                    }, 0), (panel.data['condition'] || []).reduce(function (s, panelData) {
                      return s + panelData.data.length;
                    }, 0)].reduce(function (s, c) {
                      return s + c;
                    }, 0)
                  });
                });
                _this13.genePanels = genePanels;
                _context9.next = 14;
                break;

              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9['catch'](0);
                throw _context9.t0;

              case 14:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this13, [[0, 11]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this14 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                setTimeout(function () {
                  return _this14.$emit('unloadAlert', false);
                });

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this14);
      }))();
    },
    init: function init() {
      this.caseData = extends_default()({}, this.caseData, this.defaultData['case'] || {}, {
        affected: ![null, undefined].includes(this.defaultData['case'].affected) ? this.defaultData['case'].affected : true
      });
      this.result['case'] = extends_default()({}, this.result['case'], {
        affected: this.caseData.affected
      });
      this.analysisData = extends_default()({}, this.analysisData, this.defaultData['analysis'] || {});
      this.result['analysis'] = extends_default()({}, this.result['analysis'], {
        report_phenovardb: this.analysisData.report_phenovardb
      });
      this.analysisData.name = this.analysisData.name || 'Analysis-' + Object(util["d" /* dateFormat */])(new Date(), 'yyyyMMdd');
      this.initPhenotype();
    },
    initPhenotype: function initPhenotype(analysisData) {
      analysisData = analysisData || this.analysisData;
      var phenotypes = this.analysisData.phenotypes ? [].concat(toConsumableArray_default()((this.analysisData.phenotypes.hpo || []).map(function (hpo) {
        return {
          id: hpo.hpo_id,
          name: hpo.hpo_name,
          query: hpo.query,
          type: 'hpo'
        };
      })), toConsumableArray_default()((this.analysisData.phenotypes.disease_term || []).map(function (disease) {
        return {
          id: disease.disease_id,
          name: disease.disease_name,
          query: disease.query,
          type: 'disease_term'
        };
      }))) : [];
      !this.searchedPhenotypes['phenotypes'].length && (this.searchedPhenotypes['phenotypes'] = [].concat(toConsumableArray_default()(phenotypes || [])));
      !this.selectedPhenotypes['phenotypes'].length && (this.selectedPhenotypes['phenotypes'] = [].concat(toConsumableArray_default()(phenotypes || [])));
      var genes = analysisData.gene_panels || [];
      !this.searchedPhenotypes['genes'].length && (this.searchedPhenotypes['genes'] = [].concat(toConsumableArray_default()(genes || [])));
      !this.selectedPhenotypes['genes'].length && (this.selectedPhenotypes['genes'] = [].concat(toConsumableArray_default()(genes || [])));
    },
    getPhenotypes: function getPhenotypes(query) {
      var _this15 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!((_this15.tagData.tag['phenotypes'] || { datas: [] }).datas || []).includes(query)) {
                  if (_this15.tagData.searchTimer['phenotype']) {
                    clearTimeout(_this15.tagData.searchTimer['phenotype']);
                  }
                  _this15.tagData.searchTimer['phenotype'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                    var config, response, phenotypes;
                    return regenerator_default.a.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            if (!(!_this15.tagData.map['phenotype'][query] && query)) {
                              _context11.next = 13;
                              break;
                            }

                            _context11.prev = 1;
                            config = _this15.$ls.get('userInfo');
                            _context11.next = 5;
                            return Object(src_api["_40" /* getSearchPhenotype */])(query, config);

                          case 5:
                            response = _context11.sent;
                            phenotypes = response.data.data;

                            _this15.tagData.map['phenotype'] = extends_default()({}, _this15.tagData.map['phenotype'], defineProperty_default()({}, query, {
                              info: phenotypes,
                              datas: [].concat(toConsumableArray_default()(phenotypes.hpo.data.map(function (data) {
                                return extends_default()({}, data, { type: 'hpo' });
                              })), toConsumableArray_default()(phenotypes.disease_term.data.map(function (data) {
                                return extends_default()({}, data, { type: 'disease_term' });
                              })))
                            }));
                            _context11.next = 13;
                            break;

                          case 10:
                            _context11.prev = 10;
                            _context11.t0 = _context11['catch'](1);

                            _this15.addToast('error', !_context11.t0.response ? _context11.t0.message : _context11.t0.response.data.result.message);

                          case 13:
                            _this15.tagData.tag['phenotypes'] = _this15.tagData.map['phenotype'][query] || {};

                          case 14:
                          case 'end':
                            return _context11.stop();
                        }
                      }
                    }, _callee11, _this15, [[1, 10]]);
                  })), 200);
                }

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    getGenes: function getGenes(query) {
      var _this16 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee14() {
        return regenerator_default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if ((_this16.tagData.curTag['gene'] || {}).name !== query) {
                  _this16.tagData.tag['genes'] = {};
                  if (_this16.tagData.searchTimer['gene']) {
                    clearTimeout(_this16.tagData.searchTimer['gene']);
                  }
                  _this16.tagData.searchTimer['gene'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
                    var config, response, genes;
                    return regenerator_default.a.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            if (!(!_this16.tagData.map['gene'][query] && query)) {
                              _context13.next = 15;
                              break;
                            }

                            _this16.setLoadingAction(true);
                            _context13.prev = 2;
                            config = _this16.$ls.get('userInfo');
                            _context13.next = 6;
                            return Object(src_api["_39" /* getSearchGeneEntry */])(query, config);

                          case 6:
                            response = _context13.sent;
                            genes = response.data.data;

                            _this16.tagData.map['gene'] = extends_default()({}, _this16.tagData.map['gene'], defineProperty_default()({}, query, {
                              info: genes,
                              datas: [].concat(toConsumableArray_default()(genes.gene.data.map(function (data) {
                                return extends_default()({}, data, { type: 'gene' });
                              })), toConsumableArray_default()(genes.panel.data.map(function (data) {
                                return extends_default()({}, data, { type: 'panel' });
                              })), toConsumableArray_default()(genes.hpo.data.map(function (data) {
                                return extends_default()({}, data, { type: 'hpo' });
                              })), toConsumableArray_default()(genes.condition.data.map(function (data) {
                                return extends_default()({}, data, { type: 'condition' });
                              })))
                            }));
                            _context13.next = 14;
                            break;

                          case 11:
                            _context13.prev = 11;
                            _context13.t0 = _context13['catch'](2);

                            _this16.addToast('error', !_context13.t0.response ? _context13.t0.message : _context13.t0.response.data.result.message);

                          case 14:
                            _this16.setLoadingAction(false);

                          case 15:
                            _this16.tagData.tag['genes'] = _this16.tagData.map['gene'][query] || {};

                          case 16:
                          case 'end':
                            return _context13.stop();
                        }
                      }
                    }, _callee13, _this16, [[2, 11]]);
                  })), 500);
                }

              case 1:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this16);
      }))();
    },
    addToSearch: function addToSearch(type, data) {
      var _this17 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee15() {
        var ary, phenotypeID, phenotypeName, phenotypeType, phenotype, symbols, gene, oldData, panel, symbolTransform, _symbols, _gene, _oldData, _symbols2, _gene2, _oldData2, _symbols3, _gene3, _oldData3;

        return regenerator_default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.t0 = type;
                _context15.next = _context15.t0 === 'phenotype' ? 3 : _context15.t0 === 'gene' ? 12 : 51;
                break;

              case 3:
                if (!(_this17.tagData.tag['phenotypes'].datas || []).some(function (tag) {
                  return tag.query === _this17.tagData.query['phenotype'];
                })) {
                  data = _this17.tagData.tag['phenotypes'].datas[0].query;
                }
                ary = data.split(' ');
                phenotypeID = ary.splice(0, 1)[0];
                phenotypeName = ary.join(' ');
                phenotypeType = phenotypeID.startsWith('HP:') ? 'hpo' : 'disease_term';
                phenotype = {
                  id: phenotypeID,
                  name: phenotypeName,
                  type: phenotypeType,
                  query: phenotypeID + ' ' + phenotypeName
                };

                if (!_this17.searchedPhenotypes['phenotypes'].some(function (p) {
                  return p.id === phenotype.id;
                })) {
                  _this17.searchedPhenotypes['phenotypes'].push(phenotype);
                  if (!_this17.selectedLimit['phenotypes']) {
                    _this17.selectedPhenotypes['phenotypes'].push(phenotype);
                  }
                } else {
                  _this17.addToast('error', 'You have added a HPO term with the same HPO identity.' /* ___ */);
                }
                _this17.tagData.query['phenotype'] = '';
                return _context15.abrupt('break', 51);

              case 12:
                data = data.type ? data : (_this17.tagData.map['gene'][_this17.tagData.query['gene']] || { datas: [] }).datas[0];

                if (!(data && !_this17.loading['addToSearch'])) {
                  _context15.next = 50;
                  break;
                }

                _this17.loading['addToSearch'] = true;
                _context15.t1 = data.type;
                _context15.next = _context15.t1 === 'gene' ? 18 : _context15.t1 === 'panel' ? 25 : _context15.t1 === 'hpo' ? 34 : _context15.t1 === 'condition' ? 41 : 48;
                break;

              case 18:
                _context15.next = 20;
                return _this17.getGeneSymbols(data.type, data.gene_id);

              case 20:
                symbols = _context15.sent;
                gene = {
                  name: data.symbol,
                  category: data.type,
                  data: symbols
                };
                oldData = _this17.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === gene.name;
                });

                if (!oldData) {
                  _this17.searchedPhenotypes['genes'].push(gene);
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(gene);
                  }
                } else if (oldData.checked === false) {
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(oldData);
                  }
                }
                return _context15.abrupt('break', 48);

              case 25:
                _context15.next = 27;
                return _this17.getGenePanel(data.id);

              case 27:
                panel = _context15.sent;

                symbolTransform = function symbolTransform(symbols) {
                  return symbols.reduce(function (s, c) {
                    return extends_default()({}, s, defineProperty_default()({}, c.gene_id, c));
                  }, {});
                };

                _symbols = values_default()(extends_default()({}, symbolTransform(panel.data['free_typing'] || []), symbolTransform(panel.data['user_defined'] || []), symbolTransform(Array.prototype.concat.apply([], (panel.data['panel'] || []).map(function (panel) {
                  return panel.data;
                }))), symbolTransform(Array.prototype.concat.apply([], (panel.data['hpo'] || []).map(function (panel) {
                  return panel.data;
                }))), symbolTransform(Array.prototype.concat.apply([], (panel.data['condition'] || []).map(function (panel) {
                  return panel.data;
                }))))).filter(function (data) {
                  return data.checked;
                });
                _gene = {
                  name: panel.name,
                  category: data.type,
                  data: _symbols
                };
                _oldData = _this17.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === _gene.name;
                });

                if (!_oldData) {
                  _this17.searchedPhenotypes['genes'].push(_gene);
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(_gene);
                  }
                } else {
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(_oldData);
                  }
                }
                return _context15.abrupt('break', 48);

              case 34:
                _context15.next = 36;
                return _this17.getGeneSymbols(data.type, data.name);

              case 36:
                _symbols2 = _context15.sent;
                _gene2 = {
                  name: data.name,
                  category: data.type,
                  data: _symbols2
                };
                _oldData2 = _this17.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === _gene2.name;
                });

                if (!_oldData2) {
                  _this17.searchedPhenotypes['genes'].push(_gene2);
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(_gene2);
                  }
                } else if (_oldData2.checked === false) {
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(_oldData2);
                  }
                }
                return _context15.abrupt('break', 48);

              case 41:
                _context15.next = 43;
                return _this17.getGeneSymbols(data.type, data.name);

              case 43:
                _symbols3 = _context15.sent;
                _gene3 = {
                  name: data.name,
                  category: data.type,
                  data: _symbols3
                };
                _oldData3 = _this17.searchedPhenotypes['genes'].find(function (g) {
                  return g.name === _gene3.name;
                });

                if (!_oldData3) {
                  _this17.searchedPhenotypes['genes'].push(_gene3);
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(_gene3);
                  }
                } else if (_oldData3.checked === false) {
                  if (!_this17.selectedLimit['genes']) {
                    _this17.selectedPhenotypes['genes'].push(_oldData3);
                  }
                }
                return _context15.abrupt('break', 48);

              case 48:
                _this17.tagData.query['gene'] = '';
                _this17.loading['addToSearch'] = false;

              case 50:
                return _context15.abrupt('break', 51);

              case 51:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this17);
      }))();
    },
    getGeneSymbols: function getGeneSymbols(type, query) {
      var _this18 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee16() {
        var config, api, response, symbols;
        return regenerator_default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                config = _this18.$ls.get('userInfo');
                api = {
                  gene: src_api["_15" /* getGenePanelSymbol */],
                  hpo: src_api["_14" /* getGenePanelHpo */],
                  condition: src_api["_12" /* getGenePanelCondition */]
                }[type];
                _context16.next = 5;
                return api(query, config);

              case 5:
                response = _context16.sent;
                symbols = response.data.data;

                symbols = symbols.map(function (symbol) {
                  return extends_default()({}, symbol, {
                    checked: true,
                    date: new Date()
                  });
                });
                return _context16.abrupt('return', symbols);

              case 11:
                _context16.prev = 11;
                _context16.t0 = _context16['catch'](0);

                _this18.addToast('error', !_context16.t0.response ? _context16.t0.message : _context16.t0.response.data.result.message);
                return _context16.abrupt('return', null);

              case 15:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this18, [[0, 11]]);
      }))();
    },
    getGenePanel: function getGenePanel(id) {
      var _this19 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee17() {
        var config, response, panel;
        return regenerator_default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                config = _this19.$ls.get('userInfo');
                _context17.next = 4;
                return Object(src_api["_11" /* getGenePanel */])(id, config);

              case 4:
                response = _context17.sent;
                panel = response.data.data;
                return _context17.abrupt('return', panel);

              case 9:
                _context17.prev = 9;
                _context17.t0 = _context17['catch'](0);

                _this19.addToast('error', !_context17.t0.response ? _context17.t0.message : _context17.t0.response.data.result.message);
                return _context17.abrupt('return', null);

              case 13:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this19, [[0, 9]]);
      }))();
    },
    addToPanel: function addToPanel(phenotype) {
      var _this20 = this;

      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      action({
        action: 'addToPanel',
        width: '468px',
        param: {
          phenotype: phenotype,
          panels: this.phenotypePanels
        },
        callback: function () {
          var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee18(result) {
            return regenerator_default.a.wrap(function _callee18$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                    if (!result) {
                      _context18.next = 3;
                      break;
                    }

                    _context18.next = 3;
                    return _this20.fetchPhenotypePanels();

                  case 3:
                  case 'end':
                    return _context18.stop();
                }
              }
            }, _callee18, _this20);
          }));

          return function callback(_x2) {
            return _ref7.apply(this, arguments);
          };
        }()
      });
    },
    openGenePanelDataSelect: function openGenePanelDataSelect(data) {
      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      action({
        action: 'genePanelDataSelect',
        width: '1208px',
        param: {
          data: data
        }
      });
    },
    openGenePanelSearch: function openGenePanelSearch() {
      var _this21 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee20() {
        var action;
        return regenerator_default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (_this21.genePanels.length && _this21.divisions.length) {
                  _context20.next = 3;
                  break;
                }

                _context20.next = 3;
                return _this21.fetchSubData();

              case 3:
                action = _this21.modal.action ? _this21.setModal2Action : _this21.setModalAction;

                action({
                  action: 'genePanelQuickSelection',
                  width: '1208px',
                  customStyles: {
                    'max-height': 'calc(100% - 160px)'
                  },
                  param: {
                    datas: _this21.genePanels,
                    divisions: _this21.divisions
                  },
                  callback: function () {
                    var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee19(result) {
                      return regenerator_default.a.wrap(function _callee19$(_context19) {
                        while (1) {
                          switch (_context19.prev = _context19.next) {
                            case 0:
                              if (!result) {
                                _context19.next = 3;
                                break;
                              }

                              _context19.next = 3;
                              return _this21.addToSearch('gene', {
                                type: 'panel',
                                id: result - 0
                              });

                            case 3:
                            case 'end':
                              return _context19.stop();
                          }
                        }
                      }, _callee19, _this21);
                    }));

                    return function callback(_x3) {
                      return _ref8.apply(this, arguments);
                    };
                  }()
                });

              case 5:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this21);
      }))();
    },
    onEvent: function onEvent(e, c) {
      if (['tag', 'send'].includes(e)) {
        if (c && c !== 'all') {
          var id = c.id || (this.users.find(function (user) {
            return c === [user.first_name, user.last_name].filter(function (x) {
              return x;
            }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
              return x;
            }).join(' ') + ')' : '');
          }) || {}).id;
          this.result['case'].user_id = id || this.result['case'].user_id;
          this.caseData = extends_default()({}, this.caseData, {
            user_id: this.result['case'].user_id
          });
        } else {
          this.result['case'].user_id = -1;
        }
      }
    },
    initFile: function initFile() {
      this.vcfSets = [{
        vcf: null
      }];
      this.fileSets = [{
        r1: null,
        r2: null
      }];
    },
    selectFile: function selectFile(e, set, target) {
      set[target] = e.target.files[0];
    },
    openFileCloud: function openFileCloud(set, target) {
      var _this22 = this;

      var action = this.modal.action ? this.setModal2Action : this.setModalAction;
      var selectedPaths = Array.prototype.concat.apply([], (target === 'vcf' ? this.vcfSets : this.fileSets).map(function (set) {
        return values_default()(set).map(function (file) {
          return (file || {}).path;
        }).filter(function (x) {
          return x;
        });
      }));
      selectedPaths = selectedPaths.filter(function (path) {
        return path !== (set[target] || {}).path;
      });
      action({
        action: 'fileCloud',
        width: '616px',
        param: {
          type: 'single',
          options: {
            checkbox: false
          },
          fileTypes: ['fastq', 'fq', 'fastq.gz', 'fq.gz'],
          paths: this.cloudFilePaths,
          currentPath: set[target] ? set[target].path : this.cloudFileCurrentPath || this.userSetting.cloudspace_browse_path || '',
          disabledPaths: selectedPaths,
          defaultSelectedPaths: set[target] ? [set[target].path] : [],
          functions: {
            saveCurrentPath: function saveCurrentPath(path) {
              return _this22.saveCurrentPath(path);
            }
          }
        },
        callback: function () {
          var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee21(result) {
            var path, contentTypeMap;
            return regenerator_default.a.wrap(function _callee21$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    if (result) {
                      path = result[0];
                      contentTypeMap = {
                        gz: 'application/x-gzip',
                        vcf: 'text/directory'
                      };

                      set[target] = {
                        name: path.split('/').reverse()[0],
                        type: contentTypeMap[path.split('.').reverse(0)[0]] || 'text/plain',
                        path: path
                      };
                    }

                  case 1:
                  case 'end':
                    return _context21.stop();
                }
              }
            }, _callee21, _this22);
          }));

          return function callback(_x4) {
            return _ref9.apply(this, arguments);
          };
        }()
      });
    },
    saveCurrentPath: function saveCurrentPath(path) {
      var _this23 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee22() {
        var config, folderPath, data, response, userSettings;
        return regenerator_default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                config = _this23.$ls.get('userInfo');
                folderPath = path.replace(/\/(?!.*\/).*$/, '');
                data = {
                  cloudspace_browse_path: folderPath
                };
                _context22.next = 6;
                return Object(src_api["_100" /* putUserSettings */])(data, config);

              case 6:
                response = _context22.sent;
                userSettings = response.data.data;

                _this23.cloudFileCurrentPath = response.data.data.cloudspace_browse_path;
                _this23.setUserSettingAction(userSettings);
                _context22.next = 15;
                break;

              case 12:
                _context22.prev = 12;
                _context22.t0 = _context22['catch'](0);

                _this23.addToast('error', !_context22.t0.response ? _context22.t0.message : _context22.t0.response.data.result.message);

              case 15:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this23, [[0, 12]]);
      }))();
    },
    formOnChange: function formOnChange(key, field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result[key] = extends_default()({}, this.result[key], result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(cols || keys_default()(this.caseData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var col = _step2.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    fileValidate: function fileValidate() {
      if (values_default()(this.fileSets[this.fileSets.length - 1]).filter(function (file) {
        return file;
      }).length !== 1) {
        return true;
      } else {
        this.addToast('error', 'The data should be paired, please check you file numbers.' /* ___ */);
        return false;
      }
    },
    validateSubmit: function validateSubmit() {
      var _this24 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee23() {
        var result, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, kv;

        return regenerator_default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                result = {};

                _this24.onSubmit = true;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context23.prev = 5;
                _iterator3 = get_iterator_default()(entries_default()(_this24.validate));

              case 7:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context23.next = 15;
                  break;
                }

                kv = _step3.value;
                _context23.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context23.sent;

              case 12:
                _iteratorNormalCompletion3 = true;
                _context23.next = 7;
                break;

              case 15:
                _context23.next = 21;
                break;

              case 17:
                _context23.prev = 17;
                _context23.t0 = _context23['catch'](5);
                _didIteratorError3 = true;
                _iteratorError3 = _context23.t0;

              case 21:
                _context23.prev = 21;
                _context23.prev = 22;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 24:
                _context23.prev = 24;

                if (!_didIteratorError3) {
                  _context23.next = 27;
                  break;
                }

                throw _iteratorError3;

              case 27:
                return _context23.finish(24);

              case 28:
                return _context23.finish(21);

              case 29:
                result['file'] = !_this24.layoutBlocks.includes('file') || _this24.fileValidate();

                if (values_default()(result).includes(false)) {
                  _context23.next = 32;
                  break;
                }

                return _context23.abrupt('return', true);

              case 32:
                _this24.onSubmit = false;

              case 33:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this24, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    submit: function submit() {
      var _this25 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee24() {
        var data, fileSets;
        return regenerator_default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                data = _this25.sendData;
                fileSets = _this25.sendFileSets;
                return _context24.abrupt('return', { data: data, fileSets: fileSets, users: _this25.users });

              case 3:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this25);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8721b33a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/base.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-base-page col-block width-full"},[(_vm.layoutBlocks.includes('form'))?[_c('div',{staticClass:"form-container col-block width-full"},[((['create'].includes(_vm.mode) && ['supervisor', 'manager'].includes(_vm.user.role)) || (['edit'].includes(_vm.mode) && ['supervisor'].includes(_vm.user.role)))?_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":{
            'create': 6,
            'edit': 4
          }[this.mode],"alerts":_vm.alerts,"forms":_vm.formOptions['field0'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('case', 'field0', result, validate, errors); }},scopedSlots:_vm._u([{key:"USER_ID",fn:function(props){return [_c('div',{staticClass:"input-group",style:({ width: '100%', padding: 0 }),attrs:{"name":props}},[_c('inputTag',{style:({
                  width: '100%'
                }),attrs:{"inputStyle":{
                  'padding-right': '40px'
                },"init":(_vm.userOptions.find(function (option) { return option.value === _vm.result['case'].user_id; }) || {}).title,"emptyDisplay":true,"disabled":false,"placeholder":'all',"tags":_vm.users,"prefix":'(?:^)',"target":'^(.*?)$',"replace":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); },"filter":function (content) { return function (user) { return content && ([user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : '')).match(new RegExp(content.replace(/(\(|\)|\[|\]|\{|\}|\\)/g, '\\$1'), 'i')); }; },"tagDisplay":function (user) { return [user.first_name, user.last_name].filter(function (x) { return x; }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) { return x; }).join(' ') + ')' : ''); }},on:{"send":function (content) { return _vm.onEvent('send', content); },"tag":function (content) { return _vm.onEvent('tag', content); }}})],1)]}}])})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":{
            'create': 6,
            'edit': 4,
            'analysis': 6
          }[this.mode],"alerts":_vm.alerts,"forms":_vm.formOptions['field1'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('case', 'field1', result, validate, errors); }},scopedSlots:_vm._u([{key:"AFFECTED",fn:function(props){return [(props.form.type === 'custom')?_c('div',{staticClass:"AFFECTED-block row-block flex-start",attrs:{"name":props}},[_c('div',{staticClass:"AFFECTED-title"},[_vm._v(_vm._s('Affected'/* ___ */))]),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"checked":_vm.caseData.affected},on:{"input":function (c) { return _vm.result['case'].affected = c; }}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1):_vm._e()]}}])})],1)])]:_vm._e(),_vm._v(" "),(_vm.layoutBlocks.includes('analysis'))?[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-container col-block width-full"},[_c('div',{staticClass:"analysis-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field2'],"scope":'test',"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('analysis', 'field2', result, validate, errors); }},scopedSlots:_vm._u([{key:"REPORT_PHENOVARDB",fn:function(props){return [_c('div',{staticClass:"REPORT_PHENOVARDB-block row-block flex-start",attrs:{"name":props}},[_c('div',{staticClass:"REPORT_PHENOVARDB-title"},[_vm._v(_vm._s('Off'/* ___ */))]),_vm._v(" "),_c('switchButton',{attrs:{"disabled":!_vm.reportDatabaseable,"checked":_vm.analysisData.report_phenovardb,"customStyle":{
                  cursor: 'pointer'
                }},on:{"click":function (e) { return !_vm.reportDatabaseable && _vm.addToast('error', 'At least one card should be left open.'/* ___ */); },"input":function (c) { return _vm.result['analysis'].report_phenovardb = c; }}}),_vm._v(" "),_c('div',{staticClass:"REPORT_PHENOVARDB-title active"},[_vm._v(_vm._s('On'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]}}])}),_vm._v(" "),(_vm.isUpdate)?_vm._t('analysis-update',null,{data:_vm.sendData}):_vm._e()],2),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-block col-block width-full"},[_vm._t('analysis-import',null,{data:_vm.sendData}),_vm._v(" "),_c('div',{staticClass:"analysis-title-container row-block"},[_c('div',{staticClass:"analysis-title main"},[_vm._v(_vm._s('Phenotype prioritization'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"phenotype-panel-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.phenotypePanel },on:{"click":function (e) { return _vm.display.phenotypePanel = !_vm.display.phenotypePanel; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s('Phenotype Panel'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.phenotypePanel),expression:"display.phenotypePanel"}],staticClass:"phenotype-panel-block block-content col-block width-full"},[_c('div',{style:({ height: '10px' })}),_vm._v(" "),(_vm.phenotypePanels.length)?_vm._l((_vm.phenotypePanels),function(panel,pindex){return _c('div',{key:pindex,staticClass:"panel-group col-block flex-start"},[_c('div',{staticClass:"item-container row-block",on:{"click":function (e) {
                      _vm.selectedPhenotypes['panelPhenotypes'] =
                        _vm.selectedPhenotypes['panelPhenotypes'].some(function (phenotype) { return phenotype.panel.id === panel.id; }) ? _vm.selectedPhenotypes['panelPhenotypes'].filter(function (p) { return p.panel.id !== panel.id; })
                        : _vm.selectedPhenotypes['panelPhenotypes'].filter(function (p) { return p.panel.id !== panel.id; }).concat(panel.phenotypes)
                    }}},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['panelPhenotypes'].filter(function (phenotype) { return phenotype.panel.id === panel.id; }).length === panel.phenotypes.length ? __webpack_require__("7kqe")
                        : _vm.selectedPhenotypes['panelPhenotypes'].some(function (phenotype) { return phenotype.panel.id === panel.id; }) ? __webpack_require__("Z77G")
                        : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title main"},[_vm._v(_vm._s(panel.panel))])]),_vm._v(" "),_c('div',{staticClass:"panel-item-container row-block flex-wrap"},_vm._l((panel.phenotypes),function(phenotype,phindex){return _c('div',{key:phindex,staticClass:"item-container row-block",on:{"click":function (e) {
                        _vm.selectedPhenotypes['panelPhenotypes'] =
                          _vm.selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? _vm.selectedPhenotypes['panelPhenotypes'].filter(function (p) { return (p.panel.id + '_' + p.id) !== (phenotype.panel.id + '_' + phenotype.id); })
                          : _vm.selectedPhenotypes['panelPhenotypes'].concat([phenotype])
                      }}},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['panelPhenotypes'].includes(phenotype) ? __webpack_require__("7kqe")
                          : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(phenotype.query))])])}),0)])}):[_c('div',{staticClass:"row-block",style:({ width: '100%' })},[_c('router-link',{staticClass:"link dark",attrs:{"to":{ name: 'panel' }}},[_vm._v(_vm._s('You don\'t have any panel yet. you can create a panel here'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)]],2)])]),_vm._v(" "),_c('div',{staticClass:"search-container row-block"},[_c('div',{staticClass:"search-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"row-block",style:({ width: '100%' })},[_c('div',{staticClass:"search-input input-group",style:({ flex: 1 })},[_c('phenotypeTag',{style:({
                    width: '100%'
                  }),attrs:{"placeholder":'Phenotype (eg: Dyspnea) or Disease (eg: Breast Cancer)'/* ___ */,"init":_vm.tagData.query['phenotype'],"dataInfo":_vm.tagData.tag['phenotypes'].info,"phenotypes":_vm.tagData.tag['phenotypes'].datas},on:{"input":function (content) { _vm.tagData.query['phenotype'] = content; _vm.getPhenotypes(content); _vm.customValidate([], ['selected', 'genePanel']) },"tag":function (content) { _vm.tagData.query['phenotype'] = content; _vm.customValidate([], ['selected', 'genePanel']) },"send":function (content) { return (_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'] ? _vm.addToSearch('phenotype', _vm.tagData.query['phenotype']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '22px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"disabled":!((_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'])},on:{"click":function (e) { return (_vm.tagData.tag['phenotypes'].datas || []).length && _vm.tagData.query['phenotype'] ? _vm.addToSearch('phenotype', _vm.tagData.query['phenotype']) : ''; }}},[_c('span',[_vm._v(_vm._s('Add'/* ___ */))])])]),_vm._v(" "),(_vm.searchedPhenotypes['phenotypes'].length)?_c('div',{staticClass:"selected-container col-block flex-start"},[_c('div',{staticClass:"selected-title-container row-block"},[_c('div',{staticClass:"selected-title"},[_vm._v(_vm._s('Selected'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"selected-item-container row-block flex-wrap"},_vm._l((_vm.searchedPhenotypes['phenotypes']),function(phenotype,phindex){return _c('div',{key:phindex,staticClass:"item-container row-block",class:{
                    disabled: _vm.selectedLimit['phenotypes'] && !_vm.selectedPhenotypes['phenotypes'].includes(phenotype)
                  },on:{"click":function (e) {
                    _vm.selectedPhenotypes['phenotypes'] =
                      e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedPhenotypes['phenotypes']
                      : _vm.selectedPhenotypes['phenotypes'].includes(phenotype) ? _vm.selectedPhenotypes['phenotypes'].filter(function (p) { return p.id !== phenotype.id; })
                      : _vm.selectedPhenotypes['phenotypes'].concat([phenotype])
                  }}},[_c('div',{staticClass:"item-block row-block"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['phenotypes'].includes(phenotype) ? __webpack_require__("7kqe")
                        : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(phenotype.query))])]),_vm._v(" "),_c('img',{staticClass:"option",attrs:{"src":__webpack_require__("Xb65"),"alt":""},on:{"click":function (e) { return _vm.addToPanel(phenotype); }}})])}),0)]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '0px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-title-container row-block"},[_c('div',{staticClass:"analysis-title"},[_vm._v(_vm._s('Gene filter'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"search-container row-block"},[_c('div',{staticClass:"search-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"row-block",style:({ width: '100%' })},[_c('div',{staticClass:"search-input input-group",style:({ flex: 1 })},[_c('geneTag',{style:({
                    width: '100%'
                  }),attrs:{"tagHeight":'300px',"placeholder":'Gene Panel (eg: Additional findings health related)'/* ___ */,"init":_vm.tagData.query['gene'],"dataInfo":_vm.tagData.tag['genes'].info,"genes":_vm.tagData.tag['genes'].datas},on:{"input":function (content) { _vm.tagData.query['gene'] = content; _vm.getGenes(content); _vm.customValidate([], ['selected', 'genePanel']) },"tag":function (content) { _vm.tagData.query['gene'] = content.name; _vm.tagData.curTag['gene'] = content; _vm.customValidate([], ['selected', 'genePanel']) },"send":function (content) { return (_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'] ? _vm.addToSearch('gene', _vm.tagData.curTag['gene'] || _vm.tagData.query['gene']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '22px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.loading['addToSearch'] },attrs:{"disabled":!((_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'])},on:{"click":function (e) { return (_vm.tagData.tag['genes'].datas || []).length && _vm.tagData.query['gene'] ? _vm.addToSearch('gene', _vm.tagData.curTag['gene'] || _vm.tagData.query['gene']) : ''; }}},[_c('span',[_vm._v(_vm._s('Add'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '6px' })}),_vm._v(" "),_c('div',{staticClass:"icon-block",style:({ '--size': '40px' }),on:{"click":function (e) { return _vm.openGenePanelSearch(); }}},[_c('img',{attrs:{"src":__webpack_require__("Qd2E"),"alt":""}})])]),_vm._v(" "),(_vm.searchedPhenotypes['genes'].length)?_c('div',{staticClass:"selected-container col-block flex-start"},[_c('div',{staticClass:"selected-title-container row-block"},[_c('div',{staticClass:"selected-title"},[_vm._v(_vm._s('Selected'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"selected-item-container row-block flex-wrap"},_vm._l((_vm.searchedPhenotypes['genes']),function(gene,gindex){return _c('div',{key:gindex,staticClass:"item-container row-block",class:{
                    disabled: _vm.selectedLimit['genes'] && !_vm.selectedPhenotypes['genes'].includes(gene)
                  },on:{"click":function (e) {
                    _vm.selectedPhenotypes['genes'] =
                      e.currentTarget.className.split(' ').includes('disabled') ? _vm.selectedPhenotypes['genes']
                      : _vm.selectedPhenotypes['genes'].includes(gene) ? _vm.selectedPhenotypes['genes'].filter(function (g) { return g.name + '_' + g.id !== gene.name + '_' + gene.id; })
                      : _vm.selectedPhenotypes['genes'].concat([gene])
                  }}},[_c('div',{staticClass:"item-block row-block"},[_c('img',{staticClass:"checkbox",attrs:{"src":_vm.selectedPhenotypes['genes'].includes(gene) ? __webpack_require__("7kqe")
                        : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(gene.name))])]),_vm._v(" "),_c('img',{staticClass:"option",attrs:{"src":__webpack_require__("NMi8"),"alt":""},on:{"click":function (e) { return _vm.openGenePanelDataSelect(gene); }}})])}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"allele-frequency-threshold-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.alleleFrequencyThreshold },on:{"click":function (e) { return _vm.display.alleleFrequencyThreshold = !_vm.display.alleleFrequencyThreshold; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s('Allele frequency threshold for inheritance modes'/* ___ */))]),_vm._v(" "),_c('borCor',{attrs:{"width":'300px',"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{
                  padding: '10px'
                }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("Rp0L"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s('The allele frequency threshold depends on the prevalence of diseases and should be adjusted accordingly. The value should be > 0 and ≤ 1.'/* ___ */))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.alleleFrequencyThreshold),expression:"display.alleleFrequencyThreshold"}],staticClass:"allele-frequency-threshold-block block-content col-block"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field3_1'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('analysis', 'field3_1', result, validate, errors); }}})],1)])]),_vm._v(" "),_c('div',{staticClass:"score-threshold-container block col-block"},[_c('div',{staticClass:"block-content"},[_c('div',{staticClass:"display-icon center-block",class:{ active: _vm.display.scoreThreshold },on:{"click":function (e) { return _vm.display.scoreThreshold = !_vm.display.scoreThreshold; }}},[_c('img',{attrs:{"src":__webpack_require__("0Pmj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"block-title-container row-block"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s('Score threshold for phenotype/gene panel selection'/* ___ */))]),_vm._v(" "),_c('borCor',{attrs:{"width":'300px',"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{
                  padding: '10px'
                }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("Rp0L"),"alt":""}})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_vm._v(_vm._s('Phenotype scores were calculated using semantic similarity based on phenotypes user provided. Variant scores were calculated by multiple prediction scores (e.g SIFT, CADD) and population allele frequencies. The value should be ≥ 0.6 and ≤ 1'/* ___ */))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display.scoreThreshold),expression:"display.scoreThreshold"}],staticClass:"score-threshold-block block-content col-block"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field3_2'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('analysis', 'field3_2', result, validate, errors); }}})],1)])])],2)])]:_vm._e(),_vm._v(" "),(_vm.layoutBlocks.includes('file'))?[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"file-container col-block width-full"},[_c('div',{staticClass:"file-title row-block"},[_c('div',{staticClass:"title row-block"},[_c('b',[_vm._v(_vm._s({ 'vcf': 'VCF', 'fastq': 'FASTQ' }[_vm.dataset] + ' Dataset'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',[_vm._v(_vm._s('( If you don\'t have data yet, you can upload later.)'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(['supervisor'].includes(_vm.user.role) && ['fastq'].includes(_vm.dataset))?[_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"file-cloud-container row-block"},[_c('div',{staticClass:"file-cloud-title"},[_vm._v(_vm._s('Upload from google bucket'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('switchButton',{attrs:{"disabled":false,"checked":_vm.fromCloud},on:{"input":function (c) { _vm.fromCloud = c; _vm.initFile(); }}})],1)]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"other row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.dataset === 'fastq')?_c('button',{staticClass:"white-gray-button circle-button center-block",attrs:{"disabled":Object.values(_vm.fileSets[_vm.fileSets.length - 1]).some(function (file) { return !file; })},on:{"click":function (e) { return _vm.fileSets.push({ r1: null, r2: null }); }}},[_c('img',{attrs:{"src":__webpack_require__("Hct3"),"alt":""}})]):_c('div')])],2),_vm._v(" "),(_vm.dataset === 'fastq')?[_c('div',{style:({ height: '4px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field4'],"scope":_vm.scope,"reading":false},on:{"change":function (result, validate, errors) { return _vm.formOnChange('case', 'field4', result, validate, errors); }}})]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataset === 'vcf'),expression:"dataset === 'vcf'"}],staticClass:"file-content"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_vm._l((_vm.vcfSets),function(set,index){return _c('div',{key:index,staticClass:"file-set-group row-block stretch"},[_c('div',{staticClass:"file-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('VCF file'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.vcf)?[_c('div',{staticClass:"source"},[_vm._v(_vm._s(set.vcf.name))]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role) || _vm.userSetting.allow_upload_vcf)?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_vcf',"extension":"vcf,gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'vcf'); }, function () { return _vm.addToast('error', 'Please upload vcf file'/* ___ */); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_vcf'}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])]):_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.openFileCloud(set, 'vcf'); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])]:_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addToast('error', 'You have no permission to upload the file.'/* ___ */); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{staticClass:"file-block col-block alert",style:({ flex: 1 })},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Important Notice !'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"source",domProps:{"innerHTML":_vm._s([
                'Currently, we only support genome build version GRCh38/hg38.',
                'Please make sure a concordant genome build version of vcf file is uploaded.'
              ].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataset === 'fastq'),expression:"dataset === 'fastq'"}],staticClass:"file-content"},[_c('div',{style:({ height: '15px' })}),_vm._v(" "),_vm._l((_vm.fileSets),function(set,index){return _c('div',{key:index,staticClass:"file-set-group row-block stretch"},[_c('div',{staticClass:"file-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Set' + (index + 1) + '-Fastq-R1'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.r1)?[_c('div',{staticClass:"source"},[_vm._v(_vm._s(set.r1.name))]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role))?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_r1',"extension":"fq,gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'r1'); }, function () { return _vm.addToast('error', 'Please upload fq or gz file'/* ___ */); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_r1'}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])]):_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.openFileCloud(set, 'r1'); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])]:_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addToast('error', 'You have no permission to upload the file.'/* ___ */); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{staticClass:"file-block col-block",style:({ flex: 1 })},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Set' + (index + 1) + '-Fastq-R2'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),(set.r2)?[_c('div',{staticClass:"source"},[_vm._v(_vm._s(set.r2.name))]),_vm._v(" "),_c('div',{style:({ height: '10px' })})]:_vm._e(),_vm._v(" "),(['manager', 'supervisor'].includes(_vm.user.role))?[(!_vm.fromCloud)?_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":'set' + (index + 1) + '_r2',"extension":"fq,gz"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectFile(e, set, 'r2'); }, function () { return _vm.addToast('error', 'Please upload fq or gz file'/* ___ */); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":'set' + (index + 1) + '_r2'}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])]):_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.openFileCloud(set, 'r2'); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])]:_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.addToast('error', 'You have no permission to upload the file.'/* ___ */); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])})],2)],2)]:_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_vm._v(_vm._s(_vm.onError))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var case_base = (esExports);
// CONCATENATED MODULE: ./src/components/case/base.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  base,
  case_base,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_case_base = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/2uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/scrollBottom.vue


//
//
//
//
//
//

/* harmony default export */ var scrollBottom = ({
  props: {
    containerKey: {
      type: String,
      default: function _default() {
        return 'default';
      }
    },
    onScrollBottom: {
      type: Function,
      required: true
    },
    deviation: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return {
      currentScroll: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.onScroll(_this.$refs['scroll-container-' + _this.containerKey], true);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onScroll: function onScroll(element) {
      var _this2 = this;

      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(element.scrollTop >= element.scrollHeight - element.offsetHeight - (init ? 0 : _this2.deviation) && (element.scrollTop > _this2.currentScroll || _this2.currentScroll === 0))) {
                  _context2.next = 6;
                  break;
                }

                _this2.currentScroll = element.scrollHeight - element.offsetHeight;
                _context2.next = 4;
                return _this2.onScrollBottom();

              case 4:
                result = _context2.sent;

                if (result !== false && element.scrollHeight === element.offsetHeight) {
                  _this2.onScroll(element);
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e669a22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/scrollBottom.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'scroll-container-' + _vm.containerKey,attrs:{"id":"scroll-bottom"},on:{"scroll":function (e) { return _vm.onScroll(e.target); }}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_scrollBottom = (esExports);
// CONCATENATED MODULE: ./src/components/tool/scrollBottom.vue
function injectStyle (ssrContext) {
  __webpack_require__("bxm6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  scrollBottom,
  tool_scrollBottom,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_scrollBottom = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "02u3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "09wH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzc4OTEiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDc4OTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDUzMSAzMDM4KSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyNDAiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyNDAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ1MzEgLTMwMzgpIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iZm9sZGVyLW9wZW4tbGlnaHQiIGQ9Ik0xNi41LDY5SDE1VjY3LjVBMS41LDEuNSwwLDAsMCwxMy41LDY2aC01bC0yLTJoLTVBMS41LDEuNSwwLDAsMCwwLDY1LjV2OUExLjUsMS41LDAsMCwwLDEuNSw3NkgxMy41MzNhMi41LDIuNSwwLDAsMCwyLjE0NC0xLjIxNGwyLjEwOC0zLjUxNUExLjUsMS41LDAsMCwwLDE2LjUsNjlabS0xNS00SDYuMDg2bDIsMkgxMy41YS41LjUsMCwwLDEsLjUuNVY2OUg1LjM0OWEyLjUsMi41LDAsMCwwLTIuMTQ0LDEuMjE0TDEsNzMuODlWNjUuNUEuNS41LDAsMCwxLDEuNSw2NVptMTUuNDI4LDUuNzU3LTIuMTA5LDMuNTE1QTEuNSwxLjUsMCwwLDEsMTMuNTMzLDc1SDEuNGwyLjU2My00LjI3MkExLjUsMS41LDAsMCwxLDUuMjUsNzBIMTYuNWEuNS41LDAsMCwxLC40MjkuNzU3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQ1MzIgLTMwOTgpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC4yNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "0Pmj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjguNTY2IiB2aWV3Qm94PSIwIDAgMTYuNSA4LjU2NiI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTUuODczLjczNywxNS4xNTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEw4LDUuODIsMS40NTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEwuMTI3LjczN2EuMzQ3LjM0NywwLDAsMCwwLC41MzdMNy42OTMsNy44ODlhLjQ3OS40NzksMCwwLDAsLjYxNCwwbDcuNTY2LTYuNjE1QS4zNDcuMzQ3LDAsMCwwLDE1Ljg3My43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNi4yNSA4LjI4Mykgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiIHN0cm9rZT0iIzA1MzY3OSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "2PDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/toastMethods.vue




/* harmony default export */ var toastMethods = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addToastAction']), {
    addToast: function addToast(type, content) {
      var data = {
        type: type,
        content: content
      };
      this.addToastAction(data);
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/toastMethods.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  toastMethods,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_toastMethods = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4fCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/svg/dataset-annotation-solid.vue
//
//
//
//
//
//

/* harmony default export */ var dataset_annotation_solid = ({
  props: {
    color: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84fc817c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/dataset-annotation-solid.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"24","viewBox":"0 0 21 24"}},[_c('path',{attrs:{"id":"database-solid","d":"M21,3.429V5.571C21,7.46,16.3,9,10.5,9S0,7.46,0,5.571V3.429C0,1.54,4.7,0,10.5,0S21,1.54,21,3.429ZM21,8.25v4.821C21,14.96,16.3,16.5,10.5,16.5S0,14.96,0,13.071V8.25C2.256,9.8,6.385,10.527,10.5,10.527S18.744,9.8,21,8.25Zm0,7.5v4.821C21,22.46,16.3,24,10.5,24S0,22.46,0,20.571V15.75c2.256,1.554,6.385,2.277,10.5,2.277S18.744,17.3,21,15.75Z","fill":_vm.color}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var svg_dataset_annotation_solid = (esExports);
// CONCATENATED MODULE: ./src/components/svg/dataset-annotation-solid.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  dataset_annotation_solid,
  svg_dataset_annotation_solid,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_svg_dataset_annotation_solid = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "598Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__("yXtV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);



var options = {
  namespace: 'inheriNext_'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a, options);

/***/ }),

/***/ "5Ggm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNiZTBmMGYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "5Ivo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY5NzUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY5NzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2ZmZiIvPgogICAgPGcgaWQ9IumVt+aWueW9ol8yODY4IiBkYXRhLW5hbWU9IumVt+aWueW9oiAyODY4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTcyIDE1MzMpIiBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE3IiBoZWlnaHQ9IjE3IiByeD0iMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "5xS/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "6EFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/inputTag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var inputTag = ({
  props: {
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tags: {
      type: Array,
      required: true
    },
    tagWidth: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagHeight: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    emptyDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    prefix: {
      type: String,
      default: function _default() {
        return '(?: |^)';
      }
    },
    target: {
      type: String,
      default: function _default() {
        return '@(?!.* )(.*?)$';
      }
    },
    replace: {
      type: Function,
      default: function _default(x) {
        return '@' + x + ' ';
      }
    },
    filter: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    tagDisplay: {
      type: Function,
      default: function _default(x) {
        return x;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    // style
    inputStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      content: '',
      keyword: null,
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    };
  },

  computed: {
    filtedTags: function filtedTags() {
      var _this = this;

      if (this.keyword || !this.emptyDisplay) {
        var filter = this.filter(this.keyword) || function (x) {
          return x.includes(_this.keyword);
        };
        return this.tags.filter(function (x) {
          return filter(x);
        });
      } else {
        return this.tags;
      }
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      var match = this.content.match(new RegExp(this.prefix + this.target));
      this.keyword = match ? match[1] : null;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.filtedTags.length - 1) % this.filtedTags.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.filtedTags.length;
            break;
          }
      }
      this.$refs['tag-block'].scrollTop = 29.2 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.filtedTags[this.tagIndex];
      this.onCompelete = true;
      this.content = this.content.replace(new RegExp(this.target), this.replace(curTag));
      this.$emit('tag', curTag);
      this.commentOnInput(this.content);
      this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408b9c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/inputTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"input-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",style:(_vm.inputStyle),attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)}],"keypress":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return (_vm.filtedTags || []).length === 0 ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)},"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),((_vm.filtedTags.length > 1 || (_vm.filtedTags.length && ![_vm.content].includes(_vm.replace(_vm.filtedTags[0])))) && !_vm.onCompelete && _vm.display && (_vm.content || _vm.emptyDisplay))?_c('div',{staticClass:"input-tag",style:(_vm.tagWidth ? { 'min-width': _vm.tagWidth } : {})},[_c('div',{ref:"tag-block",staticClass:"tag-block",style:(_vm.tagHeight ? { 'max-height': _vm.tagHeight } : {})},_vm._l((_vm.filtedTags),function(tag,index){return _c('div',{key:index,staticClass:"tag",class:{ selected: _vm.tagIndex === index },on:{"mousemove":function (e) { return _vm.tagIndex = index; },"click":function($event){_vm.commentTag()}}},[_vm._v(_vm._s(_vm.tagDisplay(tag)))])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_inputTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/inputTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("tIXw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  inputTag,
  tool_inputTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_inputTag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Qul":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "6v0c":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./quality-nopass-info-icon.svg": "RCqP",
	"./quality-pass-info-icon.svg": "i1qd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6v0c";

/***/ }),

/***/ "7kqe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY4ODMiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY4ODMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iIzgzYzkxZSIvPgogICAgPGcgaWQ9IuODkeOCuV81MTUiIGRhdGEtbmFtZT0i44OR44K5IDUxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTMzKSIgZmlsbD0ibm9uZSI+CiAgICAgIDxwYXRoIGQ9Ik0yLDBIMTZhMiwyLDAsMCwxLDIsMlYxNmEyLDIsMCwwLDEtMiwySDJhMiwyLDAsMCwxLTItMlYyQTIsMiwwLDAsMSwyLDBaIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHBhdGggZD0iTSAyIDEgQyAxLjQ0ODYwMDc2OTA0Mjk2OSAxIDEgMS40NDg2MDA3NjkwNDI5NjkgMSAyIEwgMSAxNiBDIDEgMTYuNTUxMzk5MjMwOTU3MDMgMS40NDg2MDA3NjkwNDI5NjkgMTcgMiAxNyBMIDE2IDE3IEMgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTcgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTYgTCAxNyAyIEMgMTcgMS40NDg2MDA3NjkwNDI5NjkgMTYuNTUxMzk5MjMwOTU3MDMgMSAxNiAxIEwgMiAxIE0gMiAwIEwgMTYgMCBDIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTggMC44OTU0Mjk2MTEyMDYwNTQ3IDE4IDIgTCAxOCAxNiBDIDE4IDE3LjEwNDU3MDM4ODc5Mzk1IDE3LjEwNDU3MDM4ODc5Mzk1IDE4IDE2IDE4IEwgMiAxOCBDIDAuODk1NDI5NjExMjA2MDU0NyAxOCAwIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTYgTCAwIDIgQyAwIDAuODk1NDI5NjExMjA2MDU0NyAwLjg5NTQyOTYxMTIwNjA1NDcgMCAyIDAgWiIgc3Ryb2tlPSJub25lIiBmaWxsPSIjMzMzIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "9odj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hldnJvbi1jaXJjbGUtZG93bi1saWdodCIgZD0iTTE4LDhBMTAsMTAsMCwxLDAsMjgsMTgsMTAsMTAsMCwwLDAsMTgsOFptOC43MSwxMEE4LjcxLDguNzEsMCwxLDEsMTgsOS4yOSw4LjcwOSw4LjcwOSwwLDAsMSwyNi43MSwxOFptLTguMzY3LDMuNDkyLDQuNjM3LTQuNjQxYS40ODQuNDg0LDAsMCwwLDAtLjY4NWwtLjI4Ni0uMjg2YS40ODQuNDg0LDAsMCwwLS42ODUsMEwxOCwxOS45bC00LjAxMi00LjAxMmEuNDg0LjQ4NCwwLDAsMC0uNjg1LDBsLS4yODYuMjg2YS40ODQuNDg0LDAsMCwwLDAsLjY4NUwxNy42NTMsMjEuNUEuNDkzLjQ5MywwLDAsMCwxOC4zNDMsMjEuNDkyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjggMjgpIHJvdGF0ZSgxODApIiBmaWxsPSIjMDAzNjc5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "AJyC":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./checkbox-false.svg": "5Ivo",
	"./radio-false.svg": "z0Pm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AJyC";

/***/ }),

/***/ "BdG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/switchButton.vue


//
//
//
//
//
//

/* harmony default export */ var switchButton = ({
  props: {
    disabled: Boolean,
    type: String,
    size: String,
    checked: Boolean,
    active: Boolean,
    customStyle: Object
  },
  data: function data() {
    return {
      value: false
    };
  },

  computed: {
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          value = this.value,
          active = this.active;

      return _ref = {}, defineProperty_default()(_ref, 'is-' + type, type), defineProperty_default()(_ref, 'is-' + size, size), defineProperty_default()(_ref, 'checked', value), defineProperty_default()(_ref, 'active', active), _ref;
    },
    styleObject: function styleObject() {
      var defaultStyle = { cursor: this.disabled ? 'not-allowed' : 'pointer' };
      return extends_default()({}, defaultStyle, this.customStyle || {});
    }
  },
  mounted: function mounted() {
    this.value = this.checked;
  },

  watch: {
    checked: function checked() {
      this.value = this.checked;
    },
    value: function value(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe30068","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/switchButton.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject,style:(_vm.styleObject),attrs:{"id":"switch-button"},on:{"click":function (e) { return _vm.$emit('click', e); }}},[(!_vm.disabled)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],style:(_vm.styleObject),attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.value)?_vm._i(_vm.value,null)>-1:(_vm.value)},on:{"change":function($event){var $$a=_vm.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.value=$$a.concat([$$v]))}else{$$i>-1&&(_vm.value=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.value=$$c}}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_switchButton = (esExports);
// CONCATENATED MODULE: ./src/components/tool/switchButton.vue
function injectStyle (ssrContext) {
  __webpack_require__("s+oG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  switchButton,
  tool_switchButton,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_switchButton = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CQ/M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cduz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return sortData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return groupBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fileTypeCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toPriceString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toDivideNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fixNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return xlsxToJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return jsonToXlsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return imageReader; });
/* unused harmony export imageUrlReader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCharLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return subCharString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyToClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertNumberCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return htmlencode; });
/* unused harmony export htmldecode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return downloadFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log10__ = __webpack_require__("j9JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__);











var _this = this;

var sortData = function sortData(arr, keys, orders) {
  if (!arr || !(arr instanceof Array)) {
    return arr;
  }
  if (keys instanceof Object && !(keys instanceof Array) && !(keys instanceof Function)) {
    return arr;
  }
  keys = keys instanceof Array ? keys : [keys];
  orders = orders instanceof Array ? orders : [orders];
  if (keys.length <= 0) {
    return arr;
  }
  var sortBy = function sortBy(keys, orders) {
    return function (o1, o2) {
      var key = keys[0];
      var order = orders[0] !== 'desc' ? 1 : -1;
      var co1 = key instanceof Function ? key(o1, order) : o1[key];
      var co2 = key instanceof Function ? key(o2, order) : o2[key];
      co1 = co1 instanceof Array ? co1.length : co1;
      co2 = co2 instanceof Array ? co2.length : co2;
      if (co1 === null || co1 === undefined || co1 < co2) {
        return -1 * order;
      } else if (co2 === null || co2 === undefined || co1 > co2) {
        return 1 * order;
      } else {
        return keys.length <= 1 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2);
      }
    };
  };
  return [].concat(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(arr)).sort(sortBy(keys, orders));
};

var dateFormat = function dateFormat(date, fmt) {
  date.setHours(date.getHours() - (date.getTimezoneOffset() - new Date().getTimezoneOffset()) / 60);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

var groupBy = function groupBy(ary, f) {
  var needKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var groups = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(ary), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      var key = needKey ? f(item) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(f(item));
      groups[key] = groups[key] || [];
      groups[key].push(item);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return needKey ? groups : __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(groups);
};

var fileTypeCheck = function fileTypeCheck(e, operation, onError) {
  var acceptTypes = e.target.getAttribute('accept');
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null;
  var extension = e.target.getAttribute('extension');
  extension = extension ? extension.split(',') : null;
  var match = function match(arys, s) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(arys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var ary = _step2.value;

        var rgx = new RegExp(ary);
        if (rgx.test(s)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return false;
  };
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(e.target.files), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var file = _step3.value;

      var fileType = file.type;
      var fileExtension = file.name.split('.');
      fileExtension = fileExtension[fileExtension.length - 1];
      if (extension && !match(extension, fileExtension)) {
        e.target.value = '';
        if (onError) {
          onError(e, extension);
        }
        return;
      }
      if (acceptTypes && !match(acceptTypes, fileType)) {
        e.target.value = '';
        if (onError) {
          onError(e, acceptTypes);
        }
        return;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  operation(e);
};

var toPriceString = function toPriceString(price) {
  return (price + '').split('.').map(function (s) {
    return s.replace(/(?!^)(?=(\d{3})+($|\.))/g, ',');
  }).join('.');
};

var cleanObject = function cleanObject(obj) {
  var strictMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  for (var key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
    if (obj[key] && strictMode) {
      if (obj[key] === '' || obj[key] instanceof Array && !obj[key].length || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj[key]) === 'object' && !__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj[key]).length) {
        delete obj[key];
      }
    }
  }
  return obj;
};

var toDivideNumber = function toDivideNumber(number, base) {
  return number + (base - Math.abs(number) % base) * (number >= 0 ? 1 : -1);
};

var fixNumber = function fixNumber(value, step) {
  var fix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (step) {
    var len = ((step + '').match(/\.(.*?)$/) || ['', ''])[1].length + -__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_log10___default()(fix);
    value = Math.round(value * Math.pow(10, len)) / Math.pow(10, len);
  }
  return value;
};

/* eslint-disable */
var _XLSX = XLSX;
/* eslint-enable */

var xlsxToJson = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(files) {
    var getContent, jsons, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, file;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (files) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            getContent = function getContent(file) {
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var data = e.target.result;
                  var wb = _XLSX.read(data, {
                    type: 'binary'
                  });
                  resolve(_XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]));
                };
                reader.readAsBinaryString(file);
              });
            };

            jsons = [];
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context.prev = 7;
            _iterator4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(files);

          case 9:
            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
              _context.next = 19;
              break;
            }

            file = _step4.value;
            _context.t0 = jsons;
            _context.next = 14;
            return getContent(file);

          case 14:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

          case 16:
            _iteratorNormalCompletion4 = true;
            _context.next = 9;
            break;

          case 19:
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t2 = _context['catch'](7);
            _didIteratorError4 = true;
            _iteratorError4 = _context.t2;

          case 25:
            _context.prev = 25;
            _context.prev = 26;

            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }

          case 28:
            _context.prev = 28;

            if (!_didIteratorError4) {
              _context.next = 31;
              break;
            }

            throw _iteratorError4;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(25);

          case 33:
            return _context.abrupt('return', jsons);

          case 34:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function xlsxToJson(_x4) {
    return _ref.apply(this, arguments);
  };
}();

var jsonToXlsx = function jsonToXlsx(datas) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'excel';
  var sheetname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'sheet';

  var ws = _XLSX.utils.json_to_sheet(datas);
  var wb = _XLSX.utils.book_new();
  _XLSX.utils.book_append_sheet(wb, ws, sheetname);
  _XLSX.writeFile(wb, filename + '.xlsx');
};

var imageReader = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(files) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, file;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (files) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt('return');

          case 2:
            getContent = function getContent(file) {
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var reader = new FileReader();
                reader.onload = function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e) {
                    var dataUrl;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            dataUrl = e.target.result.startsWith('data:image/') ? e.target.result : '';

                            if (!(maxWidth || maxHeight || type === 'blob' || type === 'blobUrl')) {
                              _context2.next = 9;
                              break;
                            }

                            _context2.t0 = resolve;
                            _context2.next = 5;
                            return _this.imageUrlReader([dataUrl], type === 'dataUrl' ? 'blobUrl' : type, maxWidth, maxHeight);

                          case 5:
                            _context2.t1 = _context2.sent;
                            (0, _context2.t0)(_context2.t1);
                            _context2.next = 10;
                            break;

                          case 9:
                            if (type === 'dataUrl') {
                              resolve(dataUrl);
                            } else {
                              resolve('');
                            }

                          case 10:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this);
                  }));

                  return function (_x9) {
                    return _ref3.apply(this, arguments);
                  };
                }();
                reader.readAsDataURL(file);
              });
            };

            content = [];
            _iteratorNormalCompletion5 = true;
            _didIteratorError5 = false;
            _iteratorError5 = undefined;
            _context3.prev = 7;
            _iterator5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(files);

          case 9:
            if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
              _context3.next = 19;
              break;
            }

            file = _step5.value;
            _context3.t0 = content;
            _context3.next = 14;
            return getContent(file);

          case 14:
            _context3.t1 = _context3.sent;

            _context3.t0.push.call(_context3.t0, _context3.t1);

          case 16:
            _iteratorNormalCompletion5 = true;
            _context3.next = 9;
            break;

          case 19:
            _context3.next = 25;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t2 = _context3['catch'](7);
            _didIteratorError5 = true;
            _iteratorError5 = _context3.t2;

          case 25:
            _context3.prev = 25;
            _context3.prev = 26;

            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }

          case 28:
            _context3.prev = 28;

            if (!_didIteratorError5) {
              _context3.next = 31;
              break;
            }

            throw _iteratorError5;

          case 31:
            return _context3.finish(28);

          case 32:
            return _context3.finish(25);

          case 33:
            return _context3.abrupt('return', content);

          case 34:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageReader(_x7) {
    return _ref2.apply(this, arguments);
  };
}();

var imageUrlReader = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(urls) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blobUrl';
    var maxWidth = arguments[2];
    var maxHeight = arguments[3];

    var getContent, content, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, url;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (urls) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return');

          case 2:
            getContent = function getContent(url) {
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                var img = new Image();
                img.onload = function (e) {
                  var canvas = document.createElement('canvas');
                  var targetWidth = img.width;
                  var targetHeight = img.height;
                  maxWidth = maxWidth || img.width;
                  maxHeight = maxHeight || img.height;
                  if (targetWidth > maxWidth || targetHeight > maxHeight) {
                    if (targetWidth / targetHeight > maxWidth / maxHeight) {
                      targetHeight = Math.round(maxWidth * (targetHeight / targetWidth));
                      targetWidth = maxWidth;
                    } else {
                      targetHeight = maxHeight;
                      targetWidth = Math.round(maxHeight * (targetWidth / targetHeight));
                    }
                  }
                  canvas.width = targetWidth;
                  canvas.height = targetHeight;
                  canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight);
                  canvas.toBlob(function (blob) {
                    if (type === 'blobUrl') {
                      resolve(URL.createObjectURL(blob));
                    } else if (type === 'blob') {
                      resolve(blob);
                    }
                  });
                };
                img.setAttribute('crossOrigin', 'Anonymous');
                img.src = url;
              });
            };

            content = [];
            _iteratorNormalCompletion6 = true;
            _didIteratorError6 = false;
            _iteratorError6 = undefined;
            _context4.prev = 7;
            _iterator6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(urls);

          case 9:
            if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
              _context4.next = 19;
              break;
            }

            url = _step6.value;
            _context4.t0 = content;
            _context4.next = 14;
            return getContent(url);

          case 14:
            _context4.t1 = _context4.sent;

            _context4.t0.push.call(_context4.t0, _context4.t1);

          case 16:
            _iteratorNormalCompletion6 = true;
            _context4.next = 9;
            break;

          case 19:
            _context4.next = 25;
            break;

          case 21:
            _context4.prev = 21;
            _context4.t2 = _context4['catch'](7);
            _didIteratorError6 = true;
            _iteratorError6 = _context4.t2;

          case 25:
            _context4.prev = 25;
            _context4.prev = 26;

            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }

          case 28:
            _context4.prev = 28;

            if (!_didIteratorError6) {
              _context4.next = 31;
              break;
            }

            throw _iteratorError6;

          case 31:
            return _context4.finish(28);

          case 32:
            return _context4.finish(25);

          case 33:
            return _context4.abrupt('return', content);

          case 34:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function imageUrlReader(_x10) {
    return _ref4.apply(this, arguments);
  };
}();

var getCharLength = function getCharLength(str) {
  /* eslint-disable-next-line no-control-regex */
  var arr = str.match(/[^\x00-\xff]/ig);
  return arr == null ? str.length : str.length + arr.length;
  /* eslint-disable-next-line no-control-regex */
};

var subCharString = function subCharString(str, length) {
  /* eslint-disable-next-line no-control-regex */
  return str.replace(/([^\x00-\xff])/ig, '$1ゐ').substring(0, length).replace(/([^\x00-\xff])$/, '').replace(/([^\x00-\xff])ゐ/ig, '$1');
  /* eslint-disable-next-line no-control-regex */
};

var copyToClipboard = function copyToClipboard(value) {
  navigator.clipboard.writeText(value);
};

var convertNumberCount = function convertNumberCount(_count) {
  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = arguments[2];
  var lower = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var sizeType = lower ? ['', 'k', 'm', 'b', 't', 'q'] : ['', 'K', 'M', 'B', 'T', 'Q'];
  var type = 0;
  for (; _count > 1000 || type === sizeType.length; _count /= 1000, type++) {}
  return fixNumber(_count, step) + split + sizeType[type];
};

var htmlencode = function htmlencode(s) {
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(s));
  return div.innerHTML;
};

var htmldecode = function htmldecode(s) {
  var div = document.createElement('div');
  div.innerHTML = s;
  return div.innerText || div.textContent;
};

var downloadFile = function downloadFile(fileName, urlData, target) {
  var aLink = document.createElement('a');
  if (fileName) {
    aLink.download = fileName;
  }
  if (target) {
    aLink.target = target;
  }
  aLink.href = urlData;
  aLink.click();
};

/***/ }),

/***/ "D1u2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDI0IDE4Ij4KICA8cGF0aCBpZD0ic2lnbi1vdXQtbGlnaHQiIGQ9Ik0yLjI0OSw2NEg4LjQzNUEuNTY0LjU2NCwwLDAsMSw5LDY0LjU2M3YuMzc1YS41NjQuNTY0LDAsMCwxLS41NjIuNTYzSDIuMjQ5YS43NTIuNzUyLDAsMCwwLS43NS43NXYxMy41YS43NTIuNzUyLDAsMCwwLC43NS43NUg4LjQzNUEuNTY0LjU2NCwwLDAsMSw5LDgxLjA2M3YuMzc1QS41NjQuNTY0LDAsMCwxLDguNDM1LDgySDIuMjQ5QTIuMjUsMi4yNSwwLDAsMSwwLDc5Ljc1VjY2LjI1QTIuMjUsMi4yNSwwLDAsMSwyLjI0OSw2NFptMTMuMDc1LjkxNC0uMzMzLjMzM2EuNTYzLjU2MywwLDAsMCwwLC44TDIxLjE3OCw3Mi4ySDguMDYxYS41NjQuNTY0LDAsMCwwLS41NjIuNTYzdi40NjlhLjU2NC41NjQsMCwwLDAsLjU2Mi41NjNIMjEuMTc4TDE1LDc5Ljk1NmEuNTYzLjU2MywwLDAsMCwwLC44bC4zMzMuMzMzYS41NjMuNTYzLDAsMCwwLC44LDBMMjMuODM1LDczLjRhLjU2My41NjMsMCwwLDAsMC0uOGwtNy43MTQtNy42ODdBLjU2My41NjMsMCwwLDAsMTUuMzI0LDY0LjkxNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTY0KSIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "DBs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");



var config = {
  locale: 'zh',
  events: 'input',
  dictionary: {
    zh: {
      messages: {
        required: function required(field) {
          return field + ' should not be empty.';
        },
        min: function min(field, args) {
          return field + ' should be at least ' + args + ' alphanumeric characters.';
        },
        max: function max(field, args) {
          return field + ' should be less than ' + args + ' alphanumeric characters.';
        },
        digits: function digits(field, args) {
          return field + ' should be ' + args + ' digit';
        },
        min_value: function min_value(field, args) {
          return field + ' should be at least ' + args;
        },
        max_value: function max_value(field, args) {
          return field + ' should be less than ' + args;
        },
        integer: function integer(field) {
          return field + ' should be integer';
        },
        mimes: function mimes(field, args) {
          return field + ' should be mime ' + args;
        },
        ext: function ext(field, args) {
          return field + ' should be extension ' + args;
        },
        dimensions: function dimensions(field, args) {
          return field + ' should be ' + args;
        },
        regex: function regex(field) {
          return 'The ' + field + ' is incorrect.';
        },
        email: function email() {
          return 'Please enter right email format.';
        },
        confirmed: function confirmed() {
          return 'Password confirmation is incorrect.';
        }
      },
      attributes: {}
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], config);

/***/ }),

/***/ "DGt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// EXTERNAL MODULE: ./src/components/svg/dataset-annotation-solid.vue + 2 modules
var dataset_annotation_solid = __webpack_require__("4fCP");

// EXTERNAL MODULE: ./src/components/svg/dataset-annotation-admin-solid.vue + 2 modules
var dataset_annotation_admin_solid = __webpack_require__("py3r");

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/constants/global/data.js
var data = __webpack_require__("x2hU");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dataset/card.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var card = ({
  components: {
    borCor: newBorCor["a" /* default */],
    // svg
    datasetAnnotationSolid: dataset_annotation_solid["a" /* default */],
    datasetAnnotationAdminSolid: dataset_annotation_admin_solid["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'default';
      }
    },
    dataset: {
      type: Object,
      required: true
    },
    layoutType: {
      type: String,
      default: function _default() {
        return 'default';
      }
    }
  },
  data: function data() {
    return {
      collapse: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    // static
    informationOptions: function informationOptions() {
      return ['community', 'share'].includes(this.type) ? [{
        title: 'Create',
        value: function value(dataset) {
          return Object(util["d" /* dateFormat */])(new Date(dataset.created_at), 'yyyy/MM/dd hh:mm');
        }
      }, {
        title: 'Permission',
        value: function value(dataset) {
          var permission = data["e" /* datasetPermissionMap */][dataset.dataset_share.permission || dataset.community_permission] || {};
          return '<span style=color:' + permission.color + '>' + permission.title + '</span>';
        }
      }, {
        title: 'Pipeline',
        value: function value(dataset) {
          return (data["g" /* datasetPipelineMap */][dataset.pipeline] || {}).title;
        }
      }] : [{
        title: 'Create',
        value: function value(dataset) {
          return Object(util["d" /* dateFormat */])(new Date(dataset.created_at), 'yyyy/MM/dd hh:mm');
        }
      }, {
        title: 'Modified',
        value: function value(dataset) {
          return Object(util["d" /* dateFormat */])(new Date(dataset.updated_at), 'yyyy/MM/dd hh:mm');
        }
      }, {
        title: 'Sample size',
        value: function value(dataset) {
          return Object(util["p" /* toPriceString */])(dataset.sample_size);
        }
      }, {
        title: 'Pipeline',
        value: function value(dataset) {
          return (data["g" /* datasetPipelineMap */][dataset.pipeline] || {}).title;
        }
      }, {
        title: 'External data',
        value: function value(dataset) {
          return dataset.external_data_included ? 'Yes' /* ___ */ : 'No';
        } /* ___ */
      }, {
        title: 'Status',
        value: function value(dataset) {
          var status = data["i" /* datasetStatusMap */][dataset.disabled ? 'disabled' : dataset.state] || {};
          return '<span style=color:' + status.color + '>' + status.title + '</span>';
        }
      }];
    },

    // global
    getCharLength: function getCharLength() {
      return util["h" /* getCharLength */];
    },
    subCharString: function subCharString() {
      return util["n" /* subCharString */];
    }
  }),
  watch: {
    'dataset.tags.length': function datasetTagsLength() {
      if ((this.$refs['tag-list'] || {}).clientHeight > 24) {
        this.collapse = true;
      }
    }
  },
  mounted: function mounted() {
    if ((this.$refs['tag-list'] || {}).clientHeight > 24) {
      this.collapse = true;
    }
  },

  methods: {
    getPictureUrl: function getPictureUrl(file) {
      var config = this.$ls.get('userInfo');
      return file ? file.url || api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + file.id + '&class_name=' + file.class_name + '&access_token=' + config['access_token'] : '';
    },
    cardOnClick: function cardOnClick() {
      if (!['default'].includes(this.layoutType)) {
        return;
      }
      if (!['default'].includes(this.type) && ['private', 'basic'].includes(this.dataset.dataset_share.permission || this.dataset.community_permission) && !['supervisor'].includes(this.user.role)) {
        this.addToast('error', 'You have no permission to open this dataset.' /* ___ */);
        return;
      }
      this.$router.push({ name: 'datasetDetail', params: { type: this.type, id: this.dataset.id } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf408e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataset/card.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"dataset-card-page col-block width-full",class:[_vm.layoutType, { disabled: ['created', 'failed'].includes(_vm.dataset.state) || _vm.dataset.disabled, archived: _vm.dataset.dataset_config.archived }],on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.cardOnClick(); })($event)}}},[_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"card-title-container row-block flex-start"},[_c('div',{staticClass:"card-title-block row-block flex-start",style:({ flex: 1 })},[_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"card-title",style:({ flex: 1 })},[_vm._v(_vm._s(_vm.subCharString(_vm.dataset.name, (['community', 'share'].includes(_vm.type) ? 60 : 75)) + (_vm.getCharLength(_vm.dataset.name) > (['community', 'share'].includes(_vm.type) ? 60 : 75) ? '...' : '')))])]),_vm._v(" "),(['community', 'share'].includes(_vm.type))?_c('div',{staticClass:"card-picture-field row-block flex-start"},[_c('div',{staticClass:"card-picture-container col-block flex-end",style:({ width: '116px' })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"card-picture-block col-block width-full"},[_c('div',{staticClass:"card-picture",style:({ 'background-image': 'url(' + (_vm.getPictureUrl(_vm.dataset.dataset_picture_file) || __webpack_require__("GW3Y")) + ')' })})])]),_vm._v(" "),_c('div',{style:({ width: '20px' })})]):_c('div',{staticClass:"card-option-container col-block",style:({ width: '40px' })},[_c('div',{staticClass:"icon-list col-block"},[(['supervisor'].includes(_vm.user.role) && _vm.dataset.as_admin_annotation)?_c('div',{staticClass:"annotation-icon admin icon-block",style:({ '--size': '40px' }),attrs:{"title":''/* ___ */}},[_c('datasetAnnotationAdminSolid',{attrs:{"color":'#F8C600'}})],1):_vm._e(),_vm._v(" "),((_vm.dataset.as_private_annotation || _vm.dataset.as_external_annotation) && (_vm.dataset.user || {}).email === _vm.user.email)?_c('div',{staticClass:"annotation-icon icon-block",style:({ '--size': '40px' })},[_c('borCor',{attrs:{"reverse":true,"background":'white',"border":'#CCCCCC',"radius":'0px',"blockStyle":{
              padding: '10px'
            }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('datasetAnnotationSolid',{attrs:{"color":_vm.dataset.as_private_annotation ? '#003679' : _vm.dataset.as_external_annotation ? '#349CCF' : 'transparent'}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s((_vm.dataset.as_private_annotation ? [
                  'The dataset with all your data',
                  'is selected for annotation.'
                ]/* ___ */
                : _vm.dataset.as_external_annotation ? [
                  'The dataset with community data',
                  'is selected for annotation.'
                ]/* ___ */
                : []).join('<br>'))}})])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"status-icon icon-block",style:({ '--size': '40px', cursor: 'default' })},[_c('img',{attrs:{"src":(['created', 'failed'].includes(_vm.dataset.state) || _vm.dataset.disabled) ? __webpack_require__("z3W2") : __webpack_require__("KWcF"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"card-main-container col-block width-full"},[_c('div',{staticClass:"card-information-list-container row-block flex-start flex-wrap"},_vm._l((_vm.informationOptions),function(option,index){return _c('div',{key:index,staticClass:"card-information-container col-block width-full",style:({ width: '33.33%' })},[_c('div',{staticClass:"card-information-block col-block flex-start"},[_c('div',{staticClass:"card-information-title"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('div',{staticClass:"card-information-content",domProps:{"innerHTML":_vm._s(option.value(_vm.dataset))}})])])}),0),_vm._v(" "),_c('div',{staticClass:"card-description-container"},[_c('div',{staticClass:"card-description-block col-block flex-start"},[_c('div',{staticClass:"card-description-title"},[_vm._v(_vm._s('Description'/*___ */))]),_vm._v(" "),_c('div',{staticClass:"card-description-content"},[_vm._v(_vm._s(_vm.dataset.description ? _vm.subCharString(_vm.dataset.description, 240) + (_vm.getCharLength(_vm.dataset.description) > 240 ? '...' : '') : '- -'))])])]),_vm._v(" "),(['community'].includes(_vm.type))?_c('div',{staticClass:"card-owner-main-container row-block flex-start"},[_c('div',{staticClass:"card-owner-container",style:({ flex: 1 })},[_c('div',{staticClass:"card-owner-block col-block flex-start"},[_c('div',{staticClass:"card-owner-title"},[_vm._v(_vm._s('Owner'/*___ */))]),_vm._v(" "),_c('div',{staticClass:"card-owner-content",domProps:{"innerHTML":_vm._s([
              [_vm.dataset.user.first_name, _vm.dataset.user.last_name].filter(function (x) { return x; }).join(' ') + (_vm.dataset.user.organization || _vm.dataset.user.division ? ' (' + [_vm.dataset.user.organization, _vm.dataset.user.division].filter(function (x) { return x; }).join(' ') + ')' : ''),
              _vm.dataset.user.email
            ].join('\n'))}})])]),_vm._v(" "),_c('div',{staticClass:"card-owner-avatar",style:({ 'background-image': 'url(' + (_vm.getPictureUrl(_vm.dataset.user.avatar) || __webpack_require__("GW3Y")) + ')' })})]):_vm._e(),_vm._v(" "),(_vm.dataset.tags.length)?_c('div',{staticClass:"card-tag-container",class:{ collapsable: ['default'].includes(_vm.layoutType) && ![null, undefined].includes(_vm.collapse), collapse: ['default'].includes(_vm.layoutType) && _vm.collapse }},[_c('div',{staticClass:"card-tag-block col-block flex-start"},[_c('div',{staticClass:"card-tag-title-container row-block"},[_c('a',{staticClass:"card-tag-title-block row-block",on:{"click":function($event){$event.stopPropagation();return (function (e) { return ['default'].includes(_vm.layoutType) && (_vm.collapse = { true: false, false: true }[_vm.collapse + '']); })($event)}}},[_c('div',{staticClass:"card-tag-title"},[_vm._v(_vm._s('Tags'/*___ */))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"card-tag-collapse-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":__webpack_require__("bCWW"),"alt":""}})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"card-tag-list-container width-full"},[_c('div',{ref:"tag-list",staticClass:"card-tag-list-block row-block flex-start flex-wrap"},_vm._l((_vm.dataset.tags),function(tag,index){return _c('div',{key:index,staticClass:"card-tag-block row-block",attrs:{"title":tag}},[_c('div',{staticClass:"card-tag-title"},[_vm._v(_vm._s(tag))])])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{style:({ height: '20px' })})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var dataset_card = (esExports);
// CONCATENATED MODULE: ./src/components/dataset/card.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  card,
  dataset_card,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_dataset_card = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E4co":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/responsitive.vue

/* harmony default export */ var responsitive = ({
  data: function data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      scrollbarSize: 0
    };
  },

  computed: {
    isMobile: function isMobile() {
      return this.windowWidth <= 699.9;
    }
  },
  created: function created() {
    var _this = this;

    var handler = function handler() {
      _this.windowWidth = window.innerWidth;
      _this.windowHeight = window.innerHeight;
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    window.dispatchEvent(new Event('resize'));
  },
  mounted: function mounted() {
    var scrollBox = document.getElementById('scroll-box');
    this.scrollbarSize = scrollBox.offsetWidth - scrollBox.clientWidth;
  }
});
// CONCATENATED MODULE: ./src/mixins/responsitive.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  responsitive,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_responsitive = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ew9o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F9Jn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "FUqK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Fg3B":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0idGltZXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUsOGE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCwxNSw4Wm0zLjQzMiw4LjgzN2EuMzM5LjMzOSwwLDAsMSwwLC40OGwtMS4xMTgsMS4xMTVhLjMzOS4zMzksMCwwLDEtLjQ4LDBMMTUsMTYuNTgxbC0xLjgzNywxLjg1MmEuMzM5LjMzOSwwLDAsMS0uNDgsMGwtMS4xMTUtMS4xMThhLjMzOS4zMzksMCwwLDEsMC0uNDhMMTMuNDE5LDE1bC0xLjg1Mi0xLjgzN2EuMzM5LjMzOSwwLDAsMSwwLS40OGwxLjExOC0xLjExOGEuMzM5LjMzOSwwLDAsMSwuNDgsMEwxNSwxMy40MTlsMS44MzctMS44NTJhLjMzOS4zMzksMCwwLDEsLjQ4LDBsMS4xMTgsMS4xMThhLjMzOS4zMzksMCwwLDEsMCwuNDhMMTYuNTgxLDE1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTggLTgpIiBmaWxsPSIjZmEzZDNkIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Fqd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ "GW3Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEzMTAiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEzMTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzU4IDEzMykiPgogICAgPHJlY3QgaWQ9IumVt+aWueW9ol8xMjU2IiBkYXRhLW5hbWU9IumVt+aWueW9oiAxMjU2IiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1OCAtMTMzKSIgZmlsbD0iI2NmZWNmZiIgb3BhY2l0eT0iMC45OTkiLz4KICAgIDxwYXRoIGlkPSJ1c2VyLWxpZ2h0IiBkPSJNMTIuNiwxMS4yNWMtMS4xNTMsMC0xLjcwOC42MjUtMy42LjYyNXMtMi40NDMtLjYyNS0zLjYtLjYyNUE1LjMyOCw1LjMyOCwwLDAsMCwwLDE2LjV2MS42MjVBMS45LDEuOSwwLDAsMCwxLjkyOSwyMEgxNi4wNzFBMS45LDEuOSwwLDAsMCwxOCwxOC4xMjVWMTYuNUE1LjMyOCw1LjMyOCwwLDAsMCwxMi42LDExLjI1Wm00LjExNCw2Ljg3NWEuNjM2LjYzNiwwLDAsMS0uNjQzLjYyNUgxLjkyOWEuNjM2LjYzNiwwLDAsMS0uNjQzLS42MjVWMTYuNWE0LjA2MSw0LjA2MSwwLDAsMSw0LjExNC00Yy43ODgsMCwxLjU3MS42MjUsMy42LjYyNXMyLjgxMy0uNjI1LDMuNi0uNjI1YTQuMDYxLDQuMDYxLDAsMCwxLDQuMTE0LDRaTTksMTBhNS4wNzMsNS4wNzMsMCwwLDAsNS4xNDMtNUE1LjA3Myw1LjA3MywwLDAsMCw5LDAsNS4wNzMsNS4wNzMsMCwwLDAsMy44NTcsNSw1LjA3Myw1LjA3MywwLDAsMCw5LDEwWk05LDEuMjVBMy44MTEsMy44MTEsMCwwLDEsMTIuODU3LDUsMy44MTEsMy44MTEsMCwwLDEsOSw4Ljc1LDMuODExLDMuODExLDAsMCwxLDUuMTQzLDUsMy44MTEsMy44MTEsMCwwLDEsOSwxLjI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM2OSAtMTIzKSIgZmlsbD0iIzAwMzY3OSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "GljU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEyMTUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEyMTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTQ2NyAzMjcwKSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyMzgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyMzgiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU0NjcgLTMyNzApIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iZmlsZS1hbHQtbGlnaHQiIGQ9Ik0xMS41NTcsMi45NjIsOC45MzYuMzQxQTEuNSwxLjUsMCwwLDAsNy44NzctLjFIMS41QTEuNSwxLjUsMCwwLDAsMCwxLjR2MTNhMS41LDEuNSwwLDAsMCwxLjUsMS41aDlBMS41LDEuNSwwLDAsMCwxMiwxNC40VjQuMDI0YTEuNTA3LDEuNTA3LDAsMCwwLS40NDEtMS4wNjJabS0uNzA2LjcwOWEuNDkyLjQ5MiwwLDAsMSwuMTMxLjIzMUg4Vi45MTlhLjQ5Mi40OTIsMCwwLDEsLjIzMS4xMzFaTTEwLjUsMTQuOWgtOWEuNS41LDAsMCwxLS41LS41VjEuNEEuNS41LDAsMCwxLDEuNS45SDdWNC4xNTJhLjc0OC43NDgsMCwwLDAsLjc1Ljc1SDExdjkuNUEuNS41LDAsMCwxLDEwLjUsMTQuOVpNOSw3LjI3N3YuMjVhLjM3Ni4zNzYsMCwwLDEtLjM3NS4zNzVIMy4zNzRBLjM3Ni4zNzYsMCwwLDEsMyw3LjUyN3YtLjI1QS4zNzYuMzc2LDAsMCwxLDMuMzc0LDYuOUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDcuMjc3Wm0wLDJ2LjI1YS4zNzYuMzc2LDAsMCwxLS4zNzUuMzc1SDMuMzc0QS4zNzYuMzc2LDAsMCwxLDMsOS41MjZ2LS4yNUEuMzc2LjM3NiwwLDAsMSwzLjM3NCw4LjlIOC42MjNBLjM3Ni4zNzYsMCwwLDEsOSw5LjI3NlptMCwydi4yNWEuMzc2LjM3NiwwLDAsMS0uMzc1LjM3NUgzLjM3NEEuMzc2LjM3NiwwLDAsMSwzLDExLjUyNnYtLjI1YS4zNzYuMzc2LDAsMCwxLC4zNzUtLjM3NUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDExLjI3NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NDcxIC0zMjY3LjkpIiBmaWxsPSIjMDAzNjc5Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "H3ds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/geneTag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var geneTag = ({
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagWidth: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    tagHeight: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    title: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    dataInfo: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    genes: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    noFocus: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    };
  },

  computed: {
    filtedGenes: function filtedGenes() {
      return Object(util["i" /* groupBy */])(this.genes, function (gene) {
        return gene.type;
      }, true);
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.genes.length - 1) % this.genes.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.genes.length;
            break;
          }
      }
      this.$refs['tag-block'].scrollTop = 28 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.genes[this.tagIndex];
      this.onCompelete = true;
      this.content = curTag.name;
      this.$emit('tag', curTag);
      this.commentOnInput();
      !this.noFocus && this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf532f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/geneTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gene-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.genes.length <= 1 ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)}],"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),(_vm.genes && !_vm.onCompelete && _vm.display && _vm.content)?_c('div',{staticClass:"input-tag",style:(_vm.tagWidth ? { 'min-width': _vm.tagWidth } : {})},[_c('div',{staticClass:"tag-block"},[(_vm.genes.length > 0)?[(_vm.dataInfo && (_vm.dataInfo['gene'] || _vm.dataInfo['hpo'] || _vm.dataInfo['condition'] || _vm.dataInfo['panel']))?_c('div',{staticClass:"tag-info-container"},[_c('div',{staticClass:"tag-info-block"},[_c('span',{domProps:{"innerHTML":_vm._s([
              ((_vm.dataInfo['gene'] || {}).displayed ? _vm.dataInfo['gene'].displayed + '/' + _vm.dataInfo['gene'].total + ' genes' : ''),
              ((_vm.dataInfo['panel'] || {}).displayed ? _vm.dataInfo['panel'].displayed + '/' + _vm.dataInfo['panel'].total + ' gene panels' : ''),
              ((_vm.dataInfo['hpo'] || {}).displayed ? _vm.dataInfo['hpo'].displayed + '/' + _vm.dataInfo['hpo'].total + ' phenotypes' : ''),
              ((_vm.dataInfo['condition'] || {}).displayed ? _vm.dataInfo['condition'].displayed + '/' + _vm.dataInfo['condition'].total + ' conditions' : '')
            ].filter(function (x) { return x; }).join(', ').replace(/,(?!.*,)/, ', and') + '.')}})])]):_vm._e(),_vm._v(" "),_c('div',{ref:"tag-block",staticClass:"tag-group-container",style:(_vm.tagHeight ? { 'max-height': _vm.tagHeight } : {})},[((_vm.filtedGenes['gene'] || []).length)?_c('div',{staticClass:"tag-group-block"},[(_vm.title)?_c('div',{staticClass:"tag-title"},[_vm._v("Genes")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtedGenes['gene']),function(tag,index){return _c('div',{key:index,staticClass:"tag",class:{ selected: _vm.tagIndex === index },on:{"mousemove":function (e) { return _vm.tagIndex = index; },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.name.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2):_vm._e(),_vm._v(" "),((_vm.filtedGenes['panel'] || []).length)?_c('div',{staticClass:"tag-group-block"},[(_vm.title)?_c('div',{staticClass:"tag-title"},[_vm._v("Panels")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtedGenes['panel']),function(tag,index){return _c('div',{key:index - -(_vm.filtedGenes['gene'] || []).length,staticClass:"tag",class:{ selected: _vm.tagIndex === index - -(_vm.filtedGenes['gene'] || []).length },on:{"mousemove":function (e) { return _vm.tagIndex = index - -(_vm.filtedGenes['gene'] || []).length; },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.name.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s('<span style=color:#FA3D3D> (' + tag.gene_count + ' gene' + (tag.gene_count > 1 ? 's' : '') + ')</span>')}})])})],2):_vm._e(),_vm._v(" "),((_vm.filtedGenes['hpo'] || []).length)?_c('div',{staticClass:"tag-group-block"},[(_vm.title)?_c('div',{staticClass:"tag-title"},[_vm._v("Phenotypes")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtedGenes['hpo']),function(tag,index){return _c('div',{key:index - -(_vm.filtedGenes['gene'] || []).length - -(_vm.filtedGenes['panel'] || []).length,staticClass:"tag",class:{ selected: _vm.tagIndex === index - -(_vm.filtedGenes['gene'] || []).length - -(_vm.filtedGenes['panel'] || []).length },on:{"mousemove":function (e) { return _vm.tagIndex = index - -(_vm.filtedGenes['gene'] || []).length - -(_vm.filtedGenes['panel'] || []).length; },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.name.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2):_vm._e(),_vm._v(" "),((_vm.filtedGenes['condition'] || []).length)?_c('div',{staticClass:"tag-group-block"},[(_vm.title)?_c('div',{staticClass:"tag-title"},[_vm._v("Conditions")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtedGenes['condition']),function(tag,index){return _c('div',{key:index - -(_vm.filtedGenes['gene'] || []).length - -(_vm.filtedGenes['panel'] || []).length - -(_vm.filtedGenes['hpo'] || []).length,staticClass:"tag",class:{ selected: _vm.tagIndex === index - -(_vm.filtedGenes['gene'] || []).length - -(_vm.filtedGenes['panel'] || []).length - -(_vm.filtedGenes['hpo'] || []).length },on:{"mousemove":function (e) { return _vm.tagIndex = index - -(_vm.filtedGenes['gene'] || []).length - -(_vm.filtedGenes['panel'] || []).length - -(_vm.filtedGenes['hpo'] || []).length; },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.name.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2):_vm._e()])]:[_c('div',{staticClass:"tab-empty"},[_vm._v(_vm._s('No result has been found.'/* ___ */))])]],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_geneTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/geneTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("b/41")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  geneTag,
  tool_geneTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_geneTag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HALv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/borCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var borCor = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    },
    reverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    arrow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    alwaysDisplay: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    width: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    background: {
      type: String,
      default: function _default() {
        return '#f3f3f3';
      }
    },
    border: {
      type: String,
      default: function _default() {
        return '#aaaaaa';
      }
    },
    radius: {
      type: String,
      default: function _default() {
        return '3px';
      }
    },
    shadow: {
      type: String,
      default: function _default() {
        return '0px 0px 0px transparent';
      }
    },
    blockStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    menuBlockStyle: function menuBlockStyle() {
      var style = {
        width: this.width || 'auto',
        'white-space': this.width ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      };
      return extends_default()({}, style, this.blockStyle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6404d823","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/borCor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor",class:{ 'no-arrow': !_vm.arrow }},[_c('div',{staticClass:"trigger",class:{ 'always-display': _vm.alwaysDisplay }},[_vm._t("trigger")],2),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"menu-container",class:[_vm.type, { reverse: _vm.reverse }],style:({ '--sd-style': _vm.shadow })},[_c('div',{staticClass:"menu-block default-shadow",style:(_vm.menuBlockStyle)},[_vm._t("content")],2),_vm._v(" "),_c('span',{staticClass:"cursor-bor-cor"}),_vm._v(" "),(_vm.arrow)?[_c('span',{staticClass:"menu-bor-cor shadow-top",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor",style:({ '--bg-color': _vm.background })})]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_borCor = (esExports);
// CONCATENATED MODULE: ./src/components/tool/borCor.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ew9o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  borCor,
  tool_borCor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_borCor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HCoM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "HZ4l":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Hct3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC41IiBoZWlnaHQ9IjE0LjUiIHZpZXdCb3g9IjAgMCAxNC41IDE0LjUiPgogIDxwYXRoIGlkPSJwbHVzLWxpZ2h0IiBkPSJNMTMuNzA4LDcwLjEyNUg3Ljg3NVY2NC4yOTJBLjI5Mi4yOTIsMCwwLDAsNy41ODMsNjRINi40MTdhLjI5Mi4yOTIsMCwwLDAtLjI5Mi4yOTJ2NS44MzNILjI5MkEuMjkyLjI5MiwwLDAsMCwwLDcwLjQxN3YxLjE2N2EuMjkyLjI5MiwwLDAsMCwuMjkyLjI5Mkg2LjEyNXY1LjgzM0EuMjkyLjI5MiwwLDAsMCw2LjQxNyw3OEg3LjU4M2EuMjkyLjI5MiwwLDAsMCwuMjkyLS4yOTJWNzEuODc1aDUuODMzQS4yOTIuMjkyLDAsMCwwLDE0LDcxLjU4M1Y3MC40MTdBLjI5Mi4yOTIsMCwwLDAsMTMuNzA4LDcwLjEyNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMjUgLTYzLjc1KSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNjc5IiBzdHJva2Utd2lkdGg9IjAuNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "IMLV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ "Id76":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./checkbox-true.svg": "7kqe",
	"./radio-true.svg": "xccc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Id76";

/***/ }),

/***/ "K4Tr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iT3BodGhhbG1vbG9neSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg1NCAtNzcxKSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI5MjgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI5MjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1NCA3NzEpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMSIgb3BhY2l0eT0iMCI+CiAgICAgIDxyZWN0IHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJleWUtc3ZncmVwby1jb20iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg1NCA2NjAuODI2KSI+CiAgICAgIDxnIGlkPSLjgrDjg6vjg7zjg5dfNzA4MCIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgNzA4MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMTUuODUzKSI+CiAgICAgICAgPHBhdGggaWQ9IuODkeOCuV8yNyIgZGF0YS1uYW1lPSLjg5HjgrkgMjciIGQ9Ik0yOS44ODMsMTI1LjYzNmEuOTY5Ljk2OSwwLDAsMCwwLS45MjRjLTIuODY2LTUuMjc3LTguNDU2LTkuNTM4LTE0Ljg4My05LjUzOFMyLjk4NCwxMTkuNDM1LjExOCwxMjQuNzEyYS45NjkuOTY5LDAsMCwwLDAsLjkyNGMyLjg2Niw1LjI3Nyw4LjQ1Niw5LjUzOCwxNC44ODMsOS41MzhTMjcuMDE3LDEzMC45MTMsMjkuODgzLDEyNS42MzZaTTE1LDEzMi4zMjRhNy4xNSw3LjE1LDAsMSwxLDcuMTUtNy4xNUE3LjE1LDcuMTUsMCwwLDEsMTUsMTMyLjMyNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTExNS44NTMpIiBmaWxsPSIjZmZmIi8+CiAgICAgICAgPHBhdGggaWQ9IuODkeOCuV8yOCIgZGF0YS1uYW1lPSLjg5HjgrkgMjgiIGQ9Ik0yMzUuMzEzLDIzMS42N2EzLjY1MiwzLjY1MiwwLDAsMC0uODcyLjEwNSwxLjg5LDEuODksMCwwLDEtMi42NjYsMi42NjYsMy42NDQsMy42NDQsMCwxLDAsMy41MzgtMi43NzFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjIwLjMxMyAtMjI1Ljk5MykiIGZpbGw9IiNmZmYiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "K4ph":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzQzNzkiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDQzNzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yOTIyIC0xOTg2KSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzE0OTMiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDE0OTMiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjkyMiAxOTg2KSIgZmlsbD0iI2ZmZiIgb3BhY2l0eT0iMCIvPgogICAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTEuMTExLjU4OWwtLjUtLjVhLjMuMywwLDAsMC0uNDMsMEw1LjYsNC42NTYsMS4wMi4wODlhLjMuMywwLDAsMC0uNDMsMGwtLjUuNWEuMy4zLDAsMCwwLDAsLjQzbDUuMyw1LjI5MmEuMy4zLDAsMCwwLC40MywwbDUuMy01LjI5MkEuMy4zLDAsMCwwLDExLjExMS41ODlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOTM1LjMzMyAxOTk3LjIpIHJvdGF0ZSgxODApIiBmaWxsPSIjMDAzNjc5Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "KWcF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stY2lyY2xlLXNvbGlkIiBkPSJNMjgsMThBMTAsMTAsMCwxLDEsMTgsOCwxMCwxMCwwLDAsMSwyOCwxOFpNMTYuODQzLDIzLjI5NWw3LjQxOS03LjQxOWEuNjQ1LjY0NSwwLDAsMCwwLS45MTJsLS45MTItLjkxMmEuNjQ1LjY0NSwwLDAsMC0uOTEyLDBMMTYuMzg3LDIwLjFsLTIuODI1LTIuODI1YS42NDUuNjQ1LDAsMCwwLS45MTIsMGwtLjkxMi45MTJhLjY0NS42NDUsMCwwLDAsMCwuOTEybDQuMTk0LDQuMTk0YS42NDUuNjQ1LDAsMCwwLC45MTIsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iIzgzYzkxZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "LRBV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBpZD0iaW5mby1jaXJjbGUtbGlnaHQiIGQ9Ik0xNiw5LjAzMkE2Ljk2OCw2Ljk2OCwwLDEsMSw5LjAzMiwxNiw2Ljk2OSw2Ljk2OSwwLDAsMSwxNiw5LjAzMk0xNiw4YTgsOCwwLDEsMCw4LDhBOCw4LDAsMCwwLDE2LDhaTTE0LjgzOSwxOS4xaC4zODdWMTUuMjI2aC0uMzg3YS4zODcuMzg3LDAsMCwxLS4zODctLjM4N3YtLjI1OGEuMzg3LjM4NywwLDAsMSwuMzg3LS4zODdoMS41NDhhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODdWMTkuMWguMzg3YS4zODcuMzg3LDAsMCwxLC4zODcuMzg3di4yNThhLjM4Ny4zODcsMCwwLDEtLjM4Ny4zODdIMTQuODM5YS4zODcuMzg3LDAsMCwxLS4zODctLjM4N3YtLjI1OEEuMzg3LjM4NywwLDAsMSwxNC44MzksMTkuMVpNMTYsMTEuMzU1YTEuMDMyLDEuMDMyLDAsMSwwLDEuMDMyLDEuMDMyQTEuMDMyLDEuMDMyLDAsMCwwLDE2LDExLjM1NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iIzk5OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Lkm/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNC45MTQiIHZpZXdCb3g9IjAgMCAyMCAxNC45MTQiPgogIDxwYXRoIGlkPSJjaGVjay1zb2xpZCIgZD0iTTYuNzkzLDc5LjcybC02LjUtNi41YTEsMSwwLDAsMSwwLTEuNDE0bDEuNDE0LTEuNDE0YTEsMSwwLDAsMSwxLjQxNCwwTDcuNSw3NC43N2w5LjM3OS05LjM3OWExLDEsMCwwLDEsMS40MTQsMGwxLjQxNCwxLjQxNGExLDEsMCwwLDEsMCwxLjQxNGwtMTEuNSwxMS41YTEsMSwwLDAsMS0xLjQxNCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNjUuMDk4KSIgZmlsbD0iIzgzYzkxZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "M0RH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "MsWW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiM4M2M5MWUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Mt5Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/api/config.js
var api_config = __webpack_require__("T452");

// EXTERNAL MODULE: ./src/components/tool/newBorCor.vue + 2 modules
var newBorCor = __webpack_require__("jHy4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/nullConditionalOperator.vue

/* harmony default export */ var nullConditionalOperator = ({
  methods: {
    nco: function nco(operation, _default) {
      try {
        var result = operation();
        return result !== null && result !== undefined ? result : _default;
      } catch (e) {
        return _default;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/nullConditionalOperator.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  nullConditionalOperator,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_nullConditionalOperator = (Component.exports);

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/mixins/responsitive.vue + 1 modules
var responsitive = __webpack_require__("E4co");

// EXTERNAL MODULE: ./src/mixins/loginData.vue + 1 modules
var loginData = __webpack_require__("P6mg");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/header.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var header = ({
  components: {
    borCor: newBorCor["a" /* default */]
  },
  mixins: [mixins_nullConditionalOperator, toastMethods["a" /* default */], responsitive["a" /* default */], loginData["a" /* default */]],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isLogin', 'user', 'userSetting']), {
    customIsLogin: function customIsLogin() {
      return this.isLogin && !['genePanel'].includes(this.$route.name);
    },
    leftHeader: function leftHeader() {
      return this.$route.name && ['genePanel', 'coverageRate'].includes(this.$route.name);
    },
    avatarUrl: function avatarUrl() {
      var config = this.$ls.get('userInfo');
      var avatar = this.userSetting.avatar_file || {};
      return api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + avatar.id + '&class_name=' + avatar.class_name + '&access_token=' + config['access_token'];
    },
    routes: function routes() {
      var _this = this;

      return {
        left: [{
          title: 'Case List' /* ___ */
          , to: { name: 'caseList' },
          icon: __webpack_require__("aYau"),
          iconStyle: { width: '16px' },
          actives: ['caseList']
        }, {
          title: 'PhenoVarDB<br>Population Frequencies' /* ___ */
          , to: { name: 'datasetList' },
          icon: __webpack_require__("i6O6"),
          iconStyle: { width: '16px' },
          actives: ['datasetList', 'datasetEdit', 'datasetDetail']
        }],
        right: [{
          info: 'User Manual' /* ___ */
          , subRoutes: [{
            info: 'InheriNext',
            func: function func() {
              return _this.donwoladManual('default');
            }
          }, {
            info: 'InheriNext TAIWAN',
            func: function func() {
              return _this.donwoladManual('tw');
            }
          }],
          icon: __webpack_require__("t62l")
        }, {
          info: 'Log out' /* ___ */
          , func: function func() {
            return _this.userLogout();
          },
          icon: __webpack_require__("D1u2")
        }]
      };
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoginAction']), {
    donwoladManual: function donwoladManual(type) {
      switch (type) {
        case 'default':
          {
            Object(util["e" /* downloadFile */])('InheriNext 因可閱基因數據分析平台操作手冊_v1.0.1.pdf', '../../../static/InheriNext_manual.pdf', '_blank');
            break;
          }
        case 'tw':
          {
            Object(util["e" /* downloadFile */])('InheriNext TAIWAN 臺灣因可閱基因數據分析平台操作手冊_v1.0.1.pdf', '../../../static/InheriNext_tw_manual.pdf', '_blank');
            break;
          }
      }
    },
    userLogout: function userLogout() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context.next = 4;
                return Object(api["o" /* deleteUser */])(config);

              case 4:
                _this2.setUserData(null);
                _this2.$router.push({ name: 'main' });
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this2.setLoginAction(true);
                _this2.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5470526","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"max-width row-block"},[_c('div',{staticClass:"left row-block",style:(!_vm.customIsLogin || _vm.isMobile ? { flex: 1 } : {})},[(_vm.customIsLogin && !_vm.isMobile)?[_c('router-link',{staticClass:"img",attrs:{"to":{ name: 'caseList' }}},[_c('img',{style:({ width: '108px', height: '30px' }),attrs:{"src":__webpack_require__("q3sG"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '27.3px' })}),_vm._v(" "),_vm._l((_vm.routes['left']),function(route,index){return _c('div',{key:index,staticClass:"route-container",class:{ active: (route.actives || []).includes(_vm.$route.name), icon: !route.title },attrs:{"title":route.title.replace(/\<br\>/g, ' ')}},[(route.to)?_c('router-link',{staticClass:"route-block center-block",attrs:{"to":route.to}},[_c('div',{staticClass:"route-content link",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title",domProps:{"innerHTML":_vm._s(route.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):(route.func)?_c('div',{staticClass:"route-block center-block function",class:{ icon: !route.title },on:{"click":function (e) { return route.func(); }}},[_c('div',{staticClass:"route-content",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title",domProps:{"innerHTML":_vm._s(route.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):_vm._e()],1)}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:(_vm.leftHeader)?_c('router-link',{staticClass:"img",attrs:{"to":_vm.customIsLogin ? { name: 'main' } : { name: _vm.$route.name }}},[_c('img',{style:({ width: '108px', height: '30px' }),attrs:{"src":__webpack_require__("q3sG"),"alt":""}})]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"center center-block",style:(_vm.customIsLogin ? { width: '10px'} : {})},[((!_vm.customIsLogin || _vm.isMobile) && !_vm.leftHeader)?_c('router-link',{staticClass:"img",attrs:{"to":_vm.customIsLogin ? { name: 'main' } : { name: _vm.$route.name }}},[_c('img',{style:({ width: '108px', height: '30px' }),attrs:{"src":__webpack_require__("q3sG"),"alt":""}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"right row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(_vm.customIsLogin && !_vm.isMobile)?_c('div',{staticClass:"row-block"},[_c('router-link',{staticClass:"user-container row-block",attrs:{"to":{ name: 'user' }}},[_c('div',{staticClass:"user-avatar",style:({ 'background-image': 'url(' + ((_vm.avatarUrl || __webpack_require__("GW3Y"))) + ')' })}),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"user-name"},[_vm._v(_vm._s([_vm.user.first_name, _vm.user.last_name].join(' ')))]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"col-block",style:({ height: '19px' })},[_c('div',{style:({ height: '7px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("gijb"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_vm._l((_vm.routes['right']),function(route,index){return _c('div',{key:index,staticClass:"route-container",class:{ active: (route.actives || []).includes(_vm.$route.name), icon: !route.title },attrs:{"title":route.info.replace(/\<br\>/g, ' ')}},[(route.to)?_c('router-link',{staticClass:"route-block center-block",attrs:{"to":route.to}},[_c('div',{staticClass:"route-content link",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title"},[_vm._v(_vm._s(route.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):(route.func)?_c('div',{staticClass:"route-block center-block function",class:{ icon: !route.title },on:{"click":function (e) { return route.func(); }}},[_c('div',{staticClass:"route-content",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title"},[_vm._v(_vm._s(route.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]):(route.subRoutes)?_c('div',{staticClass:"route-block center-block sub",class:{ icon: !route.title }},[_c('borCor',{attrs:{"background":'white',"border":'#CCCCCC',"deviation":'15px 45px',"radius":'8px',"blockStyle":{
                padding: '0'
              }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"route-content",class:[route.title ? 'row-block' : 'center-block']},[_c('img',{style:(route.iconStyle || {}),attrs:{"src":route.icon,"alt":""}}),_vm._v(" "),(route.title)?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"route-title"},[_vm._v(_vm._s(route.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"content sub-route-content col-block width-full",attrs:{"slot":"content"},slot:"content"},_vm._l((route.subRoutes),function(subRoute,srindex){return _c('div',{key:srindex,staticClass:"sub-route-container col-block width-full",on:{"click":function (e) { return (subRoute.func || (function () { return ({}); }))(); }}},[_c('div',{staticClass:"sub-route-title"},[_vm._v(_vm._s(subRoute.info))])])}),0)])],1):_vm._e()],1)})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_header = (esExports);
// CONCATENATED MODULE: ./src/components/layout/header.vue
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = null
/* scopeId */
var header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  layout_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_layout_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/footer.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var footer = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f99a60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"max-width"},[_c('span',[_vm._v(_vm._s('Footer'/* ___ */))])])])}
var footer_staticRenderFns = []
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var layout_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/layout/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  layout_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_layout_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/toast.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var tool_toast = ({
  mixins: [loginData["a" /* default */]],
  data: function data() {
    return {
      toasts: [],
      noPermissionTimer: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['toast']), {
    noPermissionMsg: function noPermissionMsg() {
      return 'You have no permission to do this operation.'; /* ___ */
    }
  }),
  watch: {
    'toast': function toast(nv) {
      var _this = this;

      if (!this.noPermissionTimer || nv.content !== this.noPermissionMsg) {
        var id = new Date().getTime() + '';
        this.toasts.push(extends_default()({}, nv, {
          id: id,
          clearTimer: null,
          timer: setTimeout(function () {
            _this.toasts.splice(_this.toasts.indexOf(_this.toasts.find(function (toast) {
              return toast.id === id;
            })), 1);
          }, 5000)
        }));
        if (nv.content === this.noPermissionMsg) {
          this.checkAccessToken();
        }
      }
      if (nv.content === this.noPermissionMsg) {
        this.noPermissionTimer = setTimeout(function () {
          _this.noPermissionTimer = null;
        }, 500);
      }
    }
  },
  methods: {
    keepToast: function keepToast(toast) {
      toast.clearTimer = setTimeout(function () {
        clearTimeout(toast.timer);
        toast.clearTimer = null;
      }, 500);
    },
    leaveToast: function leaveToast(toast, index) {
      if (toast.clearTimer) {
        clearTimeout(toast.clearTimer);
      } else {
        this.removeToast(index);
      }
    },
    removeToast: function removeToast(index) {
      this.toasts.splice(index, 1);
    },
    checkAccessToken: function checkAccessToken() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context.next = 4;
                return Object(api["_48" /* getUserToken */])(config);

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                _this2.setUserData(null);
                _this2.$router.push({ name: 'main' });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 6]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d54261a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/toast.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-position"},[_c('div',{staticClass:"toast-container"},[_c('transition-group',{attrs:{"name":"toastDown"}},_vm._l((_vm.toasts),function(toast,index){return _c('div',{key:index + 0,staticClass:"toast col-block",class:[toast.type],on:{"mouseenter":function (e) { return _vm.keepToast(toast); },"mouseleave":function (e) { return _vm.leaveToast(toast, index); }}},[_c('div',{staticClass:"option"},[_c('img',{attrs:{"src":__webpack_require__("nzHv"),"alt":""},on:{"click":function (e) { return _vm.removeToast(index); }}})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s({ error: 'Error !', success: 'Success !' }[toast.type]))]),_vm._v(" "),_c('div',{style:({ height: '14px' })}),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(toast.content)}})])}),0)],1)])}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var components_tool_toast = (toast_esExports);
// CONCATENATED MODULE: ./src/components/tool/toast.vue
var toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = null
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  tool_toast,
  components_tool_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var src_components_tool_toast = (toast_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/borCor.vue + 2 modules
var tool_borCor = __webpack_require__("HALv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/borCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// borCor

/* harmony default export */ var layout_borCor = ({
  components: {
    borCorCP: tool_borCor["a" /* default */]
    // borCor
  },
  data: function data() {
    return {
      borCorData: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['borCor'])),
  watch: {
    'borCor': function borCor(nv) {
      this.borCorData = nv ? extends_default()({}, nv, {
        triggerData: nv.e.target.getBoundingClientRect()
      }) : null;
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setBorCorAction']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0872e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/borCor.vue
var borCor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor-page",style:(_vm.borCorData ? {
    top: _vm.borCorData.triggerData.top + 'px',
    left: _vm.borCorData.triggerData.left + 'px'
  } : {})},[(_vm.borCorData)?_c('borCorCP',_vm._b({on:{"leave":function () { return _vm.setBorCorAction(); }}},'borCorCP',_vm.borCorData.options || {},false),[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"bor-cor-container",style:({
          width: _vm.borCorData.triggerData.width + 'px',
          height: _vm.borCorData.triggerData.height + 'px'
        })})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[((_vm.borCorData.content || {}).html)?_c('div',{domProps:{"innerHTML":_vm._s((_vm.borCorData.content || {}).html)}}):((_vm.borCorData.content || {}).component)?_c((_vm.borCorData.content || {}).component,{tag:"component",attrs:{"param":(_vm.borCorData.content || {}).param}}):_vm._e()],1)]):_vm._e()],1)}
var borCor_staticRenderFns = []
var borCor_esExports = { render: borCor_render, staticRenderFns: borCor_staticRenderFns }
/* harmony default export */ var components_layout_borCor = (borCor_esExports);
// CONCATENATED MODULE: ./src/components/layout/borCor.vue
var borCor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var borCor___vue_template_functional__ = false
/* styles */
var borCor___vue_styles__ = null
/* scopeId */
var borCor___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var borCor___vue_module_identifier__ = null
var borCor_Component = borCor_normalizeComponent(
  layout_borCor,
  components_layout_borCor,
  borCor___vue_template_functional__,
  borCor___vue_styles__,
  borCor___vue_scopeId__,
  borCor___vue_module_identifier__
)

/* harmony default export */ var src_components_layout_borCor = (borCor_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccb20d96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/loading.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var layout_loading = (loading_esExports);
// CONCATENATED MODULE: ./src/components/layout/loading.vue
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = null
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  layout_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)

/* harmony default export */ var components_layout_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/uploading.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var uploading = ({
  props: {
    content: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f1a7021","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/uploading.vue
var uploading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploading-page"},[_c('div',{staticClass:"img-box"},[_c('h1',[_vm._v(_vm._s(_vm.content !== null ? _vm.content : '檔案上傳中'/* ___ */))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var uploading_staticRenderFns = []
var uploading_esExports = { render: uploading_render, staticRenderFns: uploading_staticRenderFns }
/* harmony default export */ var layout_uploading = (uploading_esExports);
// CONCATENATED MODULE: ./src/components/layout/uploading.vue
var uploading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var uploading___vue_template_functional__ = false
/* styles */
var uploading___vue_styles__ = null
/* scopeId */
var uploading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var uploading___vue_module_identifier__ = null
var uploading_Component = uploading_normalizeComponent(
  uploading,
  layout_uploading,
  uploading___vue_template_functional__,
  uploading___vue_styles__,
  uploading___vue_scopeId__,
  uploading___vue_module_identifier__
)

/* harmony default export */ var components_layout_uploading = (uploading_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var object_values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(object_values);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/customRecursive.vue



/* harmony default export */ var mixins_customRecursive = ({
  data: function data() {
    return {
      _timer: 0
    };
  },

  methods: {
    customRecursive: function customRecursive() {
      var _this = this;

      var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return false;
      };
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var recursive;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                recursive = function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return func();

                          case 2:
                            if (!_context.sent) {
                              _context.next = 4;
                              break;
                            }

                            _this._timer = setTimeout(recursive, time);

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function recursive() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context2.next = 3;
                return recursive();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this._timer);
    this._timer = 0;
  }
});
// CONCATENATED MODULE: ./src/mixins/customRecursive.vue
var customRecursive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var customRecursive___vue_template__ = null
/* template functional */
var customRecursive___vue_template_functional__ = false
/* styles */
var customRecursive___vue_styles__ = null
/* scopeId */
var customRecursive___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var customRecursive___vue_module_identifier__ = null
var customRecursive_Component = customRecursive_normalizeComponent(
  mixins_customRecursive,
  customRecursive___vue_template__,
  customRecursive___vue_template_functional__,
  customRecursive___vue_styles__,
  customRecursive___vue_scopeId__,
  customRecursive___vue_module_identifier__
)

/* harmony default export */ var src_mixins_customRecursive = (customRecursive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/gcsResumable.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var gcsResumable = ({
  mixins: [toastMethods["a" /* default */], src_mixins_customRecursive],
  data: function data() {
    return {
      uploadThreadDatas: [],
      metadata: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isFileUpload', 'uploadCount', 'waitUploading', 'isLogin', 'user']), {
    uploadingCaseIDs: function uploadingCaseIDs() {
      return this.groupFiles.map(function (datas) {
        return datas[0].caseData.id;
      });
    },
    groupFiles: function groupFiles() {
      var _this = this;

      var groupRule = function groupRule(data) {
        var groupName = _this.getGroupName(data);
        values_default()(_this.metadata).forEach(function (m) {
          m[groupName] = m[groupName] || '';
        });
        return groupName;
      };
      return Object(util["i" /* groupBy */])(this.uploadThreadDatas, groupRule);
    }
  }),
  created: function created() {
    var _this2 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, state;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.userData = _this2.user;
              _context.prev = 1;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 5;
              _iterator = get_iterator_default()(values_default()(_this2.getResumableInfo()));

            case 7:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 16;
                break;
              }

              data = _step.value;
              _context.next = 11;
              return _this2.getUploadState(data);

            case 11:
              state = _context.sent;

              if (state) {
                _this2.uploadThreadDatas.push(extends_default()({}, data, state, {
                  state: state.loaded < data.file.size ? 'stop' : 'completed'
                }));
              }

            case 13:
              _iteratorNormalCompletion = true;
              _context.next = 7;
              break;

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context['catch'](5);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 22:
              _context.prev = 22;
              _context.prev = 23;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 25:
              _context.prev = 25;

              if (!_didIteratorError) {
                _context.next = 28;
                break;
              }

              throw _iteratorError;

            case 28:
              return _context.finish(25);

            case 29:
              return _context.finish(22);

            case 30:
              _context.next = 35;
              break;

            case 32:
              _context.prev = 32;
              _context.t1 = _context['catch'](1);

              _this2.addToast('error', !_context.t1.response ? _context.t1.message : _context.t1.response.data.result.message);

            case 35:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 32], [5, 18, 22, 30], [23,, 25, 29]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    var _this3 = this;

    this.uploadThreadDatas.filter(function (data) {
      return ['uploading'].includes(data.state);
    }).forEach(function (data) {
      _this3.stopUpload(data);
      _this3.cancelFile(data);
    });
  },

  watch: {
    'waitUploading': function waitUploading(nv) {
      if (nv) {
        this.selectFiles(nv.caseData, nv.fileSets);
      }
      this.setWaitUploadingAction();
    },
    'isLogin': function isLogin(nv) {
      if (nv === false) {
        this.deleteGroup(this.uploadThreadDatas);
      }
    },
    'groupFiles.length': function groupFilesLength(nv, ov) {
      nv > ov && this.$emit('count');
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['addUploadCountAction', 'setWaitUploadingAction', 'setResumableInfoAction']), {
    // selectFiles (e) {
    //   const s = dateFormat(new Date(), 'yyyyMMddhhmmssS')
    //   this.uploadThreadDatas = this.uploadThreadDatas.concat(Array.from(e.target.files).map(file => ({
    //     file: file,
    //     groupTime: s,
    //     extention: file.name.split('.').reverse()[0]
    //   })))
    //   e.target.value = ''
    // },
    selectFiles: function selectFiles(caseData, fileSets) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var s, datas, signUrls, _datas;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this4.uploadingCaseIDs.includes(caseData.id)) {
                  _context2.next = 12;
                  break;
                }

                s = Object(util["d" /* dateFormat */])(new Date(), 'yyyyMMddhhmmssS');
                datas = [];
                _context2.next = 5;
                return _this4.getSignUrl(caseData, fileSets);

              case 5:
                signUrls = _context2.sent;

                fileSets.forEach(function (set, index) {
                  if (caseData.dataset === 'vcf') {
                    datas.push({
                      file: set.vcf,
                      signUrl: signUrls[index].vcf,
                      caseData: caseData,
                      groupTime: s,
                      extention: set.vcf.name.split('.').reverse()[0]
                    });
                  } else if (caseData.dataset === 'fastq') {
                    datas.push({
                      file: set.r1,
                      signUrl: signUrls[index].r1,
                      caseData: caseData,
                      groupTime: s,
                      extention: set.r1.name.split('.').reverse()[0]
                    });
                    datas.push({
                      file: set.r2,
                      signUrl: signUrls[index].r2,
                      caseData: caseData,
                      groupTime: s,
                      extention: set.r1.name.split('.').reverse()[0]
                    });
                  }
                });
                _this4.uploadThreadDatas = _this4.uploadThreadDatas.concat(datas);
                _context2.next = 10;
                return _this4.uploadFile(datas);

              case 10:
                _context2.next = 14;
                break;

              case 12:
                _datas = _this4.uploadThreadDatas.filter(function (data) {
                  return data.caseData.id === caseData.id;
                });

                _this4.completeFile(fileSets, _datas);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    uploadFile: function uploadFile(datas) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var i, _i, state, _i2;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (datas.some(function (data) {
                  return !data.state || ['stop', 'error'].includes(data.state);
                })) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return', false);

              case 2:
                // if (datas.some(data => !data.signUrl)) {
                //   const signUrls = await this.getSignUrl(datas)
                //   for (let i = 0; i < datas.length; i++) {
                //     if (signUrls[i]) {
                //       datas[i] = this.refreshData(datas[i], { signUrl: signUrls[i].url })
                //       this.saveResumableInfo(datas[i])
                //     }
                //   }
                // }
                for (i = 0; i < datas.length; i++) {
                  if (!datas[i].state) {
                    datas[i] = _this5.refreshData(datas[i], { state: 'stop' });
                    _this5.saveResumableInfo(datas[i]);
                  }
                }

                if (!datas.every(function (data) {
                  return data.signUrl;
                })) {
                  _context3.next = 29;
                  break;
                }

                _i = 0;

              case 5:
                if (!(_i < datas.length)) {
                  _context3.next = 18;
                  break;
                }

                if (!(!datas[_i].state || ['stop', 'error'].includes(datas[_i].state))) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 9;
                return _this5.getUploadState(datas[_i]);

              case 9:
                state = _context3.sent;

                if (!state) {
                  _context3.next = 14;
                  break;
                }

                datas[_i] = _this5.refreshData(datas[_i], state);
                _context3.next = 15;
                break;

              case 14:
                return _context3.abrupt('return', true);

              case 15:
                _i++;
                _context3.next = 5;
                break;

              case 18:
                _i2 = 0;

              case 19:
                if (!(_i2 < datas.length)) {
                  _context3.next = 26;
                  break;
                }

                if (!(!datas[_i2].state || ['stop', 'error'].includes(datas[_i2].state))) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 23;
                return _this5.postFile(datas, _i2);

              case 23:
                _i2++;
                _context3.next = 19;
                break;

              case 26:
                return _context3.abrupt('return', false);

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getSignUrl: function getSignUrl(caseData, fileSets) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, id, dataset, data, response, signUrls;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this6.$ls.get('userInfo', {});
                id = caseData.id;
                dataset = caseData.dataset;
                data = {};

                if (caseData.dataset === 'vcf') {
                  data.vcf_file = {
                    vcf: {
                      name: fileSets[0].vcf.name,
                      content_type: fileSets[0].vcf.type || 'text/plain'
                    }
                  };
                } else if (caseData.dataset === 'fastq') {
                  data.omics = caseData.omics_name;
                  data.pipeline = caseData.pipeline_name;
                  data.library_type = caseData.library_type_name;
                  data.ngs_files = fileSets.map(function (set) {
                    return {
                      r1: {
                        name: set.r1.name,
                        content_type: set.r1.type || 'text/plain'
                      },
                      r2: {
                        name: set.r2.name,
                        content_type: set.r2.type || 'text/plain'
                      }
                    };
                  });
                }
                _context4.next = 8;
                return Object(api["_60" /* postCaseSampleFile */])(id, dataset, data, config);

              case 8:
                response = _context4.sent;
                signUrls = response.data.data;
                return _context4.abrupt('return', caseData.dataset === 'vcf' ? [signUrls] : signUrls);

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](0);

                _this6.addToast('error', !_context4.t0.response ? _context4.t0.message : _context4.t0.response.data.result.message);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 13]]);
      }))();
    },
    getUploadState: function getUploadState(data) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var status;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!data.signUrl) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 3;
                return new promise_default.a(function (resolve) {
                  var xhr = _this7.createCORSRequest('PUT', data.signUrl);
                  if (xhr.upload) {
                    xhr.onerror = function (e) {
                      resolve(null);
                    };
                    xhr.onload = function (e) {
                      var headers = xhr.getAllResponseHeaders().split('\n').reduce(function (s, c) {
                        return extends_default()({}, s, defineProperty_default()({}, c.split(': ')[0], c.split(': ')[1]));
                      }, {});
                      var loaded = headers['range'] ? headers['range'].replace('bytes=0-', '') - -1 : 0;
                      resolve({
                        loaded: loaded,
                        curLoaded: 0
                      });
                    };
                    xhr.setRequestHeader('Content-Type', data.file.type || 'text/plain');
                    xhr.setRequestHeader('Content-Range', 'bytes */' + data.file.size);
                    xhr.send();
                  }
                });

              case 3:
                _context5.t0 = _context5.sent;
                _context5.next = 7;
                break;

              case 6:
                _context5.t0 = null;

              case 7:
                status = _context5.t0;
                return _context5.abrupt('return', status);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    postFile: function postFile(datas, i) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var xhr, file;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                xhr = _this8.createCORSRequest('PUT', datas[i].signUrl);

                if (xhr.upload) {
                  xhr.upload.addEventListener('progress', function (e) {
                    if (e.lengthComputable) {
                      datas[i] = _this8.refreshData(datas[i], { curLoaded: e.loaded });
                    }
                  }, false);
                  xhr.onload = function (e) {
                    datas[i] = _this8.refreshData(datas[i], { state: 'completed' });
                    if (datas.every(function (data) {
                      return ['completed'].includes(data.state);
                    })) {
                      for (var _i3 = 0; _i3 < datas.length; _i3++) {
                        _this8.removeResumableInfo(datas[_i3]);
                      }
                      _this8.$emit('complete');
                      _this8.addUploadCountAction(true);
                    }
                  };
                  xhr.onerror = function () {
                    datas[i] = _this8.stopUpload(datas[i], true);
                    if (datas.every(function (data) {
                      return ['completed', 'error'].includes(data.state);
                    })) {
                      _this8.customRecursive(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                        var result;
                        return regenerator_default.a.wrap(function _callee6$(_context6) {
                          while (1) {
                            switch (_context6.prev = _context6.next) {
                              case 0:
                                if (!datas.every(function (data) {
                                  return _this8.getResumableInfo()[data.signUrl];
                                })) {
                                  _context6.next = 6;
                                  break;
                                }

                                _context6.next = 3;
                                return _this8.uploadFile(datas);

                              case 3:
                                _context6.t0 = _context6.sent;
                                _context6.next = 7;
                                break;

                              case 6:
                                _context6.t0 = false;

                              case 7:
                                result = _context6.t0;
                                return _context6.abrupt('return', result);

                              case 9:
                              case 'end':
                                return _context6.stop();
                            }
                          }
                        }, _callee6, _this8);
                      })), 10 * 1000);
                    }
                  };
                  xhr.setRequestHeader('Content-Type', datas[i].file.type || 'text/plain');
                  if (datas[i].loaded > 0) {
                    xhr.setRequestHeader('Content-Range', 'bytes ' + datas[i].loaded + '-' + (datas[i].file.size - 1) + '/' + datas[i].file.size);
                  }
                  file = datas[i].loaded === 0 ? datas[i].file : datas[i].file.slice(datas[i].loaded, datas[i].file.size);

                  datas[i] = _this8.refreshData(datas[i], {
                    xhr: xhr,
                    state: 'uploading'
                  });
                  xhr.send(file);
                } else {
                  _this8.addToast('error', 'Xhr can not upload.' /* ___ */);
                }

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    stopUpload: function stopUpload(data) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (['uploading'].includes(data.state)) {
        data = this.refreshData(data, {
          loaded: data.curLoaded + data.loaded,
          curLoaded: 0,
          state: isError ? 'error' : 'stop'
        });
        data.xhr.abort();
      }
      return data;
    },
    cancelFile: function cancelFile(data) {
      this.removeResumableInfo(data);
      this.uploadThreadDatas.splice(this.uploadThreadDatas.indexOf(data), 1);
    },

    // completeFile (e, datas) {
    //   let files = Array.from(e.target.files)
    //   for (let i = 0; i < datas.length; i++) {
    //     let index = files.map(file => file.name + '_' + file.type + '_' + file.size).indexOf(datas[i].file.name + '_' + datas[i].file.type + '_' + datas[i].file.size)
    //     if (index !== -1) {
    //       datas[i] = this.refreshData(datas[i], {
    //         file: files[index]
    //       })
    //     } else {
    //       break
    //     }
    //   }
    //   if (datas.every(data => ['completed'].includes(data.state) || data.file.lastModified)) {
    //     for (let i = 0; i < datas.length; i++) {
    //       if (!datas[i].state || ['stop', 'error'].includes(datas[i].state)) {
    //         this.postFile(datas, i)
    //       }
    //     }
    //   } else {
    //     this.addToast('error', 'Wrong Files'/* ___ */)
    //   }
    // },
    completeFile: function completeFile(fileSets, datas) {
      var files = Array.prototype.concat.apply([], fileSets.map(function (set) {
        return values_default()(set);
      }));
      for (var i = 0; i < datas.length; i++) {
        var index = files.map(function (file) {
          return file.name + '_' + file.type + '_' + file.size;
        }).indexOf(datas[i].file.name + '_' + datas[i].file.type + '_' + datas[i].file.size);
        if (index !== -1) {
          datas[i] = this.refreshData(datas[i], {
            file: files[index]
          });
        } else {
          break;
        }
      }
      if (datas.every(function (data) {
        return ['completed'].includes(data.state) || data.file.lastModified;
      })) {
        for (var _i4 = 0; _i4 < datas.length; _i4++) {
          if (!datas[_i4].state || ['stop', 'error'].includes(datas[_i4].state)) {
            this.postFile(datas, _i4);
            this.saveResumableInfo(datas[_i4]);
          }
        }
      } else {
        this.addToast('error', 'Wrong Files' /* ___ */);
      }
    },
    saveResumableInfo: function saveResumableInfo(data) {
      var info = this.$ls.get('resumableInfo') || {};
      info[this.userData.email] = info[this.userData.email] || {};
      info[this.userData.email][data.signUrl] = extends_default()({}, data, {
        file: {
          name: data.file.name,
          type: data.file.type,
          size: data.file.size
        }
      });
      this.$ls.set('resumableInfo', info);
      this.setResumableInfoAction(info);
    },
    getResumableInfo: function getResumableInfo() {
      var info = this.$ls.get('resumableInfo') || {};
      return info[this.userData.email] || {};
    },
    removeResumableInfo: function removeResumableInfo(data) {
      var info = this.$ls.get('resumableInfo') || {};
      if (info[this.userData.email] && info[this.userData.email][data.signUrl]) {
        delete info[this.userData.email][data.signUrl];
        this.$ls.set('resumableInfo', info);
        this.setResumableInfoAction(info);
      }
    },
    createCORSRequest: function createCORSRequest(method, url) {
      var xhr = new XMLHttpRequest();
      if ('withCredentials' in xhr) {
        xhr.open(method, url, true);
      } else if (typeof XDomainRequest !== 'undefined') {
        xhr = new XDomainRequest();
        xhr.open(method, url);
      } else {
        xhr = null;
      }
      return xhr;
    },
    refreshData: function refreshData(data, _data) {
      if (!_data || !values_default()(_data).length) return data;
      var index = this.uploadThreadDatas.indexOf(data);
      this.$set(this.uploadThreadDatas, index, extends_default()({}, data, _data));
      return this.uploadThreadDatas[index];
    },
    getGroupName: function getGroupName(data) {
      var s = data.groupTime || this.dateFormat(new Date(), 'yyyyMMddhhmmssS');
      return data.caseData.id + '_' + (s || '');
    },
    getGroupState: function getGroupState(group) {
      var _this9 = this;

      var sum = group.reduce(function (s, c) {
        return s + _this9.getFilePersent(c);
      }, 0) / group.length;
      var state = group[0].state;
      return {
        uploading: Math.round(sum) + '%' /* ___ */
        , stop: 'Pending' /* ___ */
        , error: 'Failed' /* ___ */
        , completed: '100%' /* ___ */
      }[state] || 'Pending'; /* ___ */
    },
    getFilePersent: function getFilePersent(data) {
      return !data.signUrl ? 0 : Math.round(data.file.size ? (data.curLoaded + data.loaded || 0) * 100 / data.file.size : data.loaded !== undefined ? 100 : 0);
    },
    deleteGroup: function deleteGroup(datas) {
      var _this10 = this;

      this.$emit('cancel', datas.every(function (data) {
        return ['completed'].includes(data.state);
      }));
      datas.forEach(function (data) {
        // this.stopUpload(data)
        if (['uploading'].includes(data.state)) {
          data.xhr.abort();
        }
        _this10.cancelFile(data);
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbd8f24a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/gcsResumable.vue
var gcsResumable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gcs-resumable-container"}},[_c('div',{staticClass:"table-container col-block sub-shadow",style:({ height: '360px' })},[_c('div',{staticClass:"tbody",style:({ flex: 1 })},[_c('div',{style:({ height: 0 })},_vm._l((_vm.groupFiles),function(datas,cindex){return _c('div',{key:cindex,staticClass:"tr row-block"},[_c('div',{staticClass:"container-block row-block"},[_c('div',{staticClass:"td center-block",style:({ width: '140px' })},[_c('span',{attrs:{"title":datas[0].caseData.case_id}},[_vm._v(_vm._s(datas[0].caseData.case_id))])]),_vm._v(" "),_c('div',{staticClass:"td center-block",class:[datas[0].state || 'none'],style:({ width: '102px' })},[_c('span',[_vm._v(_vm._s(_vm.getGroupState(datas)))])]),_vm._v(" "),(!['error', 'completed'].includes(datas[0].state))?_c('div',{staticClass:"icon td center-block",style:({ flex: 1 }),on:{"click":function (e) { return _vm.deleteGroup(datas); }}},[_c('img',{attrs:{"src":__webpack_require__("rafa"),"alt":""}})]):_c('div',{style:({ flex: 1 })})])])}),0)])])])}
var gcsResumable_staticRenderFns = []
var gcsResumable_esExports = { render: gcsResumable_render, staticRenderFns: gcsResumable_staticRenderFns }
/* harmony default export */ var tool_gcsResumable = (gcsResumable_esExports);
// CONCATENATED MODULE: ./src/components/tool/gcsResumable.vue
function injectStyle (ssrContext) {
  __webpack_require__("SY89")
}
var gcsResumable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var gcsResumable___vue_template_functional__ = false
/* styles */
var gcsResumable___vue_styles__ = injectStyle
/* scopeId */
var gcsResumable___vue_scopeId__ = "data-v-bbd8f24a"
/* moduleIdentifier (server only) */
var gcsResumable___vue_module_identifier__ = null
var gcsResumable_Component = gcsResumable_normalizeComponent(
  gcsResumable,
  tool_gcsResumable,
  gcsResumable___vue_template_functional__,
  gcsResumable___vue_styles__,
  gcsResumable___vue_scopeId__,
  gcsResumable___vue_module_identifier__
)

/* harmony default export */ var components_tool_gcsResumable = (gcsResumable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/fileUpload.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var layout_fileUpload = ({
  components: {
    gcsResumable: components_tool_gcsResumable
  },
  data: function data() {
    return {
      count: 0,
      compeleted: 0
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isFileUpload', 'uploadCount'])),
  watch: {
    'count': function count(nv, ov) {
      if (nv > ov) {
        this.setUnloadAlertAction(true);
      } else {
        this.setUnloadAlertAction(false);
      }
    },
    'compeleted': function compeleted(nv, ov) {
      if (nv > ov) {
        this.setUnloadAlertAction(false);
      } else {
        this.setUnloadAlertAction(true);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setFileUploadAction', 'addUploadCountAction', 'setUnloadAlertAction']), {
    fileUploadOpen: function fileUploadOpen() {
      // if (!this.isFileUpload) {
      //   this.addUploadCountAction(false)
      // }
      this.setFileUploadAction(!this.isFileUpload);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c29998","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/fileUpload.vue
var fileUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ open: _vm.isFileUpload },attrs:{"id":"file-upload"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.count),expression:"count"}],staticClass:"file-container col-block"},[_c('div',{staticClass:"title-container row-block",on:{"click":function (e) { return _vm.fileUploadOpen(); }}},[_c('div',{staticClass:"title-icon center-block"},[_c('img',{attrs:{"src":_vm.isFileUpload ? __webpack_require__("WGo8") : __webpack_require__("nfOD"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.isFileUpload ? '(' + _vm.compeleted + '/' + _vm.count + ')' : _vm.compeleted + '/' + _vm.count))]),_vm._v(" "),(_vm.isFileUpload)?_c('div',{style:({ flex: 1 })}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"display-icon",class:{ active: _vm.isFileUpload }},[_c('img',{attrs:{"src":_vm.isFileUpload ? __webpack_require__("prJ5") : __webpack_require__("9odj"),"alt":""}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFileUpload),expression:"isFileUpload"}],staticClass:"gcs-container"},[_c('gcsResumable',{on:{"count":function () { return _vm.count += 1; },"cancel":function (c) {
          _vm.count -= 1
          if (c) {
            _vm.compeleted -= 1
          }
        },"complete":function () { return _vm.compeleted += 1; }}})],1)])])}
var fileUpload_staticRenderFns = []
var fileUpload_esExports = { render: fileUpload_render, staticRenderFns: fileUpload_staticRenderFns }
/* harmony default export */ var components_layout_fileUpload = (fileUpload_esExports);
// CONCATENATED MODULE: ./src/components/layout/fileUpload.vue
function fileUpload_injectStyle (ssrContext) {
  __webpack_require__("s77y")
}
var fileUpload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fileUpload___vue_template_functional__ = false
/* styles */
var fileUpload___vue_styles__ = fileUpload_injectStyle
/* scopeId */
var fileUpload___vue_scopeId__ = "data-v-71c29998"
/* moduleIdentifier (server only) */
var fileUpload___vue_module_identifier__ = null
var fileUpload_Component = fileUpload_normalizeComponent(
  layout_fileUpload,
  components_layout_fileUpload,
  fileUpload___vue_template_functional__,
  fileUpload___vue_styles__,
  fileUpload___vue_scopeId__,
  fileUpload___vue_module_identifier__
)

/* harmony default export */ var src_components_layout_fileUpload = (fileUpload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/loading.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_loading = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ebe78c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/loading.vue
var dialog_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-dialog"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":__webpack_require__("5xS/"),"alt":""}})])])}
var dialog_loading_staticRenderFns = []
var dialog_loading_esExports = { render: dialog_loading_render, staticRenderFns: dialog_loading_staticRenderFns }
/* harmony default export */ var components_dialog_loading = (dialog_loading_esExports);
// CONCATENATED MODULE: ./src/components/dialog/loading.vue
var dialog_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_loading___vue_template_functional__ = false
/* styles */
var dialog_loading___vue_styles__ = null
/* scopeId */
var dialog_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_loading___vue_module_identifier__ = null
var dialog_loading_Component = dialog_loading_normalizeComponent(
  dialog_loading,
  components_dialog_loading,
  dialog_loading___vue_template_functional__,
  dialog_loading___vue_styles__,
  dialog_loading___vue_scopeId__,
  dialog_loading___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_loading = (dialog_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/container.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var container = ({
  components: {
    dialogLoading: src_components_dialog_loading
  },
  props: {
    width: {
      type: String,
      default: function _default() {
        return '400px';
      }
    },
    height: {
      type: String,
      default: function _default() {
        return 'auto';
      }
    },
    customStyles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    maskClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      onClose: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['isDialogLoading']), {
    containerStyle: function containerStyle() {
      return extends_default()({}, this.customStyles, { height: this.height, width: this.width });
    }
  }),
  methods: {
    closeModal: function closeModal(e, type) {
      if (this.maskClose) {
        if (!['modal-mask', 'modal-wrapper'].includes(e.target.className)) {
          this.onClose = false;
          return;
        }
        if (type === 'down') {
          this.onClose = true;
        } else if (this.onClose) {
          this.$emit('hide');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a6f74b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/container.vue
var container_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"mousedown":function (e) { return _vm.closeModal(e, 'down'); },"mouseup":function (e) { return _vm.closeModal(e, 'up'); }}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",style:(_vm.containerStyle)},[_vm._t("default"),_vm._v(" "),(_vm.isDialogLoading)?_c('dialogLoading'):_vm._e()],2)])])])}
var container_staticRenderFns = []
var container_esExports = { render: container_render, staticRenderFns: container_staticRenderFns }
/* harmony default export */ var dialog_container = (container_esExports);
// CONCATENATED MODULE: ./src/components/dialog/container.vue
function container_injectStyle (ssrContext) {
  __webpack_require__("02u3")
}
var container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var container___vue_template_functional__ = false
/* styles */
var container___vue_styles__ = container_injectStyle
/* scopeId */
var container___vue_scopeId__ = "data-v-61a6f74b"
/* moduleIdentifier (server only) */
var container___vue_module_identifier__ = null
var container_Component = container_normalizeComponent(
  container,
  dialog_container,
  container___vue_template_functional__,
  container___vue_styles__,
  container___vue_scopeId__,
  container___vue_module_identifier__
)

/* harmony default export */ var components_dialog_container = (container_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./src/components/tool/customForm.vue + 2 modules
var customForm = __webpack_require__("uuH9");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/userConfirm.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var userConfirm = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */], loginData["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      confirmData: {
        code: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [{
          title: 'Verification' /* ___ */
          , value: 'code',
          type: 'input',
          placeholder: function placeholder() {
            return '6 digits code';
          } /* ___ */
          , validate: 'required'
        }]
      };
    }
  },
  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.confirmData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateConfirmUser: function validateConfirmUser() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this2.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this2.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this2.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this2.confirmUser();

              case 33:
                _this2.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    confirmUser: function confirmUser() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = extends_default()({}, _this3.result, {
                  email: _this3.param.data.email
                });
                _context2.next = 4;
                return Object(api["_61" /* postConfirmUser */])(data);

              case 4:
                response = _context2.sent;

                _this3.setUserData(response);
                _this3.addToast('success', response.data.result.message);
                _this3.$router.push(_this3.$route.query.redirect ? { path: _this3.$route.query.redirect } : { name: 'caseList' });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this3.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 10]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c4ddda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/userConfirm.vue
var userConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-confirm-dailog dialog col-block"},[_c('div',{staticClass:"title-container col-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Success !'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"description-container col-block"},[_c('div',{staticClass:"description"},[_vm._v(_vm._s('We\'ve sent a verification code to your E-mail address.'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s('Please enter verification code to login.'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.confirmData,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateConfirmUser() : ''; }}},[_c('span',[_vm._v(_vm._s('Confirm'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var userConfirm_staticRenderFns = []
var userConfirm_esExports = { render: userConfirm_render, staticRenderFns: userConfirm_staticRenderFns }
/* harmony default export */ var dialog_userConfirm = (userConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/userConfirm.vue
var userConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userConfirm___vue_template_functional__ = false
/* styles */
var userConfirm___vue_styles__ = null
/* scopeId */
var userConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var userConfirm___vue_module_identifier__ = null
var userConfirm_Component = userConfirm_normalizeComponent(
  userConfirm,
  dialog_userConfirm,
  userConfirm___vue_template_functional__,
  userConfirm___vue_styles__,
  userConfirm___vue_scopeId__,
  userConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_userConfirm = (userConfirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelInfo.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var genePanelInfo = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      emailData: {
        email: '',
        name: '',
        organization: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [{
          title: 'Your Name' /* ___ */
          , errorTitle: 'Name' /* ___ */
          , value: 'name',
          type: 'input',
          grid: 6,
          placeholder: function placeholder() {
            return 'Ex: Eric Tsai or 李大平';
          } /* ___ */
          , validate: 'required'
        }, {
          title: 'Organization' /* ___ */
          , errorTitle: 'Organization' /* ___ */
          , value: 'organization',
          type: 'input',
          grid: 6,
          placeholder: function placeholder() {
            return 'Ex: Taiwan Biobank or 康百事生物資訊股份有限公司';
          } /* ___ */
          , validate: 'required'
        }, {
          title: 'Your Email' /* ___ */
          , errorTitle: 'E-mail' /* ___ */
          , value: 'email',
          type: 'input',
          grid: 6,
          placeholder: function placeholder() {
            return 'Your E-mail eg: info@compassbioinfo.com ';
          } /* ___ */
          , validate: 'required|email'
        }]
      };
    }
  },
  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.emailData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendEmail: function validateSendEmail() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this2.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this2.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this2.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this2.sendEmail();

              case 33:
                _this2.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendEmail: function sendEmail() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$emit('changeModal', {}, extends_default()({}, _this3.result));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5783f4c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelInfo.vue
var genePanelInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-info-dailog dialog col-block"},[_c('div',{staticClass:"info-container col-block"},[_c('div',{staticClass:"info-block",domProps:{"innerHTML":_vm._s([
        'Welcome to <b>Gene panel tool</b>,',
        'a free and public search tool.'
      ].join(_vm.isMobile ? '<br>' : ' '))}}),_vm._v(" "),_c('div',{staticClass:"info-block",domProps:{"innerHTML":_vm._s([
        '<span>Please leave your information first, thank you.</span>'
      ].join(_vm.isMobile ? '<br>' : ' '))}})]),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.emailData,"layoutType":'grid',"groupCount":6,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendEmail() : ''; }}},[_c('span',[_vm._v(_vm._s('Enter'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var genePanelInfo_staticRenderFns = []
var genePanelInfo_esExports = { render: genePanelInfo_render, staticRenderFns: genePanelInfo_staticRenderFns }
/* harmony default export */ var dialog_genePanelInfo = (genePanelInfo_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelInfo.vue
var genePanelInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelInfo___vue_template_functional__ = false
/* styles */
var genePanelInfo___vue_styles__ = null
/* scopeId */
var genePanelInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelInfo___vue_module_identifier__ = null
var genePanelInfo_Component = genePanelInfo_normalizeComponent(
  genePanelInfo,
  dialog_genePanelInfo,
  genePanelInfo___vue_template_functional__,
  genePanelInfo___vue_styles__,
  genePanelInfo___vue_scopeId__,
  genePanelInfo___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelInfo = (genePanelInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editPanel.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var editPanel = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      panelData: {
        panel: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [{
          title: 'New panel name' /* ___ */
          , value: 'panel',
          type: 'input',
          placeholder: function placeholder() {
            return 'Please create a new panel name';
          } /* ___ */
          , validate: 'required'
        }]
      };
    }
  },
  created: function created() {
    var panelData = this.param.panel || this.panelData;
    this.panelData = panelData;
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.panelData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendPanel: function validateSendPanel() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this2.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this2.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this2.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this2.sendPanel();

              case 33:
                _this2.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendPanel: function sendPanel() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, data, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                id = _this3.panelData.id;
                data = _this3.result;

                if (!id) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 7;
                return Object(api["_94" /* putPhenotypePanel */])(id, data, config);

              case 7:
                _context2.t0 = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.next = 12;
                return Object(api["_77" /* postPhenotypePanel */])(data, config);

              case 12:
                _context2.t0 = _context2.sent;

              case 13:
                response = _context2.t0;

                _this3.addToast('success', response.data.result.message);
                _this3.$emit('changeModal', {}, true);
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t1 = _context2['catch'](0);

                _this3.addToast('error', !_context2.t1.response ? _context2.t1.message : _context2.t1.response.data.result.message);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 18]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2c6590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editPanel.vue
var editPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-panel-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendPanel() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.panelData.id ? 'Update'/* ___ */ : 'Add'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var editPanel_staticRenderFns = []
var editPanel_esExports = { render: editPanel_render, staticRenderFns: editPanel_staticRenderFns }
/* harmony default export */ var dialog_editPanel = (editPanel_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editPanel.vue
var editPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editPanel___vue_template_functional__ = false
/* styles */
var editPanel___vue_styles__ = null
/* scopeId */
var editPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editPanel___vue_module_identifier__ = null
var editPanel_Component = editPanel_normalizeComponent(
  editPanel,
  dialog_editPanel,
  editPanel___vue_template_functional__,
  editPanel___vue_styles__,
  editPanel___vue_scopeId__,
  editPanel___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editPanel = (editPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/addToPanel.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var dialog_addToPanel = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      panelData: {
        selectedPanelID: '',
        newPanelName: ''
      },
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },
    selectedPhenotypePanel: function selectedPhenotypePanel() {
      var _this2 = this;

      return this.param.panels.find(function (panel) {
        return panel.id === _this2.result.selectedPanelID;
      });
    },

    // static
    formOptions: function formOptions() {
      var _this3 = this;

      return {
        field1: [{
          title: 'Phenotype' /* ___ */
          , value: 'PHENOTYPE_HPO'
        }],
        field2: [{
          title: 'Select a Panel' /* ___ */
          , value: 'selectedPanelID',
          type: 'select',
          options: this.param.panels.filter(function (panel) {
            return !panel.phenotypes.some(function (phenotype) {
              return phenotype.id === _this3.param.phenotype.id;
            });
          }).map(function (panel) {
            return { title: panel.panel, value: panel.id };
          }),
          placeholder: function placeholder() {
            return 'Please Select a Panel you need';
          } /* ___ */
        }],
        field3: [{
          title: 'Add to new panel' /* ___ */
          , value: 'newPanelName',
          type: 'input',
          placeholder: function placeholder() {
            return 'Please create a new panel name';
          } /* ___ */
        }]
      };
    }
  },
  watch: {
    'result.selectedPanelID': function resultSelectedPanelID() {
      this.customValidate([], ['newPanelName']);
    },
    'result.newPanelName': function resultNewPanelName() {
      this.customValidate([], ['newPanelName']);
    }
  },
  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var _this4 = this;

      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {
        newPanelName: function newPanelName(value) {
          if (!value && !_this4.result.selectedPanelID) {
            return {
              type: 'error',
              msg: 'New panel name should not be empty.' /* ___ */
            };
          }
        }
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.panelData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateAddToPanel: function validateAddToPanel() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this5.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this5.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this5.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 37;
                  break;
                }

                if (!(!_this5.selectedPhenotypePanel || !_this5.selectedPhenotypePanel.phenotypes.some(function (phenotype) {
                  return phenotype.id === _this5.param.phenotype.id;
                }))) {
                  _context.next = 36;
                  break;
                }

                _context.next = 34;
                return _this5.addToPanel();

              case 34:
                _context.next = 37;
                break;

              case 36:
                _this5.addToast('error', 'You have added a HPO term with the same HPO identity.' /* ___ */);

              case 37:
                _this5.onSubmit = false;

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    addToPanel: function addToPanel() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, phenotypeID, type, idType, id, panelName, response, newPanel;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this6.$ls.get('userInfo');
                phenotypeID = _this6.param.phenotype.id;
                type = _this6.param.phenotype.type;
                idType = {
                  hpo: 'hpo_id',
                  disease_term: 'disease_id'
                }[type];
                id = _this6.result.selectedPanelID;
                panelName = _this6.result.newPanelName;

                if (!panelName) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 10;
                return Object(api["_77" /* postPhenotypePanel */])(defineProperty_default()({ panel: panelName }, idType + 's', [phenotypeID]), config);

              case 10:
                _context2.t0 = _context2.sent;
                _context2.next = 16;
                break;

              case 13:
                _context2.next = 15;
                return Object(api["_50" /* postAddToPhenotypePanel */])(id, type, defineProperty_default()({}, idType, phenotypeID), config);

              case 15:
                _context2.t0 = _context2.sent;

              case 16:
                response = _context2.t0;

                _this6.addToast('success', response.data.result.message);
                newPanel = response.data.data;

                _this6.$emit('changeModal', {}, newPanel);
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t1 = _context2['catch'](0);

                _this6.addToast('error', !_context2.t1.response ? _context2.t1.message : _context2.t1.response.data.result.message);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 22]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03101cb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/addToPanel.vue
var addToPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-to-panel-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }},scopedSlots:_vm._u([{key:"PHENOTYPE_HPO",fn:function(props){return [_c('div',{attrs:{"id":props.value}},[_vm._v(_vm._s(_vm.param.phenotype.id + ' ' + _vm.param.phenotype.name))])]}}])}),_vm._v(" "),_c('div',{style:({ height: '7px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"row-block",style:({ padding: '0 10px', 'box-sizing': 'border-box' })},[_c('div',{style:({ flex: 1, height: '1px', background: '#003679' })}),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{style:({ 'color': '#003679', 'font-size': '1rem', 'font-weight': 'bold' })},[_vm._v(_vm._s('OR'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{style:({ flex: 1, height: '1px', background: '#003679' })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.panelData,"alerts":_vm.alerts,"forms":_vm.formOptions['field3']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field3', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateAddToPanel() : ''; }}},[_c('span',[_vm._v(_vm._s('Add'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var addToPanel_staticRenderFns = []
var addToPanel_esExports = { render: addToPanel_render, staticRenderFns: addToPanel_staticRenderFns }
/* harmony default export */ var components_dialog_addToPanel = (addToPanel_esExports);
// CONCATENATED MODULE: ./src/components/dialog/addToPanel.vue
var addToPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addToPanel___vue_template_functional__ = false
/* styles */
var addToPanel___vue_styles__ = null
/* scopeId */
var addToPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addToPanel___vue_module_identifier__ = null
var addToPanel_Component = addToPanel_normalizeComponent(
  dialog_addToPanel,
  components_dialog_addToPanel,
  addToPanel___vue_template_functional__,
  addToPanel___vue_styles__,
  addToPanel___vue_scopeId__,
  addToPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_addToPanel = (addToPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelQuickSelection.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var genePanelQuickSelection = ({
  mixins: [responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      curDivision: null
    };
  },

  computed: {
    genePanels: function genePanels() {
      var genePanels = this.param.divisions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, []));
      }, {});
      this.datas.forEach(function (data) {
        var count = data.count || [(data.data['free_typing'] || []).length, (data.data['user_defined'] || []).length, (data.data['panel'] || []).reduce(function (s, panelData) {
          return s + panelData.data.length;
        }, 0), (data.data['hpo'] || []).reduce(function (s, panelData) {
          return s + panelData.data.length;
        }, 0), (data.data['condition'] || []).reduce(function (s, panelData) {
          return s + panelData.data.length;
        }, 0)].reduce(function (s, c) {
          return s + c;
        }, 0);
        genePanels[data.division] && genePanels[data.division].push(extends_default()({}, data, {
          count: count
        }));
      });
      return genePanels;
    },

    // param
    datas: function datas() {
      return this.param.datas;
    },
    divisions: function divisions() {
      return this.param.divisions;
    },

    // global
    toPriceString: function toPriceString() {
      return util["p" /* toPriceString */];
    },
    sortData: function sortData() {
      return util["m" /* sortData */];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a89b0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelQuickSelection.vue
var genePanelQuickSelection_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-quick-selection-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[(_vm.curDivision)?[_c('img',{attrs:{"src":__webpack_require__("Pbv1"),"alt":""},on:{"click":function (e) { return _vm.curDivision = null; }}}),_vm._v(" "),_c('div',{style:({ width: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.curDivision || 'Quick selection by Division'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"data-container row-block flex-wrap flex-start",style:({ flex: 1, 'max-height': Math.min(_vm.windowHeight - 321, _vm.curDivision ? 630 : 530) + 'px' })},[(!_vm.curDivision)?_vm._l((_vm.sortData(_vm.divisions, function (data) { return data; })),function(division,index){return _c('div',{key:index,staticClass:"data-block",style:({ width: '33.33333%' })},[_c('div',{staticClass:"data division row-block",on:{"click":function (e) { return _vm.curDivision = division; }}},[_c('div',{staticClass:"division-icon center-block"},[_c('img',{attrs:{"src":__webpack_require__("mr+9")("./" + division + '.svg'),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"division-info col-block",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"division-title ellipsis",attrs:{"title":division}},[_vm._v(_vm._s(division))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"division-content"},[_vm._v(_vm._s('Panel counts: '/* ___ */ + _vm.toPriceString(_vm.genePanels[division].length)))])])])])}):_vm._l((_vm.sortData(_vm.genePanels[_vm.curDivision], function (data) { return data.name; })),function(panel,index){return _c('div',{key:index,staticClass:"data-block",style:({ width: '33.33333%' })},[_c('div',{staticClass:"data panel col-block",on:{"click":function (e) { return _vm.$emit('changeModal', {}, panel.id); }}},[_c('div',{staticClass:"panel-title ellipsis"},[_vm._v(_vm._s(panel.name))]),_vm._v(" "),_c('div',{style:({ height: '2px' })}),_vm._v(" "),_c('div',{staticClass:"panel-sub"},[(false)?_c('b',{staticClass:"main"},[_vm._v(_vm._s('(Default) '))]):_vm._e(),_vm._v(_vm._s('Gene counts: '/* ___ */)),_c('b',[_vm._v(_vm._s(panel.count))])]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"panel-content",style:({ flex: 1 })},[_vm._v(_vm._s(panel.note ? panel.note.length > 100 ? panel.note.slice(0, 100) + '...' : panel.note : ''))])])])})],2),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var genePanelQuickSelection_staticRenderFns = []
var genePanelQuickSelection_esExports = { render: genePanelQuickSelection_render, staticRenderFns: genePanelQuickSelection_staticRenderFns }
/* harmony default export */ var dialog_genePanelQuickSelection = (genePanelQuickSelection_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelQuickSelection.vue
var genePanelQuickSelection_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelQuickSelection___vue_template_functional__ = false
/* styles */
var genePanelQuickSelection___vue_styles__ = null
/* scopeId */
var genePanelQuickSelection___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelQuickSelection___vue_module_identifier__ = null
var genePanelQuickSelection_Component = genePanelQuickSelection_normalizeComponent(
  genePanelQuickSelection,
  dialog_genePanelQuickSelection,
  genePanelQuickSelection___vue_template_functional__,
  genePanelQuickSelection___vue_styles__,
  genePanelQuickSelection___vue_scopeId__,
  genePanelQuickSelection___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelQuickSelection = (genePanelQuickSelection_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelDataSelect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var genePanelDataSelect = ({
  mixins: [responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      data: null
    };
  },
  created: function created() {
    this.data = JSON.parse(stringify_default()(this.param.data));
  },

  computed: {
    // param
    functions: function functions() {
      return this.param.functions || {};
    }
  },
  methods: {
    toggleData: function toggleData(index) {
      if (this.functions['toggleData']) {
        var result = this.functions['toggleData'](index);
        this.data = result;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fff87fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelDataSelect.vue
var genePanelDataSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-data-select-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[(_vm.data.data.length && _vm.functions['toggleData'])?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('img',{attrs:{"src":_vm.data.data.filter(function (data) { return data.checked !== false; }).length ? _vm.data.data.filter(function (data) { return data.checked !== false; }).length === _vm.data.data.length ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo")},on:{"click":function (e) { return _vm.toggleData('all'); }}}),_vm._v(" "),_c('div',{style:({ width: '10px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"title shrink"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),(_vm.data.data.some(function (data) { return data.checked === false; }))?[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"sub"},[_vm._v(_vm._s('(' + _vm.data.data.filter(function (data) { return data.checked !== false; }).length + '/' + _vm.data.data.length + ')'))])]:_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"data-container row-block flex-wrap flex-start",class:{ 'only-line': _vm.data.data.length < 8 },style:({ flex: 1, 'max-height': Math.min(_vm.windowHeight - 321, 630) + 'px' })},_vm._l((_vm.data.data),function(data,index){return _c('div',{key:index,staticClass:"data-block",style:({ width: '12.5%', height: '50px' }),on:{"click":function (e) { return _vm.toggleData(index); }}},[_c('div',{staticClass:"data row-block",class:{ toggle: _vm.functions['toggleData'] }},[(_vm.functions['toggleData'])?[_c('img',{attrs:{"src":data.checked !== false ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{style:({ width: '3px' })})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"data-content col-block",style:({ flex: 1, width: 0 })},[_c('div',{staticClass:"data-content-1 ellipsis",attrs:{"title":data.symbol}},[_vm._v(_vm._s(data.symbol))]),_vm._v(" "),_c('div',{staticClass:"data-content-2",attrs:{"title":data.gene_id}},[_vm._v(_vm._s('(' + data.gene_id + ')'))])])],2)])}),0):_vm._e(),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var genePanelDataSelect_staticRenderFns = []
var genePanelDataSelect_esExports = { render: genePanelDataSelect_render, staticRenderFns: genePanelDataSelect_staticRenderFns }
/* harmony default export */ var dialog_genePanelDataSelect = (genePanelDataSelect_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelDataSelect.vue
var genePanelDataSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelDataSelect___vue_template_functional__ = false
/* styles */
var genePanelDataSelect___vue_styles__ = null
/* scopeId */
var genePanelDataSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelDataSelect___vue_module_identifier__ = null
var genePanelDataSelect_Component = genePanelDataSelect_normalizeComponent(
  genePanelDataSelect,
  dialog_genePanelDataSelect,
  genePanelDataSelect___vue_template_functional__,
  genePanelDataSelect___vue_styles__,
  genePanelDataSelect___vue_scopeId__,
  genePanelDataSelect___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelDataSelect = (genePanelDataSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/genePanelConfirm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var genePanelConfirm = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // param
    data: function data() {
      return this.param.data;
    },
    now: function now() {
      return this.param.now;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282127b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/genePanelConfirm.vue
var genePanelConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gene-panel-confirm-dailog dialog col-block"},[_c('div',{staticClass:"info-container"},[_vm._v(_vm._s('The following list is the modified detail, please confirm again before update.'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"confirm-container col-block"},[(_vm.data.add)?_c('div',{staticClass:"confirm-block add-block col-block flex-start"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s('Add'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '8px' })}),_vm._v(" "),(_vm.data.add['free_typing'])?_c('div',{staticClass:"item-container gene-ft col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Gene-Free typing:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.data.add['free_typing'].reduce(function (s, data) { return s + (s ? '、' : '') + (data.symbol + ' (' + data.gene_id + ')'); }, '')))])]):_vm._e(),_vm._v(" "),(_vm.data.add['user_defined'] || _vm.data.add['user_defined_replace'])?_c('div',{staticClass:"item-container gene-ud col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Gene-User defined:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            _vm.data.add['user_defined_replace'] ? 'Add (' + _vm.data.add['user_defined_replace'].name + ') to <b>replace present list</b>' : null,
            (_vm.data.add['user_defined'] || []).length ? _vm.data.add['user_defined'].length + (_vm.data.add['user_defined'].length > 1 ? ' genes were' : ' gene was') + ' selected' : null
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.add['panel'] || _vm.data.add['panelGene'])?_c('div',{staticClass:"item-container panel col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Panel:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.add['panel'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + (panel.data.some(function (data) { return data.checked === false; }) ? ' (' + panel.data.filter(function (data) { return data.checked !== false; }).length + (panel.data.filter(function (data) { return data.checked !== false; }).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''); }, ''),
            (_vm.data.add['panelGene'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + ' (' + panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length + (panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' selected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.add['hpo'] || _vm.data.add['hpoGene'])?_c('div',{staticClass:"item-container hpo col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('HPO phenotypes:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.add['hpo'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + (hpo.data.some(function (data) { return data.checked === false; }) ? ' (' + hpo.data.filter(function (data) { return data.checked !== false; }).length + (hpo.data.filter(function (data) { return data.checked !== false; }).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''); }, ''),
            (_vm.data.add['hpoGene'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + ' (' + hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length + (hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' selected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.add['condition'] || _vm.data.add['conditionGene'])?_c('div',{staticClass:"item-container condition col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Conditions:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.add['condition'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + (condition.data.some(function (data) { return data.checked === false; }) ? ' (' + condition.data.filter(function (data) { return data.checked !== false; }).length + (condition.data.filter(function (data) { return data.checked !== false; }).length > 1 ? ' genes were' : ' gene was') + ' selected)' : ''); }, ''),
            (_vm.data.add['conditionGene'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + ' (' + condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length + (condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked === false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' selected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.data.add && _vm.data.remove)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.data.remove)?_c('div',{staticClass:"confirm-block remove-block col-block flex-start"},[_c('div',{staticClass:"block-title"},[_vm._v(_vm._s('Remove'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '8px' })}),_vm._v(" "),(_vm.data.remove['free_typing'])?_c('div',{staticClass:"item-container gene-ft col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Gene-Free typing:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.data.remove['free_typing'].reduce(function (s, data) { return s + (s ? '、' : '') + (data.symbol + ' (' + data.gene_id + ')'); }, '')))])]):_vm._e(),_vm._v(" "),(_vm.data.remove['user_defined'])?_c('div',{staticClass:"item-container gene-ud col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Gene-User defined:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.data.remove['user_defined'].length + (_vm.data.remove['user_defined'].length > 1 ? ' genes were' : ' gene was') + ' unselected'))])]):_vm._e(),_vm._v(" "),(_vm.data.remove['panel'] || _vm.data.remove['panelGene'])?_c('div',{staticClass:"item-container panel col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Panel:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.remove['panel'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + (panel.oLength < panel.data.length ? ' (' + panel.oLength + (panel.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''); }, ''),
            (_vm.data.remove['panelGene'] || []).reduce(function (s, panel) { return s + (s ? ', ' : '') + panel.name + ' (' + panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length + (panel.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' unselected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.remove['hpo'] || _vm.data.remove['hpoGene'])?_c('div',{staticClass:"item-container hpo col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('HPO phenotypes:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.remove['hpo'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + (hpo.oLength < hpo.data.length ? ' (' + hpo.oLength + (hpo.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''); }, ''),
            (_vm.data.remove['hpoGene'] || []).reduce(function (s, hpo) { return s + (s ? ', ' : '') + hpo.name + ' (' + hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length + (hpo.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' unselected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e(),_vm._v(" "),(_vm.data.remove['condition'] || _vm.data.remove['conditionGene'])?_c('div',{staticClass:"item-container condition col-block flex-start"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s('Conditions:'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"item-content",domProps:{"innerHTML":_vm._s([
            (_vm.data.remove['condition'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + (condition.oLength < condition.data.length ? ' (' + condition.oLength + (condition.oLength > 1 ? ' genes were' : ' gene was') + ' unselected)' : ''); }, ''),
            (_vm.data.remove['conditionGene'] || []).reduce(function (s, condition) { return s + (s ? ', ' : '') + condition.name + ' (' + condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length + (condition.data.filter(function (data) { return new Date(data.date) > _vm.now && data.oChecked !== false && data.checked !== data.oChecked; }).length > 1 ? ' genes were' : ' gene was') + ' unselected)'; }, '')
          ].filter(function (x) { return x; }).join(', '))}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function($event){_vm.$emit('changeModal', {}, true)}}},[_c('span',[_vm._v(_vm._s('Confirm'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var genePanelConfirm_staticRenderFns = []
var genePanelConfirm_esExports = { render: genePanelConfirm_render, staticRenderFns: genePanelConfirm_staticRenderFns }
/* harmony default export */ var dialog_genePanelConfirm = (genePanelConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/genePanelConfirm.vue
var genePanelConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var genePanelConfirm___vue_template_functional__ = false
/* styles */
var genePanelConfirm___vue_styles__ = null
/* scopeId */
var genePanelConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var genePanelConfirm___vue_module_identifier__ = null
var genePanelConfirm_Component = genePanelConfirm_normalizeComponent(
  genePanelConfirm,
  dialog_genePanelConfirm,
  genePanelConfirm___vue_template_functional__,
  genePanelConfirm___vue_styles__,
  genePanelConfirm___vue_scopeId__,
  genePanelConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_genePanelConfirm = (genePanelConfirm_Component.exports);

// EXTERNAL MODULE: ./src/constants/global/data.js
var global_data = __webpack_require__("x2hU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/selectDataset.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var selectDataset = ({
  computed: {
    // global
    priceMap: function priceMap() {
      return global_data["r" /* priceMap */];
    }
  },
  data: function data() {
    return {
      hover: {
        vcf: false,
        fastq: false
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c5e4322","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/selectDataset.vue
var selectDataset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-dataset-dailog dialog col-block"},[_c('div',{staticClass:"description-container"},[_c('div',{staticClass:"description"},[_vm._v(_vm._s('Different upload data formats will charge different points, please choose the format before creating a case.'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{staticClass:"select-container row-block stretch"},[_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"vcf-container select-block col-block",class:{ hover: _vm.hover['vcf'] },style:({ flex: 1 }),on:{"mouseover":function (e) { return _vm.hover['vcf'] = true; },"mouseleave":function (e) { return _vm.hover['vcf'] = false; }}},[_c('div',{staticClass:"select-title"},[_vm._v(_vm._s('VCF'))]),_vm._v(" "),_c('div',{staticClass:"select-description",domProps:{"innerHTML":_vm._s('<b>' + _vm.priceMap['vcf'].price + '</b> points/case'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('button',{staticClass:"circle-button",class:['white-gray-button'],on:{"click":function (e) { return _vm.$emit('changeModal', {}, 'vcf'); }}},[_c('span',[_vm._v(_vm._s('VCF'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ height: '20px' })})]),_vm._v(" "),_c('div',{staticClass:"fastq-container select-block col-block",class:{ hover: _vm.hover['fastq'] },style:({ flex: 1 }),on:{"mouseover":function (e) { return _vm.hover['fastq'] = true; },"mouseleave":function (e) { return _vm.hover['fastq'] = false; }}},[_c('div',{staticClass:"select-title"},[_vm._v(_vm._s('FASTQ'))]),_vm._v(" "),_c('div',{staticClass:"select-description",domProps:{"innerHTML":_vm._s('<b>' + _vm.priceMap['fastq'].price + '</b> points/case'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('button',{staticClass:"circle-button",class:['main-button'],on:{"click":function (e) { return _vm.$emit('changeModal', {}, 'fastq'); }}},[_c('span',[_vm._v(_vm._s('fastq'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ height: '20px' })})]),_vm._v(" "),_c('div',{style:({ width: '10px' })})])])}
var selectDataset_staticRenderFns = []
var selectDataset_esExports = { render: selectDataset_render, staticRenderFns: selectDataset_staticRenderFns }
/* harmony default export */ var dialog_selectDataset = (selectDataset_esExports);
// CONCATENATED MODULE: ./src/components/dialog/selectDataset.vue
var selectDataset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selectDataset___vue_template_functional__ = false
/* styles */
var selectDataset___vue_styles__ = null
/* scopeId */
var selectDataset___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selectDataset___vue_module_identifier__ = null
var selectDataset_Component = selectDataset_normalizeComponent(
  selectDataset,
  dialog_selectDataset,
  selectDataset___vue_template_functional__,
  selectDataset___vue_styles__,
  selectDataset___vue_scopeId__,
  selectDataset___vue_module_identifier__
)

/* harmony default export */ var components_dialog_selectDataset = (selectDataset_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/fileCloud.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var fileCloud = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedPaths: []
    };
  },

  computed: {
    fileTrees: function fileTrees() {
      var _this = this;

      var paths = this.paths.filter(function (path) {
        return path.endsWith('/') || !_this.fileTypes.length || _this.fileTypes.some(function (t) {
          return path.endsWith('.' + t);
        });
      });
      var fileTrees = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(paths), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var path = _step.value;

          var current = fileTrees;
          var pathAry = path.replace(/\//g, '/ゐ').split(/ゐ/g).filter(function (x) {
            return x;
          });
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(pathAry), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var file = _step2.value;

              var fileName = file.replace(/\/$/, '');
              var type = file.endsWith('/') ? 'folder' : 'file';
              !current.nodes && (current.nodes = {});
              !current.nodes[fileName] && (current.nodes[fileName] = {
                type: type,
                path: pathAry.slice(0, pathAry.indexOf(file) + 1).join('').replace(/\/$/, '')
              });
              current = current.nodes[fileName];
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return fileTrees;
    },

    // param
    type: function type() {
      return this.param.type || 'single';
    },
    options: function options() {
      return this.param.options || {};
    },
    fileTypes: function fileTypes() {
      return this.param.fileTypes || [];
    },
    paths: function paths() {
      return this.param.paths || [];
    },
    currentPath: function currentPath() {
      return this.param.currentPath || '';
    },
    disabledPaths: function disabledPaths() {
      return this.param.disabledPaths || [];
    },
    functions: function functions() {
      return this.param.functions || {};
    }
  },
  watch: {
    'param.defaultSelectedPaths': function paramDefaultSelectedPaths() {
      this.selectedPaths = [].concat(toConsumableArray_default()(this.param.defaultSelectedPaths));
    }
  },
  created: function created() {
    this.selectedPaths = [].concat(toConsumableArray_default()(this.param.defaultSelectedPaths));
  },

  methods: {
    pathOnSelect: function pathOnSelect(path) {
      var selectedPaths = this.selectedPaths.includes(path) || this.type === 'multiple' ? [].concat(toConsumableArray_default()(this.selectedPaths)) : [];
      selectedPaths.includes(path) ? selectedPaths.splice(selectedPaths.indexOf(path), 1) : selectedPaths.push(path);
      this.selectedPaths = selectedPaths;
      this.functions.saveCurrentPath(path);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-519ab467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/fileCloud.vue
var fileCloud_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-cloud-dialog dialog col-block width-full"},[_c('div',{staticClass:"file-cloud-title-container row-block"},[_c('div',{staticClass:"file-cloud-title"},[_vm._v(_vm._s('List of google bucket file'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('div',{staticClass:"file-cloud-sub-title"},[_vm._v(_vm._s('(Please select SINGLE file to upload.)'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"tree-list-container resize-container vertical"},[_c('textarea',{style:({ height: '480px' })}),_vm._v(" "),_c('div',{staticClass:"tree-list-block"},[_c('treeList',{attrs:{"treeData":_vm.fileTrees,"options":_vm.options,"icons":{
          file: __webpack_require__("GljU"),
          select: __webpack_require__("OCMH"),
          open: __webpack_require__("09wH"),
          close: __webpack_require__("roYr"),
          boxtrue: __webpack_require__("k4Yl"),
          boxfalse: __webpack_require__("pWQO")
        },"currentPath":_vm.currentPath,"disabledPaths":_vm.disabledPaths,"selectedPaths":_vm.selectedPaths},on:{"select":function (path) { return _vm.pathOnSelect(path); }}})],1)]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",attrs:{"disabled":!_vm.selectedPaths.length},on:{"click":function (e) { return _vm.selectedPaths.length ? _vm.$emit('changeModal', {}, _vm.selectedPaths) : ''; }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var fileCloud_staticRenderFns = []
var fileCloud_esExports = { render: fileCloud_render, staticRenderFns: fileCloud_staticRenderFns }
/* harmony default export */ var dialog_fileCloud = (fileCloud_esExports);
// CONCATENATED MODULE: ./src/components/dialog/fileCloud.vue
function fileCloud_injectStyle (ssrContext) {
  __webpack_require__("PKnz")
}
var fileCloud_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var fileCloud___vue_template_functional__ = false
/* styles */
var fileCloud___vue_styles__ = fileCloud_injectStyle
/* scopeId */
var fileCloud___vue_scopeId__ = "data-v-519ab467"
/* moduleIdentifier (server only) */
var fileCloud___vue_module_identifier__ = null
var fileCloud_Component = fileCloud_normalizeComponent(
  fileCloud,
  dialog_fileCloud,
  fileCloud___vue_template_functional__,
  fileCloud___vue_styles__,
  fileCloud___vue_scopeId__,
  fileCloud___vue_module_identifier__
)

/* harmony default export */ var components_dialog_fileCloud = (fileCloud_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseConfirm.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var caseConfirm = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    caseData: function caseData() {
      return this.param.caseData;
    },
    analysisData: function analysisData() {
      return this.caseData.project;
    },
    fileSets: function fileSets() {
      return this.param.fileSets;
    },

    // static
    formOptions: function formOptions() {
      return {
        'field1': [
        // 1
        {
          title: 'Case ID' /* ___ */
          , value: 'case_id',
          type: 'text',
          wrap: true,
          grid: 2
        }, {
          title: 'Sample type' /* ___ */
          , value: 'affected',
          type: 'text',
          wrap: true,
          grid: 1,
          style: {
            'true': { color: '#83C91E' },
            'false': { color: '#999999' }
          }[this.caseData.affected + ''],
          inputFormat: function inputFormat(value) {
            return {
              'true': 'Affected' /* ___ */
              , 'false': 'Unaffected' /* ___ */
            }[value + ''];
          }
        }, {
          title: 'Name' /* ___ */
          , value: 'subject_name',
          type: 'text',
          wrap: true,
          grid: 1
        }, {
          title: 'Sex' /* ___ */
          , value: 'sex',
          type: 'text',
          wrap: true,
          grid: 1,
          style: {
            Male: { color: '#003679' },
            Female: { color: '#FA3D3D' },
            Unknown: { color: '#333333' }
          }[this.caseData.sex],
          inputFormat: function inputFormat(value) {
            return { Male: 'Male', Female: 'Female', Unknown: 'Unknown' }[value];
          }
        }, {
          title: 'Birth Year' /* ___ */
          , value: 'birth_year',
          type: 'text',
          wrap: true,
          grid: 1,
          inputFormat: function inputFormat(value) {
            return value || 'Unknown';
          }
        },
        // 2
        {
          title: 'Population' /* ___ */
          , value: 'population',
          type: 'text',
          wrap: true,
          grid: 2,
          inputFormat: function inputFormat(value) {
            return value || '--';
          }
        }, {
          title: 'Note' /* ___ */
          , value: 'note',
          type: 'text',
          wrap: true,
          grid: 4,
          inputFormat: function inputFormat(value) {
            return value || '--';
          }
        }],
        'field2': [{
          title: 'Analysis Name' /* ___ */
          , value: 'name',
          type: 'text',
          wrap: true,
          grid: 2
        }, {
          title: 'Analysis note' /* ___ */
          , value: 'note',
          type: 'text',
          wrap: true,
          grid: 3,
          inputFormat: function inputFormat(value) {
            return value || '--';
          }
        }, {
          title: 'Report to PhenoVarDB' /* ___ */
          , value: 'report_phenovardb',
          type: 'text',
          wrap: true,
          grid: 1,
          style: {
            'true': { color: '#83C91E' },
            'false': { color: '#999999' }
          }[this.analysisData.report_phenovardb + ''],
          inputFormat: function inputFormat(value) {
            return {
              'true': 'On' /* ___ */
              , 'false': 'Off' /* ___ */
            }[value + ''];
          }
        }],
        'field3': [
        // 1
        {
          title: 'Phenotype' /* ___ */
          , value: 'PHENOTYPE',
          type: 'custom',
          wrap: true,
          grid: 3
        }, {
          title: 'Gene Panel' /* ___ */
          , value: 'GENE_PANEL',
          type: 'custom',
          grid: 3
        },
        // 2
        {
          title: 'Allele frequency threshold for inheritance modes' /* ___ */
          , value: 'AFT',
          type: 'custom',
          grid: 6
        },
        // 3
        {
          title: 'Score threshold for phenotype gene selection' /* ___ */
          , value: 'ST',
          type: 'custom',
          grid: 6
        }]
      };
    },
    AFTOptions: function AFTOptions() {
      return [
      // 1
      {
        title: 'AD' /* ___ */
        , value: function value(data) {
          return data.ad_cutoff;
        },
        grid: 1
      }, {
        title: 'AR' /* ___ */
        , value: function value(data) {
          return data.ar_cutoff;
        },
        grid: 1
      }, {
        title: 'Exclude LQ variants' /* ___ */
        , value: function value(data) {
          return data.exclude_low_quality_variants;
        },
        grid: 4,
        style: function style(value) {
          return {
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + ''];
        },
        display: function display(value) {
          return {
            'true': 'ON' /* ___ */
            , 'false': 'OFF' /* ___ */
          }[value + ''];
        }
      },
      // 2
      {
        title: 'Compound heterozygosity' /* ___ */
        , value: function value(data) {
          return data.comp_het_cutoff;
        },
        grid: 2
      }, {
        title: 'Lower priority for known benign variants' /* ___ */
        , value: function value(data) {
          return data.enable_clinvar_benign_filter;
        },
        grid: 4,
        style: function style(value) {
          return {
            'true': { color: '#006ED6' },
            'false': { color: '#999999' }
          }[value + ''];
        },
        display: function display(value) {
          return {
            'true': 'ON' /* ___ */
            , 'false': 'OFF' /* ___ */
          }[value + ''];
        }
      }];
    },
    STOptions: function STOptions() {
      return [{
        title: 'Phenotype score' /* ___ */
        , value: function value(data) {
          return data.phenotype_score_cutoff;
        },
        grid: 2
      }, {
        title: 'Variant score' /* ___ */
        , value: function value(data) {
          return data.variant_score_cutoff;
        },
        grid: 2
      }];
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModal2Action']), {
    checkAlerts: function checkAlerts() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!['Unknown'].includes(_this.caseData.sex)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return _this.unknownSexAlert();

              case 3:
                if (_context.sent) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.$emit('changeModal', {}, true);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    unknownSexAlert: function unknownSexAlert() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new promise_default.a(function (resolve) {
                  _this2.setModal2Action({
                    action: 'toast',
                    width: '496px',
                    customStyles: {
                      padding: 0,
                      border: 0
                    },
                    param: {
                      type: 'alert',
                      content: '<span style="color:#FA3D3D">Unknown sex may affect subsequent analysis results. Would you like to continue?</span>' /* ___ */
                      , buttons: [{
                        title: 'Cancel' /* ___ */
                        , type: 'gray',
                        result: false
                      }, {
                        title: 'Create' /* ___ */
                        , type: 'alert',
                        result: true
                      }]
                    },
                    callback: function () {
                      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(result) {
                        return regenerator_default.a.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                resolve(result);

                              case 1:
                              case 'end':
                                return _context2.stop();
                            }
                          }
                        }, _callee2, _this2);
                      }));

                      return function callback(_x) {
                        return _ref.apply(this, arguments);
                      };
                    }()
                  });
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-651f12ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseConfirm.vue
var caseConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-confirm-dailog dialog col-block width-full"},[[_c('div',{staticClass:"main-container case col-block width-full"},[_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.caseData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field1'],"reading":true,"titleSmallInterval":true},on:{"change":function () {}}})],1)])],_vm._v(" "),[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"main-container analysis col-block width-full"},[_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field2'],"reading":true,"titleSmallInterval":true},on:{"change":function () {}}})],1),_vm._v(" "),_c('div',{staticClass:"form-block col-block width-full"},[_c('customForm',{attrs:{"init":_vm.analysisData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field3'],"reading":true,"titleSmallInterval":true},on:{"change":function () {}},scopedSlots:_vm._u([{key:"PHENOTYPE",fn:function(props){return [_c('div',{staticClass:"PHENOTYPE-container col-block flex-start",attrs:{"name":props}},[(_vm.analysisData.phenotypes)?[_vm._l((Object.keys(_vm.analysisData.phenotypes)),function(key,kindex){return _vm._l((_vm.analysisData.phenotypes[key]),function(data,dindex){return _c('div',{key:kindex + '_' + dindex},[_vm._v(_vm._s(data.query))])})})]:_c('div',[_vm._v("- -")])],2)]}},{key:"GENE_PANEL",fn:function(props){return [_c('div',{staticClass:"GENE_PANEL-container col-block flex-start",attrs:{"name":props}},[(_vm.analysisData.gene_panels)?_vm._l((_vm.analysisData.gene_panels),function(data,dindex){return _c('div',{key:dindex},[_vm._v(_vm._s(data.name))])}):_c('div',[_vm._v("- -")])],2)]}},{key:"AFT",fn:function(props){return [_c('div',{staticClass:"AFT-container col-block width-full",style:({ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }),attrs:{"name":props}},_vm._l((_vm.AFTOptions),function(option,oindex){return _c('div',{key:oindex,style:({ 'grid-column': 'span ' + option.grid + ' / auto' })},[_vm._v(_vm._s(option.title + (option.operator || ' =') + ' ')),_c('span',{style:((option.style || (function () { return ({}); }))(option.value(_vm.analysisData)))},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(option.value(_vm.analysisData))))])])}),0)]}},{key:"ST",fn:function(props){return [_c('div',{staticClass:"ST-container col-block width-full",style:({ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' }),attrs:{"name":props}},_vm._l((_vm.STOptions),function(option,oindex){return _c('div',{key:oindex,style:({ 'grid-column': 'span ' + option.grid + ' / auto' })},[_vm._v(_vm._s(option.title + (option.operator || ' =') + ' ')),_c('span',{style:((option.style || (function () { return ({}); }))(option.value(_vm.analysisData)))},[_vm._v(_vm._s((option.display || (function (x) { return x; }))(option.value(_vm.analysisData))))])])}),0)]}}])})],1)])],_vm._v(" "),(_vm.fileSets.length || _vm.caseData.omics_name)?[_c('hr',{staticClass:"custom full",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"main-container file col-block width-full"},[_c('div',{staticClass:"main-title"},[_vm._v(_vm._s({ 'vcf': 'VCF', 'fastq': 'FASTQ' }[_vm.caseData.dataset] + ' Dataset'/* ___ */))]),_vm._v(" "),_c('div',{staticClass:"file-field row-block",style:({ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr' })},[(_vm.caseData.dataset === 'fastq')?_c('div',{staticClass:"pipeline-container col-block",style:({ 'grid-column': 'span 2 / auto' })},[_c('div',{staticClass:"main-title"},[_vm._v(_vm._s('Pipeline'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '8px' })}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s([_vm.caseData.omics_name, _vm.caseData.pipeline_name, _vm.caseData.library_type_name].filter(function (x) { return x; }).join(',<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"set-container col-block",style:({ 'grid-column': 'span 4 / auto' })},_vm._l((_vm.fileSets),function(set,index){return _c('div',{key:index,staticClass:"set-block row-block"},[(_vm.caseData.dataset === 'vcf')?[_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s('VCF File'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.vcf.name))])])]:_vm._e(),_vm._v(" "),(_vm.caseData.dataset === 'fastq')?[_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s('Set' + (index + 1) + '-Fastq-R1'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.r1.name))])]),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('div',{staticClass:"file-block",style:({ flex: 1 })},[_c('div',{staticClass:"file-title"},[_vm._v(_vm._s('Set' + (index + 1) + '-Fastq-R1'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"file-source ellipsis"},[_vm._v(_vm._s(set.r2.name))])])]:_vm._e()],2)}),0)])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.checkAlerts(); }}},[_c('span',[_vm._v(_vm._s('Create'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseConfirm_staticRenderFns = []
var caseConfirm_esExports = { render: caseConfirm_render, staticRenderFns: caseConfirm_staticRenderFns }
/* harmony default export */ var dialog_caseConfirm = (caseConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseConfirm.vue
var caseConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseConfirm___vue_template_functional__ = false
/* styles */
var caseConfirm___vue_styles__ = null
/* scopeId */
var caseConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseConfirm___vue_module_identifier__ = null
var caseConfirm_Component = caseConfirm_normalizeComponent(
  caseConfirm,
  dialog_caseConfirm,
  caseConfirm___vue_template_functional__,
  caseConfirm___vue_styles__,
  caseConfirm___vue_scopeId__,
  caseConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseConfirm = (caseConfirm_Component.exports);

// EXTERNAL MODULE: ./src/components/case/base.vue + 2 modules
var base = __webpack_require__("+lE8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseEdit.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var caseEdit = ({
  components: {
    caseBase: base["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      caseData: {},
      onError: false,
      onSubmit: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    defaultData: function defaultData() {
      return {
        'case': this.caseData,
        'analysis': {}
      };
    }
  }),
  created: function created() {
    this.caseData = extends_default()({}, this.param.caseData);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setModalAction', 'setModal2Action']), {
    validateSendCase: function validateSendCase() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var forms, success, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form, result, datas, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _form, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.prev = 1;
                forms = entries_default()(_this.$refs).filter(function (_ref) {
                  var _ref2 = slicedToArray_default()(_ref, 1),
                      key = _ref2[0];

                  return key.startsWith('form-');
                }).map(function (_ref3) {
                  var _ref4 = slicedToArray_default()(_ref3, 2),
                      key = _ref4[0],
                      ref = _ref4[1];

                  return ref[0] || ref;
                });
                success = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = get_iterator_default()(forms);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 18;
                  break;
                }

                form = _step.value;
                _context.next = 13;
                return form.validateSubmit();

              case 13:
                result = _context.sent;

                if (form && !result) {
                  success = false;
                }

              case 15:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 24:
                _context.prev = 24;
                _context.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context.prev = 27;

                if (!_didIteratorError) {
                  _context.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context.finish(27);

              case 31:
                return _context.finish(24);

              case 32:
                if (!success) {
                  _context.next = 68;
                  break;
                }

                datas = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 37;
                _iterator2 = get_iterator_default()(forms);

              case 39:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 52;
                  break;
                }

                _form = _step2.value;
                _context.next = 43;
                return _form.submit();

              case 43:
                data = _context.sent;

                if (!(_form && !data)) {
                  _context.next = 48;
                  break;
                }

                throw new Error();

              case 48:
                datas.push(data);

              case 49:
                _iteratorNormalCompletion2 = true;
                _context.next = 39;
                break;

              case 52:
                _context.next = 58;
                break;

              case 54:
                _context.prev = 54;
                _context.t1 = _context['catch'](37);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 58:
                _context.prev = 58;
                _context.prev = 59;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 61:
                _context.prev = 61;

                if (!_didIteratorError2) {
                  _context.next = 64;
                  break;
                }

                throw _iteratorError2;

              case 64:
                return _context.finish(61);

              case 65:
                return _context.finish(58);

              case 66:
                _context.next = 68;
                return _this.sendCase(datas[0]);

              case 68:
                _context.next = 72;
                break;

              case 70:
                _context.prev = 70;
                _context.t2 = _context['catch'](1);

              case 72:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 70], [7, 20, 24, 32], [25,, 27, 31], [37, 54, 58, 66], [59,, 61, 65]]);
      }))();
    },
    sendCase: function sendCase(formData) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, id, data, sendCase, owner, newOwner;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                config = _this2.$ls.get('userInfo');
                id = _this2.param.caseData.id;
                data = extends_default()({}, formData.data);

                if (['supervisor'].includes(_this2.user.role)) {
                  data.new_user_id = formData.data.user_id;
                }

                sendCase = function () {
                  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                    var response, newCase;
                    return regenerator_default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return Object(api["_83" /* putCase */])(id, data, config);

                          case 3:
                            response = _context2.sent;
                            newCase = response.data.data;

                            _this2.addToast('success', response.data.result.message);
                            _this2.$emit('changeModal', {}, newCase);
                            _context2.next = 12;
                            break;

                          case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](0);

                            _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

                          case 12:
                            _this2.onSubmit = false;

                          case 13:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2, [[0, 9]]);
                  }));

                  return function sendCase() {
                    return _ref5.apply(this, arguments);
                  };
                }();

                owner = formData.users.find(function (user) {
                  return user.id === _this2.caseData.user.id;
                });
                newOwner = formData.users.find(function (user) {
                  return user.id === formData.data.user_id;
                });

                if (!(owner && newOwner && owner.id !== newOwner.id)) {
                  _context4.next = 11;
                  break;
                }

                _this2.setModal2Action({
                  action: 'toast',
                  width: '496px',
                  customStyles: {
                    padding: 0,
                    border: 0
                  },
                  param: {
                    type: 'alert',
                    content: '<span style="color:#FA3D3D">Once you change the owner, the case will be transferred from ' + [owner.first_name, owner.last_name].filter(function (x) {
                      return x;
                    }).join(' ') + ' to ' + [newOwner.first_name, newOwner.last_name].filter(function (x) {
                      return x;
                    }).join(' ') + '. Do you want to transfer it? </span>' /* ___ */
                    , buttons: [{
                      title: 'Cancel' /* ___ */
                      , type: 'gray',
                      result: false
                    }, {
                      title: 'Change' /* ___ */
                      , type: 'alert',
                      result: true
                    }]
                  },
                  callback: function () {
                    var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(result) {
                      return regenerator_default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              if (!result) {
                                _context3.next = 5;
                                break;
                              }

                              _context3.next = 3;
                              return sendCase();

                            case 3:
                              _context3.next = 6;
                              break;

                            case 5:
                              _this2.onSubmit = false;

                            case 6:
                            case 'end':
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this2);
                    }));

                    return function callback(_x) {
                      return _ref6.apply(this, arguments);
                    };
                  }()
                });
                _context4.next = 13;
                break;

              case 11:
                _context4.next = 13;
                return sendCase();

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6b5ec1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseEdit.vue
var caseEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-edit-dailog col-block block"},[_c('div',{staticClass:"form-container col-block width-full"},[_c('caseBase',{ref:'form-main',attrs:{"mode":'edit',"isUpdate":true,"layoutBlocks":[
        'form'
      ],"dataset":_vm.caseData.dataset,"defaultData":_vm.defaultData},on:{"onError":function (error) { return _vm.onError = error; },"unloadAlert":function (alert) { return _vm.unloadAlert = alert; }}})],1),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit && _vm.validateSendCase(); }}},[_c('span',[_vm._v(_vm._s('Update'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseEdit_staticRenderFns = []
var caseEdit_esExports = { render: caseEdit_render, staticRenderFns: caseEdit_staticRenderFns }
/* harmony default export */ var dialog_caseEdit = (caseEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseEdit.vue
var caseEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseEdit___vue_template_functional__ = false
/* styles */
var caseEdit___vue_styles__ = null
/* scopeId */
var caseEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseEdit___vue_module_identifier__ = null
var caseEdit_Component = caseEdit_normalizeComponent(
  caseEdit,
  dialog_caseEdit,
  caseEdit___vue_template_functional__,
  caseEdit___vue_styles__,
  caseEdit___vue_scopeId__,
  caseEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseEdit = (caseEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/projectEdit.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var projectEdit = ({
  components: {
    caseBase: base["a" /* default */],
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      caseData: {},
      analysisData: {},
      importData: {},
      selectedProjectID: null,
      onError: false,
      onSubmit: {
        info: false,
        phenotype: false
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    defaultData: function defaultData() {
      return {
        'case': this.caseData,
        'analysis': this.analysisData
      };
    },

    // static
    projectOptions: function projectOptions() {
      return this.param.projects.map(function (project) {
        return { title: project.name, value: project.id };
      });
    },
    formOptions: function formOptions() {
      return {
        'field1': [{
          title: 'Import Parameters' /* ___ */
          , value: 'import',
          type: 'select',
          grid: 2,
          options: this.projectOptions,
          disabled: function disabled() {
            return false;
          },
          placeholder: function placeholder() {
            return 'Select a analysis';
          } /* ___ */
        }, {
          title: '　',
          value: 'IMPORT_BUTTON',
          type: 'custom',
          grid: 4
        }]
      };
    }
  }),
  created: function created() {
    this.caseData = extends_default()({}, this.param.caseData);
    this.analysisData = extends_default()({}, this.param.project);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModalAction', 'setModal2Action']), {
    importProject: function importProject() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var keepKeyList, project, forms, datas, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form, data, keepData;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keepKeyList = ['name', 'note', 'report_phenovardb'];
                project = _this.param.projects.find(function (project) {
                  return project.id === _this.selectedProjectID;
                }) || {};
                forms = entries_default()(_this.$refs).filter(function (_ref) {
                  var _ref2 = slicedToArray_default()(_ref, 1),
                      key = _ref2[0];

                  return key.startsWith('form-');
                }).map(function (_ref3) {
                  var _ref4 = slicedToArray_default()(_ref3, 2),
                      key = _ref4[0],
                      ref = _ref4[1];

                  return ref[0] || ref;
                });
                datas = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = get_iterator_default()(forms);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 22;
                  break;
                }

                form = _step.value;
                _context.next = 13;
                return form.submit();

              case 13:
                data = _context.sent;

                if (!(form && !data)) {
                  _context.next = 18;
                  break;
                }

                throw new Error();

              case 18:
                datas.push(data);

              case 19:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 22:
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 28:
                _context.prev = 28;
                _context.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 31:
                _context.prev = 31;

                if (!_didIteratorError) {
                  _context.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context.finish(31);

              case 35:
                return _context.finish(28);

              case 36:
                keepData = keepKeyList.reduce(function (data, key) {
                  return extends_default()({}, data, defineProperty_default()({}, key, datas[0].data.project[key]));
                }, {});

                _this.analysisData = extends_default()({}, project, keepData);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 24, 28, 36], [29,, 31, 35]]);
      }))();
    },
    validateSendCase: function validateSendCase(isAnalysis) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _forms, success, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, form, result, _datas, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _form, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _forms = entries_default()(_this2.$refs).filter(function (_ref5) {
                  var _ref6 = slicedToArray_default()(_ref5, 1),
                      key = _ref6[0];

                  return key.startsWith('form-');
                }).map(function (_ref7) {
                  var _ref8 = slicedToArray_default()(_ref7, 2),
                      key = _ref8[0],
                      ref = _ref8[1];

                  return ref[0] || ref;
                });
                success = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 6;
                _iterator2 = get_iterator_default()(_forms);

              case 8:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 17;
                  break;
                }

                form = _step2.value;
                _context2.next = 12;
                return form.validateSubmit();

              case 12:
                result = _context2.sent;

                if (form && !result) {
                  success = false;
                }

              case 14:
                _iteratorNormalCompletion2 = true;
                _context2.next = 8;
                break;

              case 17:
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 23:
                _context2.prev = 23;
                _context2.prev = 24;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 26:
                _context2.prev = 26;

                if (!_didIteratorError2) {
                  _context2.next = 29;
                  break;
                }

                throw _iteratorError2;

              case 29:
                return _context2.finish(26);

              case 30:
                return _context2.finish(23);

              case 31:
                if (!success) {
                  _context2.next = 72;
                  break;
                }

                _datas = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 36;
                _iterator3 = get_iterator_default()(_forms);

              case 38:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context2.next = 51;
                  break;
                }

                _form = _step3.value;
                _context2.next = 42;
                return _form.submit();

              case 42:
                data = _context2.sent;

                if (!(_form && !data)) {
                  _context2.next = 47;
                  break;
                }

                throw new Error();

              case 47:
                _datas.push(data);

              case 48:
                _iteratorNormalCompletion3 = true;
                _context2.next = 38;
                break;

              case 51:
                _context2.next = 57;
                break;

              case 53:
                _context2.prev = 53;
                _context2.t1 = _context2['catch'](36);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t1;

              case 57:
                _context2.prev = 57;
                _context2.prev = 58;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 60:
                _context2.prev = 60;

                if (!_didIteratorError3) {
                  _context2.next = 63;
                  break;
                }

                throw _iteratorError3;

              case 63:
                return _context2.finish(60);

              case 64:
                return _context2.finish(57);

              case 65:
                _context2.next = 67;
                return _this2.checkAlerts();

              case 67:
                if (!_context2.sent) {
                  _context2.next = 72;
                  break;
                }

                _this2.setLoadingAction(true);
                _this2.onSubmit[!isAnalysis ? 'info' : 'phenotype'] = true;
                _context2.next = 72;
                return _this2.sendCase(_datas[0], isAnalysis);

              case 72:
                _context2.next = 76;
                break;

              case 74:
                _context2.prev = 74;
                _context2.t2 = _context2['catch'](0);

              case 76:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 74], [6, 19, 23, 31], [24,, 26, 30], [36, 53, 57, 65], [58,, 60, 64]]);
      }))();
    },
    checkAlerts: function checkAlerts() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!['Unknown'].includes(_this3.caseData.sex)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return _this3.unknownSexAlert();

              case 3:
                if (_context3.sent) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                return _context3.abrupt('return', true);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    unknownSexAlert: function unknownSexAlert() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', new promise_default.a(function (resolve) {
                  _this4.setModal2Action({
                    action: 'toast',
                    width: '496px',
                    customStyles: {
                      padding: 0,
                      border: 0
                    },
                    param: {
                      type: 'alert',
                      content: '<span style="color:#FA3D3D">Unknown sex may affect subsequent analysis results. Would you like to continue?</span>' /* ___ */
                      , buttons: [{
                        title: 'Cancel' /* ___ */
                        , type: 'gray',
                        result: false
                      }, {
                        title: 'Create' /* ___ */
                        , type: 'alert',
                        result: true
                      }]
                    },
                    callback: function () {
                      var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(result) {
                        return regenerator_default.a.wrap(function _callee4$(_context4) {
                          while (1) {
                            switch (_context4.prev = _context4.next) {
                              case 0:
                                resolve(result);

                              case 1:
                              case 'end':
                                return _context4.stop();
                            }
                          }
                        }, _callee4, _this4);
                      }));

                      return function callback(_x) {
                        return _ref9.apply(this, arguments);
                      };
                    }()
                  });
                }));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    sendCase: function sendCase(formData, isAnalysis) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var config, id, projectID, data, sendCase;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                config = _this5.$ls.get('userInfo');
                id = _this5.param.caseData.id;
                projectID = _this5.param.project.id;
                data = formData.data;

                sendCase = function () {
                  var _ref10 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                    var response, newProject;
                    return regenerator_default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.prev = 0;

                            if (projectID) {
                              _context6.next = 7;
                              break;
                            }

                            _context6.next = 4;
                            return Object(api["_78" /* postProject */])(id, data.project, config);

                          case 4:
                            _context6.t0 = _context6.sent;
                            _context6.next = 17;
                            break;

                          case 7:
                            if (!isAnalysis) {
                              _context6.next = 13;
                              break;
                            }

                            _context6.next = 10;
                            return Object(api["_96" /* putProjectPhenotype */])(projectID, id, data.project, config);

                          case 10:
                            _context6.t1 = _context6.sent;
                            _context6.next = 16;
                            break;

                          case 13:
                            _context6.next = 15;
                            return Object(api["_95" /* putProjectInfo */])(projectID, id, data.project, config);

                          case 15:
                            _context6.t1 = _context6.sent;

                          case 16:
                            _context6.t0 = _context6.t1;

                          case 17:
                            response = _context6.t0;
                            newProject = response.data.data;

                            response.data.result && _this5.addToast('success', response.data.result.message);
                            _this5.$emit('changeModal', {}, newProject);
                            _context6.next = 26;
                            break;

                          case 23:
                            _context6.prev = 23;
                            _context6.t2 = _context6['catch'](0);

                            _this5.addToast('error', !_context6.t2.response ? _context6.t2.message : _context6.t2.response.data.result.message);

                          case 26:
                            _this5.onSubmit[!isAnalysis ? 'info' : 'phenotype'] = false;
                            _this5.setLoadingAction(false);

                          case 28:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this5, [[0, 23]]);
                  }));

                  return function sendCase() {
                    return _ref10.apply(this, arguments);
                  };
                }();

                _context7.next = 7;
                return sendCase();

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db03f3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/projectEdit.vue
var projectEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-edit-dailog col-block block"},[_c('div',{staticClass:"form-container col-block width-full"},[_c('caseBase',{ref:'form-main',attrs:{"mode":'analysis',"isUpdate":!!_vm.param.project.id,"layoutBlocks":[
        'form',
        'analysis'
      ],"dataset":_vm.caseData.dataset,"defaultData":_vm.defaultData,"projects":_vm.param.projects},on:{"onError":function (error) { return _vm.onError = error; },"unloadAlert":function (alert) { return _vm.unloadAlert = alert; }},scopedSlots:_vm._u([{key:"analysis-update",fn:function(props){return [_c('div',{staticClass:"analysis-update-container row-block",attrs:{"name":props}},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit['info'] },attrs:{"type":"button","disabled":!props.data.project.name},on:{"click":function (e) { return !_vm.onSubmit['info'] && _vm.validateSendCase(false); }}},[_c('span',[_vm._v(_vm._s('Update'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}},{key:"analysis-import",fn:function(props){return [_c('div',{staticClass:"analysis-import-container col-block",attrs:{"name":props}},[_c('customForm',{attrs:{"init":_vm.importData,"layoutType":'grid',"groupCount":6,"forms":_vm.formOptions['field1'],"scope":'import',"reading":false},on:{"change":function (result) { return _vm.selectedProjectID = result.import; }},scopedSlots:_vm._u([{key:"IMPORT_BUTTON",fn:function(props){return [_c('div',{staticClass:"IMPORT_BUTTON-container row-block",attrs:{"name":props}},[_c('button',{staticClass:"main-button circle-button",attrs:{"type":"button","disabled":!_vm.selectedProjectID},on:{"click":function (e) { return _vm.importProject(); }}},[_c('span',[_vm._v(_vm._s('Import'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}}])})],1)]}}])})],1),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit['phenotype'] },attrs:{"disabled":false},on:{"click":function (e) { return !_vm.onSubmit['phenotype'] && _vm.validateSendCase(true); }}},[_c('span',[_vm._v(_vm._s(_vm.param.project.id ? 'Reanalysis'/* ___ */ : 'Create'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var projectEdit_staticRenderFns = []
var projectEdit_esExports = { render: projectEdit_render, staticRenderFns: projectEdit_staticRenderFns }
/* harmony default export */ var dialog_projectEdit = (projectEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/projectEdit.vue
var projectEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var projectEdit___vue_template_functional__ = false
/* styles */
var projectEdit___vue_styles__ = null
/* scopeId */
var projectEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var projectEdit___vue_module_identifier__ = null
var projectEdit_Component = projectEdit_normalizeComponent(
  projectEdit,
  dialog_projectEdit,
  projectEdit___vue_template_functional__,
  projectEdit___vue_styles__,
  projectEdit___vue_scopeId__,
  projectEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_projectEdit = (projectEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseFile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var caseFile = ({
  components: {
    borCor: tool_borCor["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    fileGroups: function fileGroups() {
      return Object(util["i" /* groupBy */])(Object(util["m" /* sortData */])(this.param.sampleFiles, function (file) {
        return file.read_strand;
      }), function (file) {
        return file.group;
      });
    },

    // global
    API_ROOT: function API_ROOT() {
      return api_config["a" /* API_ROOT */];
    },
    fixNumber: function fixNumber() {
      return util["g" /* fixNumber */];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ff3a3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseFile.vue
var caseFile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-file-dailog col-block block"},[_c('div',{staticClass:"sample-file-container col-block"},[_c('div',{staticClass:"sample-file-title"},[_vm._v(_vm._s('Data Information'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-content col-block"},[(['fastq'].includes(_vm.param.caseData.dataset))?[_c('div',{staticClass:"sample-file-info-container row-block"},[_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 2 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s('Omics'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.omics || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 3 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s('Pipeline'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.pipeline || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 3 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s('Library Type'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content"},[_vm._v(_vm._s(_vm.param.caseData.library_type || '--'))])]),_vm._v(" "),_c('div',{staticClass:"sample-file-info-block col-block flex-start",style:({ flex: 2 })},[_c('div',{staticClass:"sample-file-info-title"},[_vm._v(_vm._s('Total Bases'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-info-content",attrs:{"title":_vm.param.caseData.total_bases}},[_vm._v(_vm._s(_vm.param.caseData.total_bases ? _vm.fixNumber(_vm.param.caseData.total_bases * Math.pow(10, -9), 0.01) + ' G' : '--'))])])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-main-field row-block"},[_c('div',{staticClass:"sample-file-main-container col-block flex-start",style:({ flex: 1 })},[_c('div',{staticClass:"sample-file-main-title"},[_vm._v(_vm._s('Fastq Files'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file-list-container col-block"},[_vm._l((_vm.fileGroups),function(fileGroup,index){return [_c('div',{key:index,staticClass:"sample-file-list-block row-block flex-start"},[_c('div',{staticClass:"sample-file",style:({ flex: 1 })},[_c('b',[_vm._v(_vm._s('Set' + fileGroup[0].group.replace(/L/, '') + '-R' + fileGroup[0].read_strand + ': '/* ___ */))]),_vm._v(_vm._s(fileGroup[0].name))]),_vm._v(" "),_c('div',{staticClass:"sample-file",style:({ flex: 1 })},[_c('b',[_vm._v(_vm._s('Set' + fileGroup[1].group.replace(/L/, '') + '-R' + fileGroup[1].read_strand + ': '/* ___ */))]),_vm._v(_vm._s(fileGroup[1].name))])]),_vm._v(" "),(_vm.fileGroups[index + 1])?_c('hr',{key:'hr-' + index}):_vm._e()]})],2)])])]:[_c('div',{staticClass:"sample-file-main-field row-block"},_vm._l((_vm.param.sampleFiles),function(file,index){return _c('div',{key:index,staticClass:"sample-file-main-container col-block flex-start",style:({ flex: 1 })},[_c('div',{staticClass:"sample-file-main-title"},[_vm._v(_vm._s(file.name.includes('bam') ? 'BAM files'/* ___ */ : file.name.includes('vcf') ? 'VCF files'/* ___ */ : 'files'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '6px' })}),_vm._v(" "),_c('div',{staticClass:"sample-file",style:({ flex: 1 })},[_vm._v(_vm._s(file.name))])])}),0)]],2)]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"analysis-file-container col-block flex-start"},_vm._l((_vm.param.analysisFiles),function(fileType,type,tindex){return _c('div',{key:tindex,staticClass:"analysis-file-block"},[_c('div',{staticClass:"block-content col-block"},[_c('div',{staticClass:"af-title row-block"},[_c('div',{staticClass:"row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(type))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_vm._l((fileType),function(fileGroup,group,tindex){return _c('div',{key:tindex,staticClass:"af-container row-block flex-start"},[_c('div',{staticClass:"af-group-title",style:({ flex: 1 })},[_vm._v(_vm._s((tindex + 1) + '. ' + group))]),_vm._v(" "),_c('div',{staticClass:"af-block col-block",style:({ flex: 1 })},_vm._l((fileGroup),function(file,findex){return _c('div',{key:findex,staticClass:"file row-block flex-start"},[_c('a',{staticClass:"link",style:({ flex: 1 }),attrs:{"href":_vm.API_ROOT + 'global/files/download?file_id=' + file.id + '&class_name=' + file.class_name + '&access_token=' + _vm.$ls.get('userInfo').access_token}},[_vm._v(_vm._s(file.name))])])}),0)])})],2)])}),0),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseFile_staticRenderFns = []
var caseFile_esExports = { render: caseFile_render, staticRenderFns: caseFile_staticRenderFns }
/* harmony default export */ var dialog_caseFile = (caseFile_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseFile.vue
var caseFile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseFile___vue_template_functional__ = false
/* styles */
var caseFile___vue_styles__ = null
/* scopeId */
var caseFile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseFile___vue_module_identifier__ = null
var caseFile_Component = caseFile_normalizeComponent(
  caseFile,
  dialog_caseFile,
  caseFile___vue_template_functional__,
  caseFile___vue_styles__,
  caseFile___vue_scopeId__,
  caseFile___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseFile = (caseFile_Component.exports);

// EXTERNAL MODULE: ./src/components/case/clinvarStatisticTable.vue + 2 modules
var clinvarStatisticTable = __webpack_require__("qFyz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGeneClinvar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var caseDetailGeneClinvar = ({
  components: {
    clinvarStatisticTable: clinvarStatisticTable["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },
    clinvarStatistic: function clinvarStatistic() {
      return this.param.clinvarStatistic;
    },

    // static
    tableOptionGroups: function tableOptionGroups() {
      var clinvar = {
        title: 'ClinVar' /* ___ */
        , link: function link(variant) {
          return variant.ClinVar_URL;
        },
        options: [{
          title: 'Interpretation' /* ___ */
          , value: function value(variant) {
            return Object(global_data["k" /* getClinvarACMGMapDatas */])(variant.CLIN_SIG).map(function (data) {
              return '<span' + (data.display === 'N/A' ? '' : ' style="color:' + data.color + ';"') + '>' + data.display + '</span>';
            }).join(',<br>');
          },
          color: null,
          width: '200px',
          position: 'center',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Review status' /* ___ */
          , value: function value(variant) {
            return variant.ClinVar_CLNREVSTAT ? variant.ClinVar_CLNREVSTAT.split(',').map(function (value) {
              return value.replace(/_/g, ' ');
            }).join(',<br>') : null;
          },
          color: null,
          width: '250px',
          position: 'left',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Condition' /* ___ */
          , value: function value(variant) {
            return variant.ClinVar_Disease_Name ? variant.ClinVar_Disease_Name.split('|').map(function (value) {
              return value.replace(/_/g, ' ');
            }).join(',<br>') : null;
          },
          color: null,
          width: null,
          position: 'left',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Conflicts' /* ___ */
          , value: function value(variant) {
            return variant.CLIN_CONF ? variant.CLIN_CONF.split(',').map(function (value) {
              return value.replace(/_/g, ' ');
            }).join(',<br>') : null;
          },
          color: null,
          width: null,
          position: 'left',
          empty: 'N/A' /* ___ */
        }]
      };
      var mitomap = (this.gene.SYMBOL || '').startsWith('MT-') ? {
        title: 'MITOMAP' /* ___ */
        , options: [{
          title: 'AF' /* ___ */
          , value: function value(variant) {
            return variant.mitomap_AF;
          },
          color: null,
          width: '70px',
          position: 'center',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Heteroplasmy' /* ___ */
          , value: function value(variant) {
            return variant.mitomap_heteroplasmy;
          },
          color: null,
          width: '130px',
          position: 'center',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Homoplasmy' /* ___ */
          , value: function value(variant) {
            return variant.mitomap_homoplasmy;
          },
          color: null,
          width: '130px',
          position: 'center',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Disease Status' /* ___ */
          , value: function value(variant) {
            return variant.mitomap_DiseaseStatus;
          },
          color: null,
          width: '250px',
          position: 'center',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Disease' /* ___ */
          , value: function value(variant) {
            return variant.mitomap_Disease ? variant.mitomap_Disease.split('-/-').join(',<br>') : null;
          },
          color: null,
          position: 'left',
          empty: 'N/A' /* ___ */
        }, {
          title: 'Pubmed IDs' /* ___ */
          , value: function value(variant) {
            return variant.mitomap_PubmedIDs ? variant.mitomap_PubmedIDs.split(',').join(',<br>') : null;
          },
          color: null,
          width: '120px',
          position: 'center',
          empty: 'N/A' /* ___ */
        }]
      } : null;
      return [clinvar, mitomap].filter(function (x) {
        return x;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a8c1618","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGeneClinvar.vue
var caseDetailGeneClinvar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-clinvar-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Variant Databases'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block width-full"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block width-full"},_vm._l((_vm.tableOptionGroups),function(optionGroup,gindex){return _c('div',{key:gindex,staticClass:"data-content-block col-block width-full"},[_c('div',{staticClass:"data-content-title-container row-block"},[_c('div',{staticClass:"data-content-title"},[_vm._v(_vm._s(optionGroup.title))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),(optionGroup.link && optionGroup.link(variant))?_c('a',{attrs:{"href":optionGroup.link(variant),"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"data-row-container col-block width-full"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{staticClass:"data-row row-block stretch"},_vm._l((optionGroup.options),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",style:(option.color ? { color: option.color(variant) } : {}),domProps:{"innerHTML":_vm._s(option.value(variant) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"clinvar-statistic-container col-block width-full"},[_c('div',{staticClass:"clinvar-statistic-title-container row-block"},[_c('div',{staticClass:"clinvar-statistic-title"},[_vm._v(_vm._s('ClinVar gene statistics'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('clinvarStatisticTable',{attrs:{"defaultData":_vm.clinvarStatistic}})],1),_vm._v(" "),_c('div',{style:({ height: 0 })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseDetailGeneClinvar_staticRenderFns = []
var caseDetailGeneClinvar_esExports = { render: caseDetailGeneClinvar_render, staticRenderFns: caseDetailGeneClinvar_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGeneClinvar = (caseDetailGeneClinvar_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGeneClinvar.vue
var caseDetailGeneClinvar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGeneClinvar___vue_template_functional__ = false
/* styles */
var caseDetailGeneClinvar___vue_styles__ = null
/* scopeId */
var caseDetailGeneClinvar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGeneClinvar___vue_module_identifier__ = null
var caseDetailGeneClinvar_Component = caseDetailGeneClinvar_normalizeComponent(
  caseDetailGeneClinvar,
  dialog_caseDetailGeneClinvar,
  caseDetailGeneClinvar___vue_template_functional__,
  caseDetailGeneClinvar___vue_styles__,
  caseDetailGeneClinvar___vue_scopeId__,
  caseDetailGeneClinvar___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGeneClinvar = (caseDetailGeneClinvar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGeneQuality.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var caseDetailGeneQuality = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // param
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },
    coverages: function coverages() {
      return this.param.coverages;
    },

    // static
    tableOption: function tableOption() {
      return (this.gene.SYMBOL || '').startsWith('MT-') ? [{
        title: 'Read depth' /* ___ */
        , value: 'readDepth',
        color: null,
        width: null,
        info: false,
        position: 'center',
        empty: 'N/A' /* ___ */
      }, {
        title: 'Allele Fractions' /* ___ */
        , value: 'alleleFractions',
        color: null,
        width: null,
        info: false,
        position: 'center',
        empty: 'N/A' /* ___ */
      }, {
        title: 'Gene Coverage(CDS)' /* ___ */
        , value: 'geneCoverage',
        color: null,
        width: null,
        options: [{ title: '2000X', value: 'x2000_cov' }, { title: '3000X', value: 'x3000_cov' }],
        position: 'center',
        empty: 'N/A' /* ___ */
      }] : [{
        title: 'Genotype' /* ___ */
        , value: 'genotype',
        color: null,
        width: null,
        position: 'center',
        empty: 'N/A' /* ___ */
      }, {
        title: 'Read depth' /* ___ */
        , value: 'readDepth',
        color: null,
        width: null,
        info: true,
        position: 'center',
        empty: 'N/A' /* ___ */
      }, {
        title: 'Allele Fractions' /* ___ */
        , value: 'alleleFractions',
        color: null,
        width: null,
        info: true,
        position: 'center',
        empty: 'N/A' /* ___ */
      }, {
        title: 'Genotype Quality' /* ___ */
        , value: 'genotypeQuality',
        color: null,
        width: null,
        info: true,
        position: 'center',
        empty: 'N/A' /* ___ */
      }, {
        title: 'Gene Coverage(CDS)' /* ___ */
        , value: 'geneCoverage',
        color: null,
        width: null,
        options: [{ title: '10X', value: 'x10_cov' }, { title: '20X', value: 'x20_cov' }],
        position: 'center',
        empty: 'N/A' /* ___ */
      }];
    },

    // global
    fixNumber: function fixNumber() {
      return util["g" /* fixNumber */];
    }
  },
  methods: {
    getCovGene: function getCovGene(variant) {
      var result = (((this.coverages['coding_exon'] || {})[this.gene.SYMBOL || ''] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || (((this.coverages['all_exon'] || {})[this.gene.SYMBOL || ''] || {}).transcripts || {})[(variant.Feature || '').replace(/\.\d$/, '')] || {};
      return result || {};
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5825482","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGeneQuality.vue
var caseDetailGeneQuality_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-quality-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Quality Control'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(option.value === 'genotype')?_c('div',{staticClass:"data-content quality-col genotype-container col-block",class:{ alert: false }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(variant.GT_raw || variant.GT || 'N/A'))])]),_vm._v(" "),_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px', opacity: 0 }),attrs:{"src":__webpack_require__("i1qd"),"alt":""}})])]):(option.value === 'readDepth')?_c('div',{staticClass:"data-content quality-col readDepth-container col-block",class:{ alert: option.info && (variant.DP || 0) < 10 }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(variant.DP || 0))])]),_vm._v(" "),(option.info)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("6v0c")("./quality-" + ((variant.DP || 0) < 10 ? 'nopass' : 'pass') + '-info-icon.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info",domProps:{"innerHTML":_vm._s((variant.DP || 0) < 10 ? 'Read depth < 10, no pass.'/* ___ */ : 'Read depth ≥ 10, pass.'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2):(option.value === 'alleleFractions')?_c('div',{staticClass:"data-content quality-col alleleFractions-container col-block",class:{ alert: option.info && ((variant.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(variant.GT)) }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(variant.GT_AF ? variant.GT_AF.toFixed(3).replace(/0+$/, '').replace(/\.$/, '') : 0))]),_vm._v(" "),_c('div',{style:({ width: '3px' })}),_vm._v(" "),_c('div',{staticClass:"quality-desc"},[_vm._v(_vm._s('(REF:' + (variant.RD || 0) + ' | ALT:' + (variant.AD || 0) + ')'))])]),_vm._v(" "),(option.info)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("6v0c")("./quality-" + (((variant.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(variant.GT)) ? 'nopass' : 'pass') + '-info-icon.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info",domProps:{"innerHTML":_vm._s(((variant.GT_AF || 0) < 0.25 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) >= 0.85 && ['heterozygosity'].includes(variant.GT)) || ((variant.GT_AF || 0) < 0.9 && ['homozygosity', 'hemizygosity'].includes(variant.GT)) ? 'Fractions no pass.'/* ___ */ : 'Fractions pass.'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2):(option.value === 'genotypeQuality')?_c('div',{staticClass:"data-content quality-col genotypeQuality-container col-block",class:{ alert: option.info && (variant.GQ || 0) < 20 }},[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(variant.GQ || 0))])]),_vm._v(" "),(option.info)?[_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px' }),attrs:{"src":__webpack_require__("6v0c")("./quality-" + ((variant.GQ || 0) < 20 ? 'nopass' : 'pass') + '-info-icon.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info",domProps:{"innerHTML":_vm._s((variant.GQ || 0) < 20 ? 'Quality < 20, no pass.'/* ___ */ : 'Quality ≥ 20, pass.'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]:_vm._e()],2):(option.value === 'geneCoverage')?_c('div',{staticClass:"data-content quality-col geneCoverage-container col-block",class:{ alert: false }},[(Object.keys(_vm.getCovGene(variant)).length)?_vm._l((option.options || []),function(option,index){return _c('div',{key:index,staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s(option.title + ': ' + _vm.fixNumber(_vm.getCovGene(variant)[option.value] * 100, 0.01) + '%'))])])}):[_c('div',{staticClass:"quality-value-block row-block"},[_c('div',{staticClass:"quality-value"},[_vm._v(_vm._s('- -'))])]),_vm._v(" "),_c('div',{style:({ height: '0px' })}),_vm._v(" "),_c('div',{staticClass:"pass-info-block row-block"},[_c('img',{style:({ width: '16px', opacity: 0 }),attrs:{"src":__webpack_require__("i1qd"),"alt":""}})])]],2):_c('div',{staticClass:"data-content",style:(option.color ? { color: option.color(variant) } : {}),domProps:{"innerHTML":_vm._s(option.value || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])])}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseDetailGeneQuality_staticRenderFns = []
var caseDetailGeneQuality_esExports = { render: caseDetailGeneQuality_render, staticRenderFns: caseDetailGeneQuality_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGeneQuality = (caseDetailGeneQuality_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGeneQuality.vue
var caseDetailGeneQuality_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGeneQuality___vue_template_functional__ = false
/* styles */
var caseDetailGeneQuality___vue_styles__ = null
/* scopeId */
var caseDetailGeneQuality___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGeneQuality___vue_module_identifier__ = null
var caseDetailGeneQuality_Component = caseDetailGeneQuality_normalizeComponent(
  caseDetailGeneQuality,
  dialog_caseDetailGeneQuality,
  caseDetailGeneQuality___vue_template_functional__,
  caseDetailGeneQuality___vue_styles__,
  caseDetailGeneQuality___vue_scopeId__,
  caseDetailGeneQuality___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGeneQuality = (caseDetailGeneQuality_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGenePublication.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var caseDetailGenePublication = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    variants: function variants() {
      return this.param.variants;
    },

    // static
    tableOption: function tableOption() {
      return [{
        title: 'Publications' /* ___ */
        , value: function value(variant) {
          return variant.publication;
        },
        color: null,
        width: null,
        position: 'left',
        empty: 'N/A' /* ___ */
      }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23253fd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGenePublication.vue
var caseDetailGenePublication_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-publication-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Publications'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"data-content-container col-block"},[_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content",domProps:{"innerHTML":_vm._s(option.title)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0),_vm._v(" "),_c('div',{staticClass:"data-row row-block stretch"},_vm._l((_vm.tableOption),function(option,oindex){return _c('div',{key:oindex,staticClass:"data-col col-block",class:[option.position],style:(option.width ? { width: option.width } : { flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(option.value === 'publication')?_c('div',{staticClass:"table-content publications-container"},[(variant.publications && Object.keys(variant.publication).length)?_vm._l((_vm.gene.publications),function(publication,id,pindex){return _c('div',{key:pindex,staticClass:"publication-block col-block"},[_c('div',{staticClass:"publication-title",domProps:{"innerHTML":_vm._s(publication.title)}}),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('a',{staticClass:"publication-link row-block",attrs:{"href":publication.pub_url,"target":"_blank"}},[_c('div',{staticClass:"link-title"},[_vm._v(_vm._s('PMID:' + id + '  ' + publication.source + '  ' + publication.epubdate))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),_c('div',{staticClass:"publication-info"},[_vm._v(_vm._s(publication.auhtors.join(', ')))])])}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(option.empty)}})],2):_c('div',{staticClass:"data-content",style:(option.color ? { color: option.color(variant) } : {}),domProps:{"innerHTML":_vm._s(option.value(variant) || option.empty || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)])])}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseDetailGenePublication_staticRenderFns = []
var caseDetailGenePublication_esExports = { render: caseDetailGenePublication_render, staticRenderFns: caseDetailGenePublication_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGenePublication = (caseDetailGenePublication_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGenePublication.vue
var caseDetailGenePublication_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGenePublication___vue_template_functional__ = false
/* styles */
var caseDetailGenePublication___vue_styles__ = null
/* scopeId */
var caseDetailGenePublication___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGenePublication___vue_module_identifier__ = null
var caseDetailGenePublication_Component = caseDetailGenePublication_normalizeComponent(
  caseDetailGenePublication,
  dialog_caseDetailGenePublication,
  caseDetailGenePublication___vue_template_functional__,
  caseDetailGenePublication___vue_styles__,
  caseDetailGenePublication___vue_scopeId__,
  caseDetailGenePublication___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGenePublication = (caseDetailGenePublication_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGeneUserSetting.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var caseDetailGeneUserSetting = ({
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      afpCols: null,
      otherCols: null,
      display: {
        dbSelect: false
      },
      onSubmit: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user', 'userSetting']), {
    onError: function onError() {
      return !this.afpCols || this.afpCols.length < { 'db': 3, 'ps': 2 }[this.param.type];
    },
    afpDataGroups: function afpDataGroups() {
      var afpCols = this.afpCols;
      return Object(util["i" /* groupBy */])(this.afpMap.filter(function (afp) {
        return afpCols.includes(afp.key) || !afp.key;
      }), function (data) {
        return data.group;
      }, true);
    },

    // param
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },

    // static
    groupTitleMap: function groupTitleMap() {
      return {
        'Coverage gnomAD Exomes': 'gnomAD Exomes',
        'Coverage gnomAD Genomes': 'gnomAD Genomes'
      };
    },
    settingColumnData: function settingColumnData() {
      var group = {
        'SpliceAI': ['SpliceAI_DS_AL', 'SpliceAI_DS_DG', 'SpliceAI_DS_DL', 'SpliceAI_DP_AG', 'SpliceAI_DP_AL', 'SpliceAI_DP_DG', 'SpliceAI_DP_DL', 'SpliceAI_DS_AG']
      };
      var map = entries_default()(group).reduce(function (map, _ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            values = _ref2[1];

        var result = values.reduce(function (valueMap, value) {
          return extends_default()({}, valueMap, defineProperty_default()({}, value, key));
        }, {});
        return extends_default()({}, map, result);
      }, {});
      return { group: group, map: map };
    },
    afpMap: function afpMap() {
      var _this = this;

      return [{
        title: 'AF' /* ___ */
        , key: 'KG_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.KG_AF;
        },
        group: '1000 Genomes' /* ___ */
      }, {
        title: 'EAS AF' /* ___ */
        , key: 'KG_EAS_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.KG_EAS_AF;
        },
        group: '1000 Genomes' /* ___ */
      }, {
        title: 'AMR AF' /* ___ */
        , key: 'KG_AMR_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.KG_AMR_AF;
        },
        group: '1000 Genomes' /* ___ */
      }, {
        title: 'AFR AF' /* ___ */
        , key: 'KG_AFR_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.KG_AFR_AF;
        },
        group: '1000 Genomes' /* ___ */
      }, {
        title: 'EUR AF' /* ___ */
        , key: 'KG_EUR_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.KG_EUR_AF;
        },
        group: '1000 Genomes' /* ___ */
      }, {
        title: 'SAS AF' /* ___ */
        , key: 'KG_SAS_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.KG_SAS_AF;
        },
        group: '1000 Genomes' /* ___ */
      }, {
        title: 'AF' /* ___ */
        , key: 'gnomAD_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'AFR AF' /* ___ */
        , key: 'gnomAD_AFR_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_AFR_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'AMR AF' /* ___ */
        , key: 'gnomAD_AMR_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_AMR_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'ASJ AF' /* ___ */
        , key: 'gnomAD_ASJ_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_ASJ_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'EAS AF' /* ___ */
        , key: 'gnomAD_EAS_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_EAS_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'FIN AF' /* ___ */
        , key: 'gnomAD_FIN_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_FIN_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'NFE AF' /* ___ */
        , key: 'gnomAD_NFE_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_NFE_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'OTH AF' /* ___ */
        , key: 'gnomAD_OTH_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_OTH_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'SAS AF' /* ___ */
        , key: 'gnomAD_SAS_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_SAS_AF;
        },
        group: 'gnomAD Exomes' /* ___ */
      }, {
        title: 'AF' /* ___ */
        , key: 'gnomAD_g_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'AFR AF' /* ___ */
        , key: 'gnomAD_g_AF_afr',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_afr;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'AMI AF' /* ___ */
        , key: 'gnomAD_g_AF_ami',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_ami;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'AMR AF' /* ___ */
        , key: 'gnomAD_g_AF_amr',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_amr;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'ASJ AF' /* ___ */
        , key: 'gnomAD_g_AF_asj',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_asj;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'EAS AF' /* ___ */
        , key: 'gnomAD_g_AF_eas',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_eas;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'FIN AF' /* ___ */
        , key: 'gnomAD_g_AF_fin',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_fin;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'MID AF' /* ___ */
        , key: 'gnomAD_g_AF_mid',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_mid;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'NFE AF' /* ___ */
        , key: 'gnomAD_g_AF_nfe',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_nfe;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'OTH AF' /* ___ */
        , key: 'gnomAD_g_AF_oth',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_oth;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'SAS AF' /* ___ */
        , key: 'gnomAD_g_AF_sas',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_AF_sas;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM !== 'chrM';
        }
      }, {
        title: 'Heteroplasmy AF' /* ___ */
        , key: 'gnomAD_g_mt_AF_het',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_AF_het;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy AFR AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_afr',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_afr;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy AMI AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_ami',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_ami;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy AMR AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_amr',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_amr;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy ASJ AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_asj',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_asj;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy EAS AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_eas',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_eas;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy FIN AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_fin',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_fin;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy MID AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_mid',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_mid;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy NFE AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_nfe',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_nfe;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy OTH AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_oth',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_oth;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Heteroplasmy SAS AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_het_sas',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_het_sas;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy AF' /* ___ */
        , key: 'gnomAD_g_mt_AF_hom',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_AF_hom;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy AFR AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_afr',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_afr;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy AMI AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_ami',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_ami;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy AMR AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_amr',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_amr;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy ASJ AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_asj',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_asj;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy EAS AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_eas',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_eas;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy FIN AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_fin',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_fin;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy MID AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_mid',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_mid;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy NFE AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_nfe',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_nfe;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy OTH AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_oth',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_oth;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Homoplasmy SAS AF' /* ___ */
        , key: 'gnomAD_g_mt_pop_AF_hom_sas',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_pop_AF_hom_sas;
        },
        group: 'gnomAD Genomes',
        display: function display(variant) {
          return variant.CHROM === 'chrM';
        }
      }, {
        title: 'Filter' /* ___ */
        , key: 'PVDB_P_FILTER',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_FILTER;
        },
        group: 'PhenoVarDB Private'
      }, {
        title: 'Missing rate' /* ___ */
        , key: 'PVDB_P_F_MISSING',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_F_MISSING;
        },
        group: 'PhenoVarDB Private'
      }, {
        title: 'AC' /* ___ */
        , key: 'PVDB_P_AC',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_AC;
        },
        group: 'PhenoVarDB Private'
      }, {
        title: 'AN' /* ___ */
        , key: 'PVDB_P_AN',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_AN;
        },
        group: 'PhenoVarDB Private'
      }, {
        title: 'AF' /* ___ */
        , key: 'PVDB_P_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_AF;
        },
        group: 'PhenoVarDB Private'
      }, {
        title: 'DP' /* ___ */
        , key: 'PVDB_P_DP',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_DP;
        },
        group: 'PhenoVarDB Private'
      }, {
        title: 'AC in heterozygous genotypes' /* ___ */
        , key: 'PVDB_P_AC_Het',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_AC_Het;
        },
        long: true,
        group: 'PhenoVarDB Private'
      }, {
        title: 'AC in homozygous genotypes' /* ___ */
        , key: 'PVDB_P_AC_Hom',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_AC_Hom;
        },
        long: true,
        group: 'PhenoVarDB Private'
      }, {
        title: 'AC in hemizygous genotypes' /* ___ */
        , key: 'PVDB_P_AC_Hemi',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_P_AC_Hemi;
        },
        long: true,
        group: 'PhenoVarDB Private'
      }, {
        title: 'Filter' /* ___ */
        , key: 'PVDB_S_FILTER',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_FILTER;
        },
        group: 'PhenoVarDB Community'
      }, {
        title: 'Missing rate' /* ___ */
        , key: 'PVDB_S_F_MISSING',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_F_MISSING;
        },
        group: 'PhenoVarDB Community'
      }, {
        title: 'AC' /* ___ */
        , key: 'PVDB_S_AC',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_AC;
        },
        group: 'PhenoVarDB Community'
      }, {
        title: 'AN' /* ___ */
        , key: 'PVDB_S_AN',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_AN;
        },
        group: 'PhenoVarDB Community'
      }, {
        title: 'AF' /* ___ */
        , key: 'PVDB_S_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_AF;
        },
        group: 'PhenoVarDB Community'
      }, {
        title: 'DP' /* ___ */
        , key: 'PVDB_S_DP',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_DP;
        },
        group: 'PhenoVarDB Community'
      }, {
        title: 'AC in heterozygous genotypes' /* ___ */
        , key: 'PVDB_S_AC_Het',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_AC_Het;
        },
        long: true,
        group: 'PhenoVarDB Community'
      }, {
        title: 'AC in homozygous genotypes' /* ___ */
        , key: 'PVDB_S_AC_Hom',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_AC_Hom;
        },
        long: true,
        group: 'PhenoVarDB Community'
      }, {
        title: 'AC in hemizygous genotypes' /* ___ */
        , key: 'PVDB_S_AC_Hemi',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_S_AC_Hemi;
        },
        long: true,
        group: 'PhenoVarDB Community'
      }, {
        title: 'Filter' /* ___ */
        , key: 'PVDB_A_FILTER',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_FILTER;
        },
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'Missing rate' /* ___ */
        , key: 'PVDB_A_F_MISSING',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_F_MISSING;
        },
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'AC' /* ___ */
        , key: 'PVDB_A_AC',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_AC;
        },
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'AN' /* ___ */
        , key: 'PVDB_A_AN',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_AN;
        },
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'AF' /* ___ */
        , key: 'PVDB_A_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_AF;
        },
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'DP' /* ___ */
        , key: 'PVDB_A_DP',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_DP;
        },
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'AC in heterozygous genotypes' /* ___ */
        , key: 'PVDB_A_AC_Het',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_AC_Het;
        },
        long: true,
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'AC in homozygous genotypes' /* ___ */
        , key: 'PVDB_A_AC_Hom',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_AC_Hom;
        },
        long: true,
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'AC in hemizygous genotypes' /* ___ */
        , key: 'PVDB_A_AC_Hemi',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.PVDB_A_AC_Hemi;
        },
        long: true,
        group: 'PhenoVarDB Admin',
        display: function display(variant) {
          return ['supervisor'].includes(_this.user.role);
        }
      }, {
        title: 'ESP6500' /* ___ */
        , key: 'ESP6500_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.ESP6500_AF;
        },
        group: 'Other' /* ___ */
      }, {
        title: 'ESP6500 AA' /* ___ */
        , key: 'ESP6500_AA_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.ESP6500_AA_AF;
        },
        group: 'Other' /* ___ */
      }, {
        title: 'ESP6500 AE' /* ___ */
        , key: 'ESP6500_EA_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.ESP6500_EA_AF;
        },
        group: 'Other' /* ___ */
      }, {
        title: 'Taiwan Biobank' /* ___ */
        , key: 'TW_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.TW_AF;
        },
        group: 'Other' /* ___ */
      }, {
        title: 'TOPMED' /* ___ */
        , key: 'TOPMED_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.TOPMED_AF;
        },
        group: 'Other' /* ___ */
      }, {
        title: 'UK10K' /* ___ */
        , key: 'UK10K_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.UK10K_AF;
        },
        group: 'Other' /* ___ */
      },
      // {
      //   title: 'ChinaMAP'/* ___ */,
      //   key: 'ChinaMAP_AF',
      //   class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      //   value: variant => variant.ChinaMAP_AF,
      //   group: 'Other'/* ___ */
      // },
      {
        title: 'Genome Asia100' /* ___ */
        , key: 'GA_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.GA_AF;
        },
        group: 'Other' /* ___ */
      },
      // {
      //   title: '4.7KJPN'/* ___ */,
      //   key: 'KJ_AF',
      //   class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      //   value: variant => variant.KJ_AF,
      //   group: 'Other'/* ___ */
      // },
      {
        title: 'ExAC' /* ___ */
        , key: 'ExAC_AF',
        class: function _class(value) {
          return value || value === 0 ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'];
        },
        value: function value(variant) {
          return variant.ExAC_AF;
        },
        group: 'Other' /* ___ */
      }, {
        group: 'Coverage',
        display: function display() {
          return _this.param.type === 'db';
        }
      }, {
        title: 'Mean' /* ___ */
        , key: 'gnomAD_cov_MEAN',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_cov_MEAN;
        },
        group: 'Coverage gnomAD Exomes' /* ___ */
        , groupFormat: function groupFormat(title) {
          return title.replace(/^Coverage /, '');
        }
      }, {
        title: ' Median' /* ___ */
        , key: 'gnomAD_cov_MEDIAN',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_cov_MEDIAN;
        },
        group: 'Coverage gnomAD Exomes' /* ___ */
        , groupFormat: function groupFormat(title) {
          return title.replace(/^Coverage /, '');
        }
      }, {
        title: '>20x coverage (%)' /* ___ */
        , key: 'gnomAD_cov_PCT_20X',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_cov_PCT_20X;
        },
        group: 'Coverage gnomAD Exomes' /* ___ */
        , groupFormat: function groupFormat(title) {
          return title.replace(/^Coverage /, '');
        }
      }, {
        title: 'Mean' /* ___ */
        , key: 'gnomAD_g_cov_MEAN',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_cov_MEAN;
        },
        group: 'Coverage gnomAD Genomes' /* ___ */
        , groupFormat: function groupFormat(title) {
          return title.replace(/^Coverage /, '');
        }
      }, {
        title: 'Median' /* ___ */
        , key: 'gnomAD_g_cov_MEDIAN',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_cov_MEDIAN;
        },
        group: 'Coverage gnomAD Genomes' /* ___ */
        , groupFormat: function groupFormat(title) {
          return title.replace(/^Coverage /, '');
        }
      }, {
        title: '>20x coverage (%)' /* ___ */
        , key: 'gnomAD_g_cov_PCT_20X',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_cov_PCT_20X;
        },
        group: 'Coverage gnomAD Genomes' /* ___ */
        , groupFormat: function groupFormat(title) {
          return title.replace(/^Coverage /, '');
        }
      }, {
        title: 'SIFT4G score' /* ___ */
        , key: 'SIFT4G_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SIFT4G'].checkPassed || function () {
            return true;
          })((variant.transcripts[variant.Feature] || {}).SIFT4G_score, (variant.transcripts[variant.Feature] || {}).SIFT4G_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return (variant.transcripts[variant.Feature] || {}).SIFT4G_score;
        }
      }, {
        title: 'SIFT4G pred' /* ___ */
        , key: 'SIFT4G_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['SIFT4G'].displayMap[(variant.transcripts[variant.Feature] || {}).SIFT4G_pred] || (variant.transcripts[variant.Feature] || {}).SIFT4G_pred;
        }
      }, {
        title: 'Polyphen-2 HDIV' /* ___ */
        , key: 'Polyphen',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['Polyphen'].checkPassed || function () {
            return true;
          })((variant.transcripts[variant.Feature] || {}).Polyphen, (variant.transcripts[variant.Feature] || {}).Polyphen_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return (variant.transcripts[variant.Feature] || {}).Polyphen;
        }
      }, {
        title: 'Polyphen-2 HDIV pred' /* ___ */
        , key: 'Polyphen_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['Polyphen'].displayMap[(variant.transcripts[variant.Feature] || {}).Polyphen_pred] || (variant.transcripts[variant.Feature] || {}).Polyphen_pred;
        }
      }, {
        title: 'FATHMM score' /* ___ */
        , key: 'FATHMM_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['FATHMM'].checkPassed || function () {
            return true;
          })((variant.transcripts[variant.Feature] || {}).FATHMM_score, (variant.transcripts[variant.Feature] || {}).FATHMM_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return (variant.transcripts[variant.Feature] || {}).FATHMM_score;
        }
      }, {
        title: 'FATHMM pred' /* ___ */
        , key: 'FATHMM_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['FATHMM'].displayMap[(variant.transcripts[variant.Feature] || {}).FATHMM_pred] || (variant.transcripts[variant.Feature] || {}).FATHMM_pred;
        }
      }, {
        title: 'PROVEAN score' /* ___ */
        , key: 'PROVEAN_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['PROVEAN'].checkPassed || function () {
            return true;
          })((variant.transcripts[variant.Feature] || {}).PROVEAN_score, (variant.transcripts[variant.Feature] || {}).PROVEAN_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return (variant.transcripts[variant.Feature] || {}).PROVEAN_score;
        }
      }, {
        title: 'PROVEAN pred' /* ___ */
        , key: 'PROVEAN_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['PROVEAN'].displayMap[(variant.transcripts[variant.Feature] || {}).PROVEAN_pred] || (variant.transcripts[variant.Feature] || {}).PROVEAN_pred;
        }
      }, {
        title: 'CADD phred' /* ___ */
        , key: 'CADD_phred',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['CADD_phred'].checkPassed || function () {
            return true;
          })(variant.CADD_phred, variant.CADD_phred_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.CADD_phred;
        }
      }, {
        title: 'CADD phred pred' /* ___ */
        , key: 'CADD_phred_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['CADD_phred'].displayMap[variant.CADD_phred_pred] || variant.CADD_phred_pred;
        }
      }, {
        title: 'MetaLR score' /* ___ */
        , key: 'MetaLR_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['MetaLR'].checkPassed || function () {
            return true;
          })(variant.MetaLR_score, variant.MetaLR_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.MetaLR_score;
        }
      }, {
        title: 'MetaLR pred' /* ___ */
        , key: 'MetaLR_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['MetaLR'].displayMap[variant.MetaLR_pred] || variant.MetaLR_pred;
        }
      }, {
        title: 'MetaSVM score' /* ___ */
        , key: 'MetaSVM_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['MetaSVM'].checkPassed || function () {
            return true;
          })(variant.MetaSVM_score, variant.MetaSVM_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.MetaSVM_score;
        }
      }, {
        title: 'MetaSVM pred' /* ___ */
        , key: 'MetaSVM_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['MetaSVM'].displayMap[variant.MetaSVM_pred] || variant.MetaSVM_pred;
        }
      },
      // {
      //   title: 'REVEL score'/* ___ */,
      //   key: 'REVEL_score',
      //   class: (value, variant) => [{
      //     'true': 'normal',
      //     'false': 'alert'
      //   }[(predictionMetaDatas['REVEL'].checkPassed || (() => true))(variant.REVEL_score, variant.REVEL_pred) + ''] || 'empty'],
      //   value: variant => variant.REVEL_score
      // },
      // {
      //   title: 'REVEL pred'/* ___ */,
      //   key: 'REVEL_pred',
      //   class: value => (value || value === 0) ? ['normal'] : ['empty'],
      //   value: variant => predictionMetaDatas['REVEL'].displayMap[variant.REVEL_pred] || variant.REVEL_pred
      // },
      {
        title: 'BayesDel addAF score' /* ___ */
        , key: 'BayesDel_addAF_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['BayesDel_addAF'].checkPassed || function () {
            return true;
          })(variant.BayesDel_addAF_score, variant.BayesDel_addAF_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.BayesDel_addAF_score;
        }
      }, {
        title: 'BayesDel addAF pred' /* ___ */
        , key: 'BayesDel_addAF_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['BayesDel_addAF'].displayMap[variant.BayesDel_addAF_pred] || variant.BayesDel_addAF_pred;
        }
      }, {
        title: 'MitoTip score' /* ___ */
        , key: 'gnomAD_g_mt_mitotip_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['gnomAD_g_mt_mitotip'].checkPassed || function () {
            return true;
          })(variant.gnomAD_g_mt_mitotip_score, variant.gnomAD_g_mt_mitotip_score_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.gnomAD_g_mt_mitotip_score;
        }
      }, {
        title: 'MitoTip pred' /* ___ */
        , key: 'gnomAD_g_mt_mitotip_score_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['gnomAD_g_mt_mitotip'].displayMap[variant.gnomAD_g_mt_mitotip_score_pred] || variant.gnomAD_g_mt_mitotip_score_pred;
        }
      }, {
        title: 'ada score' /* ___ */
        , key: 'ada_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['ada'].checkPassed || function () {
            return true;
          })(variant.ada_score, variant.ada_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.ada_score;
        }
      }, {
        title: 'ada pred' /* ___ */
        , key: 'ada_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['ada'].displayMap[variant.ada_pred] || variant.ada_pred;
        }
      }, {
        title: 'rf score' /* ___ */
        , key: 'rf_score',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['rf'].checkPassed || function () {
            return true;
          })(variant.rf_score, variant.rf_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.rf_score;
        }
      }, {
        title: 'rf pred' /* ___ */
        , key: 'rf_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['rf'].displayMap[variant.rf_pred] || variant.rf_pred;
        }
      }, {
        title: 'SpliceAI' /* ___ */
        , key: 'SpliceAI',
        link: {
          title: 'Click here to look up SpliceAI scores' /* ___ */
          , url: function url(variant) {
            return 'https://spliceailookup.broadinstitute.org/#variant=' + [variant.CHROM, variant.POS, variant.REF, variant.ALT].join('-') + '&hg=38&distance=50&mask=0&precomputed=1';
          }
        },
        long: true
      }, {
        title: 'SpliceAI\nAcceptor gain score' /* ___ */
        , key: 'SpliceAI_DS_AG',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DS_AG'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DS_AG) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DS_AG;
        },
        long: true
      }, {
        title: 'SpliceAI\nAcceptor loss score' /* ___ */
        , key: 'SpliceAI_DS_AL',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DS_AL'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DS_AL) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DS_AL;
        },
        long: true
      }, {
        title: 'SpliceAI\nDonor gain score' /* ___ */
        , key: 'SpliceAI_DS_DG',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DS_DG'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DS_DG) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DS_DG;
        },
        long: true
      }, {
        title: 'SpliceAI\nDonor loss score' /* ___ */
        , key: 'SpliceAI_DS_DL',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DS_DL'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DS_DL) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DS_DL;
        },
        long: true
      }, {
        title: 'SpliceAI\nAcceptor gain position' /* ___ */
        , key: 'SpliceAI_DP_AG',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DP_AG'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DP_AG) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DP_AG;
        },
        long: true
      }, {
        title: 'SpliceAI\nAcceptor loss position' /* ___ */
        , key: 'SpliceAI_DP_AL',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DP_AL'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DP_AL) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DP_AL;
        },
        long: true
      }, {
        title: 'SpliceAI\nDonor gain position' /* ___ */
        , key: 'SpliceAI_DP_DG',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DP_DG'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DP_DG) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DP_DG;
        },
        long: true
      }, {
        title: 'SpliceAI\nDonor loss positon' /* ___ */
        , key: 'SpliceAI_DP_DL',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SpliceAI_DP_DL'].checkPassed || function () {
            return true;
          })(variant.SpliceAI_DP_DL) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SpliceAI_DP_DL;
        },
        long: true
      }, {
        title: 'GERP++NR' /* ___ */
        , key: 'GERPpp_NR',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['GERPpp_NR'].checkPassed || function () {
            return true;
          })(variant.GERPpp_NR) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.GERPpp_NR;
        }
      }, {
        title: 'GERP++RS' /* ___ */
        , key: 'GERPpp_RS',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['GERPpp_RS'].checkPassed || function () {
            return true;
          })(variant.GERPpp_RS, variant.GERPpp_RS_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.GERPpp_RS;
        }
      }, {
        title: 'GERPpp RS pred' /* ___ */
        , key: 'GERPpp_RS_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['GERPpp_RS'].displayMap[variant.GERPpp_RS_pred] || variant.GERPpp_RS_pred;
        }
      }, {
        title: 'SiPhy 29way logOdds' /* ___ */
        , key: 'SiPhy_29way_logOdds',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SiPhy_29way_logOdds'].checkPassed || function () {
            return true;
          })(variant.SiPhy_29way_logOdds, variant.SiPhy_29way_logOdds_pred) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SiPhy_29way_logOdds;
        }
      }, {
        title: 'SiPhy 29way logOdds pred' /* ___ */
        , key: 'SiPhy_29way_logOdds_pred',
        class: function _class(value) {
          return value || value === 0 ? ['normal'] : ['empty'];
        },
        value: function value(variant) {
          return global_data["q" /* predictionMetaDatas */]['SiPhy_29way_logOdds'].displayMap[variant.SiPhy_29way_logOdds_pred] || variant.SiPhy_29way_logOdds_pred;
        }
      }, {
        title: 'SiPhy 29way pi' /* ___ */
        , key: 'SiPhy_29way_pi',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['SiPhy_29way_pi'].checkPassed || function () {
            return true;
          })(variant.SiPhy_29way_pi) + ''] || 'empty'];
        },
        value: function value(variant) {
          return variant.SiPhy_29way_pi ? variant.SiPhy_29way_pi.split(':').map(function (v) {
            return (Object(util["g" /* fixNumber */])(v, 0.01) + '').replace(/^0$/, '0.0');
          }).join(':') : variant.SiPhy_29way_pi;
        },
        hover: function hover(variant) {
          return variant.SiPhy_29way_pi;
        }
      }, {
        title: 'Synonymous\no/e' /* ___ */
        , key: 'oe_syn',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['oe_syn'].checkPassed || function () {
            return true;
          })(_this.gene.oe_syn) + ''] || 'empty'];
        },
        value: function value() {
          return _this.gene.oe_syn;
        }
      }, {
        title: 'Missense\no/e' /* ___ */
        , key: 'oe_mis',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['oe_mis'].checkPassed || function () {
            return true;
          })(_this.gene.oe_mis) + ''] || 'empty'];
        },
        value: function value() {
          return _this.gene.oe_mis;
        }
      }, {
        title: 'pLoF\no/e' /* ___ */
        , key: 'oe_lof',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['oe_lof'].checkPassed || function () {
            return true;
          })(_this.gene.oe_lof) + ''] || 'empty'];
        },
        value: function value() {
          return _this.gene.oe_lof;
        }
      }, {
        title: 'Synonymous\nz-score' /* ___ */
        , key: 'syn_z',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['syn_z'].checkPassed || function () {
            return true;
          })(_this.gene.syn_z) + ''] || 'empty'];
        },
        value: function value() {
          return _this.gene.syn_z;
        }
      }, {
        title: 'Missense\nz-score' /* ___ */
        , key: 'mis_z',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['mis_z'].checkPassed || function () {
            return true;
          })(_this.gene.mis_z) + ''] || 'empty'];
        },
        value: function value() {
          return _this.gene.mis_z;
        }
      }, {
        title: 'pLI' /* ___ */
        , key: 'pLI',
        class: function _class(value, variant) {
          return [{
            'true': 'normal',
            'false': 'alert'
          }[(global_data["q" /* predictionMetaDatas */]['pLI'].checkPassed || function () {
            return true;
          })(_this.gene.pLI) + ''] || 'empty'];
        },
        value: function value() {
          return _this.gene.pLI;
        }
      }];
    },
    dbOptionGroups: function dbOptionGroups() {
      var _this2 = this;

      return [{
        title: 'Allele Frequency' /* ___ */
        , value: 'AF',
        selects: ['AF 1000 Genomes', 'AF gnomAD Exomes', 'AF gnomAD Genomes', 'AF PhenoVarDB Private', 'AF PhenoVarDB Community', 'AF PhenoVarDB Admin', 'AF Other']
      }, {
        title: '1000 Genomes' /* ___ */
        , value: 'AF 1000 Genomes',
        optionGroups: [[[{
          title: 'AF' /* ___ */
          , key: 'KG_AF'
        }, {
          title: 'EAS AF' /* ___ */
          , key: 'KG_EAS_AF'
        }, {
          title: 'AMR AF' /* ___ */
          , key: 'KG_AMR_AF'
        }, {
          title: 'AFR AF' /* ___ */
          , key: 'KG_AFR_AF'
        }, {
          title: 'EUR AF' /* ___ */
          , key: 'KG_EUR_AF'
        }, {
          title: 'SAS AF' /* ___ */
          , key: 'KG_SAS_AF'
        }]]]
      }, {
        title: 'gnomAD Exomes' /* ___ */
        , value: 'AF gnomAD Exomes',
        optionGroups: [[[{
          title: 'AF' /* ___ */
          , key: 'gnomAD_AF'
        }, {
          title: 'AFR AF' /* ___ */
          , key: 'gnomAD_AFR_AF'
        }, {
          title: 'AMR AF' /* ___ */
          , key: 'gnomAD_AMR_AF'
        }, {
          title: 'ASJ AF' /* ___ */
          , key: 'gnomAD_ASJ_AF'
        }, {
          title: 'EAS AF' /* ___ */
          , key: 'gnomAD_EAS_AF'
        }, {
          title: 'FIN AF' /* ___ */
          , key: 'gnomAD_FIN_AF'
        }, {
          title: 'NFE AF' /* ___ */
          , key: 'gnomAD_NFE_AF'
        }, {
          title: 'OTH AF' /* ___ */
          , key: 'gnomAD_OTH_AF'
        }, {
          title: 'SAS AF' /* ___ */
          , key: 'gnomAD_SAS_AF'
        }]]]
      }, {
        title: 'gnomAD Genomes' /* ___ */
        , value: 'AF gnomAD Genomes',
        optionGroups: [[[{
          title: 'AF' /* ___ */
          , key: 'gnomAD_g_AF',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'AFR AF' /* ___ */
          , key: 'gnomAD_g_AF_afr',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'AMI AF' /* ___ */
          , key: 'gnomAD_g_AF_ami',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'AMR AF' /* ___ */
          , key: 'gnomAD_g_AF_amr',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'ASJ AF' /* ___ */
          , key: 'gnomAD_g_AF_asj',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'EAS AF' /* ___ */
          , key: 'gnomAD_g_AF_eas',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'FIN AF' /* ___ */
          , key: 'gnomAD_g_AF_fin',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'MID AF' /* ___ */
          , key: 'gnomAD_g_AF_mid',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'NFE AF' /* ___ */
          , key: 'gnomAD_g_AF_nfe',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'OTH AF' /* ___ */
          , key: 'gnomAD_g_AF_oth',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'SAS AF' /* ___ */
          , key: 'gnomAD_g_AF_sas',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM !== 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy AF' /* ___ */
          , key: 'gnomAD_g_mt_AF_het',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy AFR AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_afr',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy AMI AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_ami',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy AMR AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_amr',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy ASJ AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_asj',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy EAS AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_eas',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy FIN AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_fin',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy MID AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_mid',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy NFE AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_nfe',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy OTH AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_oth',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Heteroplasmy SAS AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_het_sas',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy AF' /* ___ */
          , key: 'gnomAD_g_mt_AF_hom',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy AFR AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_afr',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy AMI AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_ami',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy AMR AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_amr',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy ASJ AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_asj',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy EAS AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_eas',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy FIN AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_fin',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy MID AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_mid',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy NFE AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_nfe',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy OTH AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_oth',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }, {
          title: 'Homoplasmy SAS AF' /* ___ */
          , key: 'gnomAD_g_mt_pop_AF_hom_sas',
          display: function display(variants) {
            return values_default()(variants).some(function (variant) {
              return variant.CHROM === 'chrM';
            });
          }
        }]]]
      }, {
        title: 'PhenoVarDB Private' /* ___ */
        , value: 'AF PhenoVarDB Private',
        optionGroups: [[[{
          title: 'Filter' /* ___ */
          , key: 'PVDB_P_FILTER'
        }, {
          title: 'Missing rate' /* ___ */
          , key: 'PVDB_P_F_MISSING'
        }, {
          title: 'AC' /* ___ */
          , key: 'PVDB_P_AC'
        }, {
          title: 'AN' /* ___ */
          , key: 'PVDB_P_AN'
        }, {
          title: 'AF' /* ___ */
          , key: 'PVDB_P_AF'
        }, {
          title: 'DP' /* ___ */
          , key: 'PVDB_P_DP'
        }, {
          title: 'AC in heterozygous genotypes' /* ___ */
          , key: 'PVDB_P_AC_Het'
        }, {
          title: 'AC in homozygous genotypes' /* ___ */
          , key: 'PVDB_P_AC_Hom'
        }, {
          title: 'AC in hemizygous genotypes' /* ___ */
          , key: 'PVDB_P_AC_Hemi'
        }]]]
      }, {
        title: 'PhenoVarDB Community' /* ___ */
        , value: 'AF PhenoVarDB Community',
        optionGroups: [[[{
          title: 'Filter' /* ___ */
          , key: 'PVDB_S_FILTER'
        }, {
          title: 'Missing rate' /* ___ */
          , key: 'PVDB_S_F_MISSING'
        }, {
          title: 'AC' /* ___ */
          , key: 'PVDB_S_AC'
        }, {
          title: 'AN' /* ___ */
          , key: 'PVDB_S_AN'
        }, {
          title: 'AF' /* ___ */
          , key: 'PVDB_S_AF'
        }, {
          title: 'DP' /* ___ */
          , key: 'PVDB_S_DP'
        }, {
          title: 'AC in heterozygous genotypes' /* ___ */
          , key: 'PVDB_S_AC_Het'
        }, {
          title: 'AC in homozygous genotypes' /* ___ */
          , key: 'PVDB_S_AC_Hom'
        }, {
          title: 'AC in hemizygous genotypes' /* ___ */
          , key: 'PVDB_S_AC_Hemi'
        }]]]
      }, {
        title: 'PhenoVarDB Admin' /* ___ */
        , value: 'AF PhenoVarDB Admin',
        display: function display(variants) {
          return ['supervisor'].includes(_this2.user.role);
        },
        optionGroups: [[[{
          title: 'Filter' /* ___ */
          , key: 'PVDB_A_FILTER'
        }, {
          title: 'Missing rate' /* ___ */
          , key: 'PVDB_A_F_MISSING'
        }, {
          title: 'AC' /* ___ */
          , key: 'PVDB_A_AC'
        }, {
          title: 'AN' /* ___ */
          , key: 'PVDB_A_AN'
        }, {
          title: 'AF' /* ___ */
          , key: 'PVDB_A_AF'
        }, {
          title: 'DP' /* ___ */
          , key: 'PVDB_A_DP'
        }, {
          title: 'AC in heterozygous genotypes' /* ___ */
          , key: 'PVDB_A_AC_Het'
        }, {
          title: 'AC in homozygous genotypes' /* ___ */
          , key: 'PVDB_A_AC_Hom'
        }, {
          title: 'AC in hemizygous genotypes' /* ___ */
          , key: 'PVDB_A_AC_Hemi'
        }]]]
      }, {
        title: 'Other' /* ___ */
        , value: 'AF Other',
        optionGroups: [[[{
          title: 'ESP6500' /* ___ */
          , key: 'ESP6500_AF'
        }, {
          title: 'ESP6500 AA' /* ___ */
          , key: 'ESP6500_AA_AF'
        }, {
          title: 'ESP6500 AE' /* ___ */
          , key: 'ESP6500_EA_AF'
        }]], [[{
          title: 'Taiwan Biobank' /* ___ */
          , key: 'TW_AF'
        }, {
          title: 'TOPMED' /* ___ */
          , key: 'TOPMED_AF'
        }, {
          title: 'UK10K' /* ___ */
          , key: 'UK10K_AF'
        },
        // {
        //   title: 'ChinaMAP'/* ___ */,
        //   key: 'ChinaMAP_AF'
        // },
        {
          title: 'Genome Asia100' /* ___ */
          , key: 'GA_AF'
          // {
          //   title: '4.7KJPN'/* ___ */,
          //   key: 'KJ_AF'
          // }
        }]], [[{
          title: 'ExAC' /* ___ */
          , key: 'ExAC_AF'
        }]]]
      }, {
        title: 'Coverage' /* ___ */
        , value: 'Coverage' /* ___ */
        , selects: ['Coverage gnomAD Exomes', 'Coverage gnomAD Genomes']
      }, {
        title: 'gnomAD Exomes' /* ___ */
        , value: 'Coverage gnomAD Exomes',
        optionGroups: [[[{
          title: 'Mean' /* ___ */
          , key: 'gnomAD_cov_MEAN'
        }, {
          title: ' Median' /* ___ */
          , key: 'gnomAD_cov_MEDIAN'
        }, {
          title: '>20x coverage (%)' /* ___ */
          , key: 'gnomAD_cov_PCT_20X'
        }]]]
      }, {
        title: 'gnomAD Genomes' /* ___ */
        , value: 'Coverage gnomAD Genomes',
        optionGroups: [[[{
          title: 'Mean' /* ___ */
          , key: 'gnomAD_g_cov_MEAN'
        }, {
          title: ' Median' /* ___ */
          , key: 'gnomAD_g_cov_MEDIAN'
        }, {
          title: '>20x coverage (%)' /* ___ */
          , key: 'gnomAD_g_cov_PCT_20X'
        }]]]
      }];
    },
    psOptionGroups: function psOptionGroups() {
      return [{
        title: 'Prediction Scores - Function Prediction' /* ___ */
        , value: 'Prediction Scores - Function Prediction',
        selects: ['Prediction Scores - Function Prediction'],
        optionGroups: [[[{
          title: 'SIFT4G score' /* ___ */
          , key: 'SIFT4G_score'
        }, {
          title: 'SIFT4G pred' /* ___ */
          , key: 'SIFT4G_pred'
        }, {
          title: 'Polyphen-2 HDIV' /* ___ */
          , key: 'Polyphen'
        }, {
          title: 'Polyphen-2 HDIV pred' /* ___ */
          , key: 'Polyphen_pred'
        }, {
          title: 'FATHMM score' /* ___ */
          , key: 'FATHMM_score'
        }, {
          title: 'FATHMM pred' /* ___ */
          , key: 'FATHMM_pred'
        }, {
          title: 'PROVEAN score' /* ___ */
          , key: 'PROVEAN_score'
        }, {
          title: 'PROVEAN pred' /* ___ */
          , key: 'PROVEAN_pred'
        }, {
          title: 'CADD phred' /* ___ */
          , key: 'CADD_phred'
        }, {
          title: 'CADD phred pred' /* ___ */
          , key: 'CADD_phred_pred'
        }, {
          title: 'MetaLR score' /* ___ */
          , key: 'MetaLR_score'
        }, {
          title: 'MetaLR pred' /* ___ */
          , key: 'MetaLR_pred'
        }, {
          title: 'MetaSVM score' /* ___ */
          , key: 'MetaSVM_score'
        }, {
          title: 'MetaSVM pred' /* ___ */
          , key: 'MetaSVM_pred'
        },
        // {
        //   title: 'REVEL score'/* ___ */,
        //   key: 'REVEL_score'
        // },
        // {
        //   title: 'REVEL pred'/* ___ */,
        //   key: 'REVEL_pred'
        // },
        {
          title: 'BayesDel addAF score' /* ___ */
          , key: 'BayesDel_addAF_score'
        }, {
          title: 'BayesDel addAF red' /* ___ */
          , key: 'BayesDel_addAF_pred'
        }, {
          title: 'MitoTip score' /* ___ */
          , key: 'gnomAD_g_mt_mitotip_score'
        }, {
          title: 'MitoTip pred' /* ___ */
          , key: 'gnomAD_g_mt_mitotip_score_pred'
        }]]]
      }, {
        title: 'Prediction Scores - Splice Site' /* ___ */
        , value: 'Prediction Scores - Splice Site',
        selects: ['Prediction Scores - Splice Site'],
        optionGroups: [[[{
          title: 'ada score' /* ___ */
          , key: 'ada_score'
        }, {
          title: 'ada pred' /* ___ */
          , key: 'ada_pred'
        }, {
          title: 'rf score' /* ___ */
          , key: 'rf_score'
        }, {
          title: 'rf pred' /* ___ */
          , key: 'rf_pred'
        }, {
          title: 'SpliceAI' /* ___ */
          , key: 'SpliceAI'
          // {
          //   title: 'SpliceAI Acceptor gain score'/* ___ */,
          //   key: 'SpliceAI_DS_AG'
          // },
          // {
          //   title: 'SpliceAI Acceptor loss score'/* ___ */,
          //   key: 'SpliceAI_DS_AL'
          // },
          // {
          //   title: 'SpliceAI Donor gain score'/* ___ */,
          //   key: 'SpliceAI_DS_DG'
          // },
          // {
          //   title: 'SpliceAI Donor loss score'/* ___ */,
          //   key: 'SpliceAI_DS_DL'
          // },
          // {
          //   title: 'SpliceAI Acceptor gain position'/* ___ */,
          //   key: 'SpliceAI_DP_AG'
          // },
          // {
          //   title: 'SpliceAI Acceptor loss position'/* ___ */,
          //   key: 'SpliceAI_DP_AL'
          // },
          // {
          //   title: 'SpliceAI Donor gain position'/* ___ */,
          //   key: 'SpliceAI_DP_DG'
          // },
          // {
          //   title: 'SpliceAI Donor loss positon'/* ___ */,
          //   key: 'SpliceAI_DP_DL'
          // }
        }]]]
      }, {
        title: 'Prediction Scores - Conservation' /* ___ */
        , value: 'Prediction Scores - Conservation',
        selects: ['Prediction Scores - Conservation'],
        optionGroups: [[[{
          title: 'GERP++NR' /* ___ */
          , key: 'GERPpp_NR'
        }, {
          title: 'GERP++RS' /* ___ */
          , key: 'GERPpp_RS'
        }, {
          title: 'GERP++RS pred' /* ___ */
          , key: 'GERPpp_RS_pred'
        }, {
          title: 'SiPhy 29way logOdds' /* ___ */
          , key: 'SiPhy_29way_logOdds'
        }, {
          title: 'SiPhy 29way logOdds pred' /* ___ */
          , key: 'SiPhy_29way_logOdds_pred'
        }, {
          title: 'SiPhy 29way pi' /* ___ */
          , key: 'SiPhy_29way_pi'
        }]]]
      }, {
        title: 'Prediction Scores - gnomAD Constraint' /* ___ */
        , value: 'Prediction Scores - gnomAD Constraint',
        selects: ['Prediction Scores - gnomAD Constraint'],
        optionGroups: [[[{
          title: 'Synonymous o/e' /* ___ */
          , key: 'oe_syn'
        }, {
          title: 'Missense o/e' /* ___ */
          , key: 'oe_mis'
        }, {
          title: 'pLoF o/e' /* ___ */
          , key: 'oe_lof'
        }, {
          title: 'Synonymous z-score' /* ___ */
          , key: 'syn_z'
        }, {
          title: 'Missense z-score' /* ___ */
          , key: 'mis_z'
        }, {
          title: 'pLI' /* ___ */
          , key: 'pLI'
        }]]]
      }];
    },
    reportOptionGroups: function reportOptionGroups() {
      return [].concat(toConsumableArray_default()(['db'].includes(this.param.type) ? [this.dbOptionGroups] : []), toConsumableArray_default()(['ps'].includes(this.param.type) ? [this.psOptionGroups] : []));
    }
  }),
  created: function created() {
    var _this3 = this;

    var colMap = function colMap(reportGroups) {
      var result = reportGroups;
      result = Array.prototype.concat.apply([], result.map(function (reportGroup) {
        return reportGroup.optionGroups || [];
      }));
      result = Array.prototype.concat.apply([], result);
      result = Array.prototype.concat.apply([], result);
      result = result.map(function (x) {
        return x.key;
      });
      return result;
    };
    var settingColumns = keys_default()(this.userSetting.report_preview_af_columns.reduce(function (result, column) {
      return extends_default()({}, result, defineProperty_default()({}, _this3.settingColumnData['map'][column] || column, true));
    }, {}));
    var cols = {
      'db': colMap(this.dbOptionGroups),
      'ps': colMap(this.psOptionGroups)
    };
    var afpCols = settingColumns.filter(function (col) {
      return cols[_this3.param.type].includes(col);
    });
    afpCols = afpCols && afpCols.length ? afpCols : {
      'db': ['KG_EAS_AF', 'gnomAD_EAS_AF', 'TW_AF'],
      'ps': ['SIFT4G_score', 'Polyphen']
    }[this.param.type];
    delete cols[this.param.type];
    cols = Array.prototype.concat.apply([], values_default()(cols));
    var otherCols = settingColumns.filter(function (col) {
      return cols.includes(col);
    });
    this.afpCols = afpCols;
    this.otherCols = otherCols;
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserSettingAction']), {
    valueMap: function valueMap(value) {
      return value || value === 0 ? value : value === null || value === '' ? 'N/A' : '?';
    },
    getSelectKeys: function getSelectKeys(selects) {
      var optionMap = this.reportOptionGroups[0].reduce(function (map, option) {
        return extends_default()({}, map, defineProperty_default()({}, option.value, option));
      }, {});
      return Array.prototype.concat.apply([], selects.map(function (select) {
        return Array.prototype.concat.apply([], optionMap[select].optionGroups.map(function (optionGroup) {
          return Array.prototype.concat.apply([], optionGroup.map(function (options) {
            return options.map(function (option) {
              return option.key;
            });
          }));
        }));
      }));
    },
    setAfpCol: function setAfpCol(keys) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var afpCols;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                afpCols = [].concat(toConsumableArray_default()(_this4.afpCols));

                afpCols = afpCols.filter(function (col) {
                  return !keys.includes(col);
                });
                if (_this4.afpCols.length === afpCols.length) {
                  afpCols = afpCols.concat(keys);
                }
                _this4.afpCols = afpCols;
                _context.next = 6;
                return _this4.editUserSetting();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    editUserSetting: function editUserSetting() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, selectedColumns, data, response, userSettings;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.onSubmit = true;
                _context2.prev = 1;
                config = _this5.$ls.get('userInfo');
                selectedColumns = [].concat(toConsumableArray_default()(_this5.afpCols), toConsumableArray_default()(_this5.otherCols));

                selectedColumns = Array.prototype.concat.apply([], selectedColumns.map(function (column) {
                  return _this5.settingColumnData['group'][column] || [column];
                }));
                data = {
                  report_preview_af_columns: selectedColumns
                };
                _context2.next = 8;
                return Object(api["_100" /* putUserSettings */])(data, config);

              case 8:
                response = _context2.sent;
                userSettings = response.data.data;

                _this5.setUserSettingAction(userSettings);
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](1);

                _this5.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 16:
                _this5.onSubmit = false;

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[1, 13]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a0c1f98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGeneUserSetting.vue
var caseDetailGeneUserSetting_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-user-setting-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
        'db': 'Population Databases'/* ___ */,
        'ps': 'Prediction Scores'/* ___ */
      }[_vm.param.type])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"tab-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"tab-block row-block",class:{ display: _vm.display['dbSelect'] },on:{"click":function (e) { return _vm.display['dbSelect'] = !_vm.display['dbSelect']; }}},[_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s('Options'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("K4ph"),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '8px' })})])]),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),(_vm.display['dbSelect'])?[(_vm.afpCols)?_c('div',{staticClass:"report-container col-block"},_vm._l((_vm.reportOptionGroups),function(reportGroups,rgindex){return _c('div',{key:rgindex,staticClass:"report-group col-block"},_vm._l((reportGroups.filter(function (report) { return (report.display || (function () { return true; }))(_vm.variants); })),function(report,rindex){return _c('div',{key:rindex,staticClass:"report-block col-block",class:{ 'title-only': !(report.optionGroups || []).length }},[_c('div',{staticClass:"report-title-container row-block"},[_c('div',{staticClass:"report-title-block row-block",class:{ selectable: report.selects },on:{"click":function (e) { return _vm.setAfpCol(_vm.getSelectKeys(report.selects)); }}},[_c('div',{staticClass:"report-title"},[_vm._v(_vm._s(report.title))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),(report.selects)?_c('img',{attrs:{"src":_vm.getSelectKeys(report.selects).some(function (key) { return _vm.afpCols.includes(key); }) ? _vm.getSelectKeys(report.selects).every(function (key) { return _vm.afpCols.includes(key); }) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo")}}):_vm._e()]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),((report.optionGroups || []).length)?_c('div',{staticClass:"report-option-container col-block"},_vm._l((report.optionGroups),function(optionGroups,ogindex){return _c('div',{key:ogindex,staticClass:"report-option-group row-block flex-start"},_vm._l((optionGroups),function(options,osindex){return _c('div',{key:osindex,staticClass:"report-option-block row-block flex-wrap",style:((osindex + 1) === optionGroups.length ? { flex: 1 } : {})},_vm._l((options.filter(function (option) { return (option.display || (function () { return true; }))(_vm.variants); })),function(option,oindex){return _c('div',{key:oindex,staticClass:"report-option row-block",class:{ disabled: _vm.afpCols.length <= { 'db': 3, 'ps': 2 }[_vm.param.type] && _vm.afpCols.includes(option.key) },on:{"click":function (e) { return !(_vm.afpCols.length <= { 'db': 3, 'ps': 2 }[_vm.param.type] && _vm.afpCols.includes(option.key)) && _vm.setAfpCol([option.key]); }}},[_c('img',{attrs:{"src":_vm.afpCols.includes(option.key) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"report-option-title"},[_vm._v(_vm._s(option.title))])])}),0)}),0)}),0):_vm._e()])}),0)}),0):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"no-margin"}),_vm._v(" "),_c('div',{style:({ height: '15px' })})]:_vm._e(),_vm._v(" "),_vm._l((_vm.variants),function(variant,vindex){return _c('div',{key:vindex,staticClass:"data-container col-block"},[_c('div',{staticClass:"data-title-container row-block"},[_c('div',{staticClass:"data-title"},[_vm._v(_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_vm._l((Object.entries(_vm.afpDataGroups).filter(function (ref) {
            var group = ref[0];
            var afpDatas = ref[1];

            return afpDatas.some(function (afpData) { return (afpData.display || (function () { return true; }))(variant); });
      })),function(ref,agindex){
      var group = ref[0];
      var afpDatas = ref[1];
return _c('div',{key:agindex,staticClass:"data-content-field col-block",class:{ 'title-only': !afpDatas.some(function (afpData) { return afpData.title; }) }},[(group && group !== 'undefined')?[_c('div',{staticClass:"data-content-title"},[_vm._v(_vm._s(_vm.groupTitleMap[group] || group))])]:_vm._e(),_vm._v(" "),(afpDatas.some(function (afpData) { return afpData.title; }))?_c('div',{staticClass:"data-content-container row-block flex-wrap flex-start stretch"},_vm._l((afpDatas.filter(function (afpData) { return (afpData.display || (function () { return true; }))(variant); })),function(afpData,aindex){return _c('div',{key:aindex,staticClass:"data-block-container col-block",style:({ width: afpData.long ? '18.75%' : '12.5%' })},[_c('div',{staticClass:"data-block col-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"data-content"},[_vm._v(_vm._s(afpData.title))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"data-block col-block",class:[_vm.param.type]},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),(afpData.link)?_c('a',{staticClass:"data-link row-block",attrs:{"href":afpData.link.url(variant),"target":"_blank"}},[_c('a',{staticClass:"link row-block shrink",domProps:{"innerHTML":_vm._s(afpData.link.title)}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("wtkH"),"alt":""}})]):_c('div',{staticClass:"data-content ellipsis",class:afpData.class(afpData.value(variant), variant),attrs:{"title":_vm.valueMap((afpData.hover || afpData.value)(variant))}},[_vm._v(_vm._s(_vm.valueMap(afpData.value(variant))))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}),0):_vm._e()],2)})],2)}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var caseDetailGeneUserSetting_staticRenderFns = []
var caseDetailGeneUserSetting_esExports = { render: caseDetailGeneUserSetting_render, staticRenderFns: caseDetailGeneUserSetting_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGeneUserSetting = (caseDetailGeneUserSetting_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGeneUserSetting.vue
var caseDetailGeneUserSetting_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGeneUserSetting___vue_template_functional__ = false
/* styles */
var caseDetailGeneUserSetting___vue_styles__ = null
/* scopeId */
var caseDetailGeneUserSetting___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGeneUserSetting___vue_module_identifier__ = null
var caseDetailGeneUserSetting_Component = caseDetailGeneUserSetting_normalizeComponent(
  caseDetailGeneUserSetting,
  dialog_caseDetailGeneUserSetting,
  caseDetailGeneUserSetting___vue_template_functional__,
  caseDetailGeneUserSetting___vue_styles__,
  caseDetailGeneUserSetting___vue_scopeId__,
  caseDetailGeneUserSetting___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGeneUserSetting = (caseDetailGeneUserSetting_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/caseDetailGeneACMG.vue







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var caseDetailGeneACMG = ({
  components: {
    borCor: tool_borCor["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      acmg: null,
      display: {}
    };
  },

  computed: {
    acmgResults: function acmgResults() {
      var _this = this;

      return entries_default()(this.acmg[this.gene.SYMBOL || '']).reduce(function (result, _ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            vkey = _ref2[0],
            acmg = _ref2[1];

        return extends_default()({}, result, defineProperty_default()({}, vkey, entries_default()(acmg).filter(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              _ = _ref4[0],
              value = _ref4[1];

          return value;
        }).map(function (_ref5) {
          var _ref6 = slicedToArray_default()(_ref5, 1),
              key = _ref6[0];

          return _this.acmgMap[key];
        }).filter(function (x) {
          return x;
        })));
      }, {});
    },

    // param
    gene: function gene() {
      return this.param.gene;
    },
    variants: function variants() {
      return this.param.variants;
    },
    type: function type() {
      return this.param.type;
    },

    // global
    acmgMap: function acmgMap() {
      return global_data["a" /* acmgMap */];
    }
  },
  created: function created() {
    this.acmg = this.param.acmg;
    this.display = extends_default()({}, this.display, keys_default()(this.variants).reduce(function (s, vkey) {
      return extends_default()({}, s, defineProperty_default()({}, vkey, false));
    }, {}));
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction']), {
    // parent
    getACMGConsequence: function getACMGConsequence(gene, vkey) {
      return this.param.functions['getACMGConsequence'](gene, vkey);
    },
    setACMG: function setACMG(gene, vkey, tag) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.setLoadingAction(true);
                _context.next = 3;
                return _this2.param.functions['setACMG'](gene, vkey, tag);

              case 3:
                result = _context.sent;

                _this2.acmg[gene.SYMBOL || ''][vkey] = extends_default()({}, _this2.acmg[gene.SYMBOL || ''][vkey], defineProperty_default()({}, tag, result));
                _this2.setLoadingAction(false);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    resetACMG: function resetACMG(gene, vkey) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var variant, defaultACMG;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.setLoadingAction(true);
                _context2.next = 3;
                return _this3.param.functions['resetACMG'](gene, vkey);

              case 3:
                variant = gene.variants[vkey];
                defaultACMG = keys_default()(_this3.acmgMap).concat(['ACMG_Classification']).reduce(function (s, key) {
                  return extends_default()({}, s, defineProperty_default()({}, key, variant[key]));
                }, {});

                _this3.acmg[gene.SYMBOL || ''][vkey] = defaultACMG;
                _this3.setLoadingAction(false);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dabfd17e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/caseDetailGeneACMG.vue
var caseDetailGeneACMG_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail-gene-acmg-dailog dialog col-block"},[_c('div',{staticClass:"title-container row-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('ACMG'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '5px' })}),_vm._v(" "),(_vm.acmg)?_c('div',{staticClass:"data-container col-block"},[_c('div',{staticClass:"acmg-table-container col-block"},_vm._l((_vm.variants),function(variant,vkey,vindex){return _c('div',{key:vindex,staticClass:"acmg-table-block"},[_c('div',{staticClass:"acmg-table"},[_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell hgvsc col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content ellipsis",attrs:{"title":variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'},domProps:{"innerHTML":_vm._s(variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col tab col-block",style:({ flex: 3 })},[_c('div',{staticClass:"table-cell consequence col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content",domProps:{"innerHTML":_vm._s(_vm.getACMGConsequence(_vm.gene, vkey))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{staticClass:"tab-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"tab-block row-block",class:{ display: _vm.display[vkey] },on:{"click":function (e) { return _vm.display[vkey] = !_vm.display[vkey]; }}},[_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s('Rules'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("K4ph"),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '8px' })})])])])]),_vm._v(" "),(_vm.display[vkey])?[_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell criteria col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_c('button',{staticClass:"reset-button gray-button circle-button",on:{"click":function (e) { return _vm.resetACMG(_vm.gene, vkey); }}},[_c('span',[_vm._v(_vm._s('Reset'/* ___ */))])])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell benign col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Benign Criteria'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell pathogenic col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Pathogenic Criteria'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell strength-of-evidence col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Strength of Evidence'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell benign-strong col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Strong'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell benign-supporting col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Supporting'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-supporting col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Supporting'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-moderate col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Moderate'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-strong col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Strong'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell pathogenic-very-strong col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Very Strong'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Population Data'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BA1'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BA1'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BA1'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BA1'] ? 'benign-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BA1'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BA1'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BA1'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS1'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS1'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BS1'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS1'] ? 'benign-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS1'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BS1'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BS1'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS2'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS2'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BS2'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS2'] ? 'benign-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS2'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BS2'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BS2'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-supporting-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-supporting-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-moderate-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM2'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM2'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PM2'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM2'] ? 'pathogenic-moderate' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM2'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PM2'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PM2'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS4'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS4'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PS4'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS4'] ? 'pathogenic-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS4'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PS4'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"reverse":true,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PS4'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-very-strong-col col-block"},[_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_c('span',[_vm._v(_vm._s('Allelic Evidence &'/* ___ */))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s('Cosegrgation Data'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS4'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS4'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BS4'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS4'] ? 'benign-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS4'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BS4'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BS4'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-supporting-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP2'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP2'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BP2'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP2'] ? 'benign-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP2'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BP2'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BP2'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP5'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP5'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BP5'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP5'] ? 'benign-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP5'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BP5'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BP5'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-sub-col-container col-block",style:({ flex: 3 })},[_c('div',{staticClass:"table-sub-cell-container col-block"},[_c('div',{staticClass:"table-sub-col-block low-row row-block"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-supporting-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP1'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP1'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PP1'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP1'] ? 'pathogenic-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP1'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PP1'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                                  padding: '6px 8px'
                                }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PP1'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-sub-col-block row-block"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-supporting-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-moderate-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM3'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM3'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PM3'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM3'] ? 'pathogenic-moderate' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM3'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PM3'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                                  padding: '6px 8px'
                                }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PM3'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM6'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM6'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PM6'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM6'] ? 'pathogenic-moderate' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM6'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PM6'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                                  padding: '6px 8px'
                                }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PM6'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS2'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS2'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PS2'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS2'] ? 'pathogenic-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS2'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PS2'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"reverse":true,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                                  padding: '6px 8px'
                                }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PS2'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])])])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-very-strong-col col-block"},[_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_c('span',[_vm._v(_vm._s('Computation &'/* ___ */))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s('Predictive Data'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-strong-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-supporting-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP1'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP1'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BP1'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP1'] ? 'benign-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP1'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BP1'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BP1'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP3'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP3'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BP3'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP3'] ? 'benign-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP3'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BP3'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BP3'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP4'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP4'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BP4'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP4'] ? 'benign-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP4'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BP4'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BP4'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP7'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP7'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BP7'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP7'] ? 'benign-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP7'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BP7'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BP7'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-supporting-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP2'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP2'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PP2'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP2'] ? 'pathogenic-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP2'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PP2'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PP2'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP3'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP3'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PP3'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP3'] ? 'pathogenic-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP3'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PP3'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PP3'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-moderate-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM1'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM1'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PM1'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM1'] ? 'pathogenic-moderate' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM1'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PM1'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PM1'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM4'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM4'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PM4'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM4'] ? 'pathogenic-moderate' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM4'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PM4'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PM4'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM5'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM5'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PM5'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM5'] ? 'pathogenic-moderate' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PM5'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PM5'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PM5'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS1'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS1'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PS1'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS1'] ? 'pathogenic-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS1'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PS1'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"reverse":true,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PS1'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-very-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PVS1'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PVS1'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PVS1'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PVS1'] ? 'pathogenic-very-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PVS1'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PVS1'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"reverse":true,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PVS1'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row low-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Functional Data'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS3'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS3'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BS3'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS3'] ? 'benign-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BS3'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BS3'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BS3'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-supporting-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-supporting-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-moderate-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-strong-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS3'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS3'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PS3'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS3'] ? 'pathogenic-strong' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PS3'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PS3'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"reverse":true,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PS3'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-very-strong-col col-block"},[_c('div',{style:({ flex: 1 })})])])]),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 2 })},[_c('div',{staticClass:"table-cell acmg-col-title col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Other'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-strong-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col benign-supporting-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP6'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP6'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'BP6'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP6'] ? 'benign-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['BP6'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('BP6'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['BP6'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-supporting-col col-block"},[_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP4'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP4'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PP4'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP4'] ? 'pathogenic-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP4'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PP4'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PP4'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"acmg-option-container",class:{ active: _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP5'], disabled: false && _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP5'] === null }},[_c('div',{staticClass:"acmg-option-block row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"acmg-content row-block",on:{"click":function (e) { return _vm.setACMG(_vm.gene, vkey, 'PP5'); }}},[_c('img',{attrs:{"src":__webpack_require__("gvao")("./acmg-checkbox-" + (_vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP5'] ? 'pathogenic-supporting' : _vm.acmg[(_vm.gene.SYMBOL || '')][vkey]['PP5'] !== 0 ? 'empty' : 'disabled') + '.svg'),"alt":""}}),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-title"},[_vm._v(_vm._s('PP5'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '7px' })}),_vm._v(" "),_c('div',{staticClass:"acmg-info center-block"},[_c('borCor',{attrs:{"width":'250px',"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                            padding: '6px 8px'
                          }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.acmgMap['PP5'].informations.join('<br>'))}})])])],1),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-moderate-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-strong-col col-block"},[_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell acmg-col pathogenic-very-strong-col col-block"},[_c('div',{style:({ flex: 1 })})])])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-row row-block stretch"},[_c('div',{staticClass:"table-col col-block",style:({ flex: 1 })},[_c('div',{staticClass:"table-cell automated-criteria col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Automated criteria'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),(_vm.display[vkey])?_c('div',{staticClass:"table-col col-block",style:({ flex: 3 })},[_c('div',{staticClass:"table-cell explanation col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s('Explanation'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e()]),_vm._v(" "),(_vm.acmgResults[vkey].length)?[(_vm.display[vkey])?_vm._l((_vm.acmgResults[vkey]),function(acmg,aindex){return _c('div',{key:aindex,staticClass:"table-row wrap-row row-block flex-start stretch"},[_c('div',{staticClass:"table-col col-block",style:({ width: '25%', 'min-height': '50px' })},[_c('div',{staticClass:"table-cell selected-col-title row-block",class:[acmg.class + '-title']},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(acmg.title + ': ')),_c('span',{staticClass:"type"},[_vm._v(_vm._s(acmg.type))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]),_vm._v(" "),_c('div',{staticClass:"table-col col-block",style:({ width: '75%', 'min-height': '50px' })},[_c('div',{staticClass:"table-cell selected-col col-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content",domProps:{"innerHTML":_vm._s(variant[acmg.title + '_explanation'] || '- -')}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])])}):[_c('div',{staticClass:"table-row wrap-row row-block flex-start flex-wrap stretch",class:['wrap-4']},[_vm._l((_vm.acmgResults[vkey]),function(acmg,aindex){return _c('div',{key:aindex,staticClass:"table-col col-block",style:({ width: '25%', height: '50px' })},[_c('div',{staticClass:"table-cell selected-col-title row-block",class:[acmg.class + '-title']},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"},[_vm._v(_vm._s(acmg.title + ': ')),_c('span',{staticClass:"type"},[_vm._v(_vm._s(acmg.type))])]),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),(variant[acmg.title + '_explanation'])?_c('borCor',{attrs:{"width":'400px',"reverse":aindex % 4 >= 2,"background":'white',"border":'#707070',"radius":'0px',"blockStyle":{
                        padding: '6px 8px'
                      }}},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"content col-block",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(variant[acmg.title + '_explanation'])}})])]):_c('img',{attrs:{"src":__webpack_require__("LRBV"),"alt":""}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],1)])}),_vm._v(" "),(_vm.acmgResults[vkey].length % 4)?_c('div',{staticClass:"table-col col-block empty",style:({ flex: 1, height: '50px' })},[_c('div',{staticClass:"table-cell selected-col-title row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"table-content"}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]):_vm._e()],2)]]:_vm._e()],2)])}),0)]):_vm._e(),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var caseDetailGeneACMG_staticRenderFns = []
var caseDetailGeneACMG_esExports = { render: caseDetailGeneACMG_render, staticRenderFns: caseDetailGeneACMG_staticRenderFns }
/* harmony default export */ var dialog_caseDetailGeneACMG = (caseDetailGeneACMG_esExports);
// CONCATENATED MODULE: ./src/components/dialog/caseDetailGeneACMG.vue
var caseDetailGeneACMG_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var caseDetailGeneACMG___vue_template_functional__ = false
/* styles */
var caseDetailGeneACMG___vue_styles__ = null
/* scopeId */
var caseDetailGeneACMG___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var caseDetailGeneACMG___vue_module_identifier__ = null
var caseDetailGeneACMG_Component = caseDetailGeneACMG_normalizeComponent(
  caseDetailGeneACMG,
  dialog_caseDetailGeneACMG,
  caseDetailGeneACMG___vue_template_functional__,
  caseDetailGeneACMG___vue_styles__,
  caseDetailGeneACMG___vue_scopeId__,
  caseDetailGeneACMG___vue_module_identifier__
)

/* harmony default export */ var components_dialog_caseDetailGeneACMG = (caseDetailGeneACMG_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editChapter.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { postChapter, putChapter } from '../../api'


/* harmony default export */ var editChapter = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      chapter: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [{
          title: this.param.chapter ? 'Name of the chapter' /* ___ */ : 'Name of the new chapter' /* ___ */
          , value: 'title',
          type: 'input',
          placeholder: function placeholder() {
            return 'New chapter';
          } /* ___ */
          , validate: 'required'
        }],
        field2: [{
          title: 'Description of the chapter' /* ___ */
          , value: 'description',
          type: 'textarea',
          placeholder: function placeholder() {
            return 'Please type the introduction or description of the chapter.  ';
          } /* ___ */
        }]
      };
    }
  },
  created: function created() {
    var chapter = this.param.chapter || this.chapter;
    this.chapter = chapter;
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.chapter)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateSendChapter: function validateSendChapter() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this2.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this2.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this2.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this2.sendChapter();

              case 33:
                _this2.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    sendChapter: function sendChapter() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  _this3.$emit('changeModal', {}, _this3.result);
                } catch (error) {
                  _this3.addToast('error', !error.response ? error.message : error.response.data.result.message);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b6b6dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editChapter.vue
var editChapter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-chapter-dailog dialog col-block"},[_c('customForm',{attrs:{"init":_vm.chapter,"alerts":_vm.alerts,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('customForm',{attrs:{"init":_vm.chapter,"alerts":_vm.alerts,"forms":_vm.formOptions['field2']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field2', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateSendChapter() : ''; }}},[_c('span',[_vm._v(_vm._s(_vm.chapter.id ? 'Save'/* ___ */ : 'Add'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var editChapter_staticRenderFns = []
var editChapter_esExports = { render: editChapter_render, staticRenderFns: editChapter_staticRenderFns }
/* harmony default export */ var dialog_editChapter = (editChapter_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editChapter.vue
var editChapter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editChapter___vue_template_functional__ = false
/* styles */
var editChapter___vue_styles__ = null
/* scopeId */
var editChapter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editChapter___vue_module_identifier__ = null
var editChapter_Component = editChapter_normalizeComponent(
  editChapter,
  dialog_editChapter,
  editChapter___vue_template_functional__,
  editChapter___vue_styles__,
  editChapter___vue_scopeId__,
  editChapter___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editChapter = (editChapter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/addVariantToChapter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var addVariantToChapter = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedChapters: []
    };
  },

  computed: {
    // param
    variant: function variant() {
      return this.param.variant;
    },
    chapters: function chapters() {
      return this.param.chapters;
    },

    // global
    geneTypeMetadatas: function geneTypeMetadatas() {
      return global_data["j" /* geneTypeMetadatas */];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-325cd9c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/addVariantToChapter.vue
var addVariantToChapter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-variant-to-chapter-dailog dialog col-block"},[_c('div',{staticClass:"block-container variant col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Add a variant to chapter'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '16px' })}),_vm._v(" "),_c('div',{staticClass:"variant-container col-block flex-start"},[_c('div',{staticClass:"variant-title",domProps:{"innerHTML":_vm._s('<b>' + _vm.variant.SYMBOL + '</b>' + ' ' + _vm.variant.CHROM + ':' + _vm.variant.POS + _vm.variant.REF + '>' + _vm.variant.ALT)}}),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"gene-tag-container row-block flex-start flex-wrap"},_vm._l(((_vm.variant.source || []).filter(function (x, i, s) { return s.indexOf(x) === i; })),function(tag,tindex){return _c('div',{key:tindex,staticClass:"gene-tag-block"},[_c('div',{staticClass:"gene-tag",class:[tag],attrs:{"title":_vm.geneTypeMetadatas[tag].tagOption.title}},[_vm._v(_vm._s(_vm.geneTypeMetadatas[tag].tagOption.title))])])}),0)])]),_vm._v(" "),_c('div',{style:({ height: '26px' })}),_vm._v(" "),_c('div',{staticClass:"block-container chapter col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Select at least one chapter'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-container row-block"},[_c('div',{staticClass:"chapter-list-container row-block flex-wrap"},_vm._l((_vm.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-item-container"},[_c('div',{staticClass:"chapter-item row-block",on:{"click":function (e) { return _vm.selectedChapters = (_vm.selectedChapters.includes(chapter.value) ? _vm.selectedChapters.slice(index, 1) : _vm.selectedChapters.concat([chapter.value])); }}},[_c('img',{attrs:{"src":_vm.selectedChapters.includes(chapter.value) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title"},[_vm._v(_vm._s(chapter.title))])])])}),0)])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.selectedChapters); }}},[_c('span',[_vm._v(_vm._s('Add'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var addVariantToChapter_staticRenderFns = []
var addVariantToChapter_esExports = { render: addVariantToChapter_render, staticRenderFns: addVariantToChapter_staticRenderFns }
/* harmony default export */ var dialog_addVariantToChapter = (addVariantToChapter_esExports);
// CONCATENATED MODULE: ./src/components/dialog/addVariantToChapter.vue
var addVariantToChapter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addVariantToChapter___vue_template_functional__ = false
/* styles */
var addVariantToChapter___vue_styles__ = null
/* scopeId */
var addVariantToChapter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addVariantToChapter___vue_module_identifier__ = null
var addVariantToChapter_Component = addVariantToChapter_normalizeComponent(
  addVariantToChapter,
  dialog_addVariantToChapter,
  addVariantToChapter___vue_template_functional__,
  addVariantToChapter___vue_styles__,
  addVariantToChapter___vue_scopeId__,
  addVariantToChapter___vue_module_identifier__
)

/* harmony default export */ var components_dialog_addVariantToChapter = (addVariantToChapter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editReportVariant.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var editReportVariant = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      result: {
        'ACMG': [],
        'SIFT': [],
        'Polyphen2': [],
        'ParentalOrigin': []
      },
      multiple: {
        'ACMG': false,
        'SIFT': false,
        'Polyphen2': false,
        'ParentalOrigin': false
      }
    };
  },
  created: function created() {
    this.result = extends_default()({}, this.result, this.param.value);
    this.multiple = extends_default()({}, this.multiple, this.param.multiple);
  },

  computed: {
    formItems: function formItems() {
      return {
        'ACMG': [{ title: 'Pathogenic', value: 'Pathogenic', color: '#FA3D3D' }, { title: 'Likely pathogenic', value: 'Likely pathogenic', color: '#FF9E03' }, { title: 'Uncertain significance', value: 'Uncertain significance' }, { title: 'Likely benign', value: 'Likely benign' }, { title: 'Benign', value: 'Benign' }],
        'SIFT': [].concat(toConsumableArray_default()(entries_default()(global_data["q" /* predictionMetaDatas */]['SIFT4G'].displayMap).map(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              value = _ref2[0],
              title = _ref2[1];

          return extends_default()({ title: title, value: value }, (global_data["q" /* predictionMetaDatas */]['SIFT4G'].checkPassed || function () {
            return true;
          })(null, value) ? {} : { color: '#FA3D3D' });
        })), [{ title: 'N/A', value: 'N/A' }]),
        'Polyphen2': [].concat(toConsumableArray_default()(entries_default()(global_data["q" /* predictionMetaDatas */]['Polyphen'].displayMap).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              value = _ref4[0],
              title = _ref4[1];

          return extends_default()({ title: title, value: value }, (global_data["q" /* predictionMetaDatas */]['Polyphen'].checkPassed || function () {
            return true;
          })(null, value) ? {} : { color: '#FA3D3D' });
        })), [{ title: 'N/A', value: 'N/A' }]),
        'ParentalOrigin': entries_default()(global_data["v" /* reportParentalOriginMap */]).map(function (_ref5) {
          var _ref6 = slicedToArray_default()(_ref5, 2),
              value = _ref6[0],
              title = _ref6[1];

          return { title: title, value: value };
        })
      };
    },

    // param
    type: function type() {
      return this.param.type;
    },
    variant: function variant() {
      return this.param.variant;
    }
  },
  methods: {
    setValue: function setValue(type, item) {
      if (!this.multiple[type]) {
        this.result[type] = [];
      }
      this.result[type] = !this.result[type].includes(item.value) ? this.result[type].concat([item.value]) : this.result[type].length > 1 ? this.result[type].filter(function (value) {
        return value !== item.value;
      }) : this.result[type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc97907","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editReportVariant.vue
var editReportVariant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report-variant-dailog dialog col-block"},[_c('div',{staticClass:"block-container variant col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
          'ACMG': 'Change the ACMG classification of the variant'/* ___ */,
          'SIFT & Polyphen2': 'Change the SIFT & Polyphen2 classification of the variant'/* ___ */
        }[_vm.type])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"variant-container col-block flex-start"},[_c('div',{staticClass:"variant-title",domProps:{"innerHTML":_vm._s('<b>' + (_vm.variant.SYMBOL || '- -') + '</b>' + ' ' + _vm.variant.CHROM + ':' + _vm.variant.POS + _vm.variant.REF + '>' + _vm.variant.ALT)}})])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),(_vm.type === 'ACMG')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('Select a classification'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['ACMG']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('ACMG', item); }}},[_c('img',{class:{ multiple: _vm.multiple['ACMG'] },attrs:{"src":_vm.result['ACMG'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['ACMG'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['ACMG'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.type === 'SIFT & Polyphen2')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('Select a classification of <b>SIFT</b>'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['SIFT']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('SIFT', item); }}},[_c('img',{class:{ multiple: _vm.multiple['SIFT'] },attrs:{"src":_vm.result['SIFT'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['SIFT'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['SIFT'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('Select a classification of <b>Polyphen2</b>'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['Polyphen2']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('Polyphen2', item); }}},[_c('img',{class:{ multiple: _vm.multiple['Polyphen2'] },attrs:{"src":_vm.result['Polyphen2'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['Polyphen2'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['Polyphen2'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.type === 'Parental Origin')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('Select a Parental Origin'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['ParentalOrigin']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('ParentalOrigin', item); }}},[_c('img',{class:{ multiple: _vm.multiple['ParentalOrigin'] },attrs:{"src":_vm.result['ParentalOrigin'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.result); }}},[_c('span',[_vm._v(_vm._s('Update'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var editReportVariant_staticRenderFns = []
var editReportVariant_esExports = { render: editReportVariant_render, staticRenderFns: editReportVariant_staticRenderFns }
/* harmony default export */ var dialog_editReportVariant = (editReportVariant_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editReportVariant.vue
var editReportVariant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editReportVariant___vue_template_functional__ = false
/* styles */
var editReportVariant___vue_styles__ = null
/* scopeId */
var editReportVariant___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editReportVariant___vue_module_identifier__ = null
var editReportVariant_Component = editReportVariant_normalizeComponent(
  editReportVariant,
  dialog_editReportVariant,
  editReportVariant___vue_template_functional__,
  editReportVariant___vue_styles__,
  editReportVariant___vue_scopeId__,
  editReportVariant___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editReportVariant = (editReportVariant_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/geneTag.vue + 2 modules
var geneTag = __webpack_require__("H3ds");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editCNVToChapter.vue








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var editCNVToChapter = ({
  components: {
    geneTag: geneTag["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      cnv: {
        CHROM: '',
        genes: [],
        chapters: []
      },
      selectedGenes: [],
      selectedChapters: [],
      // search
      map: {
        gene: {}
      },
      query: {
        gene: ''
      },
      tag: {
        genes: {}
      },
      curTag: {
        gene: null
      },
      searchTimer: {
        gene: []
      },
      loading: {
        addToSearch: false
      }
    };
  },

  computed: {
    sendData: function sendData() {
      var cnv = {
        CHROM: this.cnv.CHROM,
        POS_START: this.cnv.POS_START,
        POS_END: this.cnv.POS_END
      };
      var nGeneIDs = this.selectedGenes.map(function (gene) {
        return gene.gene_id;
      });
      var oGeneIDs = this.cnv.genes.map(function (gene) {
        return gene.gene_id;
      });
      var iGeneIDs = nGeneIDs.filter(function (id) {
        return oGeneIDs.includes(id);
      });
      var genes = {
        add: this.selectedGenes.filter(function (gene) {
          return !iGeneIDs.includes(gene.gene_id);
        }),
        original: this.selectedGenes.filter(function (gene) {
          return iGeneIDs.includes(gene.gene_id);
        }),
        remove: this.cnv.genes.filter(function (gene) {
          return !iGeneIDs.includes(gene.gene_id);
        })
      };
      var nChapterValues = this.selectedChapters;
      var oChapterValues = this.cnv.chapters;
      var iChapterValues = nChapterValues.filter(function (value) {
        return oChapterValues.includes(value);
      });
      var chapters = {
        add: this.selectedChapters.filter(function (chapter) {
          return !iChapterValues.includes(chapter);
        }),
        original: this.selectedChapters.filter(function (chapter) {
          return iChapterValues.includes(chapter);
        }),
        remove: this.cnv.chapters.filter(function (chapter) {
          return !iChapterValues.includes(chapter);
        })
      };
      if (values_default()(cnv).every(function (x) {
        return x;
      }) && this.selectedChapters.length) {
        return { cnv: cnv, genes: genes, chapters: chapters };
      } else {
        return null;
      }
    },
    chromOptions: function chromOptions() {
      return entries_default()(global_data["b" /* chromMap */]).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return { title: value.title, value: key };
      });
    },

    // param
    isEdit: function isEdit() {
      return this.param.defaultData;
    },
    chapters: function chapters() {
      return this.param.chapters;
    }
  },
  watch: {
    'query.gene': function queryGene(nv) {
      this.getGenes(nv);
    },
    'cnv.CHROM': function cnvCHROM(nv) {
      if (nv) {
        if (nv === 'chrM') {
          this.selectedGenes = this.selectedGenes.filter(function (gene) {
            return gene.SYMBOL.startsWith('MT-');
          });
        } else {
          this.selectedGenes = this.selectedGenes.filter(function (gene) {
            return !gene.SYMBOL.startsWith('MT-');
          });
        }
      }
    }
  },
  created: function created() {
    if (this.param.defaultData) {
      this.cnv = extends_default()({}, this.param.defaultData);
      this.selectedGenes = [].concat(toConsumableArray_default()(this.param.defaultData.genes));
      this.selectedChapters = [].concat(toConsumableArray_default()(this.param.defaultData.chapters));
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setModal2Action']), {
    getGenes: function getGenes(query) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ((_this.curTag['gene'] || {}).name !== query) {
                  _this.tag['genes'] = {};
                  if (_this.searchTimer['gene']) {
                    clearTimeout(_this.searchTimer['gene']);
                  }
                  _this.searchTimer['gene'] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    var config, response, genes, mtGenes;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(!_this.map['gene'][query] && query)) {
                              _context.next = 22;
                              break;
                            }

                            _this.setLoadingAction(true);
                            _context.prev = 2;
                            config = _this.$ls.get('userInfo');
                            response = null;
                            _context.next = 7;
                            return Object(api["K" /* getCnvGenes */])(query, false, config);

                          case 7:
                            response = _context.sent;
                            genes = response.data.data;

                            genes = Object(util["i" /* groupBy */])(genes, function (gene) {
                              return gene.gene_id;
                            }).map(function (group) {
                              return group[0];
                            });
                            _context.next = 12;
                            return Object(api["K" /* getCnvGenes */])(query, true, config);

                          case 12:
                            response = _context.sent;
                            mtGenes = response.data.data;

                            mtGenes = Object(util["i" /* groupBy */])(mtGenes, function (gene) {
                              return gene.gene_id;
                            }).map(function (group) {
                              return group[0];
                            });
                            _this.map['gene'] = extends_default()({}, _this.map['gene'], defineProperty_default()({}, query, {
                              info: null,
                              datas: [].concat(toConsumableArray_default()(genes.map(function (data) {
                                return extends_default()({}, data, { name: data.symbol, type: 'gene' });
                              })), toConsumableArray_default()(mtGenes.map(function (data) {
                                return extends_default()({}, data, { name: data.symbol, type: 'gene' });
                              })))
                            }));
                            _context.next = 21;
                            break;

                          case 18:
                            _context.prev = 18;
                            _context.t0 = _context['catch'](2);

                            _this.addToast('error', !_context.t0.response ? _context.t0.message : _context.t0.response.data.result.message);

                          case 21:
                            _this.setLoadingAction(false);

                          case 22:
                            _this.tag['genes'] = _this.map['gene'][query] || {};

                          case 23:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[2, 18]]);
                  })), 500);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    addToSearch: function addToSearch(data) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var oldData;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = data.type ? data : (_this2.map['gene'][_this2.query['gene']] || { datas: [] }).datas[0];

                if (!(data && !_this2.loading['addToSearch'])) {
                  _context3.next = 11;
                  break;
                }

                _this2.loading['addToSearch'] = true;
                _context3.t0 = data.type;
                _context3.next = _context3.t0 === 'gene' ? 6 : 9;
                break;

              case 6:
                oldData = _this2.selectedGenes.find(function (g) {
                  return g.SYMBOL === data.symbol;
                });

                if (!oldData) {
                  _this2.selectedGenes.push({
                    SYMBOL: data.symbol,
                    gene_id: data.gene_id
                  });
                }
                return _context3.abrupt('break', 9);

              case 9:
                _this2.query['gene'] = '';
                _this2.loading['addToSearch'] = false;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    deleteCNV: function deleteCNV() {
      var _this3 = this;

      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'alert',
          content: '<span style="color:#FA3D3D">If you delete this variant, all the content inside will also be deleted. Do you want to delete the variant?</span>' /* ___ */
          , buttons: [{
            title: 'Cancel' /* ___ */
            , type: 'gray',
            result: false
          }, {
            title: 'Delete' /* ___ */
            , type: 'alert',
            result: true
          }]
        },
        callback: function () {
          var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(result) {
            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (result) {
                      _this3.$emit('changeModal', {}, extends_default()({}, _this3.sendData, {
                        chapters: {
                          add: [],
                          original: [],
                          remove: [].concat(toConsumableArray_default()(_this3.sendData.chapters.original), toConsumableArray_default()(_this3.sendData.chapters.remove))
                        }
                      }));
                    }

                  case 1:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this3);
          }));

          return function callback(_x) {
            return _ref4.apply(this, arguments);
          };
        }()
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c381c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editCNVToChapter.vue
var editCNVToChapter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-cnv-to-chapter-dailog dialog col-block"},[(_vm.isEdit)?_c('div',{staticClass:"option-container"},[_c('div',{staticClass:"delete-icon icon-block",style:({ '--size': '40px' }),on:{"click":function (e) { return _vm.deleteCNV(); }}},[_c('img',{style:({ height: '21px' }),attrs:{"src":__webpack_require__("j6F1"),"alt":""}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"block-container cnv col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.isEdit ? 'Edit the new CNV' : 'Create a new CNV'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"cnv-container col-block flex-start"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnv.CHROM),expression:"cnv.CHROM"}],staticClass:"form-input chr",style:(_vm.cnv.CHROM ? {} : { color: '#A9A9A9' }),on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cnv, "CHROM", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s('Chr'/* ___ */))]),_vm._v(" "),_vm._l((_vm.chromOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.value}},[_vm._v(_vm._s(option.title))])})],2),_vm._v(" "),_c('div',{staticClass:"split"},[_vm._v(_vm._s(':'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnv.POS_START),expression:"cnv.POS_START"}],staticClass:"form-input start",attrs:{"type":"text","placeholder":'Start Position'/* ___ */},domProps:{"value":(_vm.cnv.POS_START)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cnv, "POS_START", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"split"},[_vm._v(_vm._s('~'))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnv.POS_END),expression:"cnv.POS_END"}],staticClass:"form-input end",attrs:{"type":"text","placeholder":'End Position'/* ___ */},domProps:{"value":(_vm.cnv.POS_END)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cnv, "POS_END", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"block-container gene col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Enter relevant gene symbols'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"gene-container col-block flex-start"},[_c('div',{staticClass:"search-container row-block"},[_c('div',{staticClass:"search-input input-group",style:({ flex: 1 })},[_c('geneTag',{style:({
              width: '100%'
            }),attrs:{"disabled":!_vm.cnv.CHROM,"tagHeight":'300px',"placeholder":'Gene name'/* ___ */,"init":_vm.query['gene'],"title":false,"dataInfo":_vm.tag['genes'].info,"genes":_vm.tag['genes'].datas ? _vm.tag['genes'].datas.filter(function (gene) { return (_vm.cnv.CHROM === 'chrM' && (gene.symbol || '').startsWith('MT-')) || (_vm.cnv.CHROM !== 'chrM' && !(gene.symbol || '').startsWith('MT-')); }) : _vm.tag['genes'].datas},on:{"input":function (content) { _vm.query['gene'] = content; },"tag":function (content) { _vm.query['gene'] = content.name; _vm.curTag['gene'] = content; },"send":function (content) { return (_vm.tag['genes'].datas || []).length && _vm.query['gene'] ? _vm.addToSearch(_vm.curTag['gene'] || _vm.query['gene']) : ''; }}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})],1),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.loading['addToSearch'] },attrs:{"disabled":!((_vm.tag['genes'].datas || []).length && _vm.query['gene'])},on:{"click":function (e) { return (_vm.tag['genes'].datas || []).length && _vm.query['gene'] ? _vm.addToSearch(_vm.curTag['gene'] || _vm.query['gene']) : ''; }}},[_c('span',[_vm._v(_vm._s('Add'/* ___ */))])])])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"gene-list-container row-block flex-start flex-wrap"},_vm._l((_vm.selectedGenes),function(gene,index){return _c('div',{key:index,staticClass:"gene-block row-block",on:{"click":function (e) { return _vm.selectedGenes.splice(index, 1); }}},[_c('div',{staticClass:"gene-title"},[_vm._v(_vm._s(gene.SYMBOL))]),_vm._v(" "),_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('img',{staticClass:"gene-remove-icon",attrs:{"src":__webpack_require__("ZM3o"),"alt":""}})])}),0)]),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px', })}),_vm._v(" "),_c('div',{staticClass:"block-container chapter col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s('Select at least one chapter'/* ___ */))]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-container row-block"},[_c('div',{staticClass:"chapter-list-container row-block flex-wrap"},_vm._l((_vm.chapters),function(chapter,index){return _c('div',{key:index,staticClass:"chapter-item-container"},[_c('div',{staticClass:"chapter-item row-block",on:{"click":function (e) { return _vm.selectedChapters = (_vm.selectedChapters.includes(chapter.value) ? _vm.selectedChapters.filter(function (c) { return c !== chapter.value; }) : _vm.selectedChapters.concat([chapter.value])); }}},[_c('img',{attrs:{"src":_vm.selectedChapters.includes(chapter.value) ? __webpack_require__("7kqe") : __webpack_require__("5Ivo")}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title"},[_vm._v(_vm._s(chapter.title))])])])}),0)])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.sendData); }}},[_c('span',[_vm._v(_vm._s(_vm.isEdit ? 'Update'/* ___ */ : 'Create'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var editCNVToChapter_staticRenderFns = []
var editCNVToChapter_esExports = { render: editCNVToChapter_render, staticRenderFns: editCNVToChapter_staticRenderFns }
/* harmony default export */ var dialog_editCNVToChapter = (editCNVToChapter_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editCNVToChapter.vue
var editCNVToChapter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editCNVToChapter___vue_template_functional__ = false
/* styles */
var editCNVToChapter___vue_styles__ = null
/* scopeId */
var editCNVToChapter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editCNVToChapter___vue_module_identifier__ = null
var editCNVToChapter_Component = editCNVToChapter_normalizeComponent(
  editCNVToChapter,
  dialog_editCNVToChapter,
  editCNVToChapter___vue_template_functional__,
  editCNVToChapter___vue_styles__,
  editCNVToChapter___vue_scopeId__,
  editCNVToChapter___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editCNVToChapter = (editCNVToChapter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/editReportCNV.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var editReportCNV = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      result: {
        'type': [],
        'GT': '',
        'intron': '',
        'length': '',
        'ParentalOrigin': []
      },
      multiple: {
        'type': false,
        'GT': false,
        'intron': false,
        'length': false,
        'ParentalOrigin': false
      }
    };
  },
  created: function created() {
    this.result = extends_default()({}, this.result, this.param.value);
    this.multiple = extends_default()({}, this.multiple, this.param.multiple);
  },

  computed: {
    formItems: function formItems() {
      return {
        'type': entries_default()(global_data["s" /* reportCNVTypeMap */]).map(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              value = _ref2[0],
              title = _ref2[1];

          return { title: title, value: value };
        }),
        'ParentalOrigin': entries_default()(global_data["v" /* reportParentalOriginMap */]).map(function (_ref3) {
          var _ref4 = slicedToArray_default()(_ref3, 2),
              value = _ref4[0],
              title = _ref4[1];

          return { title: title, value: value };
        })
      };
    },

    // param
    type: function type() {
      return this.param.type;
    },
    cnv: function cnv() {
      return extends_default()({}, this.param.cnv);
    }
  },
  methods: {
    setValue: function setValue(type, item) {
      if (!this.multiple[type]) {
        this.result[type] = [];
      }
      this.result[type] = !this.result[type].includes(item.value) ? this.result[type].concat([item.value]) : this.result[type].length > 1 ? this.result[type].filter(function (value) {
        return value !== item.value;
      }) : this.result[type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d15d3dba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/editReportCNV.vue
var editReportCNV_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report-cnv-dailog dialog col-block"},[_c('div',{staticClass:"block-container cnv col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s({
          'type': 'Change mutation classification of the CNV'/* ___ */,
          'GT': 'Change GT of CNV'/* ___ */,
          'intron': 'Change intron / exon of the CNV'/* ___ */,
          'length': 'Change length of the CNV '/* ___ */
        }[_vm.type])}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"cnv-container col-block flex-start"},[_c('div',{staticClass:"cnv-title",domProps:{"innerHTML":_vm._s('<b>CNV</b>' + ' ' + _vm.cnv.CHROM + ':' + _vm.cnv.POS_START + '-' + _vm.cnv.POS_END)}})])]),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),(_vm.type === 'type')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('Select a type of the <b>CNV</b>'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['type']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('type', item); }}},[_c('img',{class:{ multiple: _vm.multiple['type'] },attrs:{"src":_vm.result['type'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['type'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['type'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),(_vm.type === 'GT')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['GT']),expression:"result['GT']"}],attrs:{"type":"text","placeholder":'GT of CNV'/* ___ */},domProps:{"value":(_vm.result['GT'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'GT', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'intron')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['intron']),expression:"result['intron']"}],attrs:{"type":"text","placeholder":'intron / exon of the CNV'/* ___ */},domProps:{"value":(_vm.result['intron'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'intron', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'length')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"form-container input-group row-block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result['length']),expression:"result['length']"}],attrs:{"type":"text","placeholder":'length of the CNV'/* ___ */},domProps:{"value":(_vm.result['length'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, 'length', $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.type === 'Parental Origin')?[_c('div',{staticClass:"block-container form col-block"},[_c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s('Select a Parental Origin of <b>CNV</b>'/* ___ */)}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),_c('div',{style:({ height: '12px' })}),_vm._v(" "),_c('div',{staticClass:"form-container row-block"},[_c('div',{staticClass:"form-list-container row-block flex-wrap"},_vm._l((_vm.formItems['ParentalOrigin']),function(item,index){return _c('div',{key:index,staticClass:"form-item-container"},[_c('div',{staticClass:"form-item row-block",on:{"click":function (e) { return _vm.setValue('ParentalOrigin', item); }}},[_c('img',{class:{ multiple: _vm.multiple['ParentalOrigin'] },attrs:{"src":_vm.result['ParentalOrigin'].includes(item.value) ? __webpack_require__("Id76")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-true.svg') : __webpack_require__("AJyC")("./" + (_vm.multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-false.svg')}}),_vm._v(" "),_c('div',{style:({ width: '8px' })}),_vm._v(" "),_c('div',{staticClass:"chapter-title",style:(item.color ? { color: item.color } : {})},[_vm._v(_vm._s(item.title))])])])}),0)])])]:_vm._e(),_vm._v(" "),_c('div',{style:({ height: '15px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.result); }}},[_c('span',[_vm._v(_vm._s('Update'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var editReportCNV_staticRenderFns = []
var editReportCNV_esExports = { render: editReportCNV_render, staticRenderFns: editReportCNV_staticRenderFns }
/* harmony default export */ var dialog_editReportCNV = (editReportCNV_esExports);
// CONCATENATED MODULE: ./src/components/dialog/editReportCNV.vue
var editReportCNV_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editReportCNV___vue_template_functional__ = false
/* styles */
var editReportCNV___vue_styles__ = null
/* scopeId */
var editReportCNV___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editReportCNV___vue_module_identifier__ = null
var editReportCNV_Component = editReportCNV_normalizeComponent(
  editReportCNV,
  dialog_editReportCNV,
  editReportCNV___vue_template_functional__,
  editReportCNV___vue_styles__,
  editReportCNV___vue_scopeId__,
  editReportCNV___vue_module_identifier__
)

/* harmony default export */ var components_dialog_editReportCNV = (editReportCNV_Component.exports);

// EXTERNAL MODULE: ./src/mixins/routeLoading.vue + 1 modules
var routeLoading = __webpack_require__("zVZS");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/userAvatar.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var userAvatar = ({
  mixins: [toastMethods["a" /* default */], routeLoading["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedID: null,
      avatars: [],
      customAvatar: null
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['userSetting']), {
    // param
    defaultAvatar: function defaultAvatar() {
      return this.param.avatar || {};
    },

    // global
    fileTypeCheck: function fileTypeCheck() {
      return util["f" /* fileTypeCheck */];
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserSettingAction', 'setModal2Action']), {
    fetchData: function fetchData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchCustomAvatar();

              case 2:
                _context.next = 4;
                return _this.fetchUserAvatarFiles();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchCustomAvatar: function fetchCustomAvatar() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, response, customAvatar;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                _context2.next = 4;
                return Object(api["_45" /* getUserAvatarFile */])(config);

              case 4:
                response = _context2.sent;
                customAvatar = response.data.data;

                if (customAvatar) {
                  _this2.customAvatar = extends_default()({}, customAvatar, {
                    url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + customAvatar.id + '&class_name=' + customAvatar.class_name + '&access_token=' + config['access_token']
                  });
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    fetchUserAvatarFiles: function fetchUserAvatarFiles() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, response, avatars;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo');
                _context3.next = 4;
                return Object(api["_46" /* getUserAvatarFiles */])(config);

              case 4:
                response = _context3.sent;
                avatars = response.data.data;

                avatars = avatars.filter(function (avatar) {
                  return avatar.size && avatar.id !== (_this3.customAvatar || {}).id;
                }).map(function (avatar) {
                  return extends_default()({}, avatar, {
                    url: api_config["a" /* API_ROOT */] + 'global/files/download?file_id=' + avatar.id + '&class_name=' + avatar.class_name + '&access_token=' + config['access_token']
                  });
                });
                _this3.avatars = avatars;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    afterSetData: function afterSetData() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var id;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = _this4.defaultAvatar.id || _this4.userSetting.avatar_file.id;

                _this4.selectedID = (_this4.avatars.find(function (avatar) {
                  return avatar.id === id;
                }) || {}).id || 'custom';
                _this4.customAvatar = (_this4.defaultAvatar.id || '') === 'custom' ? _this4.defaultAvatar : _this4.customAvatar;

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    selectCustomAvatar: function selectCustomAvatar(e) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var file, url;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                file = e.target.files[0];
                _context6.next = 3;
                return Object(util["k" /* imageReader */])([file]);

              case 3:
                url = _context6.sent[0];

                _this5.setModal2Action({
                  action: 'imageCropper',
                  width: '616px',
                  param: {
                    url: url
                  },
                  callback: function () {
                    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(result) {
                      return regenerator_default.a.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (result) {
                                _this5.customAvatar = {
                                  id: 'custom',
                                  name: file.name,
                                  url: result.url,
                                  file: result.file,
                                  class_name: 'AvatarFile'
                                };
                              }

                            case 1:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this5);
                    }));

                    return function callback(_x) {
                      return _ref.apply(this, arguments);
                    };
                  }()
                });
                e.target.value = '';

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    setAvatar: function setAvatar() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var result;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                result = _this6.avatars.find(function (avatar) {
                  return avatar.id === _this6.selectedID;
                }) || _this6.customAvatar;

                _this6.$emit('changeModal', {}, result);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dbab508","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/userAvatar.vue
var userAvatar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar-dailog dialog col-block"},[_c('div',{staticClass:"user-avatar-container col-block flex-start"},[_c('div',{staticClass:"user-avatar-title"},[_vm._v(_vm._s('Select a avatar from default set or upload from drive'/* ___ */))]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"user-avatar-list-container row-block flex-start flex-wrap"},_vm._l((_vm.avatars),function(avatar,index){return _c('div',{key:index,staticClass:"user-avatar-block",on:{"click":function (e) { return _vm.selectedID = avatar.id; }}},[_c('div',{staticClass:"user-avatar",style:({ 'background-image': 'url(' + avatar.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"user-avatar-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedID === avatar.id ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})])])}),0)]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-container col-block flex-start"},[_c('div',{staticClass:"custom-avatar-title-container row-block",class:{ disabled: !_vm.customAvatar },on:{"click":function (e) { return _vm.customAvatar && (_vm.selectedID = 'custom'); }}},[_c('div',{staticClass:"custom-avatar-radio-icon icon-block",style:({ '--size': '20px' })},[_c('img',{attrs:{"src":_vm.selectedID === 'custom' ? __webpack_require__("xccc") : __webpack_require__("z0Pm"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-title"},[_vm._v(_vm._s('Custom avatar'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-main-container col-block"},[(_vm.customAvatar)?_c('div',{staticClass:"custom-avatar-image-block"},[_c('div',{staticClass:"custom-avatar-image mask",style:({ 'background-image': 'url(' + _vm.customAvatar.url + ')' })}),_vm._v(" "),_c('div',{staticClass:"custom-avatar-image",style:({ 'background-image': 'url(' + _vm.customAvatar.url + ')' })})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"file","id":"custom-avatar","accept":"image/*"},on:{"change":function (e) { return _vm.fileTypeCheck(e, function (e) { return _vm.selectCustomAvatar(e); }, function () { return _vm.addToast('error', 'Please upload image file'/* ___ */); }); }}}),_vm._v(" "),_c('label',{attrs:{"for":"custom-avatar"}}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button"},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])])])])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.setAvatar(); }}},[_c('span',[_vm._v(_vm._s('Upload'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var userAvatar_staticRenderFns = []
var userAvatar_esExports = { render: userAvatar_render, staticRenderFns: userAvatar_staticRenderFns }
/* harmony default export */ var dialog_userAvatar = (userAvatar_esExports);
// CONCATENATED MODULE: ./src/components/dialog/userAvatar.vue
var userAvatar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userAvatar___vue_template_functional__ = false
/* styles */
var userAvatar___vue_styles__ = null
/* scopeId */
var userAvatar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var userAvatar___vue_module_identifier__ = null
var userAvatar_Component = userAvatar_normalizeComponent(
  userAvatar,
  dialog_userAvatar,
  userAvatar___vue_template_functional__,
  userAvatar___vue_styles__,
  userAvatar___vue_scopeId__,
  userAvatar___vue_module_identifier__
)

/* harmony default export */ var components_dialog_userAvatar = (userAvatar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-advanced-cropper/dist/index.es.js
var index_es = __webpack_require__("RIqR");

// EXTERNAL MODULE: ./node_modules/vue-advanced-cropper/dist/style.css
var style = __webpack_require__("T0+N");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/vue-advanced-cropper/dist/theme.classic.css
var theme_classic = __webpack_require__("fRKO");
var theme_classic_default = /*#__PURE__*/__webpack_require__.n(theme_classic);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/imageCropper.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var imageCropper = ({
  components: {
    Cropper: index_es["b" /* Cropper */],
    CircleStencil: index_es["a" /* CircleStencil */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    defaultSize: function defaultSize(_ref) {
      var imageSize = _ref.imageSize;

      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width)
      };
    },
    stencilSize: function stencilSize(_ref2) {
      var boundaries = _ref2.boundaries;

      return {
        width: Math.min(boundaries.height, boundaries.width) * 0.9,
        height: Math.min(boundaries.height, boundaries.width) * 0.9
      };
    },
    sendResult: function sendResult() {
      var _this = this;

      var _$refs$cropper$getRes = this.$refs.cropper.getResult(),
          canvas = _$refs$cropper$getRes.canvas;

      canvas.toBlob(function (blob) {
        var result = {
          file: blob,
          url: canvas.toDataURL()
        };
        _this.$emit('changeModal', {}, result);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15289661","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/imageCropper.vue
var imageCropper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-cropper-dailog dialog col-block"},[_c('cropper',{ref:"cropper",style:({
      'min-width': '160px',
      'min-height': '160px'
    }),attrs:{"stencil-component":"circle-stencil","src":_vm.param.url,"imageRestriction":'stencil',"default-size":_vm.defaultSize,"stencil-size":_vm.stencilSize,"stencil-props":{
      lines: {},
      handlers: {},
      movable: false,
      scalable: false,
      aspectRatio: 1
    },"canvas":{
      width: 320,
      height: 320
    }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.sendResult(); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var imageCropper_staticRenderFns = []
var imageCropper_esExports = { render: imageCropper_render, staticRenderFns: imageCropper_staticRenderFns }
/* harmony default export */ var dialog_imageCropper = (imageCropper_esExports);
// CONCATENATED MODULE: ./src/components/dialog/imageCropper.vue
var imageCropper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var imageCropper___vue_template_functional__ = false
/* styles */
var imageCropper___vue_styles__ = null
/* scopeId */
var imageCropper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var imageCropper___vue_module_identifier__ = null
var imageCropper_Component = imageCropper_normalizeComponent(
  imageCropper,
  dialog_imageCropper,
  imageCropper___vue_template_functional__,
  imageCropper___vue_styles__,
  imageCropper___vue_scopeId__,
  imageCropper___vue_module_identifier__
)

/* harmony default export */ var components_dialog_imageCropper = (imageCropper_Component.exports);

// EXTERNAL MODULE: ./src/components/tool/pageButtons.vue + 2 modules
var pageButtons = __webpack_require__("+kXL");

// EXTERNAL MODULE: ./src/mixins/customGrab.vue + 1 modules
var customGrab = __webpack_require__("TqmH");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetSelectCase.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var datasetSelectCase = ({
  components: {
    pageButtons: pageButtons["a" /* default */]
  },
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      query: '',
      selectedTableData: null,
      selectedTableDatas: [],
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[40, 172, 66, 66, 152, 152], []],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // page
      displayPage: 1,
      pageData: {
        selectedPage: 1,
        display: 20,
        total: null,
        buttonRange: 7,
        pageJumpTo: ''
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    filtedCaseDatas: function filtedCaseDatas() {
      var _this = this;

      var filtedCaseDatas = [].concat(toConsumableArray_default()(this.cases));
      filtedCaseDatas = Object(util["m" /* sortData */])((this.cases || []).filter(function (data) {
        return !_this.selectedDataMap[data.id] && [data.case_id].concat(toConsumableArray_default()(data.phenotypeDatas.map(function (phenotypeData) {
          return phenotypeData.query;
        }))).join('ゐ').includes(_this.query);
      }), this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      filtedCaseDatas = filtedCaseDatas.filter(function (_, i) {
        return i >= _this.pageData.display * (_this.displayPage - 1) && i < _this.pageData.display * _this.displayPage;
      });
      return filtedCaseDatas;
    },
    tableDatas: function tableDatas() {
      var _this2 = this;

      var tableDatas = [].concat(toConsumableArray_default()(Object(util["m" /* sortData */])(values_default()(this.selectedDataMap), this.sort.value.map(function (x) {
        return _this2.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }))), toConsumableArray_default()(this.filtedCaseDatas.filter(function (data) {
        return !_this2.selectedDataMap[data.id];
      })));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    selectedDataMap: function selectedDataMap() {
      return this.selectedTableDatas.reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data.id, extends_default()({}, data, { selected: true })));
      }, {});
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },
    totalPage: function totalPage() {
      this.pageData.selectedPage = 1;
      return Math.ceil(Math.min(this.cases.length, this.pageData.display * 5000) / this.pageData.display);
    },

    // static
    tableOptions: function tableOptions() {
      return [{
        value: '_SELECT',
        class: function _class() {
          return ['center'];
        },
        sortMap: null
      }, {
        title: 'Case ID' /* ___ */
        , value: 'case_id'
      }, {
        title: 'Sex' /* ___ */
        , value: 'sex',
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return { Male: 'M', Female: 'F', Unknown: 'U' }[value];
        },
        style: function style(value) {
          return { Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value];
        }
      }, {
        title: 'Age' /* ___ */
        , value: 'birth_year',
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return value ? new Date().getFullYear() - value + '' : null;
        }
      }, {
        title: 'Create' /* ___ */
        , value: 'created_at',
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }, {
        title: 'Modified' /* ___ */
        , value: 'updated_at',
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }, {
        title: 'Phenotype' /* ___ */
        , value: 'phenotypeDatas',
        description: function description(value) {
          return (value || []).length > 1 ? '& ' + (value.length - 1) + ' item' + (value.length - 1 > 1 ? 's' : '') /* ___ */ : '';
        },
        style: function style(value) {
          return { 'font-weight': 'bold' };
        },
        display: function display(value) {
          return value ? (value[0] || {}).query : value;
        },
        sortMap: null
      }, {
        title: 'Gene / Disease panel' /* ___ */
        , value: 'gene_panels',
        description: function description(value) {
          return (value || []).length > 1 ? '& ' + (value.length - 1) + ' item' + (value.length - 1 > 1 ? 's' : '') /* ___ */ : '';
        },
        style: function style(value) {
          return { 'font-weight': 'bold' };
        },
        display: function display(value) {
          return value ? (value[0] || {}).name : value;
        },
        sortMap: null
      }];
    },

    // param
    cases: function cases() {
      return this.param.cases;
    },

    // global
    toPriceString: function toPriceString() {
      return util["p" /* toPriceString */];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    },

    // page
    'pageData.selectedPage': function pageDataSelectedPage() {
      var _this3 = this;

      if (this.pageData.selectedPage) {
        this.displayPage = this.pageData.selectedPage;
        setTimeout(function () {
          _this3.pageData.selectedPage = 0;
        });
      }
    }
  },
  methods: {
    // table
    tableOnSelect: function tableOnSelect(datas, value) {
      var _this4 = this;

      if (value === 'all') {
        if (!this.filtedCaseDatas.some(function (data) {
          return !_this4.selectedDataMap[data.id];
        })) {
          datas = this.selectedTableDatas;
          value = false;
        } else {
          datas = this.filtedCaseDatas;
          value = true;
        }
      }
      var dataMap = datas.reduce(function (map, data) {
        return extends_default()({}, map, defineProperty_default()({}, data.id, data));
      }, {});
      this.selectedTableDatas = value ? [].concat(toConsumableArray_default()(datas.filter(function (data) {
        return !_this4.selectedDataMap[data.id];
      })), toConsumableArray_default()(this.selectedTableDatas)) : this.selectedTableDatas.filter(function (result) {
        return !dataMap[result.id];
      });
    },
    getTableOverflow: function getTableOverflow() {
      var _this5 = this;

      setTimeout(function () {
        var scrollContainer = _this5.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this5.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 1208) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1, 1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this6 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this6.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this6.boardType['board1'] === 'grab') {
              var grabID = _this6.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this6.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this6.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this6.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths)) / ratioBase));
                }
              });
              _this6.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this6.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this6.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this6.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this6.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this6.tableOptions[i].minWidth || _this6.tableMinWidths)) / ratioBase);
              }
            });
            _this6.tableWidths = tableWidths;
            setTimeout(function () {
              _this6.sort.disabled = false;
            });
          }
        }
      }[id];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa7c260","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetSelectCase.vue
var datasetSelectCase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-select-case-dailog dialog col-block width-full"},[_c('div',{staticClass:"top-container row-block flex-end"},[_c('div',{staticClass:"top-title",domProps:{"innerHTML":_vm._s([
        'Total samples are <b>' + _vm.toPriceString(_vm.cases.length) + '</b>.',
        _vm.cases.length ? 'You can import all of them with the button.' : ''
      ].filter(function (x) { return x; }).join(' ')/* ___ */)}}),_vm._v(" "),_c('div',{staticClass:"top-option-container row-block"},[(_vm.cases.length)?_c('button',{staticClass:"white-gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, _vm.cases.map(function (caseData) { return caseData.id; })); }}},[_c('span',[_vm._v(_vm._s('Add all'/* ___ */))])]):_vm._e()]),_vm._v(" "),_c('div',{style:({ flex: 1 })})]),_vm._v(" "),(_vm.cases.length)?[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-search-container row-block"},[_c('div',{staticClass:"search-title",domProps:{"innerHTML":_vm._s('<b>' + _vm.toPriceString(_vm.selectedTableDatas.length) + '</b> samples are selected.')}}),_vm._v(" "),_c('div',{staticClass:"search-container input-group",style:({ width: '420px' })},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],attrs:{"type":"text","placeholder":'Keywords of the samples'/* ___ */},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zSkq"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"table-main-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":_vm.selectedTableDatas.length ? !_vm.filtedCaseDatas.some(function (data) { return !_vm.selectedDataMap[data.id]; }) ? __webpack_require__("7kqe") : __webpack_require__("Z77G") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.tableOnSelect(null, 'all'); }}})])]:[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e()],_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[(option.value === '_SELECT')?[_c('div',{staticClass:"_SELECT center-block"},[_c('img',{attrs:{"src":data.selected ? __webpack_require__("7kqe") : __webpack_require__("5Ivo"),"alt":""},on:{"click":function (e) { return _vm.tableOnSelect([data], !data.selected); }}})])]:[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),((option.description || (function () {}))(data[option.value]))?[_c('span',{style:({ flex: 'inherit' }),domProps:{"innerHTML":_vm._s((option.description || (function () {}))(data[option.value]))}})]:_vm._e(),_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-page-container row-block",style:({ height: '50px' })},[_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"display-container row-block"},[_c('div',{staticClass:"display-title"},[_vm._v(_vm._s('Items per page'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageData.display),expression:"pageData.display"}],staticClass:"display",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pageData, "display", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")]),_vm._v(" "),_c('option',{attrs:{"value":"200"}},[_vm._v("200")])])])])]),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block"},[_c('pageButtons',{attrs:{"default":_vm.pageData.selectedPage,"display":_vm.pageData.display - 0,"total":_vm.totalPage * _vm.pageData.display,"buttonRange":_vm.pageData.buttonRange},on:{"selectPage":function (page) { _vm.pageData.selectedPage = page }}})],1),_vm._v(" "),_c('div',{staticClass:"options-container input-group row-block",style:({ flex: 1 })},[_c('div',{staticClass:"jump-container row-block"},[_c('div',{staticClass:"jump-title"},[_vm._v(_vm._s('Go to'/* ___ */))]),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageData.pageJumpTo),expression:"pageData.pageJumpTo"}],staticClass:"jump",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pageData, "pageJumpTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return _vm.pageData.selectedPage = _vm.pageData.pageJumpTo - 0; }]}},_vm._l(((new Array(_vm.totalPage)).fill('').map(function (_, i) { return i + 1; })),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v(_vm._s(value))])}),0)]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])]:[_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-page-container row-block"})],_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),(_vm.cases.length)?_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, Object.keys(_vm.selectedDataMap).map(function (id) { return id - 0; })); }}},[_c('span',[_vm._v(_vm._s('Add'/* ___ */))])]):_vm._e(),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],2)}
var datasetSelectCase_staticRenderFns = []
var datasetSelectCase_esExports = { render: datasetSelectCase_render, staticRenderFns: datasetSelectCase_staticRenderFns }
/* harmony default export */ var dialog_datasetSelectCase = (datasetSelectCase_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetSelectCase.vue
var datasetSelectCase_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetSelectCase___vue_template_functional__ = false
/* styles */
var datasetSelectCase___vue_styles__ = null
/* scopeId */
var datasetSelectCase___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetSelectCase___vue_module_identifier__ = null
var datasetSelectCase_Component = datasetSelectCase_normalizeComponent(
  datasetSelectCase,
  dialog_datasetSelectCase,
  datasetSelectCase___vue_template_functional__,
  datasetSelectCase___vue_styles__,
  datasetSelectCase___vue_scopeId__,
  datasetSelectCase___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetSelectCase = (datasetSelectCase_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetDetail.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var datasetDetail = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], [66, 67, 167, 167]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = [].concat(toConsumableArray_default()(this.cases));
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [{
          title: 'Dataset name' /* ___ */
          , value: 'name',
          type: 'text',
          wrap: true,
          grid: 3
        }, {
          title: 'Sample size' /* ___ */
          , value: 'sample_size',
          type: 'text',
          wrap: true,
          grid: 1,
          inputFormat: function inputFormat(value) {
            return value ? Object(util["p" /* toPriceString */])(value) : value;
          }
        }, {
          title: 'Owner' /* ___ */
          , value: 'user',
          type: 'text',
          wrap: true,
          grid: 2,
          inputFormat: function inputFormat(value) {
            return value ? [value.first_name, value.last_name].filter(function (x) {
              return x;
            }).join(' ') + (value.email ? ' (' + [value.email].filter(function (x) {
              return x;
            }).join(' ') + ')' : '') : value;
          }
        }]
      };
    },
    tableOptions: function tableOptions() {
      return [{
        title: 'Case ID' /* ___ */
        , value: 'case_id'
      }, {
        title: 'Sex' /* ___ */
        , value: 'sex',
        width: 66,
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return { Male: 'M', Female: 'F', Unknown: 'U' }[value];
        },
        style: function style(value) {
          return { Male: { color: '#003679' }, Female: { color: '#BE0F0F' }, Unknown: { color: '#333333' } }[value];
        }
      }, {
        title: 'Age' /* ___ */
        , value: 'birth_year',
        width: 67,
        class: function _class() {
          return ['center'];
        },
        display: function display(value) {
          return value ? new Date().getFullYear() - value + '' : null;
        }
      }, {
        title: 'Create' /* ___ */
        , value: 'created_at',
        width: 167,
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }, {
        title: 'Modified' /* ___ */
        , value: 'updated_at',
        width: 167,
        display: function display(value) {
          return value ? Object(util["d" /* dateFormat */])(new Date(value), 'yyyy/MM/dd hh:mm') : value;
        }
      }];
    },

    // param
    dataset: function dataset() {
      return this.param.dataset;
    },
    cases: function cases() {
      return this.param.cases;
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this2 = this;

      setTimeout(function () {
        var scrollContainer = _this2.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this2.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 912) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this3 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this3.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this3.boardType['board1'] === 'grab') {
              var grabID = _this3.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase));
                }
              });
              _this3.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this3.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase);
              }
            });
            _this3.tableWidths = tableWidths;
            setTimeout(function () {
              _this3.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb9d8a98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetDetail.vue
var datasetDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-detail-dailog dialog col-block width-full"},[_c('div',{staticClass:"form-container col-block width-full"},[_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"init":_vm.dataset,"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) {}}})],1),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"table-main-container col-block width-full",style:({ flex: 1 })},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': false }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e(),_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Return'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetDetail_staticRenderFns = []
var datasetDetail_esExports = { render: datasetDetail_render, staticRenderFns: datasetDetail_staticRenderFns }
/* harmony default export */ var dialog_datasetDetail = (datasetDetail_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetDetail.vue
var datasetDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetDetail___vue_template_functional__ = false
/* styles */
var datasetDetail___vue_styles__ = null
/* scopeId */
var datasetDetail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetDetail___vue_module_identifier__ = null
var datasetDetail_Component = datasetDetail_normalizeComponent(
  datasetDetail,
  dialog_datasetDetail,
  datasetDetail___vue_template_functional__,
  datasetDetail___vue_styles__,
  datasetDetail___vue_scopeId__,
  datasetDetail___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetDetail = (datasetDetail_Component.exports);

// EXTERNAL MODULE: ./src/components/dataset/base.vue + 5 modules
var dataset_base = __webpack_require__("+9L4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetEdit.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datasetEdit = ({
  components: {
    datasetBase: dataset_base["a" /* default */],
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dataset: null,
      onError: false,
      onSubmit: false,
      // alert
      unloadAlert: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['user']), {
    // static
    formOptions: function formOptions() {
      return {
        field1: this.dataset.shareAlert ? [{
          title: 'Sharing' /* ___ */
          , value: '_SHAREALERT',
          type: 'custom',
          grid: 6
        }] : [{
          title: 'Sharing' /* ___ */
          , value: '_SHARING',
          type: 'custom',
          grid: 2
        }, {
          title: 'Dataset URL' /* ___ */
          , value: '_URL',
          type: 'custom',
          grid: 4
        }, {
          title: 'Users' /* ___ */
          , value: '_USER',
          type: 'custom',
          grid: 2
        }, {
          title: 'Access Key' /* ___ */
          , value: '_KEY',
          type: 'custom',
          grid: 4
        }]
      };
    },

    // global
    datasetPermissionMap: function datasetPermissionMap() {
      return global_data["e" /* datasetPermissionMap */];
    }
  }),
  watch: {
    // unload alert
    'unloadAlert': function unloadAlert(nv) {
      if (nv) {
        this.setUnloadAlertAction(true);
      } else {
        this.setUnloadAlertAction(false);
      }
    }
  },
  created: function created() {
    this.dataset = extends_default()({}, this.param.defaultData);
  },
  beforeDestroy: function beforeDestroy() {
    this.setUnloadAlertAction(false);
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUnloadAlertAction']), {
    copyDatasetUrl: function copyDatasetUrl() {
      navigator.clipboard.writeText(this.dataset.url);
    },
    validateEditDataset: function validateEditDataset() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var forms, success, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form, result, datas, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _form, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onSubmit = true;
                _context.prev = 1;
                forms = values_default()(_this.$refs).map(function (ref) {
                  return ref[0] || ref;
                });
                success = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = get_iterator_default()(forms);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 18;
                  break;
                }

                form = _step.value;
                _context.next = 13;
                return form.validateSubmit();

              case 13:
                result = _context.sent;

                if (form && !result) {
                  success = false;
                }

              case 15:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 24:
                _context.prev = 24;
                _context.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context.prev = 27;

                if (!_didIteratorError) {
                  _context.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context.finish(27);

              case 31:
                return _context.finish(24);

              case 32:
                if (!success) {
                  _context.next = 68;
                  break;
                }

                datas = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 37;
                _iterator2 = get_iterator_default()(forms);

              case 39:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 52;
                  break;
                }

                _form = _step2.value;
                _context.next = 43;
                return _form.submit();

              case 43:
                data = _context.sent;

                if (!(_form && !data)) {
                  _context.next = 48;
                  break;
                }

                throw new Error();

              case 48:
                datas.push(data);

              case 49:
                _iteratorNormalCompletion2 = true;
                _context.next = 39;
                break;

              case 52:
                _context.next = 58;
                break;

              case 54:
                _context.prev = 54;
                _context.t1 = _context['catch'](37);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 58:
                _context.prev = 58;
                _context.prev = 59;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 61:
                _context.prev = 61;

                if (!_didIteratorError2) {
                  _context.next = 64;
                  break;
                }

                throw _iteratorError2;

              case 64:
                return _context.finish(61);

              case 65:
                return _context.finish(58);

              case 66:
                _context.next = 68;
                return _this.editDataset(datas[0]);

              case 68:
                _context.next = 72;
                break;

              case 70:
                _context.prev = 70;
                _context.t2 = _context['catch'](1);

              case 72:
                _this.onSubmit = false;

              case 73:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 70], [7, 20, 24, 32], [25,, 27, 31], [37, 54, 58, 66], [59,, 61, 65]]);
      }))();
    },
    editDataset: function editDataset(formData) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, data, file, response, dataset;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this2.$ls.get('userInfo');
                id = _this2.dataset.id;
                data = formData.data;

                if (!(['custom'].includes(data.dataset_picture_file_id) && formData.customPicture)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return _this2.uploadCustomPicture(_this2.dataset, formData.customPicture);

              case 7:
                file = _context2.sent;

                data.dataset_picture_file_id = file.id;

              case 9:
                _context2.next = 11;
                return Object(api["_88" /* putDataset */])(id, data, config);

              case 11:
                response = _context2.sent;
                dataset = response.data.data;
                // this.addToast('success', response.data.result.message)

                _this2.$emit('changeModal', {}, dataset);
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);

                _this2.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 16]]);
      }))();
    },
    uploadCustomPicture: function uploadCustomPicture(dataset, customPicture) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var config, id, data, response, url, result, file;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                config = _this3.$ls.get('userInfo');
                id = dataset.id;
                data = {
                  name: customPicture.name,
                  content_type: customPicture.file.type
                };
                _context3.next = 6;
                return Object(api["_66" /* postDatasetPictureFile */])(id, data, config);

              case 6:
                response = _context3.sent;
                url = response.data.data.url;
                _context3.next = 10;
                return _this3.uploadPictureFile(url, customPicture.file);

              case 10:
                result = _context3.sent;

                if (!result) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 14;
                return _this3.getCustomPicture(id);

              case 14:
                file = _context3.sent;
                return _context3.abrupt('return', file);

              case 16:
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](0);

                _this3.addToast('error', !_context3.t0.response ? _context3.t0.message : _context3.t0.response.data.result.message);

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 18]]);
      }))();
    },
    uploadPictureFile: function uploadPictureFile(url, file) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var result;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new promise_default.a(function (resolve) {
                  var xhr = _this4.createCORSRequest('PUT', url);
                  if (xhr.upload) {
                    xhr.onload = function () {
                      resolve(true);
                    };
                    xhr.onerror = function () {
                      resolve(true);
                    };
                    xhr.setRequestHeader('Content-Type', file.type);
                    xhr.send(file);
                  } else {
                    _this4.addToast('error', 'Xhr can not upload.' /* ___ */);
                  }
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt('return', result);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getCustomPicture: function getCustomPicture(id) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var config, response, file;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                config = _this5.$ls.get('userInfo');
                _context5.next = 4;
                return Object(api["V" /* getDatasetPictureFile */])(id, config);

              case 4:
                response = _context5.sent;
                file = response.data.data;
                return _context5.abrupt('return', file);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                _this5.addToast('error', !_context5.t0.response ? _context5.t0.message : _context5.t0.response.data.result.message);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    },
    createCORSRequest: function createCORSRequest(method, url) {
      var xhr = new XMLHttpRequest();
      if ('withCredentials' in xhr) {
        xhr.open(method, url, true);
      } else if (typeof XDomainRequest !== 'undefined') {
        xhr = new XDomainRequest();
        xhr.open(method, url);
      } else {
        xhr = null;
      }
      return xhr;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6172a894","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetEdit.vue
var datasetEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-edit-dailog dialog col-block"},[_c('div',{staticClass:"main-container col-block width-full"},[_c('datasetBase',{ref:'main',attrs:{"defaultData":_vm.dataset,"form":{}},on:{"onError":function (error) { return _vm.onError = error; },"unloadAlert":function (alert) { return _vm.unloadAlert = alert; }}})],1),_vm._v(" "),_c('div',{staticClass:"sharing-container col-block width-full"},[_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"displayMode":true,"init":{},"alerts":{},"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) {}},scopedSlots:_vm._u([{key:"_SHAREALERT",fn:function(props){return [_c('div',{staticClass:"_SHAREALERT row-block flex-start",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",domProps:{"innerHTML":_vm._s([
              '<b>Not available</b>'/* ___ */,
              _vm.dataset.shareAlert
            ].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}},{key:"_SHARING",fn:function(props){return [_c('div',{staticClass:"_SHARING row-block flex-start",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",domProps:{"innerHTML":_vm._s([
              'Community:'/* ___ */,
              _vm.datasetPermissionMap[_vm.dataset.community_permission].title
            ].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"white-gray-button circle-button",attrs:{"type":"button"},on:{"click":function (e) { return _vm.$emit('changeModal', {}, { tab: 'share' }); }}},[_c('span',[_vm._v(_vm._s('Share setting'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '10px' })})])]}},{key:"_URL",fn:function(props){return [_c('div',{staticClass:"_URL row-block",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",domProps:{"innerHTML":_vm._s([
              _vm.dataset.url
            ].join('<br>'))}}),_vm._v(" "),_c('div',{style:({ width: '10px' })}),_vm._v(" "),_c('div',{staticClass:"icon-block",style:({ '--size': '20px' }),attrs:{"title":'Copy'/* ___ */},on:{"click":function (e) { return _vm.copyDatasetUrl(); }}},[_c('img',{attrs:{"src":__webpack_require__("qL9y"),"alt":""}})]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])]}},{key:"_USER",fn:function(props){return [_c('div',{staticClass:"_USER row-block",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",style:({ flex: 1 }),domProps:{"innerHTML":_vm._s([
              _vm.dataset.shares.length + ' user' + (_vm.dataset.shares.length > 1 ? 's' : '')/* ___ */
            ].join('<br>'))}})])]}},{key:"_KEY",fn:function(props){return [_c('div',{staticClass:"_KEY row-block",attrs:{"name":props}},[_c('div',{staticClass:"content break-line shrink",style:({ flex: 1 }),domProps:{"innerHTML":_vm._s([
              _vm.dataset.access_key || '- -'
            ].join('<br>'))}})])]}}])})],1),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '16px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit && _vm.validateEditDataset(); }}},[_c('span',[_vm._v(_vm._s('Update'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetEdit_staticRenderFns = []
var datasetEdit_esExports = { render: datasetEdit_render, staticRenderFns: datasetEdit_staticRenderFns }
/* harmony default export */ var dialog_datasetEdit = (datasetEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetEdit.vue
var datasetEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetEdit___vue_template_functional__ = false
/* styles */
var datasetEdit___vue_styles__ = null
/* scopeId */
var datasetEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetEdit___vue_module_identifier__ = null
var datasetEdit_Component = datasetEdit_normalizeComponent(
  datasetEdit,
  dialog_datasetEdit,
  datasetEdit___vue_template_functional__,
  datasetEdit___vue_styles__,
  datasetEdit___vue_scopeId__,
  datasetEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetEdit = (datasetEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetShareEdit.vue









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var datasetShareEdit = ({
  components: {
    customForm: customForm["a" /* default */]
  },
  mixins: [toastMethods["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      shareData: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    };
  },

  computed: {
    onError: function onError() {
      var _this = this;

      return values_default()(this.alerts).filter(function (alert) {
        return alert && alert.type === 'error';
      }).length || entries_default()(this.error).some(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            field = _ref2[0],
            error = _ref2[1];

        return error.items.filter(function (item) {
          return _this.formOptions[field].map(function (form) {
            return form.value;
          }).includes(item.field);
        }).length;
      });
    },

    // static
    formOptions: function formOptions() {
      return {
        field1: [
        // 1
        {
          title: 'User' /* ___ */
          , value: 'user',
          type: 'text',
          displayMode: true,
          grid: 4
        }, {
          title: 'Permission' /* ___ */
          , value: 'permission',
          type: 'select',
          options: this.param.permissionOptions,
          grid: 2
        },
        // 2
        {
          title: 'E-mail' /* ___ */
          , value: 'email',
          type: 'text',
          displayMode: true,
          grid: 4
        }, {
          grid: 2
        }]
      };
    }
  },
  created: function created() {
    var shareData = this.param.shareData || this.shareData;
    var user = shareData.user;
    this.shareData = extends_default()({}, shareData, {
      user: [user.first_name, user.last_name].filter(function (x) {
        return x;
      }).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(function (x) {
        return x;
      }).join(' ') + ')' : ''),
      email: user.email
    });
  },

  methods: {
    formOnChange: function formOnChange(field, result, validate, errors) {
      this.$set(this.error, field, errors);
      this.$set(this.validate, field, validate);
      this.result = extends_default()({}, this.result, result);
    },
    customValidate: function customValidate(cols) {
      var rcols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      // const isSubmit = !cols
      var validates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(cols || keys_default()(this.shareData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          var alert = (validates[col] || function () {})(this.result[col]);
          this.alerts = extends_default()({}, this.alerts, defineProperty_default()({}, col, alert || null));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.alerts = extends_default()({}, this.alerts, rcols.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c, null));
      }, {}));
      return !values_default()(this.alerts).filter(function (x) {
        return x;
      }).length;
    },
    validateEditDatasetShare: function validateEditDatasetShare() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, kv;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};

                _this2.onSubmit = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 5;
                _iterator2 = get_iterator_default()(entries_default()(_this2.validate));

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 15;
                  break;
                }

                kv = _step2.value;
                _context.next = 11;
                return kv[1].validate();

              case 11:
                result[kv[0]] = _context.sent;

              case 12:
                _iteratorNormalCompletion2 = true;
                _context.next = 7;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError2) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError2;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                result['custom'] = _this2.customValidate();

                if (values_default()(result).includes(false)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 33;
                return _this2.editDatasetShare();

              case 33:
                _this2.onSubmit = false;

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[5, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    editDatasetShare: function editDatasetShare() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var config, id, datasetID, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                config = _this3.$ls.get('userInfo');
                id = _this3.shareData.id;
                datasetID = _this3.param.datasetData.id;
                data = {
                  permission: _this3.result.permission
                };
                _context2.next = 7;
                return Object(api["_90" /* putDatasetShare */])(id, datasetID, data, config);

              case 7:
                _this3.$emit('changeModal', {}, true);
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this3.addToast('error', !_context2.t0.response ? _context2.t0.message : _context2.t0.response.data.result.message);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 10]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-598769d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetShareEdit.vue
var datasetShareEdit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-share-edit-dailog dialog col-block"},[_c('customForm',{attrs:{"layoutType":'grid',"groupCount":6,"gap":'0px 16px',"init":_vm.shareData,"alerts":{},"forms":_vm.formOptions['field1']},on:{"change":function (result, validate, errors) { return _vm.formOnChange('field1', result, validate, errors); }}}),_vm._v(" "),_c('div',{style:({ height: '0' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",class:{ loading: _vm.onSubmit },attrs:{"disabled":_vm.onError},on:{"click":function (e) { return !_vm.onSubmit ? _vm.validateEditDatasetShare() : ''; }}},[_c('span',[_vm._v(_vm._s('Update'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var datasetShareEdit_staticRenderFns = []
var datasetShareEdit_esExports = { render: datasetShareEdit_render, staticRenderFns: datasetShareEdit_staticRenderFns }
/* harmony default export */ var dialog_datasetShareEdit = (datasetShareEdit_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetShareEdit.vue
var datasetShareEdit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetShareEdit___vue_template_functional__ = false
/* styles */
var datasetShareEdit___vue_styles__ = null
/* scopeId */
var datasetShareEdit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetShareEdit___vue_module_identifier__ = null
var datasetShareEdit_Component = datasetShareEdit_normalizeComponent(
  datasetShareEdit,
  dialog_datasetShareEdit,
  datasetShareEdit___vue_template_functional__,
  datasetShareEdit___vue_styles__,
  datasetShareEdit___vue_scopeId__,
  datasetShareEdit___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetShareEdit = (datasetShareEdit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetDeleteConfirm.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var datasetDeleteConfirm = ({
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], [127]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = [].concat(toConsumableArray_default()(this.shares));
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      if (!['private'].includes(this.communityPermission)) {
        tableDatas = [{
          id: -1,
          user: {
            title: 'PhenoVarDB Community' /* ___ */
          },
          permission: this.communityPermission
        }].concat(toConsumableArray_default()(tableDatas));
      }
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    tableOptions: function tableOptions() {
      return [{
        title: 'Affected User ID (organization, email)' /* ___ */
        , value: '_USERID',
        display: function display(_, __, data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        },
        sortMap: function sortMap(data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        }
      }, {
        title: 'Permission' /* ___ */
        , value: 'permission',
        display: function display(value) {
          return (global_data["e" /* datasetPermissionMap */][value] || {}).title;
        }
      }];
    },

    // param
    communityPermission: function communityPermission() {
      return this.param.communityPermission || 'private';
    },
    shares: function shares() {
      return this.param.shares || [];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this2 = this;

      setTimeout(function () {
        var scrollContainer = _this2.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this2.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 912) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this3 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this3.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this3.boardType['board1'] === 'grab') {
              var grabID = _this3.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase));
                }
              });
              _this3.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this3.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase);
              }
            });
            _this3.tableWidths = tableWidths;
            setTimeout(function () {
              _this3.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e93ce80e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetDeleteConfirm.vue
var datasetDeleteConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-delete-confirm-dailog dialog col-block width-full"},[_c('div',{staticClass:"information-container col-block"},[_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s('This dataset has been shared with the community or other users. Would you like to revoke the sharing and delete the dataset?'/* ___ */)}}),_vm._v(" "),_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s('<b>' + _vm.shares.length + '</b> dataset' + (_vm.shares.length > 1 ? 's' : '') + ' will be not available.'/* ___ */)}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-container col-block width-full"},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': true }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e(),_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"alert-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, true); }}},[_c('span',[_vm._v(_vm._s('Delete'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetDeleteConfirm_staticRenderFns = []
var datasetDeleteConfirm_esExports = { render: datasetDeleteConfirm_render, staticRenderFns: datasetDeleteConfirm_staticRenderFns }
/* harmony default export */ var dialog_datasetDeleteConfirm = (datasetDeleteConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetDeleteConfirm.vue
var datasetDeleteConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetDeleteConfirm___vue_template_functional__ = false
/* styles */
var datasetDeleteConfirm___vue_styles__ = null
/* scopeId */
var datasetDeleteConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetDeleteConfirm___vue_module_identifier__ = null
var datasetDeleteConfirm_Component = datasetDeleteConfirm_normalizeComponent(
  datasetDeleteConfirm,
  dialog_datasetDeleteConfirm,
  datasetDeleteConfirm___vue_template_functional__,
  datasetDeleteConfirm___vue_styles__,
  datasetDeleteConfirm___vue_scopeId__,
  datasetDeleteConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetDeleteConfirm = (datasetDeleteConfirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetArchiveConfirm.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var datasetArchiveConfirm = ({
  mixins: [customGrab["a" /* default */], responsitive["a" /* default */]],
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedTableData: null,
      // table
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [[], [255, 352]],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['scrollState']), {
    tableDatas: function tableDatas() {
      var _this = this;

      var tableDatas = [].concat(toConsumableArray_default()(this.datasets));
      tableDatas = Object(util["m" /* sortData */])(tableDatas, this.sort.value.map(function (x) {
        return _this.sortMap[x];
      }), this.sort.order.map(function (x) {
        return x.replace('-', '');
      }));
      tableDatas = Object(util["i" /* groupBy */])(tableDatas, function () {
        return 'default';
      }).map(function (datas) {
        return { title: datas[0].group, isGroup: true, datas: datas };
      });
      return tableDatas;
    },
    sortMap: function sortMap() {
      return this.tableOptions.reduce(function (s, c) {
        return extends_default()({}, s, defineProperty_default()({}, c.value, c.sortMap || c.value));
      }, {});
    },

    // static
    tableOptions: function tableOptions() {
      return [{
        title: 'Dataset name' /* ___ */
        , value: 'name'
      }, {
        title: 'Owner' /* ___ */
        , value: '_USERID',
        display: function display(_, __, data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        },
        sortMap: function sortMap(data) {
          var user = data.user;
          return user ? ([user.title, user.first_name, user.last_name].filter(function (x) {
            return x;
          }).join(' ') + ' (' + [user.email, user.organization || user.division ? [user.organization, user.division].filter(function (x) {
            return x;
          }).join(' ') : ''].filter(function (x) {
            return x;
          }).join(', ') + ')').replace(/ \(\)$/, '') : user;
        }
      }, {
        title: 'Dataset description' /* ___ */
        , value: 'description'
      }];
    },

    // param
    datasets: function datasets() {
      return this.param.datasets || [];
    }
  }),
  watch: {
    // data
    'selectedTableData': function selectedTableData(nv, ov) {
      if (nv !== ov && stringify_default()(nv) !== stringify_default()(ov)) {
        this.selectedTableData = nv ? JSON.parse(stringify_default()(nv)) : null;
      }
    },

    // table
    'tableDatas': function tableDatas() {
      this.getTableOverflow();
    },
    'windowWidth': function windowWidth(nv) {
      this.getTableWidths(nv);
      this.getTableOverflow();
    }
  },
  methods: {
    // table
    getTableOverflow: function getTableOverflow() {
      var _this2 = this;

      setTimeout(function () {
        var scrollContainer = _this2.$refs['custom-table-scroll'];
        if (scrollContainer) {
          _this2.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight;
        }
      });
    },
    getTableWidths: function getTableWidths(windowWidth) {
      window.dispatchEvent(new Event('scroll'));
      var tableWidth = Math.min(windowWidth - 20 * 2, 912) - 22 * 2 - (this.scrollState.height ? this.scrollbarSize : 0);
      tableWidth = tableWidth - this.staticTableWidths[0].reduce(function (s, c) {
        return s + c;
      }, 0) - this.staticTableWidths[1].reduce(function (s, c) {
        return s + c;
      }, 0);
      var tableWidths = this.tableWidths || [].concat(toConsumableArray_default()(this.staticTableWidths[0]), [1], toConsumableArray_default()(this.staticTableWidths[1])).map(function (width) {
        return {
          value: width
        };
      });
      var tableMinWidths = this.tableMinWidths || 0.1;
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length);
      var ratio = tableWidth / tableWidths.reduce(function (s, c) {
        return s + c.value;
      }, 0);
      tableWidths = Array.prototype.concat.apply([], [this.staticTableWidths[0].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      }), tableWidths.map(function (width) {
        return {
          value: width.value * ratio,
          grab: 0
        };
      }), this.staticTableWidths[1].map(function (width) {
        return {
          value: width,
          grab: 0
        };
      })]);
      this.tableMinWidths = tableMinWidths * ratio;
      this.tableWidths = tableWidths;
    },
    tableSortBy: function tableSortBy(value) {
      var position = this.sort.value.indexOf(value);
      if (position === 0) {
        var order = this.sort.order[position] === '-asc' ? '-desc' : '-asc';
        this.sort.order.splice(position, 1);
        this.sort.order.unshift(order);
      } else {
        var _order = position !== -1 ? this.sort.order[position] === '-asc' ? '-desc' : '-asc' : undefined;
        position = position !== -1 ? position : 0;
        this.sort.value.splice(position, 1);
        this.sort.order.splice(position, 1);
        this.sort.value.unshift(value);
        this.sort.order.unshift(_order || '-asc');
      }
    },

    // grab
    boardResponse: function boardResponse(id, type) {
      var _this3 = this;

      return {
        'board1': {
          'start': function start(boardData) {
            _this3.sort.disabled = true;
          },
          'move': function move(boardData) {
            if (_this3.boardType['board1'] === 'grab') {
              var grabID = _this3.boardData[id].grabID;
              var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
              var result = boardData.grabX - boardData.baseX;
              var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
                return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
              }, 0);
              tableWidths.forEach(function (_, i) {
                if (i === grabID) {
                  tableWidths[i].grab = result;
                }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase));
                }
              });
              _this3.tableWidths = tableWidths;
            }
          },
          'end': function end(boardData) {
            var grabID = _this3.boardData[id].grabID;
            var tableWidths = [].concat(toConsumableArray_default()(_this3.tableWidths));
            var result = boardData.grabX - boardData.baseX;
            var ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - _this3.staticTableWidths[1].length).reduce(function (s, c, i) {
              return s + c.value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths);
            }, 0);
            tableWidths.forEach(function (_, i) {
              tableWidths[i].grab = 0;
              if (i === grabID) {
                tableWidths[i].value += result;
              }if (i > grabID && i + _this3.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (_this3.tableOptions[i].minWidth || _this3.tableMinWidths)) / ratioBase);
              }
            });
            _this3.tableWidths = tableWidths;
            setTimeout(function () {
              _this3.sort.disabled = false;
            });
          }
        }
      }[id][type];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf5442e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetArchiveConfirm.vue
var datasetArchiveConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-archive-confirm-dailog dialog col-block width-full"},[_c('div',{staticClass:"information-container col-block"},[_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s('The following community dataset will be archived from your data pool, and any dataset associated with this community dataset will no longer be available to you.'/* ___ */)}}),_vm._v(" "),_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s('<b>' + _vm.datasets.length + '</b> dataset' + (_vm.datasets.length > 1 ? 's' : '') + ' will be not available.'/* ___ */)}})]),_vm._v(" "),_c('div',{style:({ height: '10px' })}),_vm._v(" "),_c('div',{staticClass:"table-container col-block width-full"},[_c('div',{staticClass:"custom-table",class:{ 'auto-height': true }},[(_vm.tableWidths)?_c('div',{staticClass:"table-field col-block grab-container",style:({ width: _vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) + 'px' }),on:{"mousedown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardStart]); })($event)},"mousemove":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseout":function (e) { return _vm.boardEvent('board1', e, [_vm.boardMove]); },"mouseup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return (function (e) { return _vm.boardEvent('board1', e, [_vm.boardEnd]); })($event)}}},[_c('div',{staticClass:"grab-line x min",style:(_vm.lineData.x.min && _vm.lineData.x.min.display ? { left: _vm.lineData.x.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x max",style:(_vm.lineData.x.max && _vm.lineData.x.max.display ? { left: _vm.lineData.x.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x main",style:(_vm.lineData.x.main && _vm.lineData.x.main.display ? { left: (_vm.lineData.x.main.base + _vm.lineData.x.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line x custom",style:(_vm.lineData.x.custom && _vm.lineData.x.custom.display ? { left: _vm.lineData.x.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y min",style:(_vm.lineData.y.min && _vm.lineData.y.min.display ? { top: _vm.lineData.y.min.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y max",style:(_vm.lineData.y.max && _vm.lineData.y.max.display ? { top: _vm.lineData.y.max.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y main",style:(_vm.lineData.y.main && _vm.lineData.y.main.display ? { top: (_vm.lineData.y.main.base + _vm.lineData.y.main.grab) + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"grab-line y custom",style:(_vm.lineData.y.custom && _vm.lineData.y.custom.display ? { top: _vm.lineData.y.custom.value + 'px', display: 'block' } : {})}),_vm._v(" "),_c('div',{staticClass:"table-container col-block"},[_c('div',{staticClass:"thead"},[_c('div',{staticClass:"tr row-block"},_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"th row-block",class:[{ sortable: option.sortMap !== null }, (option.class || (function () { return []; }))(null, -1, null)],style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab + 'px' }),on:{"click":function (e) { return !_vm.sort.disabled && option.sortMap !== null && _vm.tableSortBy(option.sortValue || option.value); }}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),(option.sortMap !== null)?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],attrs:{"aria-hidden":"true"}})]:_vm._e(),_vm._v(" "),(index + 1 > _vm.staticTableWidths[0].length && _vm.tableOptions[index + 1 + _vm.staticTableWidths[1].length])?_c('div',{staticClass:"grab-box grab-x",class:{ grabbing: _vm.boardData['board1'].grabID === index },attrs:{"grab-id":index,"grab-type":'x' + { line: '', grab: '*' }[_vm.boardType['board1']],"grab-x-min":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + (option.minWidth || _vm.tableMinWidths) + '*',"grab-x-max":_vm.tableWidths.reduce(function (s, c) { return s + c.value; }, 0) - _vm.tableOptions.slice(index + 1, _vm.tableOptions.length - _vm.staticTableWidths[1].length).reduce(function (s, c) { return s + (c.minWidth || _vm.tableMinWidths); }, 0) - _vm.staticTableWidths[1].reduce(function (s, c) { return s + c; }, 0) + '*',"grab-x-custom":_vm.tableWidths.slice(0, index).reduce(function (s, c) { return s + c.value; }, 0) + { line: '', grab: '*' }[_vm.boardType['board1']]}}):_vm._e()],2)}),0)])]),_vm._v(" "),_c('div',{ref:"custom-table-scroll",staticClass:"table-group-container col-block width-full"},[_c('div',{staticClass:"col-block"},_vm._l((_vm.tableDatas),function(group,gindex){return _c('div',{key:gindex,staticClass:"table-container col-block"},[_c('div',{staticClass:"tbody"},[_c('div',{staticClass:"tr group row-block",class:{ selected: group.datas.some(function (data) { return (_vm.selectedTableData || {}).id === data.id; }) },style:(group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' })},[_c('a',{staticClass:"container-block row-block"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(group[option.gValue], gindex, group),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.gstyle || (function () { return ({}); }))(group[option.gValue], gindex, group)),attrs:{"title":((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.gdisplay || (function (x) { return x; }))(group[option.gValue], gindex, group) || option.gempty || '')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('center') && !(option.class || (function () { return []; }))(group[option.gValue], gindex, group).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)]),_vm._v(" "),_vm._l((group.datas),function(data,dindex){return _c('div',{key:dindex,staticClass:"tr col-block",class:{ selectable: false, selected: (_vm.selectedTableData || {}).id === data.id }},[_c('a',{staticClass:"container-block row-block",style:({ flex: 1 }),on:{"click":function (e) { return false && (_vm.selectedTableData = data); }}},[_c('div',{staticClass:"bar"}),_vm._v(" "),_vm._l((_vm.tableOptions),function(option,index){return _c('div',{key:index,staticClass:"td row-block",class:(option.class || (function () { return []; }))(data[option.value], dindex, data),style:({ width: _vm.tableWidths[index].value + _vm.tableWidths[index].grab - (!_vm.tableOptions[index + 1] && _vm.tableOverflow ? _vm.scrollbarSize : 0) + 'px' })},[[_c('span',{style:((option.style || (function () { return ({}); }))(data[option.value], dindex, data)),attrs:{"title":((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')},domProps:{"innerHTML":_vm._s((option.display || (function (x) { return x; }))(data[option.value], dindex, data) || option.empty || '- -')}})],_vm._v(" "),(option.sortMap !== null && (option.class || (function () { return []; }))(data[option.value], dindex, data).includes('center') && !(option.class || (function () { return []; }))(data[option.value], dindex, data).includes('auto-width'))?[_c('div',{style:({ width: '5px' })}),_vm._v(" "),_c('i',{class:['fa', 'fa-sort' + (_vm.sort.order[_vm.sort.value.indexOf(option.sortValue || option.value)] || '')],style:({ opacity: 0 }),attrs:{"aria-hidden":"true"}})]:_vm._e()],2)})],2)])})],2)])}),0)])]):_vm._e()])]),_vm._v(" "),_c('div',{style:({ height: '30px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"alert-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, true); }}},[_c('span',[_vm._v(_vm._s('Archive'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])])}
var datasetArchiveConfirm_staticRenderFns = []
var datasetArchiveConfirm_esExports = { render: datasetArchiveConfirm_render, staticRenderFns: datasetArchiveConfirm_staticRenderFns }
/* harmony default export */ var dialog_datasetArchiveConfirm = (datasetArchiveConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetArchiveConfirm.vue
var datasetArchiveConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetArchiveConfirm___vue_template_functional__ = false
/* styles */
var datasetArchiveConfirm___vue_styles__ = null
/* scopeId */
var datasetArchiveConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetArchiveConfirm___vue_module_identifier__ = null
var datasetArchiveConfirm_Component = datasetArchiveConfirm_normalizeComponent(
  datasetArchiveConfirm,
  dialog_datasetArchiveConfirm,
  datasetArchiveConfirm___vue_template_functional__,
  datasetArchiveConfirm___vue_styles__,
  datasetArchiveConfirm___vue_scopeId__,
  datasetArchiveConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetArchiveConfirm = (datasetArchiveConfirm_Component.exports);

// EXTERNAL MODULE: ./src/components/dataset/card.vue + 2 modules
var card = __webpack_require__("DGt+");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/datasetInvitationConfirm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var datasetInvitationConfirm = ({
  components: {
    datasetCard: card["a" /* default */]
  },
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // param
    dataset: function dataset() {
      return this.param.dataset;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c64371b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/datasetInvitationConfirm.vue
var datasetInvitationConfirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataset-invitation-confirm-dailog dialog col-block"},[_c('datasetCard',{attrs:{"type":'community',"dataset":_vm.dataset,"layoutType":'confirm'}}),_vm._v(" "),_c('hr',{staticClass:"custom",style:({ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' })}),_vm._v(" "),_c('div',{staticClass:"information-container col-block"},[_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s([
        [_vm.dataset.user.first_name, _vm.dataset.user.last_name].filter(function (x) { return x; }).join(' ') + ' has granted you access to the dataset shown above. Would you like to accept the invitation?'/* ___ */
      ].join('<br>'))}})]),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"gray-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal'); }}},[_c('span',[_vm._v(_vm._s('Cancel'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ width: '20px' })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.$emit('changeModal', {}, true); }}},[_c('span',[_vm._v(_vm._s('Accept'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var datasetInvitationConfirm_staticRenderFns = []
var datasetInvitationConfirm_esExports = { render: datasetInvitationConfirm_render, staticRenderFns: datasetInvitationConfirm_staticRenderFns }
/* harmony default export */ var dialog_datasetInvitationConfirm = (datasetInvitationConfirm_esExports);
// CONCATENATED MODULE: ./src/components/dialog/datasetInvitationConfirm.vue
var datasetInvitationConfirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datasetInvitationConfirm___vue_template_functional__ = false
/* styles */
var datasetInvitationConfirm___vue_styles__ = null
/* scopeId */
var datasetInvitationConfirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datasetInvitationConfirm___vue_module_identifier__ = null
var datasetInvitationConfirm_Component = datasetInvitationConfirm_normalizeComponent(
  datasetInvitationConfirm,
  dialog_datasetInvitationConfirm,
  datasetInvitationConfirm___vue_template_functional__,
  datasetInvitationConfirm___vue_styles__,
  datasetInvitationConfirm___vue_scopeId__,
  datasetInvitationConfirm___vue_module_identifier__
)

/* harmony default export */ var components_dialog_datasetInvitationConfirm = (datasetInvitationConfirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dialog/toast.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dialog_toast = ({
  props: {
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588f451f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/toast.vue
var dialog_toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-toast col-block",class:_vm.param.type},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.param.content)}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-row row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_vm._l((_vm.param.buttons || []),function(button,index){return _c('button',{key:index,class:[button.type + '-button', 'circle-button'],on:{"click":function($event){_vm.$emit('changeModal', {}, button.result)}}},[_c('span',[_vm._v(_vm._s(button.title))])])}),_vm._v(" "),_c('div',{style:({ flex: 1 })})],2)])}
var dialog_toast_staticRenderFns = []
var dialog_toast_esExports = { render: dialog_toast_render, staticRenderFns: dialog_toast_staticRenderFns }
/* harmony default export */ var components_dialog_toast = (dialog_toast_esExports);
// CONCATENATED MODULE: ./src/components/dialog/toast.vue
var dialog_toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var dialog_toast___vue_template_functional__ = false
/* styles */
var dialog_toast___vue_styles__ = null
/* scopeId */
var dialog_toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dialog_toast___vue_module_identifier__ = null
var dialog_toast_Component = dialog_toast_normalizeComponent(
  dialog_toast,
  components_dialog_toast,
  dialog_toast___vue_template_functional__,
  dialog_toast___vue_styles__,
  dialog_toast___vue_scopeId__,
  dialog_toast___vue_module_identifier__
)

/* harmony default export */ var src_components_dialog_toast = (dialog_toast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// modals



































__webpack_require__("5W8o");

/* harmony default export */ var App = ({
  name: 'app',
  components: {
    layoutHeader: components_layout_header,
    layoutFooter: components_layout_footer,
    layoutToast: src_components_tool_toast,
    layoutBorCor: src_components_layout_borCor,
    layoutLoading: components_layout_loading,
    layoutUploading: components_layout_uploading,
    layoutFileUpload: src_components_layout_fileUpload,
    // modals
    modal: components_dialog_container,
    userConfirm: components_dialog_userConfirm,
    genePanelInfo: components_dialog_genePanelInfo,
    editPanel: components_dialog_editPanel,
    addToPanel: src_components_dialog_addToPanel,
    genePanelQuickSelection: components_dialog_genePanelQuickSelection,
    genePanelDataSelect: components_dialog_genePanelDataSelect,
    genePanelConfirm: components_dialog_genePanelConfirm,
    selectDataset: components_dialog_selectDataset,
    fileCloud: components_dialog_fileCloud,
    caseConfirm: components_dialog_caseConfirm,
    caseEdit: components_dialog_caseEdit,
    projectEdit: components_dialog_projectEdit,
    caseFile: components_dialog_caseFile,
    caseDetailGeneClinvar: components_dialog_caseDetailGeneClinvar,
    caseDetailGeneQuality: components_dialog_caseDetailGeneQuality,
    caseDetailGenePublication: components_dialog_caseDetailGenePublication,
    caseDetailGeneUserSetting: components_dialog_caseDetailGeneUserSetting,
    caseDetailGeneACMG: components_dialog_caseDetailGeneACMG,
    editChapter: components_dialog_editChapter,
    addVariantToChapter: components_dialog_addVariantToChapter,
    editReportVariant: components_dialog_editReportVariant,
    editCNVToChapter: components_dialog_editCNVToChapter,
    editReportCNV: components_dialog_editReportCNV,
    userAvatar: components_dialog_userAvatar,
    imageCropper: components_dialog_imageCropper,
    datasetSelectCase: components_dialog_datasetSelectCase,
    datasetDetail: components_dialog_datasetDetail,
    datasetEdit: components_dialog_datasetEdit,
    datasetShareEdit: components_dialog_datasetShareEdit,
    datasetDeleteConfirm: components_dialog_datasetDeleteConfirm,
    datasetArchiveConfirm: components_dialog_datasetArchiveConfirm,
    datasetInvitationConfirm: components_dialog_datasetInvitationConfirm,
    toast: src_components_dialog_toast
  },
  mixins: [responsitive["a" /* default */], loginData["a" /* default */], toastMethods["a" /* default */]],
  data: function data() {
    return {
      userAgent: '',
      minHeight: '300px'
    };
  },

  watch: {
    '$route': function $route() {
      var _document = document,
          body = _document.body;

      body.scroll(0, 0);
      this.setModalAction({});
      this.setModal2Action({});
      window.dispatchEvent(new Event('resize'));
      if (this.initial !== null) {
        this.setLoadingAction(true);
        this.validateRoute(this.isLogin);
      }
    },
    'isLogin': function isLogin(n, o) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(o !== null)) {
                  _context.next = 12;
                  break;
                }

                _this.setLoadingAction(true);
                _context.next = 4;
                return _this.preFetchDataGuest();

              case 4:
                if (!n) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.preFetchData();

              case 7:
                _context.next = 10;
                break;

              case 9:
                _this.setUnloadAlertAction();

              case 10:
                _this.appInitialAction(n);
                _this.setLoadingAction(false);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    'unloadAlert': function unloadAlert(nv) {
      if (nv) {
        window.document.body.onbeforeunload = function () {
          return '';
        };
      } else {
        window.document.body.onbeforeunload = null;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['normalPage', 'userPage', 'adminPage', 'initial', 'isLogin', 'isLoading', 'isDialogLoading', 'isUploading', 'modal', 'modal2', 'unloadAlert']), {
    isMainPage: function isMainPage() {
      return this.$route.name && [
      // normal page
      'main', 'deviceAlert', 'forget', 'reset', 'register', 'active', 'genePanel', 'phenotypeDisease', 'coverageRate',
      // user page
      'user', 'phenotype', 'config', 'point', 'systemInfo', 'configEdit', 'datasetInvitationConfirm',
      //
      ''].includes(this.$route.name);
    },
    isLargePage: function isLargePage() {
      return this.$route.name && [
      // normal page
      // user page
      //
      ''].includes(this.$route.name);
    },
    noHeader: function noHeader() {
      return this.$route.name && ['main', ''].includes(this.$route.name);
    }
  }),
  created: function created() {
    var _this2 = this;

    this.userAgent = navigator.userAgent;
    this.setModalAction({});
    this.setModal2Action({});
    this.setLoadingAction(true);
    var validateLogin = function validateLogin() {
      if (_this2.$route.name) {
        _this2.validateLogin();
      } else {
        setTimeout(function () {
          return validateLogin();
        }, 100);
      }
    };
    validateLogin();
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    var _document2 = document,
        body = _document2.body;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var headerHeight = _this3.noHeader ? 0 : 60;
        var footerHeight = 0;
        var height = rect.height - headerHeight - footerHeight + 0;
        _this3.minHeight = height + 'px';
      }
    };
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },
  mounted: function mounted() {
    var _this4 = this;

    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      var offsetHeight = document.documentElement.offsetHeight || document.body.offsetHeight;
      _this4.setScrollStateAction({
        top: scrollTop,
        height: scrollHeight - offsetHeight
      });
    });
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['appInitialAction', 'setLoadingAction', 'setDialogLoadingAction', 'clearLoadingAction', 'clearDialogLoadingAction', 'setModalAction', 'setModal2Action', 'setUnloadAlertAction', 'setScrollStateAction',
  // global
  'setUserSettingAction', 'setUserAvatarAction']), {
    preFetchDataGuest: function preFetchDataGuest() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    preFetchData: function preFetchData() {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this6.fetchUserSettings();

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    fetchUserSettings: function fetchUserSettings() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var config, response, userSettings;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                config = _this7.$ls.get('userInfo');
                _context4.next = 4;
                return Object(api["_47" /* getUserSettings */])(config);

              case 4:
                response = _context4.sent;
                userSettings = response.data.data;

                userSettings = userSettings || {};
                _this7.setUserSettingAction(userSettings);
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0;

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 10]]);
      }))();
    },
    validateLogin: function validateLogin() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var userInfo;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                userInfo = _this8.$ls.get('userInfo') || {};
                _context5.next = 3;
                return _this8.preFetchDataGuest();

              case 3:
                if (!userInfo['access_token']) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 6;
                return _this8.getUserByToken(userInfo);

              case 6:
                _context5.next = 11;
                break;

              case 8:
                _this8.setUserData(null);
                _this8.appInitialAction(false);
                _this8.validateRoute(false);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    getUserByToken: function getUserByToken(data) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var response, user;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return Object(api["_48" /* getUserToken */])(data);

              case 3:
                response = _context6.sent;
                _context6.next = 6;
                return _this9.preFetchData();

              case 6:
                user = response.data.user || response.data.data || { role: {} };

                _this9.setUserData(response, data);
                _this9.appInitialAction(true);
                _this9.validateRoute(true, user.role, ['supervisor'].includes(user.role));
                _context6.next = 18;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](0);

                _this9.setUserData(null);
                _this9.appInitialAction(true);
                _this9.addToast('error', !_context6.t0.response ? _context6.t0.message : _context6.t0.response.data.result.message);
                _this9.validateRoute(false);

              case 18:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[0, 12]]);
      }))();
    },
    validateRoute: function validateRoute(isLogin, role, admin) {
      var array = [];
      if (isLogin) {
        switch (role) {
          default:
            {
              array = lodash_default.a.union(this.userPage, this.normalPage);
            }
        }
      } else {
        array = this.normalPage;
      }
      if (admin) {
        array = lodash_default.a.union(array, this.adminPage);
      }
      this.validateRole(isLogin, array);
    },
    validateRole: function validateRole(isLogin, pages) {
      var routeName = this.$route.name;
      if (routeName && !lodash_default.a.includes(pages, routeName)) {
        this.addToast('error', 'You have no permission to do this operation.');
        this.$router.push(isLogin ? { name: 'main' } : { name: 'main', query: { redirect: this.$route.fullPath } });
        this.setLoadingAction(false);
      } else {
        if (isLogin && lodash_default.a.includes(this.normalPage, routeName) && !['active', 'datasetInvitationConfirm', 'genePanel', 'phenotypeDisease', 'coverageRate', 'datasetDetail'].includes(routeName)) {
          this.$router.push({ name: 'caseList' });
        }
        this.setLoadingAction(false);
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aada6a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-root",attrs:{"id":"app"}},[(!_vm.noHeader)?_c('layout-header'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"scroll-box"}}),_vm._v(" "),_c('div',{staticClass:"app-container",style:({ position: _vm.modal.action && !_vm.isDialogLoading ? 'relative' : 'relative' })},[_c('div',{staticClass:"app-pages",class:{ 'no-header': _vm.noHeader }},[(!_vm.isMainPage)?_c('div',{staticClass:"max-width",class:{ 'large-page': _vm.isLargePage },style:({ minHeight: _vm.minHeight, display: _vm.isMainPage ? 'flex' : 'block', 'align-items': 'center' })},[_c('div',{staticClass:"view-container"},[_c('div',{staticClass:"view-field responsitive-color transparent-transparent"},[_c('keep-alive',{attrs:{"include":['caseList', 'datasetList']}},[_c('router-view',{attrs:{"minHeight":_vm.minHeight}})],1)],1)])]):_c('div',{staticClass:"app-main-container"},[_c('keep-alive',{attrs:{"include":[]}},[_c('router-view',{attrs:{"minHeight":_vm.minHeight}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-container"},[(_vm.modal.action)?_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"width":_vm.modal.width,"height":_vm.modal.height,"customStyles":_vm.modal.customStyles,"maskClose":_vm.modal.maskClose},on:{"hide":function () {
      _vm.modal.callback && _vm.modal.callback()
      _vm.setModalAction({})
    }}},[_c(_vm.modal.action,{tag:"component",attrs:{"param":_vm.modal.param},on:{"changeModal":function (option, param) {
        _vm.modal.callback && _vm.modal.callback(param)
        this$1.setModalAction(option || {})
      }}})],1):_vm._e(),_vm._v(" "),(_vm.modal2.action)?_c('modal',{style:(!_vm.isDialogLoading ? {} : { display: 'none' }),attrs:{"width":_vm.modal2.width,"height":_vm.modal2.height,"customStyles":_vm.modal2.customStyles,"maskClose":_vm.modal2.maskClose},on:{"hide":function () {
      _vm.modal2.callback && _vm.modal2.callback()
      _vm.setModal2Action({})
    }}},[_c(_vm.modal2.action,{tag:"component",attrs:{"param":_vm.modal2.param},on:{"changeModal":function (option, param) {
        _vm.modal2.callback && _vm.modal2.callback(param)
        this$1.setModal2Action(option || {})
      }}})],1):_vm._e()],1),_vm._v(" "),(_vm.isLogin)?_c('layoutFileUpload'):_vm._e(),_vm._v(" "),_c('layoutToast'),_vm._v(" "),_c('layoutBorCor'),_vm._v(" "),(_vm.isLoading)?_c('layoutLoading'):_vm._e(),_vm._v(" "),(_vm.isUploading !== undefined)?_c('layoutUploading',{attrs:{"content":_vm.isUploading}}):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("qBXn")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'root',
    redirect: { name: 'main' }
  }, {
    path: '/main',
    name: 'main',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8too")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/deviceAlert',
    name: 'deviceAlert',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gr8x")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/forget',
    name: 'forget',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HHUW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/reset',
    name: 'reset',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8jyM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/register',
    name: 'register',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Dhdo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/active',
    name: 'active',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T4tO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetAccess/:id',
    name: 'datasetAccess',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aWKw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/coverageRate',
    name: 'coverageRate',
    component: function component(resolve) {
      __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ljaW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/genePanel',
    name: 'genePanel',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XLX7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/phenotypeDisease',
    name: 'phenotypeDisease',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GUIV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/user',
    name: 'user',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FNn1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/panel',
    name: 'panel',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PU4H")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/config',
    name: 'config',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("szT4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/point',
    name: 'point',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/E6y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/systemInfo',
    name: 'systemInfo',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JCCc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/configEdit/:id?',
    name: 'configEdit',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Tl8S")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/caseList/:tab?',
    name: 'caseList',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oytU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/caseEdit/:dataset',
    name: 'caseEdit',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4DmU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/caseDetail/:type/:id',
    name: 'caseDetail',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qrhr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetList',
    name: 'datasetList',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BfKk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetEdit',
    name: 'datasetEdit',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+rS8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetDetail/:type/:id',
    name: 'datasetDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("q/8J")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/datasetInvitationConfirm',
    name: 'datasetInvitationConfirm',
    component: function component(resolve) {
      __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gaYw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/genomeBrowser/:id/:type/:symbol/:vkey',
    name: 'genomeBrowser',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gYSt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '*',
    redirect: { name: 'main' }
  }]
}));
// CONCATENATED MODULE: ./src/store/modules/app.js



var _mutations;

var app_state = {
  initial: null,
  isLogin: null,
  isLoading: 0,
  isDialogLoading: 0,
  isUploading: undefined,
  modal: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  modal2: {
    action: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    closeButton: true,
    customStyles: {}
  },
  toast: null,
  borCor: null,
  unloadAlert: 0,
  scrollState: {
    top: null,
    height: null
  },
  pageDisplayData: {},
  // const
  normalPage: ['main', 'deviceAlert', 'forget', 'reset', 'register', 'active', 'genePanel', 'phenotypeDisease', 'coverageRate', 'datasetAccess', 'datasetDetail'],
  userPage: ['user', 'panel', 'point', 'config', 'systemInfo', 'configEdit', 'caseList', 'caseEdit', 'caseDetail', 'datasetList', 'datasetEdit', 'datasetInvitationConfirm', 'genomeBrowser'],
  adminPage: []
};

var getters = {
  initial: function initial(state) {
    return state.initial;
  },
  isLogin: function isLogin(state) {
    return state.isLogin;
  },
  isLoading: function isLoading(state) {
    return state.isLoading > 0;
  },
  isDialogLoading: function isDialogLoading(state) {
    return state.isDialogLoading > 0;
  },
  isUploading: function isUploading(state) {
    return state.isUploading;
  },
  modal: function modal(state) {
    return state.modal;
  },
  modal2: function modal2(state) {
    return state.modal2;
  },
  toast: function toast(state) {
    return state.toast;
  },
  borCor: function borCor(state) {
    return state.borCor;
  },
  unloadAlert: function unloadAlert(state) {
    return state.unloadAlert;
  },
  scrollState: function scrollState(state) {
    return state.scrollState;
  },
  pageDisplayData: function pageDisplayData(state) {
    return state.pageDisplayData;
  },
  // const
  normalPage: function normalPage(state) {
    return state.normalPage;
  },
  userPage: function userPage(state) {
    return state.userPage;
  },
  adminPage: function adminPage(state) {
    return state.adminPage;
  }
};

var types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setModal: 'app/setModal',
  setModal2: 'app/setModal2',
  addToast: 'app/addToast',
  deleteToast: 'app/deleteToast',
  setUnloadAlert: 'app/setUnloadAlert',
  setScrollState: 'app/setScrollState',
  setPageDisplayData: 'app/setPageDisplayData'
};

var mutations = (_mutations = {}, defineProperty_default()(_mutations, types.appInitial, function (state, boolean) {
  state.initial = boolean;
}), defineProperty_default()(_mutations, types.setLogin, function (state, boolean) {
  state.isLogin = boolean;
}), defineProperty_default()(_mutations, types.setLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isLoading += 1;
    } else {
      state.isLoading -= 1;
    }
  }
}), defineProperty_default()(_mutations, types.clearLoading, function (state) {
  state.isLoading = 0;
}), defineProperty_default()(_mutations, types.setDialogLoading, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.isDialogLoading += 1;
    } else {
      state.isDialogLoading -= 1;
    }
  }
}), defineProperty_default()(_mutations, types.clearDialogLoading, function (state) {
  state.isDialogLoading = 0;
}), defineProperty_default()(_mutations, types.setUploading, function (state, content) {
  state.isUploading = content;
}), defineProperty_default()(_mutations, types.setModal, function (state, object) {
  state.modal = object;
}), defineProperty_default()(_mutations, types.setModal2, function (state, object) {
  state.modal2 = object;
}), defineProperty_default()(_mutations, types.addToast, function (state, object) {
  state.toast = extends_default()({}, object);
}), defineProperty_default()(_mutations, types.setBorCor, function (state, object) {
  state.borCor = object;
}), defineProperty_default()(_mutations, types.setUnloadAlert, function (state, boolean) {
  if (boolean !== undefined) {
    if (boolean) {
      state.unloadAlert += 1;
    } else {
      state.unloadAlert -= 1;
    }
  } else {
    state.unloadAlert = 0;
  }
}), defineProperty_default()(_mutations, types.setScrollState, function (state, object) {
  state.scrollState = object;
}), defineProperty_default()(_mutations, types.setPageDisplayData, function (state, object) {
  state.pageDisplayData = object;
}), _mutations);

var actions = {
  appInitialAction: function appInitialAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(types.appInitial, boolean);
  },
  setLoginAction: function setLoginAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(types.setLogin, boolean);
  },
  setLoadingAction: function setLoadingAction(_ref3, boolean) {
    var commit = _ref3.commit;

    commit(types.setLoading, boolean);
  },
  clearLoadingAction: function clearLoadingAction(_ref4) {
    var commit = _ref4.commit;

    commit(types.clearLoading);
  },
  setDialogLoadingAction: function setDialogLoadingAction(_ref5, boolean) {
    var commit = _ref5.commit;

    commit(types.setDialogLoading, boolean);
  },
  clearDialogLoadingAction: function clearDialogLoadingAction(_ref6) {
    var commit = _ref6.commit;

    commit(types.clearDialogLoading);
  },
  setUploadingAction: function setUploadingAction(_ref7, content) {
    var commit = _ref7.commit;

    commit(types.setUploading, content);
  },
  setModalAction: function setModalAction(_ref8, object) {
    var commit = _ref8.commit;

    commit(types.setModal, object);
  },
  setModal2Action: function setModal2Action(_ref9, object) {
    var commit = _ref9.commit;

    commit(types.setModal2, object);
  },
  addToastAction: function addToastAction(_ref10, object) {
    var commit = _ref10.commit;

    commit(types.addToast, object);
  },
  setBorCorAction: function setBorCorAction(_ref11, object) {
    var commit = _ref11.commit;

    commit(types.setBorCor, object);
  },
  setUnloadAlertAction: function setUnloadAlertAction(_ref12, boolean) {
    var commit = _ref12.commit;

    commit(types.setUnloadAlert, boolean);
  },
  setScrollStateAction: function setScrollStateAction(_ref13, object) {
    var commit = _ref13.commit;

    commit(types.setScrollState, object);
  },
  setPageDisplayDataAction: function setPageDisplayDataAction(_ref14, boolean) {
    var commit = _ref14.commit;

    commit(types.setPageDisplayData, boolean);
  }
};

/* harmony default export */ var app = ({
  state: app_state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
// CONCATENATED MODULE: ./src/store/modules/gcs.js


var gcs__mutations;

var gcs_state = {
  isFileUpload: false,
  uploadCount: 0,
  waitUploading: null,
  resumableInfo: null
};

var gcs_getters = {
  isFileUpload: function isFileUpload(state) {
    return state.isFileUpload;
  },
  uploadCount: function uploadCount(state) {
    return state.uploadCount;
  },
  waitUploading: function waitUploading(state) {
    return state.waitUploading;
  },
  resumableInfo: function resumableInfo(state) {
    return state.resumableInfo;
  }
};

var gcs_types = {
  setFileUpload: 'gcs/setFileUpload',
  addUploadCount: 'gcs/addUploadCount',
  setWaitUploading: 'gcs/setWaitUploading',
  setResumableInfo: 'gcs/setResumableInfo'
};

var gcs_mutations = (gcs__mutations = {}, defineProperty_default()(gcs__mutations, gcs_types.setFileUpload, function (state, boolean) {
  state.isFileUpload = boolean;
}), defineProperty_default()(gcs__mutations, gcs_types.addUploadCount, function (state, boolean) {
  state.uploadCount = boolean ? state.uploadCount + 1 : 0;
}), defineProperty_default()(gcs__mutations, gcs_types.setWaitUploading, function (state, data) {
  state.waitUploading = data;
}), defineProperty_default()(gcs__mutations, gcs_types.setResumableInfo, function (state, data) {
  state.resumableInfo = data;
}), gcs__mutations);

var gcs_actions = {
  setFileUploadAction: function setFileUploadAction(_ref, boolean) {
    var commit = _ref.commit;

    commit(gcs_types.setFileUpload, boolean);
  },
  addUploadCountAction: function addUploadCountAction(_ref2, boolean) {
    var commit = _ref2.commit;

    commit(gcs_types.addUploadCount, boolean);
  },
  setWaitUploadingAction: function setWaitUploadingAction(_ref3, data) {
    var commit = _ref3.commit;

    commit(gcs_types.setWaitUploading, data);
  },
  setResumableInfoAction: function setResumableInfoAction(_ref4, data) {
    var commit = _ref4.commit;

    commit(gcs_types.setResumableInfo, data);
  }
};

/* harmony default export */ var gcs = ({
  state: gcs_state,
  getters: gcs_getters,
  mutations: gcs_mutations,
  actions: gcs_actions
});
// CONCATENATED MODULE: ./src/store/modules/global.js


var global__mutations;

var global_state = {
  userSetting: {},
  userAvatar: {}
};

var global_getters = {
  userSetting: function userSetting(state) {
    return state.userSetting;
  },
  userAvatar: function userAvatar(state) {
    return state.userAvatar;
  }
};

var global_types = {
  setUserSetting: 'global/userSetting',
  setUserAvatar: 'global/setUserAvatar'
};

var global_mutations = (global__mutations = {}, defineProperty_default()(global__mutations, global_types.setUserSetting, function (state, obj) {
  state.userSetting = obj;
}), defineProperty_default()(global__mutations, global_types.setUserAvatar, function (state, obj) {
  state.userAvatar = obj;
}), global__mutations);

var global_actions = {
  setUserSettingAction: function setUserSettingAction(_ref, obj) {
    var commit = _ref.commit;

    commit(global_types.setUserSetting, obj);
  }
};

/* harmony default export */ var global = ({
  state: global_state,
  getters: global_getters,
  mutations: global_mutations,
  actions: global_actions
});
// CONCATENATED MODULE: ./src/store/modules/user.js



var user__mutations;

var user_state = {
  data: null,
  info: null
};

var user_getters = {
  user: function user(state) {
    return state.data ? extends_default()({}, state.data) : state.data;
  },
  userInfo: function userInfo(state) {
    return state.info ? extends_default()({}, state.info) : state.info;
  }
};

var user_types = {
  setUser: 'user/setUser',
  setUserInfo: 'user/setUserInfo'
};

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, user_types.setUser, function (state, object) {
  state.data = object;
}), defineProperty_default()(user__mutations, user_types.setUserInfo, function (state, object) {
  state.info = object;
}), user__mutations);

var user_actions = {
  setUserAction: function setUserAction(_ref, object) {
    var commit = _ref.commit;

    commit(user_types.setUser, object);
  },
  setUserInfoAction: function setUserInfoAction(_ref2, object) {
    var commit = _ref2.commit;

    commit(user_types.setUserInfo, object);
  }
};

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  mutations: user_mutations,
  actions: user_actions
});
// CONCATENATED MODULE: ./src/store/index.js








vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    app: app,
    gcs: gcs,
    global: global,
    user: modules_user
  }
}));
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/constants/lang/_report/en/lang.js
/* harmony default export */ var lang = ({
  // report
  REPORT: {
    chapter: {
      ___appendix: 'Appendix',
      title: {
        ___subject: 'Patient Information',
        ___disease_diagnosis: 'Diagnosis',
        ___active_screening: 'Proactive Test',
        ___cause_screening: 'Carrier Screening',
        ___acmg_incidental: 'ACMG Incidental',
        ___custom1: 'custom1',
        ___custom2: 'custom2',
        ___custom3: 'custom3',
        ___constitution: 'Constitution-related genes',
        ___drug_meta: 'Pharmacogenetics',
        ___method: 'Method',
        ___appendix_disease_gene: 'List of Genes for Disease Diagnosis',
        ___appendix_disease_gene_lite: 'Gene List',
        ___appendix_us_gene: 'ACMG Guideline'
      },
      item: {
        title: {
          ___resultSummary: 'Result Summary',
          ___interpretation: 'Interpretation'
        },
        variant: {
          ___empty: 'No variants have been added yet.'
        }
      },
      header: {
        ___info01: 'Report Date',
        ___info02: 'Sample ID'
      },
      footer: {
        ___info01: '＊The report has to be interpreted by medical professionals.',
        ___info02: '17F.-10, No. 118, Ciyun Rd., Hsinchu City 300 , Taiwan (R.O.C.) | Compass Bioinformatics Inc. | 886-3-574-5009'
      },
      basicInfo: {
        ___title: 'Patient Information',
        form: {
          title: {
            ___case_id: 'Name',
            ___sex: 'Sex',
            ___age: 'Age',
            ___testing_date: 'Test Date',
            ___testing_category: 'Sample\ntype',
            ___sequencing_range: 'Test',
            ___sequencing_tech: 'Seqencing \nPlatform',
            ___doctor_name: 'Doctor',
            ___organization: 'Hospital',
            ___medical_number: 'Clinical\nID',
            ___family_medical_history: 'Note'
          }
        }
      },
      variantResult: {
        mainData: {
          default: {
            ___title: 'Interpretation',
            ___contentTitle01: 'The genetic test identified a total of <b>{count}</b> gene having likely causative-variant. |  The genetic test identified a total of <b>{count}</b> genes having likely causative-variants.',
            ___contentTitle02: 'there is <b>{count}</b> gene located in the mitochondria. | there are <b>{count}</b> genes located in the mitochondria.',
            detail: {
              title: {
                ___ClinVar: 'The clinical interpretation of ClinVar is ',
                ___ClinVar_empty: 'ClinVar data is not available',
                ___ACMG: 'The classification of ACMG is ',
                ___OMIM: 'There are associated-diseases were found in OMIM, which are:',
                ___OMIM_empty: 'No gene associated-diseases were found in OMIM',
                ___Orphanet: 'There are associated-diseases were found in Orphanet, which are:',
                ___Orphanet_empty: 'No gene associated-diseases were found in Orphanet'
              }
            }
          },
          cnv: {
            ___title: 'CNV Interpretation',
            ___contentTitle01: 'The genetic test identified a total of <b>{count}</b> region having likely causative-variant. |  The genetic test identified a total of <b>{count}</b> regions having likely causative-variants.',
            detail: {
              title: {
                ___genes: 'Affected genes within this region are ',
                ___OMIM: 'There are associated-diseases were found in OMIM, which are:',
                ___OMIM_empty: 'No gene associated-diseases were found in OMIM'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: 'Result Summary',
        ___variantContainerTitle: 'Related Diseases and Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___variantNotePlaceholder: 'Note',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar Database',
            ___ACMG: 'ACMG Guideline',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___Population_Databases: 'Population Databases',
            ___Prediction_Score: 'Prediction Score',
            ___Sequencing_Quality: 'Sequencing Quality'
          }
        },
        info: {
          title: {
            ___phenotypes: 'Phenotype',
            ___gene_panels: 'Gene Panels',
            ___related_genes: 'Gene'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: 'Position<br>(HG38)',
            ___custom_details_Rank: 'Exon/Intron',
            ___custom_details_HGVSm: 'HGVSm',
            ___custom_details_HGVSc: 'HGVSc',
            ___custom_details_HGVSp: 'HGVSp',
            ___custom_details_GT_AF: 'Heteroplasmy<br>Level (%)',
            ___custom_details_GT: 'Zygosity',
            ___custom_details_Consequence: 'Consequence',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: 'Parental<br>Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: 'TW Biobank',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_addAF: 'BayesDel addAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'CNV Result Summary',
        ___symbolContainerTitle: 'Related Gene',
        ___geneContainerTitle: 'Related Diseases ana Phenotypes',
        ___phenotypeTableEmpty: 'No Data',
        ___cnvNotePlaceholder: 'Note',
        cnvTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'Exon/Intron',
            ___Zygosity: 'Zygosity',
            ___Consequence: 'Consequence',
            ___Fragment_size: 'Fragment size',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: 'Phenotypes',
            ___id: 'OMIM number',
            ___Inheritance: 'Inheritance Patterns'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: 'Phenotypes',
            ___id: 'ORPHA number'
          }
        }
      },
      constitutionGene: {
        ___title: 'Constitution-related genes',
        ___subTitle: 'Many genes have been found to be associated with allergies, blood clots, and alcohol intolerance. This important information provides lifestyle precautions for you.',
        mainData: {
          testSummary: {
            ___title: 'Test summary'
          }
        },
        mainTable: {
          testingItems: {
            ___title: 'Detailed testing items'
          }
        },
        table: {
          title: {
            ___title: 'Items',
            ___SYMBOL: 'Gene',
            ___Location2: 'Position',
            ___Result: 'Results'
          },
          value: {
            Result: {
              ___true: 'Positive',
              ___false: 'Negative'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: 'Pharmacogenetics',
        ___subTitle: 'Pharmacogenetics provides doctors with references to choose the most suitable medication for individuals, preventing severe side effects and toxicity, and achieving the optimal treatment response. In the case of the same medication, some individuals may experience severe allergies or heightened side effects, which can be attributed to using medication or dosages that are not suitable for them.',
        customInfos: {
          ___info01: 'The genotype marked in red indicates the detected risk genotype.'
        },
        mainData: {
          testSummary: {
            ___title: 'Test summary'
          }
        },
        mainTable: {
          testingItems: {
            ___title: 'Detailed testing items'
          }
        },
        table: {
          title: {
            ___name: 'Chemicals',
            ___type: 'Type',
            ___SYMBOL: 'Gene',
            ___risk_genotype2: 'Position',
            ___clinical_phenotype: 'Clinical phenotype',
            ___Result: 'Results'
          },
          value: {
            Result: {
              ___true: 'Positive',
              ___false: 'Negative'
            }
          }
        }
      },
      detectMethod: {
        ___title: 'Test method/quality and analysis software versions',
        ___subTitle: 'Description of testing method',
        table: {
          title: {
            ___library_kit: 'Library preparation kit',
            ___sequencing_platform: 'Sequencing platform',
            ___sequencing_length: 'Sequencing length',
            ___average_sequencing_length: 'Sequencing throughput',
            ___pct_target_bases_xx: '10/20X coverage of target region',
            ___reference: 'Reference genome',
            ___alignment_version: 'Alignment software',
            ___variant_calling_version: 'Variant calling software',
            ___jannovar_version: 'Variant annotation software jANNOVAR',
            ___vep_version: 'Variant annotation software VEP',
            ___hpo_version: 'HPO version',
            ___omim_version: 'OMIM version',
            ___dbsnp_version: 'dbSNP version',
            ___clinvar_version: 'ClinVar version',
            ___mitomap_version: 'MITOMAP version',
            ___dbnsfp_version: 'dbNSFP version'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: 'Terminologies',
        list: {
          list01: {
            ___title: 'The reference genome used for this examination is GRCh38 (or hg38)'
          },
          list02: {
            ___title: '<b>Genotype</b>',
            detail: {
              detail01: {
                ___title: 'Homozygous: A homozygous genotype may include two normal alleles or two alleles that have the same variant.'
              },
              detail02: {
                ___title: 'Heterozygous: A heterozygous genotype may include one normal allele and one mutated allele or two different mutated alleles (compound heterozygote).'
              },
              detail03: {
                ___title: 'Hemizygous: A term that describes a person who has only one copy of a gene rather than the usual two copies. Hemizygosity can occur under normal conditions. For example, because most males have one X chromosome and one Y chromosome, they are hemizygous for genes on those chromosomes.'
              }
            }
          },
          list03: {
            ___title: '<b>Clinical significance</b>: Refer to ClinVar database interpretation or ACMG (2015) classification.',
            detail: {
              detail01: {
                ___title: 'Pathogenic: The variant of a given gene is pathogenic.'
              },
              detail02: {
                ___title: 'Likely pathogenic: The variant of a given gene is likely to be pathogenic.'
              },
              detail03: {
                ___title: 'Uncertain significance: The variant of a given gene is uncertain significance'
              },
              detail04: {
                ___title: 'Likely benign: The variant of a given gene is likely to be benign.'
              },
              detail05: {
                ___title: 'Benign： The variant of a given gene is benign.'
              },
              detail06: {
                ___title: 'Conflicting interpretations of pathogenicity:Only for submissions from a consortium, where groups within the consortium have conflicting interpretations of a variant but provide a single submission to ClinVar.'
              },
              detail07: {
                ___title: 'Disease-associated polymorphism: It has been reported that polymorphism in a particular gene is associated with the disease.'
              },
              detail08: {
                ___title: 'SNP:The allele frequency of the variant is greater than 1% in 1000 Genomes, and no related diseases have been reported.'
              },
              detail09: {
                ___title: 'Drug response: A general term for a variant that affects a drug response, not a disease.'
              }
            }
          },
          list04: {
            ___title: '<b>Refereces</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS: The allele frequency from the East Asian population of the 1000 Genomes project.'
              },
              detail02: {
                ___title: 'gnomAD EAS: The allele frequency from the East Asian population of the gnomAD project.'
              },
              detail03: {
                ___title: 'Taiwan BioBank: The allele frequency from Taiwan BioBank'
              },
              detail04: {
                ___title: 'References：If this variant has been reported in literature, the reference will list the first author, publication year, journal name, volume number, and starting page.'
              },
              detail05: {
                ___title: 'SIFT and PolyPhen-2 are two tools used to predict the clinical impact of amino acid variations. In SIFT, the prediction result is labeled as "damaging" or "tolerated", with the number in parentheses being the predicted result. In PolyPhen-2, the prediction result is labeled as "damaging", "possibly damaging", or "benign", with the number in parentheses being the predicted result. However, this prediction result lacks relevant evidence for protein or genomic research, and the accuracy of its predicted clinical significance cannot be confirmed, and is for reference only.'
              }
            }
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: 'List of Genes for Disease Diagnosis',
        ___title_lite: 'Gene List',
        ___geneListTitle01: 'The coverage of genes ≥ {cov}',
        ___geneListTitle02: 'The coverage of genes < {cov}'
      },
      attachmentASoHGGene: {
        ___title: 'ACMG Guideline'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/_report/tc/lang.js
/* harmony default export */ var tc_lang = ({
  // report
  REPORT: {
    chapter: {
      ___appendix: '附錄',
      title: {
        ___subject: '受檢者基本資訊',
        ___disease_diagnosis: '疾病診斷',
        ___disease_diagnosis_lite: '候選清單',
        ___active_screening: '主動篩查',
        ___cause_screening: '帶因篩查',
        ___acmg_incidental: 'ACMG偶然發現',
        ___custom1: '自訂頁面1',
        ___custom2: '自訂頁面2',
        ___custom3: '自訂頁面3',
        ___constitution: '體質相關基因',
        ___drug_meta: '藥物代謝',
        ___method: '檢測方法',
        ___appendix_disease_gene: '疾病診斷之基因清單',
        ___appendix_disease_gene_lite: '基因清單',
        ___appendix_us_gene: '美國人類遺傳學會規範之基因'
      },
      item: {
        title: {
          ___resultSummary: '結果表格',
          ___interpretation: '文字說明'
        },
        variant: {
          ___empty: '尚未加入任何位點'
        }
      },
      header: {
        ___info01: 'Report Date',
        ___info02: 'Sample ID'
      },
      footer: {
        ___info01: '＊ 本報告內容須經專業醫療人員解釋。',
        ___info02: '300 新竹市東區慈雲路118號17樓之10 | 康百事生物資訊 | 03-574-5009'
      },
      basicInfo: {
        ___title: '受檢者基本資訊',
        form: {
          title: {
            ___case_id: '姓名',
            ___sex: '性別',
            ___age: '年齡',
            ___testing_date: '檢測日期',
            ___testing_category: '檢測種類',
            ___sequencing_range: '定序範圍',
            ___sequencing_tech: '定序技術',
            ___doctor_name: '送檢醫師',
            ___organization: '機構院所',
            ___medical_number: '病歷號',
            ___family_medical_history: '備註'
          }
        }
      },
      variantResult: {
        mainData: {
          default: {
            ___title: '文字說明',
            ___contentTitle01: '本次基因檢測中，共發現 <b>{count}</b> 個基因攜帶可能致病的突變',
            ___contentTitle02: '其中<b> {count} </b>個位於粒線體 DNA 區域',
            detail: {
              title: {
                ___ClinVar: 'ClinVar 資料庫登載為',
                ___ClinVar_empty: 'ClinVar 資料庫無登載',
                ___ACMG: 'ACMG 指南預測為',
                ___OMIM: 'OMIM 資料庫記載可能相關的疾病為，',
                ___OMIM_empty: 'OMIM 資料庫未記載可能相關的疾病',
                ___Orphanet: 'Orphanet 資料庫記載可能相關的疾病為，',
                ___Orphanet_empty: 'Orphanet 資料庫未記載可能相關的疾病'
              }
            }
          },
          cnv: {
            ___title: 'CNV文字說明',
            ___contentTitle01: '本次基因檢測中，共發現 <b>{count}</b> 個區域產生可能致病的突變',
            detail: {
              title: {
                ___genes: '該區域涵蓋之相關基因為',
                ___OMIM: 'OMIM 資料庫記載可能相關的疾病為，',
                ___OMIM_empty: 'OMIM 資料庫未記載可能相關的疾病'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: '結果表格',
        ___variantContainerTitle: '相關疾病與表型',
        ___phenotypeTableEmpty: '無資料',
        ___variantNotePlaceholder: '備註',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar登載',
            ___ACMG: 'ACMG指南預測',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___Population_Databases: '變異頻率',
            ___Prediction_Score: '蛋白質功能預測',
            ___Sequencing_Quality: '定序品質'
          }
        },
        info: {
          title: {
            ___phenotypes: '臨床表徵',
            ___gene_panels: '基因套組',
            ___related_genes: '基因範圍'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: '位置',
            ___custom_details_Rank: '外顯子/<br>內含子編號',
            ___custom_details_HGVSm: '核苷酸變異位點<br>HGVSm',
            ___custom_details_HGVSc: '核苷酸變異位點<br>HGVSc',
            ___custom_details_HGVSp: '胺基酸變異位點<br>HGVSp',
            ___custom_details_GT_AF: '異質性程度 (%)',
            ___custom_details_GT: '合子型',
            ___custom_details_Consequence: '變異類型',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: 'Parental<br>Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '臨床表徵',
            ___id: 'OMIM表徵編號',
            ___Inheritance: '遺傳模式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '臨床表徵',
            ___id: 'ORPHA表徵編號'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: '台灣人基因型頻率',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_addAF: 'BayesDel addAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'CNV 結果表格',
        ___symbolContainerTitle: '相關基因',
        ___geneContainerTitle: '相關疾病與表型',
        ___phenotypeTableEmpty: '無資料',
        ___cnvNotePlaceholder: '備註',
        cnvTable: {
          title: {
            ___Position: '變異區域',
            ___Exon_Intron: '外顯子 / 內含子編號',
            ___Zygosity: '合子型',
            ___Consequence: '變異類型',
            ___Fragment_size: '片段大小',
            ___Parental_Origin: 'Parental Origin'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '臨床表徵',
            ___id: 'OMIM表徵編號',
            ___Inheritance: '遺傳模式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '臨床表徵',
            ___id: 'ORPHA表徵編號'
          }
        }
      },
      constitutionGene: {
        ___title: '體質相關基因',
        ___subTitle: '許多基因被發現與過敏、⾎栓、酒精不耐有關，這些重要資訊能提醒你更多⽣活注意事項。',
        mainData: {
          testSummary: {
            ___title: '檢測結果說明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '詳細檢測項目'
          }
        },
        table: {
          title: {
            ___title: '檢測項目',
            ___SYMBOL: '檢測基因',
            ___Location2: '檢測位點',
            ___Result: '檢測結果'
          },
          value: {
            Result: {
              ___true: '檢出',
              ___false: '未檢出'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: '藥物代謝分析',
        ___subTitle: '藥物相關基因可提供醫師作為參考，選擇對⾃⼰最適合的藥物，預防嚴重副作⽤、毒性，並達到最佳的治療反應。同⼀種藥物，有些⼈⽤藥後全⾝過敏或副作⽤特別強，是因為⽤了不適合⾃⼰的藥物或劑量。',
        customInfos: {
          ___info01: '紅色標示之基因型為檢測出之風險基因型。'
        },
        mainData: {
          testSummary: {
            ___title: '檢測結果說明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '詳細檢測項目'
          }
        },
        table: {
          title: {
            ___name: '藥物名稱',
            ___type: '藥物作用',
            ___SYMBOL: '檢測基因',
            ___risk_genotype2: '檢測位點',
            ___clinical_phenotype: '臨床意義',
            ___Result: '檢測結果'
          },
          value: {
            Result: {
              ___true: '檢出',
              ___false: '未檢出'
            }
          }
        }
      },
      detectMethod: {
        ___title: '檢測方法、檢測品質與分析軟體版本資訊',
        ___subTitle: '檢測方法說明',
        table: {
          title: {
            ___library_kit: '樣本庫試劑組',
            ___sequencing_platform: '定序平台',
            ___sequencing_length: '定序長度',
            ___average_sequencing_length: '平均定序深度',
            ___pct_target_bases_xx: '所有定序範圍內之<br>20X檢測覆蓋率',
            ___reference: '參考序列',
            ___alignment_version: '序列比對<br>Alignment軟體',
            ___variant_calling_version: '序列比對<br>Variant Calling軟體',
            ___jannovar_version: '變異點位註解軟體<br>jANNOVAR 版本',
            ___vep_version: '變異點位註解軟體<br>VEP 版本',
            ___hpo_version: 'HPO版本',
            ___omim_version: 'OMIM版本',
            ___dbsnp_version: 'dbSNP版本',
            ___clinvar_version: 'ClinVar版本',
            ___mitomap_version: 'MITOMAP版本',
            ___dbnsfp_version: 'dbNSFP 版本'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: '檢測方法注釋',
        list: {
          list01: {
            ___title: '檢測結果比對參考序列為人類GRCh38 (或稱 hg38) 版本。'
          },
          list02: {
            ___title: '<b>基因型 (genotype)</b>',
            detail: {
              detail01: {
                ___title: 'Homozygous：在2條相對的對偶基因(allele)中，皆出現此基因變異位點。'
              },
              detail02: {
                ___title: 'Heterozygous：此基因變異位點僅出於1條對偶基因中，另1條對偶基因上無位點變異。'
              },
              detail03: {
                ___title: 'Hemizygous：在男性受測者中，因僅有1條X或Y染色體，稱為半合子。若基因變異位點出現於性染色體上，則以Hemizygous表示之。'
              }
            }
          },
          list03: {
            ___title: '<b>臨床意義 (clinical significance)</b>：主要引用ClinVar資料庫註解或依據2015年版ACMG準則進行分類',
            detail: {
              detail01: {
                ___title: 'Pathogenic：此基因變異位點具致病性。'
              },
              detail02: {
                ___title: 'Likely pathogenic：此基因變異位點可能具致病性。'
              },
              detail03: {
                ___title: 'Uncertain significance：此基因變異位點對於臨床上的影響目前尚無定論。'
              },
              detail04: {
                ___title: 'Likely benign：此基因變異位點可能不具致病性。'
              },
              detail05: {
                ___title: 'Benign：此基因變異位點不具致病性。'
              },
              detail06: {
                ___title: 'Conflicting interpretations of pathogenicity：此基因變異位點對於臨床上影響程度的定義並未有一致性解釋，有的文獻認為具致病性，有的文獻則認為不具致病性。'
              },
              detail07: {
                ___title: 'Disease-associated polymorphism：有文獻報導此基因多型性與疾病有顯著相關性。'
              },
              detail08: {
                ___title: 'SNP：在1000 Genomes資料庫中，此基因變異點在東南族群 (East Asian, EAS) 的發生比例大於1%，並無與疾病相關之文獻報導。'
              },
              detail09: {
                ___title: 'Drug response：此基因變異位點會影響藥物反應，可能干擾藥物療效或藥物副作用的產生與否有關。'
              }
            }
          },
          list04: {
            ___title: '<b>參考資料</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS：在1000 Genomes資料庫中，為此基因變異位點在東亞族 (East Asian, EAS) 的基因型比例。'
              },
              detail02: {
                ___title: 'gnomAD EAS：在 gnomAD 資料庫，為此基因變異位點在東亞族 (East Asian, EAS) 的基因型比例。'
              },
              detail03: {
                ___title: 'Taiwan BioBank: 在臺灣人體生物資料庫中，為此基因變異位點的基因型比例。臨床意義正確性仍無法確認，僅供參考。'
              },
              detail04: {
                ___title: '參考文獻：報導過此突變位點文獻，會列出文獻第一作者、出版年份、期刊名稱、卷號、和起始碼。'
              },
              detail05: {
                ___title: 'SIFT 與 PolyPhen-2 為預測胺基酸變異對於臨床上影響程度的 2 種統計工具。在 SIFT 中將預測結果標示為「有害」(Damaing) 或「無害」(Tolerated)，括弧內的數字為統計結果 ; 在 PolyPhen-2 中，將預測結果標示為「有害」(Damaging)、「可能有害」(Possibly damaging) 和「無害」(Benign)，括弧內的數字為統計結果，然而此預測結果缺乏對於蛋白質或基因學研究的相關證據，其預測出的臨床意義正確性仍無法確認，僅供參考。'
              }
            }
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: '疾病診斷之基因清單',
        ___title_lite: '基因清單',
        ___geneListTitle01: '覆蓋率 ≥ {cov}之基因',
        ___geneListTitle02: '覆蓋率未達{cov}之基因'
      },
      attachmentASoHGGene: {
        ___title: '美國人類遺傳學會規範之基因清單'
      }
    }
  }
});
// CONCATENATED MODULE: ./src/constants/lang/i18n.js





vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

var locale = localStorage.getItem('locale') || 'tc';

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: locale,
  messages: { ren: lang, rtc: tc_lang }
});

/* harmony default export */ var lang_i18n = (i18n);
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./src/constants/font/font.sass
var font = __webpack_require__("bPG1");
var font_default = /*#__PURE__*/__webpack_require__.n(font);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









vee_validate_esm["a" /* Validator */].extend('youtubeLink', {
  getMessage: function getMessage() {
    return '';
  },
  validate: function validate(value) {
    return (/(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
    );
  }
});

__webpack_require__("DBs5");
__webpack_require__("598Q");

vue_esm["default"].config.productionTip = false;

vue_esm["default"].component('item', {
  template: '\n    <li>\n      <div class="mask"></div>\n      <div class="line-container">\n        <div class="line"></div>\n      </div>\n      <div class="item-container row-block" :class="{ open: tree.type === \'folder\' && open && !disabled, selected: selected && !disabled, disabled: disabled }" @click.stop="e => !disabled && toggle()">\n        <div class="item-icon" v-if="tree.title">\n          <img :src="tree.type === \'folder\' ? open ? icons.open : icons.close : selected ? icons.select : icons.file" alt="">\n        </div>\n        <div :style="{ width: \'5px\' }"></div>\n        <div class="item-title shrink">{{ tree.title }}</div>\n        <div :style="{ flex: 1 }"></div>\n        <img v-if="tree.type === \'file\' && !disabled && options.checkbox !== false" class="item-check" :src="selected ? icons.boxtrue : icons.boxfalse">\n      </div>\n      <ul v-show="open" v-if="Object.keys(tree.nodes || {}).length > 0 && !disabled">\n        <div class="line"></div>\n        <item v-for="(node, title, index) in tree.nodes" :key="index" :tree="{ ...node, title: title }" :options="options" :icons="icons" :currentPath="currentPath" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit(\'select\', path)">\n        </item>\n      </ul>\n    </li>\n  ',
  props: {
    tree: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: Array,
      required: true
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      open: this.currentPath.includes(this.tree.title) || !this.tree.title
    };
  },

  computed: {
    selected: function selected() {
      return this.selectedPaths.includes(this.tree.path);
    },
    disabled: function disabled() {
      return this.disabledPaths.includes(this.tree.path);
    }
  },
  methods: {
    toggle: function toggle() {
      switch (this.tree.type) {
        case 'folder':
          {
            if (this.tree.title) {
              this.open = !this.open;
            }
            break;
          }
        case 'file':
          {
            if (this.tree.title) {
              this.$emit('select', this.tree.path);
            }
          }
      }
    }
  }
});

vue_esm["default"].component('treeList', {
  template: '\n    <ul id="root" :class="{ \'no-root\': !treeData.title }">\n      <item :tree="treeData" :options="options" :icons="icons" :currentPath="(currentPath || \'\').split(\'/\')" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit(\'select\', path)"></item>\n    </ul>\n  ',
  props: {
    treeData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  }
});

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  store: store,
  i18n: lang_i18n,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "NMi8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE2IDE0Ij4KICA8cGF0aCBpZD0idGFibGUtbGlnaHQiIGQ9Ik0xNC41LDMySDEuNUExLjUsMS41LDAsMCwwLDAsMzMuNXYxMUExLjUsMS41LDAsMCwwLDEuNSw0NmgxM0ExLjUsMS41LDAsMCwwLDE2LDQ0LjV2LTExQTEuNSwxLjUsMCwwLDAsMTQuNSwzMlpNNSw0NUgxLjVhLjUuNSwwLDAsMS0uNS0uNVY0Mkg1Wm0wLTRIMVYzOEg1Wm0wLTRIMVYzNEg1Wm01LDhINlY0Mmg0Wm0wLTRINlYzOGg0Wm0wLTRINlYzNGg0Wm01LDV2Mi41YS41LjUsMCwwLDEtLjUuNUgxMVY0MlptMC0xSDExVjM4aDRabTAtNEgxMVYzNGg0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMzIpIiBmaWxsPSIjOTk5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "O+D1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0i44Kw44Or44O844OXXzMxNDIiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDMxNDIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogIDxwYXRoIGlkPSJjaGVjay1zcXVhcmUtc29saWQiIGQ9Ik0xNy44NTcsNTJIMi4xNDNBMi4xNDMsMi4xNDMsMCwwLDEsMCw0OS44NTdWMzQuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDIuMTQzLDMySDE3Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwyMCwzNC4xNDNWNDkuODU3QTIuMTQzLDIuMTQzLDAsMCwxLDE3Ljg1Nyw1MlpNOC43MTksNDcuNjIybDguMjE0LTguMjE0YS43MTQuNzE0LDAsMCwwLDAtMS4wMWwtMS4wMS0xLjAxYS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtNi43LDYuN0w1LjA4Nyw0MC45NTlhLjcxNC43MTQsMCwwLDAtMS4wMSwwbC0xLjAxLDEuMDFhLjcxNC43MTQsMCwwLDAsMCwxLjAxbDQuNjQzLDQuNjQzQS43MTQuNzE0LDAsMCwwLDguNzE5LDQ3LjYyMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMyKSIgZmlsbD0ibm9uZSIvPgogIDxnIGlkPSLjgrDjg6vjg7zjg5dfMzMwMyIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgMzMwMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5NzIgLTE1MzMpIj4KICAgIDxnIGlkPSLjg5HjgrlfNDY5IiBkYXRhLW5hbWU9IuODkeOCuSA0NjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5NzIgMTUzMykiIGZpbGw9IiNmZmYiPgogICAgICA8cGF0aCBkPSJNIDE3IDE5LjUgTCAzIDE5LjUgQyAxLjYyMTUwMDAxNTI1ODc4OSAxOS41IDAuNSAxOC4zNzg0OTk5ODQ3NDEyMSAwLjUgMTcgTCAwLjUgMyBDIDAuNSAxLjYyMTUwMDAxNTI1ODc4OSAxLjYyMTUwMDAxNTI1ODc4OSAwLjUgMyAwLjUgTCAxNyAwLjUgQyAxOC4zNzg0OTk5ODQ3NDEyMSAwLjUgMTkuNSAxLjYyMTUwMDAxNTI1ODc4OSAxOS41IDMgTCAxOS41IDE3IEMgMTkuNSAxOC4zNzg0OTk5ODQ3NDEyMSAxOC4zNzg0OTk5ODQ3NDEyMSAxOS41IDE3IDE5LjUgWiIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxwYXRoIGQ9Ik0gMyAxIEMgMS44OTcxOTk2MzA3MzczMDUgMSAxIDEuODk3MTk5NjMwNzM3MzA1IDEgMyBMIDEgMTcgQyAxIDE4LjEwMjgwMDM2OTI2MjcgMS44OTcxOTk2MzA3MzczMDUgMTkgMyAxOSBMIDE3IDE5IEMgMTguMTAyODAwMzY5MjYyNyAxOSAxOSAxOC4xMDI4MDAzNjkyNjI3IDE5IDE3IEwgMTkgMyBDIDE5IDEuODk3MTk5NjMwNzM3MzA1IDE4LjEwMjgwMDM2OTI2MjcgMSAxNyAxIEwgMyAxIE0gMyAwIEwgMTcgMCBDIDE4LjY1Njg1MDgxNDgxOTM0IDAgMjAgMS4zNDMxNDkxODUxODA2NjQgMjAgMyBMIDIwIDE3IEMgMjAgMTguNjU2ODUwODE0ODE5MzQgMTguNjU2ODUwODE0ODE5MzQgMjAgMTcgMjAgTCAzIDIwIEMgMS4zNDMxNDkxODUxODA2NjQgMjAgMCAxOC42NTY4NTA4MTQ4MTkzNCAwIDE3IEwgMCAzIEMgMCAxLjM0MzE0OTE4NTE4MDY2NCAxLjM0MzE0OTE4NTE4MDY2NCAwIDMgMCBaIiBzdHJva2U9Im5vbmUiIGZpbGw9IiMzMzMiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJ0aW1lcy1zcXVhcmUtcmVndWxhciIgZD0iTTE0LjU0NSwzOS4yMjMsMTEuNzY4LDQybDIuNzc3LDIuNzc3YS41MzYuNTM2LDAsMCwxLDAsLjc1OWwtMS4wMDksMS4wMDlhLjUzNi41MzYsMCwwLDEtLjc1OSwwTDEwLDQzLjc2OCw3LjIyMyw0Ni41NDVhLjUzNi41MzYsMCwwLDEtLjc1OSwwTDUuNDU1LDQ1LjUzNmEuNTM2LjUzNiwwLDAsMSwwLS43NTlMOC4yMzIsNDIsNS40NTUsMzkuMjIzYS41MzYuNTM2LDAsMCwxLDAtLjc1OWwxLjAwOS0xLjAwOWEuNTM2LjUzNiwwLDAsMSwuNzU5LDBMMTAsNDAuMjMybDIuNzc3LTIuNzc3YS41MzYuNTM2LDAsMCwxLC43NTksMGwxLjAwOSwxLjAwOWEuNTM2LjUzNiwwLDAsMSwwLC43NTlaTTIwLDM0LjE0M1Y0OS44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzWk0xNy44NTcsNDkuNTg5VjM0LjQxMWEuMjY5LjI2OSwwLDAsMC0uMjY4LS4yNjhIMi40MTFhLjI2OS4yNjksMCwwLDAtLjI2OC4yNjhWNDkuNTg5YS4yNjkuMjY5LDAsMCwwLC4yNjguMjY4SDE3LjU4OUEuMjY5LjI2OSwwLDAsMCwxNy44NTcsNDkuNTg5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2NjYyIvPgogICAgPGcgaWQ9IumVt+aWueW9ol8xNDgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDE0OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTMzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIzIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "OCMH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEyMTUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEyMTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTQ2NyAzMjcwKSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyMzgiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyMzgiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU0NjcgLTMyNzApIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0iZmlsZS1hbHQtbGlnaHQiIGQ9Ik0xMS41NTcsMi45NjIsOC45MzYuMzQxQTEuNSwxLjUsMCwwLDAsNy44NzctLjFIMS41QTEuNSwxLjUsMCwwLDAsMCwxLjR2MTNhMS41LDEuNSwwLDAsMCwxLjUsMS41aDlBMS41LDEuNSwwLDAsMCwxMiwxNC40VjQuMDI0YTEuNTA3LDEuNTA3LDAsMCwwLS40NDEtMS4wNjJabS0uNzA2LjcwOWEuNDkyLjQ5MiwwLDAsMSwuMTMxLjIzMUg4Vi45MTlhLjQ5Mi40OTIsMCwwLDEsLjIzMS4xMzFaTTEwLjUsMTQuOWgtOWEuNS41LDAsMCwxLS41LS41VjEuNEEuNS41LDAsMCwxLDEuNS45SDdWNC4xNTJhLjc0OC43NDgsMCwwLDAsLjc1Ljc1SDExdjkuNUEuNS41LDAsMCwxLDEwLjUsMTQuOVpNOSw3LjI3N3YuMjVhLjM3Ni4zNzYsMCwwLDEtLjM3NS4zNzVIMy4zNzRBLjM3Ni4zNzYsMCwwLDEsMyw3LjUyN3YtLjI1QS4zNzYuMzc2LDAsMCwxLDMuMzc0LDYuOUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDcuMjc3Wm0wLDJ2LjI1YS4zNzYuMzc2LDAsMCwxLS4zNzUuMzc1SDMuMzc0QS4zNzYuMzc2LDAsMCwxLDMsOS41MjZ2LS4yNUEuMzc2LjM3NiwwLDAsMSwzLjM3NCw4LjlIOC42MjNBLjM3Ni4zNzYsMCwwLDEsOSw5LjI3NlptMCwydi4yNWEuMzc2LjM3NiwwLDAsMS0uMzc1LjM3NUgzLjM3NEEuMzc2LjM3NiwwLDAsMSwzLDExLjUyNnYtLjI1YS4zNzYuMzc2LDAsMCwxLC4zNzUtLjM3NUg4LjYyM0EuMzc2LjM3NiwwLDAsMSw5LDExLjI3NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NDcxIC0zMjY3LjkpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNmN2Y3ZjciIHN0cm9rZS13aWR0aD0iMC4yNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "OlcD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE2IDE0Ij4KICA8cGF0aCBpZD0idGFibGUtbGlnaHQiIGQ9Ik0xNC41LDMySDEuNUExLjUsMS41LDAsMCwwLDAsMzMuNXYxMUExLjUsMS41LDAsMCwwLDEuNSw0NmgxM0ExLjUsMS41LDAsMCwwLDE2LDQ0LjV2LTExQTEuNSwxLjUsMCwwLDAsMTQuNSwzMlpNNSw0NUgxLjVhLjUuNSwwLDAsMS0uNS0uNVY0Mkg1Wm0wLTRIMVYzOEg1Wm0wLTRIMVYzNEg1Wm01LDhINlY0Mmg0Wm0wLTRINlYzOGg0Wm0wLTRINlYzNGg0Wm01LDV2Mi41YS41LjUsMCwwLDEtLjUuNUgxMVY0MlptMC0xSDExVjM4aDRabTAtNEgxMVYzNGg0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMzIpIiBmaWxsPSIjOTk5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "P6mg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/loginData.vue




/* harmony default export */ var loginData = ({
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setUserAction', 'setLoginAction', 'setUserInfoAction']), {
    setUserData: function setUserData(response, token) {
      this.setUserAction(response ? response.data.user || response.data.data : null);
      this.setLoginAction(!!response);
      this.setUserInfo(token || (response ? response.data.auth : null));
    },
    setUserInfo: function setUserInfo(token) {
      if (token) {
        // let expiry = new Date(token.expired_at) - new Date()
        var info = {
          access_token: token.access_token
        };
        this.setUserInfoAction(info);
        this.$ls.set('userInfo', info);
      } else {
        this.setUserInfoAction(null);
        this.$ls.remove('userInfo');
      }
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/loginData.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  loginData,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_loginData = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PKnz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pbv1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgdmlld0JveD0iMCAwIDYwIDYwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzcwNzgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDcwNzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNjApIHJvdGF0ZSgtOTApIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMjkxNCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMjkxNCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0iY2hldnJvbi1kb3duLXJlZ3VsYXIiIGQ9Ik0zMS43NDUsMS40NzQsMzAuMzE1LjIyM2EuOTU4Ljk1OCwwLDAsMC0xLjIyOCwwTDE2LDExLjYzOSwyLjkxNC4yMjNhLjk1OC45NTgsMCwwLDAtMS4yMjgsMEwuMjU1LDEuNDc0YS42OTMuNjkzLDAsMCwwLDAsMS4wNzRsMTUuMTMxLDEzLjIzYS45NTguOTU4LDAsMCwwLDEuMjI4LDBMMzEuNzQ1LDIuNTQ4QS42OTMuNjkzLDAsMCwwLDMxLjc0NSwxLjQ3NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ2IDM4KSByb3RhdGUoMTgwKSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDUzNjc5IiBzdHJva2Utd2lkdGg9IjAuNSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Qd2E":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "RBQ8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0i44Kw44Or44O844OXXzMxNDIiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDMxNDIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogIDxnIGlkPSLplbfmlrnlvaJfMTQ4IiBkYXRhLW5hbWU9IumVt+aWueW9oiAxNDgiIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIj4KICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjMiIHN0cm9rZT0ibm9uZSIvPgogICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIuNSIgZmlsbD0ibm9uZSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "RCqP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE2LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE2LjUiPgogIDxwYXRoIGlkPSJpbmZvLWNpcmNsZS1saWdodCIgZD0iTTE2LDkuMDMyQTYuOTY4LDYuOTY4LDAsMSwxLDkuMDMyLDE2LDYuOTY5LDYuOTY5LDAsMCwxLDE2LDkuMDMyTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFpNMTQuODM5LDE5LjFoLjM4N1YxNS4yMjZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gxLjU0OGEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N1YxOS4xaC4zODdhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODd2LjI1OGEuMzg3LjM4NywwLDAsMS0uMzg3LjM4N0gxNC44MzlhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4QS4zODcuMzg3LDAsMCwxLDE0LjgzOSwxOS4xWk0xNiwxMS4zNTVhMS4wMzIsMS4wMzIsMCwxLDAsMS4wMzIsMS4wMzJBMS4wMzIsMS4wMzIsMCwwLDAsMTYsMTEuMzU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNzUgLTcuNzUpIiBmaWxsPSIjZmEzZDNkIiBzdHJva2U9IiNmYTNkM2QiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "Rp0L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE2LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE2LjUiPgogIDxwYXRoIGlkPSJpbmZvLWNpcmNsZS1saWdodCIgZD0iTTE2LDkuMDMyQTYuOTY4LDYuOTY4LDAsMSwxLDkuMDMyLDE2LDYuOTY5LDYuOTY5LDAsMCwxLDE2LDkuMDMyTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFpNMTQuODM5LDE5LjFoLjM4N1YxNS4yMjZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gxLjU0OGEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N1YxOS4xaC4zODdhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODd2LjI1OGEuMzg3LjM4NywwLDAsMS0uMzg3LjM4N0gxNC44MzlhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4QS4zODcuMzg3LDAsMCwxLDE0LjgzOSwxOS4xWk0xNiwxMS4zNTVhMS4wMzIsMS4wMzIsMCwxLDAsMS4wMzIsMS4wMzJBMS4wMzIsMS4wMzIsMCwwLDAsMTYsMTEuMzU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNzUgLTcuNzUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "RzRW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiMzNDljY2YiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "SQy7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "SRag":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iQ2FyZGlvbG9neSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzMzUgNDM4KSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI5MjMiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI5MjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMzUgLTQzOCkiIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzcwNzA3MCIgc3Ryb2tlLXdpZHRoPSIxIiBvcGFjaXR5PSIwIj4KICAgICAgPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPHBhdGggaWQ9IkNhcmRpb2xvZ3ktMiIgZGF0YS1uYW1lPSJDYXJkaW9sb2d5IiBkPSJNMjUuNjIsMTIuMzg2QTguNDUsOC40NSwwLDAsMCwxNSwxNC40MSw4LjQ4Myw4LjQ4MywwLDAsMCwuNDE5LDIyLjQ3NGE3LjgzNSw3LjgzNSwwLDAsMCwuNTY4LDEuNjA5SDYuNDZsMS4zNzMtMi4zMTFhMS4xMzMsMS4xMzMsMCwwLDEsMS45MjgtLjAzNmwxLjk4MiwzLjA3LDIuNDM3LTYuNjE3YTEuMTM2LDEuMTM2LDAsMCwxLDEuMDYzLS43NDZoMGExLjEzNywxLjEzNywwLDAsMSwxLjA2NS43NDRsMi4xODQsNS45aDMuNzU2YTEuMTQxLDEuMTQxLDAsMCwxLDAsMi4yODJIMTcuNzA3YTEuMTQyLDEuMTQyLDAsMCwxLTEuMDY2LS43NDJsLTEuMzkxLTMuNzU2LTIuMTU5LDUuODY3YTEuMTM4LDEuMTM4LDAsMCwxLS45MzkuNzM4LDEuMjA2LDEuMjA2LDAsMCwxLS4xMjQuMDA3LDEuMTQxLDEuMTQxLDAsMCwxLS45NTQtLjUxOUw4Ljg1MiwyNC41MTZsLS43NywxLjI5NGExLjE0LDEuMTQsMCwwLDEtLjk3Ni41NTdIMi4zNjlDNi40MjUsMzEuOTExLDE1LDM3LjMyOSwxNSwzNy4zMjlzMTMuMTI1LTguMjg3LDE0LjU3OS0xNC44NTVBOC41Myw4LjUzLDAsMCwwLDI1LjYyLDEyLjM4NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMzUgLTQ0Ni4zMjkpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "SY89":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SkAt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "T0+N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ROOT; });
var API_ROOT = 'https://api-dev.inherinext.compassbioinfo.com/';
// export const API_ROOT = 'https://api-local-dev.inherinext.compassbioinfo.com/'
// export const API_ROOT = 'https://server.inherinext.com/'

/***/ }),

/***/ "TqmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/customGrab.vue




/* harmony default export */ var customGrab = ({
  data: function data() {
    return {
      lineData: {
        x: {
          min: null,
          max: null,
          main: null,
          custom: null
        },
        y: {
          min: null,
          max: null,
          main: null,
          custom: null
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    keys_default()(this.boardData).forEach(function (id) {
      _this.boardInit(id);
    });
  },

  methods: {
    boardInit: function boardInit(id) {
      var boardData = {
        grabID: -1,
        grabType: '',
        grabTarget: null,
        baseX: 0,
        grabX: 0,
        baseY: 0,
        grabY: 0
      };
      this.boardData[id] = extends_default()({}, this.boardData[id], boardData);
    },
    boardEvent: function boardEvent(id, e, functions) {
      // rect
      var targetData = e.target.getBoundingClientRect();
      var containerData = e.currentTarget.getBoundingClientRect();
      // line
      var lx = targetData.x - containerData.x + targetData.width / 2;
      var ly = targetData.y - containerData.y + targetData.height / 2;
      // grab
      var grabID = e.target.getAttribute('grab-id');
      grabID = grabID || grabID === 0 ? grabID - 0 : -1;
      var grabType = (e.target.getAttribute('grab-type') || '').split('*');
      var grabXMin = (e.target.getAttribute('grab-x-min') || '').split('*');
      grabXMin = grabXMin.length && grabXMin[0] ? {
        value: lx - Math.max(Math.min(lx, grabXMin[0] - 0), 0),
        display: grabXMin.length <= 1
      } : {
        value: lx - (0 + targetData.width / 2),
        display: false
      };
      var grabXMax = (e.target.getAttribute('grab-x-max') || '').split('*');
      grabXMax = grabXMax.length && grabXMax[0] ? {
        value: Math.min(Math.max(lx, grabXMax[0] - 0), containerData.width) - lx,
        display: grabXMax.length <= 1
      } : {
        value: containerData.width - targetData.width / 2 - lx,
        display: false
      };
      var grabXCustom = (e.target.getAttribute('grab-x-custom') || '').split('*');
      grabXCustom = grabXCustom.length && grabXCustom[0] ? {
        value: Math.min(Math.max(0, grabXCustom[0] - 0), containerData.width),
        display: grabXCustom.length <= 1
      } : {
        value: containerData.width - targetData.width / 2 - lx,
        display: false
      };
      var grabYMin = (e.target.getAttribute('grab-y-min') || '').split('*');
      grabYMin = grabYMin.length && grabYMin[0] ? {
        value: ly - Math.max(Math.min(ly, grabYMin[0] - 0), 0),
        display: grabYMin.length <= 1
      } : {
        value: ly - (0 + targetData.height / 2),
        display: false
      };
      var grabYMax = (e.target.getAttribute('grab-y-max') || '').split('*');
      grabYMax = grabYMax.length && grabYMax[0] ? {
        value: Math.min(Math.max(ly, grabYMax[0] - 0), containerData.width) - ly,
        display: grabYMax.length <= 1
      } : {
        value: containerData.height - targetData.height / 2 - ly,
        display: false
      };
      var grabYCustom = (e.target.getAttribute('grab-y-custom') || '').split('*');
      grabYCustom = grabYCustom.length && grabYCustom[0] ? {
        value: Math.min(Math.max(0, grabYCustom[0] - 0), containerData.width),
        display: grabYCustom.length <= 1
      } : {
        value: containerData.width - targetData.width / 2 - lx,
        display: false
      };
      var cx = Math.max(Math.min(e.clientX - containerData.x, containerData.width), 0);
      var cy = Math.max(Math.min(e.clientY - containerData.y, containerData.height), 0);
      // data
      var grabData = {
        id: grabID,
        type: grabType[0],
        xRange: [grabXMin, grabXMax, grabXCustom],
        yRange: [grabYMin, grabYMax, grabYCustom],
        target: e.target,
        x: cx,
        y: cy
      };
      var lineData = {
        x: lx,
        y: ly,
        display: grabType.length <= 1
        // f
      };var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(functions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var f = _step.value;

          f(id, grabData, lineData);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    boardStart: function boardStart(id, grabData, lineData) {
      if (grabData.id >= 0 && grabData.type) {
        this.boardData[id].grabID = grabData.id;
        this.boardData[id].grabType = grabData.type;
        this.boardData[id].grabTarget = grabData.target;
        if (['all', 'x'].includes(grabData.type)) {
          this.boardData[id].baseX = this.boardData[id].grabX = grabData.x;
          this.lineData.x.main = {
            base: lineData.x,
            grab: 0,
            display: lineData.display
          };
          if (grabData.xRange[0]) {
            this.lineData.x.min = {
              value: lineData.x - grabData.xRange[0].value,
              display: grabData.xRange[0].display
            };
          }
          if (grabData.xRange[1]) {
            this.lineData.x.max = {
              value: lineData.x + grabData.xRange[1].value,
              display: grabData.xRange[1].display
            };
          }
          if (grabData.xRange[2]) {
            this.lineData.x.custom = {
              value: grabData.xRange[2].value,
              display: grabData.xRange[2].display
            };
          }
        }
        if (['all', 'y'].includes(grabData.type)) {
          this.boardData[id].baseY = this.boardData[id].grabY = grabData.y;
          this.lineData.y.main = {
            base: lineData.y,
            grab: 0,
            display: lineData.display
          };
          if (grabData.yRange[0]) {
            this.lineData.y.min = {
              value: lineData.y - grabData.yRange[0].value,
              display: grabData.yRange[0].display
            };
          }
          if (grabData.yRange[1]) {
            this.lineData.y.max = {
              value: lineData.y + grabData.yRange[1].value,
              display: grabData.yRange[1].display
            };
          }
          if (grabData.yRange[2]) {
            this.lineData.y.custom = {
              value: grabData.yRange[2].value,
              display: grabData.yRange[2].display
            };
          }
        }
        (this.boardData[id].onStart || function () {})(extends_default()({}, this.boardData[id]));
      }
    },
    boardMove: function boardMove(id, grabData) {
      if (this.boardData[id].grabID >= 0) {
        if (['all', 'x'].includes(this.boardData[id].grabType)) {
          var grabX = grabData.x;
          var lineGrab = this.boardData[id].grabX - this.boardData[id].baseX;
          if (this.lineData.x.min) {
            grabX = Math.max(grabX, this.lineData.x.min.value - this.lineData.x.main.base + this.boardData[id].baseX);
            lineGrab = Math.max(lineGrab, this.lineData.x.min.value - this.lineData.x.main.base);
          }
          if (this.lineData.x.max) {
            grabX = Math.min(grabX, this.lineData.x.max.value - this.lineData.x.main.base + this.boardData[id].baseX);
            lineGrab = Math.min(lineGrab, this.lineData.x.max.value - this.lineData.x.main.base);
          }
          this.boardData[id].grabX = grabX;
          this.lineData.x.main.grab = lineGrab;
        }
        if (['all', 'y'].includes(this.boardData[id].grabType)) {
          var grabY = grabData.y;
          var _lineGrab = this.boardData[id].grabY - this.boardData[id].baseY;
          if (this.lineData.y.min) {
            grabY = Math.max(grabY, this.lineData.y.min.value - this.lineData.y.main.base + this.boardData[id].baseY);
            _lineGrab = Math.max(_lineGrab, this.lineData.y.min.value - this.lineData.y.main.base);
          }
          if (this.lineData.y.max) {
            grabY = Math.min(grabY, this.lineData.y.max.value - this.lineData.y.main.base + this.boardData[id].baseY);
            _lineGrab = Math.min(_lineGrab, this.lineData.y.max.value - this.lineData.y.main.base);
          }
          this.boardData[id].grabY = grabY;
          this.lineData.y.main.grab = _lineGrab;
        }
        (this.boardData[id].onMove || function () {})(extends_default()({}, this.boardData[id]));
      }
    },
    boardEnd: function boardEnd(id) {
      if (this.boardData[id].grabID >= 0) {
        (this.boardData[id].onEnd || function () {})(extends_default()({}, this.boardData[id]));
      }
      this.boardInit(id);
      this.lineData = {
        x: {
          min: null,
          max: null,
          main: null
        },
        y: {
          min: null,
          max: null,
          main: null
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/customGrab.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  customGrab,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_customGrab = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V8EM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMC4zIiBoZWlnaHQ9IjMwLjMyNCIgdmlld0JveD0iMCAwIDMwLjMgMzAuMzI0Ij4KICA8cGF0aCBpZD0iRW5kb2NyaW5vbG9neSIgZD0iTTcwOS41ODYtMjIuMDg3bC42MzUtNS4xMDYtNS42MDUtMy4yODMtNS43NzYsMy4zODNMNjkyLjUtMzAuOHYtNy40MjJsNi4zMzYtMy43MTIsNS40MzgsMy4xODUtLjY1LTQuOTcxSDcwNS42bC0uNjE3LDQuOTUxLDQuODQ1LTIuODM3di02Ljc2Nmw2LjMzNi0zLjcxMSw2LjMzNiwzLjcxMXY3LjQyM2wtNS43NzUsMy4zODN2NS44MThsMi44NjYsMS42NzgtLjMyLjU2M0w3MTYuNzI5LTMxdi4ybC0uMi4xMTcsMi41NiwxLjUtLjMyLjU2My0yLjg4MS0xLjY4Ny01LjM1NywzLjEzNy42NjYsNS4wODhabS4zNjQtLjMyNWguODgybC0uNDUyLTMuNDU3Wk03MDUuMTc3LTM3LjU3djYuMTFsNS4yMTYsMy4wNTUsNS4yMTUtMy4wNTVWLTM3LjU3bC01LjIxNi0zLjA1NlptLTExLjU1MiwwdjYuMTFsNS4yMTUsMy4wNTUsNS4yMTYtMy4wNTV2LTYuMTFsLTUuMjE2LTMuMDU1Wm0xNy4zMjgtMTAuMTQ4djYuMTA5bDUuMjE2LDMuMDU1LDUuMjE1LTMuMDU1di02LjEwOWwtNS4yMTUtMy4wNTVabS0xNi43LDE1Ljg1LjQ0NS0uNzgxLDQuOCwyLjgxLS40NDUuNzgxWk03MDkuODY4LTM5LjFsLjQ0NS0uNzgxLDQuOCwyLjgwOS0uNDQ1Ljc4MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02OTIuMzU0IDUyLjI2KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMC4zIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "VBfA":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "WBdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/customTimeout.vue




/* harmony default export */ var customTimeout = ({
  data: function data() {
    return {
      r_timer: {},
      d_timer: {}
    };
  },

  methods: {
    customRecursive: function customRecursive() {
      var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return false;
      };

      var _this = this;

      var defaultTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var key = arguments[2];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var recursive;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                key = key || new Date().toJSON();

                recursive = function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                    var time;
                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return func();

                          case 2:
                            time = _context.sent;

                            if (time) {
                              time = typeof time === 'number' && time > 0 ? time : defaultTime;
                              _this.r_timer[key] = setTimeout(recursive, time);
                            }

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function recursive() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context2.next = 4;
                return recursive();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    customDelay: function customDelay() {
      var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      var _this2 = this;

      var defaultTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var key = arguments[2];
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                key = key || new Date().toJSON();
                if (_this2.d_timer[key]) {
                  clearTimeout(_this2.d_timer[key]);
                }
                _this2.d_timer[key] = setTimeout(func, defaultTime);
                return _context3.abrupt('return', key);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    [values_default()(this.r_timer), values_default()(this.d_timer)].forEach(function (timer) {
      return clearTimeout(timer);
    });
  }
});
// CONCATENATED MODULE: ./src/mixins/customTimeout.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  customTimeout,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_customTimeout = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WGo8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDIwIDE0Ij4KICA8cGF0aCBpZD0iY2xvdWQtdXBsb2FkLXNvbGlkIiBkPSJNMTYuOCwzOC4wODFBMywzLDAsMCwwLDE0LDM0YTIuOTg1LDIuOTg1LDAsMCwwLTEuNjY2LjUwNkE1LDUsMCwwLDAsMywzN2MwLC4wODQsMCwuMTY5LjAwNi4yNTNBNC41LDQuNSwwLDAsMCw0LjUsNDZIMTZhNCw0LDAsMCwwLC44LTcuOTE5Wm0tNC4zNzIsMS45OTEtLjMzNy4zMzhhLjc1My43NTMsMCwwLDEtMS4wNzgtLjAxNkwxMCwzOS4zMTZWNDMuMjVhLjc0OC43NDgsMCwwLDEtLjc1Ljc1aC0uNUEuNzQ4Ljc0OCwwLDAsMSw4LDQzLjI1VjM5LjMxNkw2Ljk4OCw0MC4zOTRhLjc1Ljc1LDAsMCwxLTEuMDc4LjAxNmwtLjMzOC0uMzM4YS43NDcuNzQ3LDAsMCwxLDAtMS4wNTlsMi45LTIuOWEuNzQ3Ljc0NywwLDAsMSwxLjA1OSwwbDIuOSwyLjlBLjc1Ljc1LDAsMCwxLDEyLjQyOCw0MC4wNzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "XE98":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iT3RoZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00OTMgLTMzNSkiPgogICAgPHJlY3QgaWQ9IumVt+aWueW9ol8xMzU2IiBkYXRhLW5hbWU9IumVt+aWueW9oiAxMzU2IiB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ5MyAzMzUpIiBmaWxsPSIjZGNkY2RjIiBvcGFjaXR5PSIwIi8+CiAgICA8ZyBpZD0i44Kw44Or44O844OXXzIxNzgiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDIxNzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY1IC0xOSkiPgogICAgICA8cGF0aCBpZD0i5ZCI5L2TXzIwIiBkYXRhLW5hbWU9IuWQiOS9kyAyMCIgZD0iTTE5LjI0OSwyNmExLjM0MiwxLjM0MiwwLDAsMS0xLjM0LTEuMzQyVjIwLjE4YTEuMzQyLDEuMzQyLDAsMCwxLDEuMzQtMS4zNDRoNC40ODRhMS4zNDIsMS4zNDIsMCwwLDEsMS4zNCwxLjM0NHY0LjQ3N0ExLjM0MiwxLjM0MiwwLDAsMSwyMy43MzIsMjZabS04Ljk1NCwwYTEuMzQyLDEuMzQyLDAsMCwxLTEuMzQtMS4zNDJWMjAuMThhMS4zNDIsMS4zNDIsMCwwLDEsMS4zNC0xLjM0NGg0LjQ4NGExLjM0MSwxLjM0MSwwLDAsMSwxLjM0LDEuMzQ0djQuNDc3QTEuMzQxLDEuMzQxLDAsMCwxLDE0Ljc3OCwyNlpNMS4zNCwyNkExLjM0MiwxLjM0MiwwLDAsMSwwLDI0LjY1N1YyMC4xOGExLjM0MiwxLjM0MiwwLDAsMSwxLjM0LTEuMzQ0SDUuODI1QTEuMzQxLDEuMzQxLDAsMCwxLDcuMTYzLDIwLjE4djQuNDc3QTEuMzQsMS4zNCwwLDAsMSw1LjgyNSwyNlptOC45NTQtOC45NTRBMS4zNDEsMS4zNDEsMCwwLDEsOC45NTQsMTUuN1YxMS4yMjVhMS4zNDIsMS4zNDIsMCwwLDEsMS4zNC0xLjM0NGg0LjQ4NGExLjM0MSwxLjM0MSwwLDAsMSwxLjM0LDEuMzQ0VjE1LjdhMS4zNCwxLjM0LDAsMCwxLTEuMzQsMS4zNDJabS04Ljk1NCwwQTEuMzQxLDEuMzQxLDAsMCwxLDAsMTUuN1YxMS4yMjVBMS4zNDIsMS4zNDIsMCwwLDEsMS4zNCw5Ljg4Mkg1LjgyNWExLjM0MSwxLjM0MSwwLDAsMSwxLjMzOCwxLjM0NFYxNS43YTEuMzQsMS4zNCwwLDAsMS0xLjMzOCwxLjM0MlptMTkuMi04LjQxOEwxNy4zNzIsNS40NTZhMS4zNCwxLjM0LDAsMCwxLDAtMS45TDIwLjU0LjM5NGExLjM0MiwxLjM0MiwwLDAsMSwxLjksMGwzLjE3MSwzLjE3MWExLjM0LDEuMzQsMCwwLDEsMCwxLjlMMjIuNDQsOC42MjZhMS4zNDIsMS4zNDIsMCwwLDEtMS45LDBaTTEuMzQsOC4wOTJBMS4zNDIsMS4zNDIsMCwwLDEsMCw2Ljc0OFYyLjI3MUExLjM0MiwxLjM0MiwwLDAsMSwxLjM0LjkyOUg1LjgyNUExLjM0LDEuMzQsMCwwLDEsNy4xNjMsMi4yNzFWNi43NDhBMS4zNDEsMS4zNDEsMCwwLDEsNS44MjUsOC4wOTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MzAgMzU2KSIgZmlsbD0iI2ZmZiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "Xb65":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE0IDE2Ij4KICA8cGF0aCBpZD0iZmlsZXMtbWVkaWNhbC1saWdodCIgZD0iTTEzLjU2MSwyLjA2MSwxMS45MzkuNDM5QTEuNSwxLjUsMCwwLDAsMTAuODc5LDBINS41QTEuNSwxLjUsMCwwLDAsNCwxLjVWM0gxLjVBMS41LDEuNSwwLDAsMCwwLDQuNXYxMEExLjUsMS41LDAsMCwwLDEuNSwxNmg3QTEuNSwxLjUsMCwwLDAsMTAsMTQuNVYxM2gyLjVBMS41LDEuNSwwLDAsMCwxNCwxMS41VjMuMTIxYTEuNSwxLjUsMCwwLDAtLjQzOS0xLjA2MVpNMTEsMS4wMTVhLjUuNSwwLDAsMSwuMjMyLjEzMWwxLjYyMSwxLjYyMUEuNS41LDAsMCwxLDEyLjk4NSwzSDExWk05LDE0LjVhLjUuNSwwLDAsMS0uNS41aC03YS41LjUsMCwwLDEtLjUtLjVWNC41QS41LjUsMCwwLDEsMS41LDRINHY3LjVBMS41LDEuNSwwLDAsMCw1LjUsMTNIOVptNC0zYS41LjUsMCwwLDEtLjUuNWgtN2EuNS41LDAsMCwxLS41LS41VjEuNUEuNS41LDAsMCwxLDUuNSwxSDEwVjMuMjVhLjc1Mi43NTIsMCwwLDAsLjc1Ljc1SDEzWk05LjgzMyw1LjcwOEEuMjA4LjIwOCwwLDAsMCw5LjYyNSw1LjVIOC4zNzVhLjIwOC4yMDgsMCwwLDAtLjIwOC4yMDhWNy4xNjdINi43MDhhLjIwOC4yMDgsMCwwLDAtLjIwOC4yMDh2MS4yNWEuMjA4LjIwOCwwLDAsMCwuMjA4LjIwOEg4LjE2N3YxLjQ1OGEuMjA4LjIwOCwwLDAsMCwuMjA4LjIwOGgxLjI1YS4yMDguMjA4LDAsMCwwLC4yMDgtLjIwOFY4LjgzM2gxLjQ1OGEuMjA4LjIwOCwwLDAsMCwuMjA4LS4yMDhWNy4zNzVhLjIwOC4yMDgsMCwwLDAtLjIwOC0uMjA4SDkuODMzWiIgZmlsbD0iIzk5OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Z77G":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzcwMzkiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDcwMzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0ibWludXMtc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDMySDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwwLDAsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMCwxLjkyOSw1MEgxNi4wNzFBMS45MjksMS45MjksMCwwLDAsMTgsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMCwxNi4wNzEsMzJaTTMuNyw0Mi42MDdhLjQ4NC40ODQsMCwwLDEtLjQ4Mi0uNDgydi0yLjI1YS40ODQuNDg0LDAsMCwxLC40ODItLjQ4MkgxNC4zYS40ODQuNDg0LDAsMCwxLC40ODIuNDgydjIuMjVhLjQ4NC40ODQsMCwwLDEtLjQ4Mi40ODJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTcyIDE1MDEpIiBmaWxsPSIjODBjNTFkIi8+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI4MDYiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI4MDYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5NzIgMTUzMykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIj4KICAgICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMTciIGhlaWdodD0iMTciIHJ4PSIxLjUiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "ZM3o":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0ibWludXMtY2lyY2xlLXNvbGlkIiBkPSJNMTUsOGE3LDcsMCwxLDAsNyw3QTcsNywwLDAsMCwxNSw4Wm0tMy43MjYsOC4xMjlhLjM0LjM0LDAsMCwxLS4zMzktLjMzOVYxNC4yMWEuMzQuMzQsMCwwLDEsLjMzOS0uMzM5aDcuNDUyYS4zNC4zNCwwLDAsMSwuMzM5LjMzOVYxNS43OWEuMzQuMzQsMCwwLDEtLjMzOS4zMzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAtOCkiIGZpbGw9IiNmYTNkM2QiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "a5p7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aYau":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE0LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE0LjUiPgogIDxwYXRoIGlkPSJ0aC1saXN0LWxpZ2h0IiBkPSJNMCwzMy41djExQTEuNSwxLjUsMCwwLDAsMS41LDQ2aDEzQTEuNSwxLjUsMCwwLDAsMTYsNDQuNXYtMTFBMS41LDEuNSwwLDAsMCwxNC41LDMySDEuNUExLjUsMS41LDAsMCwwLDAsMzMuNVptMTUsMHYyLjgzM0g2VjMzaDguNUEuNS41LDAsMCwxLDE1LDMzLjVabTAsNy4xNjdINlYzNy4zMzNoOVpNMSwzNy4zMzNINXYzLjMzM0gxWk01LDMzdjMuMzMzSDFWMzMuNWEuNS41LDAsMCwxLC41LS41Wk0xLDQ0LjVWNDEuNjY3SDVWNDVIMS41QS41LjUsMCwwLDEsMSw0NC41Wk02LDQ1VjQxLjY2N2g5VjQ0LjVhLjUuNSwwLDAsMS0uNS41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yNSAtMzEuNzUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "b/41":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bCWW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi41IiBoZWlnaHQ9IjYuNTU1IiB2aWV3Qm94PSIwIDAgMTIuNSA2LjU1NSI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTEuOS41NTMsMTEuMzY4LjA4NGEuMzU5LjM1OSwwLDAsMC0uNDYxLDBMNiw0LjM2NSwxLjA5My4wODRhLjM1OS4zNTksMCwwLDAtLjQ2MSwwTC4xLjU1M2EuMjYuMjYsMCwwLDAsMCwuNEw1Ljc3LDUuOTE2YS4zNTkuMzU5LDAsMCwwLC40NjEsMEwxMS45Ljk1NUEuMjYuMjYsMCwwLDAsMTEuOS41NTNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4yNSA2LjI3Nykgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiIHN0cm9rZT0iIzA1MzY3OSIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "bPG1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bxm6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cEaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "cmUn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ "fRKO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fsHt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fujj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gijb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+CiAgPHBhdGggaWQ9IuWkmuinkuW9ol81MyIgZGF0YS1uYW1lPSLlpJrop5LlvaIgNTMiIGQ9Ik01LjIsMS4wNjdhMSwxLDAsMCwxLDEuNiwwbDQsNS4zMzNBMSwxLDAsMCwxLDEwLDhIMmExLDEsMCwwLDEtLjgtMS42WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIgOCkgcm90YXRlKDE4MCkiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "gvao":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./acmg-checkbox-benign-strong.svg": "xg5u",
	"./acmg-checkbox-benign-supporting.svg": "RzRW",
	"./acmg-checkbox-disabled.svg": "O+D1",
	"./acmg-checkbox-empty.svg": "RBQ8",
	"./acmg-checkbox-pathogenic-moderate.svg": "qfup",
	"./acmg-checkbox-pathogenic-strong.svg": "xMCn",
	"./acmg-checkbox-pathogenic-supporting.svg": "MsWW",
	"./acmg-checkbox-pathogenic-very-strong.svg": "5Ggm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gvao";

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return getSearchPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return getSearchGeneEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getGenePanelDivisions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getGenePanelHpo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getGenePanelCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getGenePanelSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getManagedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getExchangeRates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return getToolVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getOmicss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getMethodDescriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getGeneSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getGeneMTSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return getVariantDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return getSummaryVariantDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return getSummaryCNVVariantDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getMissensePrediction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getCnvGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getGeneOmimPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getGeneOrphanetPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getGeneClinvarStatistic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return getUserAvatarFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getDatasetPictureFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return postEmailCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return postEmailConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getEnableUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return postEnableUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getCoverageRates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return putDisimJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return getUserToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return postUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return postConfirmUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return postRegisterUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return postForgetUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return getResetUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return postResetUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return putUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return putUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return getUserAvatarFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return postUserAvatarFile; });
/* unused harmony export deleteUserAvatarFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return getUserSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return putUserSettings; });
/* unused harmony export putReportUserSettings */
/* unused harmony export putCloudSpaceUserSettings */
/* unused harmony export putAvatarUserSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getPointEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getOrders; });
/* unused harmony export getOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return postOrder; });
/* unused harmony export getOrderPaymentPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getPhenotypePanels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return postPhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return putPhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return deletePhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return postAddToPhenotypePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deletePhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getGenePanels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return postGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return putGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteGenePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return postHistoryPanel; });
/* unused harmony export postSendGenePanel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getFilterConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return postFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return putFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteFilterConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return postCaseSampleFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getCaseSampleFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getCaseAnalysisFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getCloudFilePaths; });
/* unused harmony export getCloudFileLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return postCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return putCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getCaseTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getCaseIgvData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getCaseCovGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getCaseCoverages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getCaseLinkedDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return postCaseRestartPipeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return postProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return putProjectInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return putProjectPhenotype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deleteProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getCaseProjectReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getCaseProjectCandidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return postCaseProjectCandidate; });
/* unused harmony export deleteCaseProjectCandidate */
/* unused harmony export getCaseProjectReporting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return postCaseProjectReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteCaseProjectReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return putCaseProjectReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteCaseProjectReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getCaseMonitorReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return postCaseMonitorReport; });
/* unused harmony export postCaseMonitorReportBySource */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteCaseMonitorReport; });
/* unused harmony export deleteCaseMonitorReportBySource */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getCaseMonitorCandidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return postCaseMonitorCandidate; });
/* unused harmony export deleteCaseMonitorCandidate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getCaseMonitorReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return postCaseMonitorReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteCaseMonitorReporting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return putCaseMonitorReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteCaseMonitorReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getCaseMonitorReportSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return putCaseMonitorReportSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return postCaseFilterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getCaseFilterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getCaseFilterTableQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getCaseFilterState; });
/* unused harmony export getCaseFilterReporting */
/* unused harmony export postCaseFilterReporting */
/* unused harmony export deleteCaseFilterReporting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return postCaseFilterMonitorReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getCaseFilterReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return putCaseFilterReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteCaseFilterReportACMGTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getExportFilterTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getReportSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return putReportSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getReportSettingsConstitution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getReportSettingsConstitutionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getReportSettingsDrugMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return getReportSettingsDrugMetaSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getReportSettingsCovGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return getReportSettingsIncidentalFindingGenes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return getReportSettingsVariantQualityDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getReportSettingExportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getCommunityDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return getSharedWithMeDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getMyShareDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getFullAccessDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return postDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return putDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteDataset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getDatasetTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getCreateDatasetCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getCheckDatasetPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getDatasetPictureFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return postDatasetPictureFile; });
/* unused harmony export deleteDatasetPictureFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getDatasetExistingState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getDatasetCases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getDatasetArchiveAffectedDatasets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getDatasetShares; });
/* unused harmony export getDatasetShare */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return putDatasetShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteDatasetShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getDatasetAccessKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return postDatasetAccessKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getDatasetInvitationTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return postDatasetInvitationToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getDatasetConfirmInvitation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return postDatasetConfirmInvitation; });
/* unused harmony export getDatasetConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return putDatasetConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return postDatasetSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return postDatasetSummaryNF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("T452");






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

// auto complete
var getSearchPhenotype = function getSearchPhenotype(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/phenotypes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query }) });
};
var getSearchGeneEntry = function getSearchGeneEntry(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_panel_entries', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query }) });
};
var getGenePanelDivisions = function getGenePanelDivisions(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_panel_divisions', { params: config });
};
var getGenePanelHpo = function getGenePanelHpo(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/hpo_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query }) });
};
var getGenePanelCondition = function getGenePanelCondition(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/condition_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query }) });
};
var getGenePanelSymbol = function getGenePanelSymbol(query, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_symbols', { q: query }, { params: config });
};
var getManagedUsers = function getManagedUsers(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/managed_users', { params: config });
};
var getExchangeRates = function getExchangeRates(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/exchange_rates', { params: config });
};
var getProducts = function getProducts(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/products', { params: config });
};
var getToolVersions = function getToolVersions(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/tool_versions', { params: config });
};
var getOmicss = function getOmicss(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/omics', { params: config });
};
var getMethodDescriptions = function getMethodDescriptions(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/method_description', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getGeneSummary = function getGeneSummary(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/gene_summary', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getGeneMTSummary = function getGeneMTSummary(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/medlineplus_gene_function', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getVariantDescription = function getVariantDescription(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/variant_description', data, { params: config });
};
var getSummaryVariantDescription = function getSummaryVariantDescription(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/summary_variant_description', data, { params: config });
};
var getSummaryCNVVariantDescription = function getSummaryCNVVariantDescription(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/summary_cnv_variant_description', data, { params: config });
};
var getMissensePrediction = function getMissensePrediction(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/missense_prediction_with_color', data, { params: config });
};
var getCnvGenes = function getCnvGenes(query, chrm, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/cnv_gene_symbols', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { q: query, on_chrm: chrm }) });
};
var getGeneOmimPhenotype = function getGeneOmimPhenotype(geneID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/omim_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { gene_id: geneID }) });
};
var getGeneOrphanetPhenotype = function getGeneOrphanetPhenotype(geneID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/orphanet_genes', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { gene_id: geneID }) });
};
var getGeneClinvarStatistic = function getGeneClinvarStatistic(geneID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/clinvar_gene_stats', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { entrez: geneID }) });
};
var getUserAvatarFiles = function getUserAvatarFiles(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/avatar_files', { params: config });
};
var getDatasetPictureFiles = function getDatasetPictureFiles(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'ac/dataset_picture_files', { params: config });
};
// verify
var postEmailCode = function postEmailCode(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/send_email_confirmation_code', data);
};
var postEmailConfirm = function postEmailConfirm(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/confirm_email', data);
};
var getEnableUser = function getEnableUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/enable_user', { params: data });
};
var postEnableUser = function postEnableUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/enable_user', data);
};
// coverage rate
var getCoverageRates = function getCoverageRates() {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('https://storage.googleapis.com/inherinext-public/KAPA_V6_data_merge.txt');
};
// phenotype disease
var getDisimJob = function getDisimJob(lineToken) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'line/disim_query_jobs/current', { params: { line_access_token: lineToken } });
};
var putDisimJob = function putDisimJob(phenotypes, lineToken) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'line/disim_query_jobs/current', { phenotypes: phenotypes }, { params: { line_access_token: lineToken } });
};
// user
var getUserToken = function getUserToken(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current', { params: config });
};
var postUser = function postUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_in', data);
};
var postConfirmUser = function postConfirmUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/confirm_sign_in', data);
};
var deleteUser = function deleteUser(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_out', { params: config });
};
var postRegisterUser = function postRegisterUser(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/sign_up', data);
};
var postForgetUserPassword = function postForgetUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/forgot_password', data);
};
var getResetUserPassword = function getResetUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/reset_password', { params: data });
};
var postResetUserPassword = function postResetUserPassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/reset_password', data);
};
var putUser = function putUser(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current', data, { params: config });
};
var putUserPassword = function putUserPassword(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/password', data, { params: config });
};
// user avatar
var getUserAvatarFile = function getUserAvatarFile(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/avatar_file', { params: config });
};
var postUserAvatarFile = function postUserAvatarFile(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/avatar_file', data, { params: config });
};
var deleteUserAvatarFile = function deleteUserAvatarFile(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'users/current/avatar_file', { params: config });
};
// user setting
var getUserSettings = function getUserSettings(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting', { params: config });
};
var putUserSettings = function putUserSettings(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting', data, { params: config });
};
var putReportUserSettings = function putReportUserSettings(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting/report_preview_af_columns', data, { params: config });
};
var putCloudSpaceUserSettings = function putCloudSpaceUserSettings(path, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting/cloudspace_browse_path', { path: path }, { params: config });
};
var putAvatarUserSettings = function putAvatarUserSettings(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'user_setting/avatar_file', { id: id }, { params: config });
};
// point event
var getPointEvent = function getPointEvent(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'point_events', { params: config });
};
// order
var getOrders = function getOrders(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders', { params: config });
};
var getOrder = function getOrder(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders/' + id, { params: config });
};
var postOrder = function postOrder(prodoctID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders', { product_id: prodoctID }, { params: config });
};
var getOrderPaymentPage = function getOrderPaymentPage(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'orders/' + id + '/payment', { params: config });
};
// phenotype panel
var getPhenotypePanels = function getPhenotypePanels(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels', { params: config });
};
var postPhenotypePanel = function postPhenotypePanel(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels', data, { params: config });
};
var putPhenotypePanel = function putPhenotypePanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels/' + id, data, { params: config });
};
var deletePhenotypePanel = function deletePhenotypePanel(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels/' + id, { params: config });
};
var postAddToPhenotypePanel = function postAddToPhenotypePanel(id, type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotype_panels/' + id + '/phenotypes/' + type, data, { params: config });
};
var deletePhenotype = function deletePhenotype(id, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'phenotypes/' + type + '/' + id, { params: config });
};
// gene panel
var getGenePanels = function getGenePanels(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
var getGenePanel = function getGenePanel(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id, { params: config });
};
var postGenePanel = function postGenePanel(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels', data, { params: config });
};
var putGenePanel = function putGenePanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id, data, { params: config });
};
var deleteGenePanel = function deleteGenePanel(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id, { params: config });
};
var postHistoryPanel = function postHistoryPanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id + '/history', data, { params: config });
};
var postSendGenePanel = function postSendGenePanel(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'gene_panels/' + id + '/send_result', data, { params: config });
};
// filter conifg
var getFilterConfigs = function getFilterConfigs(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs', { params: config });
};
var getFilterConfig = function getFilterConfig(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs/' + id, { params: config });
};
var postFilterConfig = function postFilterConfig(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs', data, { params: config });
};
var putFilterConfig = function putFilterConfig(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs/' + id, data, { params: config });
};
var deleteFilterConfig = function deleteFilterConfig(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'filter_configs/' + id, { params: config });
};
// data file
var postCaseSampleFile = function postCaseSampleFile(id, dataset, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/sample_files/' + dataset, data, { params: config });
};
var getCaseSampleFiles = function getCaseSampleFiles(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/sample_files', { params: config });
};
var getCaseAnalysisFiles = function getCaseAnalysisFiles(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/analysis_files', { params: config });
};
// cloud file
var getCloudFilePaths = function getCloudFilePaths(config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cloudspace/paths', { params: config });
};
var getCloudFileLink = function getCloudFileLink(path, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cloudspace/paths', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ path: path }, config) });
};
// case
var getCases = function getCases(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
var getCase = function getCase(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id, { params: config });
};
var postCase = function postCase(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases', data, { params: config });
};
var putCase = function putCase(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id, data, { params: config });
};
var deleteCase = function deleteCase(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params) });
};
var getCaseTimeout = function getCaseTimeout(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/job_timeout', { params: config });
};
var getCaseIgvData = function getCaseIgvData(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/igv_data', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
var getCaseCovGenes = function getCaseCovGenes(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/cov_genes', { params: config });
};
var getCaseCoverages = function getCaseCoverages(id, locations, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/coverage', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ location: locations }, config) });
};
var getCaseLinkedDatasets = function getCaseLinkedDatasets(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/linked_datasets', { params: config });
};
var postCaseRestartPipeline = function postCaseRestartPipeline(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/restart_variant_discovery_pipeline_job', {}, { params: config });
};
// project
var getProjects = function getProjects(caseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects', { params: config });
};
var getProject = function getProject(id, caseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id, { params: config });
};
var postProject = function postProject(caseID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects', data, { params: config });
};
var putProjectInfo = function putProjectInfo(id, caseID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id + '/info', data, { params: config });
};
var putProjectPhenotype = function putProjectPhenotype(id, caseID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id + '/phenotypes', data, { params: config });
};
var deleteProject = function deleteProject(id, caseID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + caseID + '/projects/' + id, { params: config });
};
// gene
var getCaseProjectReport = function getCaseProjectReport(id, projectID, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_report', { params: config });
};
var getCaseProjectCandidate = function getCaseProjectCandidate(id, projectID, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_candidates', { params: config });
};
var postCaseProjectCandidate = function postCaseProjectCandidate(id, projectID, type, symbol, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_candidates/' + symbol, data, { params: config });
};
var deleteCaseProjectCandidate = function deleteCaseProjectCandidate(id, projectID, type, symbol, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_candidates/' + symbol, { params: config });
};
var getCaseProjectReporting = function getCaseProjectReporting(id, projectID, type, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting', { params: config });
};
var postCaseProjectReporting = function postCaseProjectReporting(id, projectID, type, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting/' + symbol, { var_id: vkey }, { params: config });
};
var deleteCaseProjectReporting = function deleteCaseProjectReporting(id, projectID, type, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_reporting/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { var_id: vkey }) });
};
var putCaseProjectReportACMGTag = function putCaseProjectReportACMGTag(id, projectID, type, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_report/acmg_tags', data, { params: config });
};
var deleteCaseProjectReportACMGTag = function deleteCaseProjectReportACMGTag(id, projectID, type, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/projects/' + projectID + '/' + type + '_report/acmg_tags', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
// monitor
var getCaseMonitorReport = function getCaseMonitorReport(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report', { params: config });
};
var postCaseMonitorReport = function postCaseMonitorReport(id, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/' + symbol, { var_id: vkey }, { params: config });
};
var postCaseMonitorReportBySource = function postCaseMonitorReportBySource(id, symbol, source, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/' + symbol, { source: source }, { params: config });
};
var deleteCaseMonitorReport = function deleteCaseMonitorReport(id, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { var_id: vkey }) });
};
var deleteCaseMonitorReportBySource = function deleteCaseMonitorReportBySource(id, symbol, source, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ source: source }, config) });
};
var getCaseMonitorCandidate = function getCaseMonitorCandidate(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_candidates', { params: config });
};
var postCaseMonitorCandidate = function postCaseMonitorCandidate(id, symbol, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_candidates/' + symbol, data, { params: config });
};
var deleteCaseMonitorCandidate = function deleteCaseMonitorCandidate(id, symbol, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_candidates/' + symbol, { params: config });
};
var getCaseMonitorReporting = function getCaseMonitorReporting(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting', { params: config });
};
var postCaseMonitorReporting = function postCaseMonitorReporting(id, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting/' + symbol, { var_id: vkey }, { params: config });
};
var deleteCaseMonitorReporting = function deleteCaseMonitorReporting(id, symbol, vkey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_reporting/' + symbol, { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { var_id: vkey }) });
};
var putCaseMonitorReportACMGTag = function putCaseMonitorReportACMGTag(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/acmg_tags', data, { params: config });
};
var deleteCaseMonitorReportACMGTag = function deleteCaseMonitorReportACMGTag(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/acmg_tags', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
var getCaseMonitorReportSetting = function getCaseMonitorReportSetting(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report_settings', { params: config });
};
var putCaseMonitorReportSetting = function putCaseMonitorReportSetting(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report_settings', data, { params: config });
};
// filter
var postCaseFilterTable = function postCaseFilterTable(id, filterConfigID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/table', filterConfigID ? { filter_config_id: filterConfigID } : {}, { params: config });
};
var getCaseFilterTable = function getCaseFilterTable(id, filterConfigID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/table', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filterConfigID ? { filter_config_id: filterConfigID } : {}, config) });
};
var getCaseFilterTableQuery = function getCaseFilterTableQuery(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/table/query', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
var getCaseFilterState = function getCaseFilterState(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/custom_filter_query_job', { params: config });
};
var getCaseFilterReporting = function getCaseFilterReporting(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter_reporting', { params: config });
};
var postCaseFilterReporting = function postCaseFilterReporting(id, symbol, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter_reporting', { data: symbol }, { params: config });
};
var deleteCaseFilterReporting = function deleteCaseFilterReporting(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter_reporting', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var postCaseFilterMonitorReport = function postCaseFilterMonitorReport(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/monitor_report/filter', { data: data }, { params: config });
};
var getCaseFilterReportACMGTag = function getCaseFilterReportACMGTag(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/acmg_tags', { params: config });
};
var putCaseFilterReportACMGTag = function putCaseFilterReportACMGTag(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/acmg_tags', data, { params: config });
};
var deleteCaseFilterReportACMGTag = function deleteCaseFilterReportACMGTag(id, params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/acmg_tags', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
var getExportFilterTable = function getExportFilterTable(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/filter/table/export', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
// report
var getReportSettings = function getReportSettings(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var putReportSettings = function putReportSettings(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings', data, { params: config });
};
var getReportSettingsConstitution = function getReportSettingsConstitution(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/constitution', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getReportSettingsConstitutionSummary = function getReportSettingsConstitutionSummary(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/constitution_summary', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getReportSettingsDrugMeta = function getReportSettingsDrugMeta(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/drug_meta', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getReportSettingsDrugMetaSummary = function getReportSettingsDrugMetaSummary(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/drug_meta_summary', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, data) });
};
var getReportSettingsCovGenes = function getReportSettingsCovGenes(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/cov_genes', { params: config });
};
var getReportSettingsIncidentalFindingGenes = function getReportSettingsIncidentalFindingGenes(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/incidental_finding_genes', { params: config });
};
var getReportSettingsVariantQualityDescription = function getReportSettingsVariantQualityDescription(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/variant_quality_description', data, { params: config });
};
var getReportSettingExportReport = function getReportSettingExportReport(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/' + id + '/report_settings/export_report', { responseType: 'blob', params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, config) });
};
// dataset population
var getDatasets = function getDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params) });
};
var getCommunityDatasets = function getCommunityDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/community', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params) });
};
var getSharedWithMeDatasets = function getSharedWithMeDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/shared_with_me', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params) });
};
var getMyShareDatasets = function getMyShareDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/my_shares', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params) });
};
var getFullAccessDatasets = function getFullAccessDatasets(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/full_access', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params) });
};
var getDataset = function getDataset(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id, { params: config });
};
var postDataset = function postDataset(data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets', data, { params: config });
};
var putDataset = function putDataset(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id, data, { params: config });
};
var deleteDataset = function deleteDataset(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id, { params: config });
};
var getDatasetTimeout = function getDatasetTimeout(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/job_timeout', { params: config });
};
var getCreateDatasetCases = function getCreateDatasetCases(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'cases/dataset_creation', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, config) });
};
var getCheckDatasetPermission = function getCheckDatasetPermission(id) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/permissions', {});
};
var getDatasetPictureFile = function getDatasetPictureFile(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_picture_file', { params: config });
};
var postDatasetPictureFile = function postDatasetPictureFile(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_picture_file', data, { params: config });
};
var deleteDatasetPictureFile = function deleteDatasetPictureFile(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_picture_file', { params: config });
};
var getDatasetExistingState = function getDatasetExistingState(params, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/existing_state', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, params) });
};
var getDatasetCases = function getDatasetCases(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/linked_cases', { params: config });
};
var getDatasetArchiveAffectedDatasets = function getDatasetArchiveAffectedDatasets(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/archive_affected_datasets', { params: config });
};
var getDatasetShares = function getDatasetShares(datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares', { params: config });
};
var getDatasetShare = function getDatasetShare(id, datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares/' + id, { params: config });
};
var putDatasetShare = function putDatasetShare(id, datasetID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares/' + id, data, { params: config });
};
var deleteDatasetShare = function deleteDatasetShare(id, datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_shares/' + id, { params: config });
};
var getDatasetAccessKey = function getDatasetAccessKey(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/access_key', { params: config });
};
var postDatasetAccessKey = function postDatasetAccessKey(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/access_key', {}, { params: config });
};
var getDatasetInvitationTokens = function getDatasetInvitationTokens(datasetID, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_invitation_tokens', { params: config });
};
var postDatasetInvitationToken = function postDatasetInvitationToken(datasetID, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + datasetID + '/dataset_invitation_tokens', data, { params: config });
};
var getDatasetConfirmInvitation = function getDatasetConfirmInvitation(accessKey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/confirm_dataset_invitation', { params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, config, { access_key: accessKey }) });
};
var postDatasetConfirmInvitation = function postDatasetConfirmInvitation(accessKey, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/confirm_dataset_invitation', { access_key: accessKey }, { params: config });
};
var getDatasetConfig = function getDatasetConfig(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_config', { params: config });
};
var putDatasetConfig = function putDatasetConfig(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/dataset_config', data, { params: config });
};
var postDatasetSummary = function postDatasetSummary(id, data, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/summary_jobs', data, { params: config });
};
var postDatasetSummaryNF = function postDatasetSummaryNF(id, config) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_ROOT */] + 'datasets/' + id + '/summary_jobs/nf', {}, { params: config });
};

/***/ }),

/***/ "hVPs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iTkJTIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE0MyAtNDE3KSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzI5MjciIGRhdGEtbmFtZT0i6ZW35pa55b2iIDI5MjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNDMgNDE3KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiIG9wYWNpdHk9IjAiPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8cGF0aCBpZD0ibmJzLTIiIGRhdGEtbmFtZT0ibmJzIiBkPSJNMjEuNDY3LDM5LjIzYTQuNDI3LDQuNDI3LDAsMSwxLDQuNDIzLDQuMjNBNC4zMzMsNC4zMzMsMCwwLDEsMjEuNDY3LDM5LjIzWm04LjkyNCw1LjYzMmEyLjY1NCwyLjY1NCwwLDAsMC0xLjktLjc1MUgyMy4yMWEyLjUyOSwyLjUyOSwwLDAsMC0xLjg0Ny43NTFsLTUuOTA2LDUuNjgxYy0xLjYxMywxLjU1Mi41NzIsMy41MjksMi4xODYsMmwzLjU2NC0zLjQ1NFY1Mi4zMkgzMC41VjQ5LjA2NkwzNC4xOSw1Mi42YzEuNDgzLDEuNSwzLjcyMS0uNSwyLjE4Ni0yWk0zMC41LDU0bC0zLjQ4NiwzLjM3OSwyLjU3NiwyLjQ3OC0yLjYyOCwyLjUyOGExLjUxMywxLjUxMywwLDEsMCwyLjE4NiwyLjA3N0wzMy4zMDUsNjAuM2EyLjQ0OSwyLjQ0OSwwLDAsMCwuMTgyLTMuNDI5Wm0tOC4zNTIsNS44MzIsMi41NzYtMi40NzhMMjEuMjMzLDU0bC0zLjAxOCwyLjg3OEEyLjQ3NCwyLjQ3NCwwLDAsMCwxOC40LDYwLjNsNC4xNjMsNC4xNTVhMS41MjIsMS41MjIsMCwxLDAsMi4yMTEtMi4wNzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTMyLjEwOSAzODIpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "i0HQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i1qd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi41IiBoZWlnaHQ9IjE2LjUiIHZpZXdCb3g9IjAgMCAxNi41IDE2LjUiPgogIDxwYXRoIGlkPSJpbmZvLWNpcmNsZS1saWdodCIgZD0iTTE2LDkuMDMyQTYuOTY4LDYuOTY4LDAsMSwxLDkuMDMyLDE2LDYuOTY5LDYuOTY5LDAsMCwxLDE2LDkuMDMyTTE2LDhhOCw4LDAsMSwwLDgsOEE4LDgsMCwwLDAsMTYsOFpNMTQuODM5LDE5LjFoLjM4N1YxNS4yMjZoLS4zODdhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4YS4zODcuMzg3LDAsMCwxLC4zODctLjM4N2gxLjU0OGEuMzg3LjM4NywwLDAsMSwuMzg3LjM4N1YxOS4xaC4zODdhLjM4Ny4zODcsMCwwLDEsLjM4Ny4zODd2LjI1OGEuMzg3LjM4NywwLDAsMS0uMzg3LjM4N0gxNC44MzlhLjM4Ny4zODcsMCwwLDEtLjM4Ny0uMzg3di0uMjU4QS4zODcuMzg3LDAsMCwxLDE0LjgzOSwxOS4xWk0xNiwxMS4zNTVhMS4wMzIsMS4wMzIsMCwxLDAsMS4wMzIsMS4wMzJBMS4wMzIsMS4wMzIsMCwwLDAsMTYsMTEuMzU1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcuNzUgLTcuNzUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "i6O6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC41IiBoZWlnaHQ9IjE0LjUiIHZpZXdCb3g9IjAgMCAyMC41IDE0LjUiPgogIDxwYXRoIGlkPSJ1c2Vycy1saWdodCIgZD0iTTE3LDM4YTIuNSwyLjUsMCwxLDAtMi41LTIuNUEyLjUsMi41LDAsMCwwLDE3LDM4Wm0wLTRhMS41LDEuNSwwLDEsMS0xLjUsMS41QTEuNSwxLjUsMCwwLDEsMTcsMzRabS03LDVhMy41LDMuNSwwLDEsMC0zLjUtMy41QTMuNSwzLjUsMCwwLDAsMTAsMzlabTAtNmEyLjUsMi41LDAsMSwxLTIuNSwyLjVBMi41LDIuNSwwLDAsMSwxMCwzM1ptNy42MjUsNmgtMS4yNWEyLjI2MSwyLjI2MSwwLDAsMC0xLjI4NC40LDQuMjM2LDQuMjM2LDAsMCwxLC43OTQuNywxLjI0MywxLjI0MywwLDAsMSwuNDkxLS4xaDEuMjVBMS40NDQsMS40NDQsMCwwLDEsMTksNDEuNWEuNS41LDAsMCwwLDEsMEEyLjQ0MywyLjQ0MywwLDAsMCwxNy42MjUsMzlaTTMsMzhBMi41LDIuNSwwLDEsMCwuNSwzNS41LDIuNSwyLjUsMCwwLDAsMywzOFptMC00YTEuNSwxLjUsMCwxLDEtMS41LDEuNUExLjUsMS41LDAsMCwxLDMsMzRabTkuNSw1LjYyNWMtMS4wNDQsMC0xLjMuMzc1LTIuNS4zNzVzLTEuNDU5LS4zNzUtMi41LS4zNzVhMy40NDQsMy40NDQsMCwwLDAtMi44ODQsMS40NjZBMy41ODEsMy41ODEsMCwwLDAsNCw0My4xdjEuNEExLjUsMS41LDAsMCwwLDUuNSw0Nmg5QTEuNSwxLjUsMCwwLDAsMTYsNDQuNVY0My4xYTMuNTgxLDMuNTgxLDAsMCwwLS42MTItMi4wMDlBMy40NDQsMy40NDQsMCwwLDAsMTIuNSwzOS42MjVaTTE1LDQ0LjVhLjUuNSwwLDAsMS0uNS41aC05YS41LjUsMCwwLDEtLjUtLjVWNDMuMWEyLjYsMi42LDAsMCwxLC40NDEtMS40NSwyLjQ0NiwyLjQ0NiwwLDAsMSwyLjA1My0xLjAyNUM4LjM1LDQwLjYyNSw4LjY1Niw0MSwxMCw0MXMxLjY1LS4zNzUsMi41LS4zNzVhMi40NDYsMi40NDYsMCwwLDEsMi4wNTMsMS4wMjVBMi42LDIuNiwwLDAsMSwxNSw0My4xdjEuNFpNNC45MDksMzkuNEEyLjI3NiwyLjI3NiwwLDAsMCwzLjYyNSwzOUgyLjM3NUEyLjQ0MywyLjQ0MywwLDAsMCwwLDQxLjVhLjUuNSwwLDAsMCwxLDBBMS40NDQsMS40NDQsMCwwLDEsMi4zNzUsNDBoMS4yNWExLjI0MywxLjI0MywwLDAsMSwuNDkxLjEsNC4zMzYsNC4zMzYsMCwwLDEsLjc5NC0uN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMjUgLTMxLjc1KSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNTc3IiBzdHJva2Utd2lkdGg9IjAuNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "iva/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Immunology.900c89c.svg";

/***/ }),

/***/ "j6F1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC4zNzUiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxOC4zNzUgMjEiPgogIDxwYXRoIGlkPSJ0cmFzaC1hbHQtbGlnaHQiIGQ9Ik0xMi4xNDEsMTcuNzE5SDEyLjhhLjMyOC4zMjgsMCwwLDAsLjMyOC0uMzI4VjYuMjM0YS4zMjguMzI4LDAsMCwwLS4zMjgtLjMyOGgtLjY1NmEuMzI4LjMyOCwwLDAsMC0uMzI4LjMyOFYxNy4zOTFBLjMyOC4zMjgsMCwwLDAsMTIuMTQxLDE3LjcxOVptLTYuNTYyLDBoLjY1NmEuMzI4LjMyOCwwLDAsMCwuMzI4LS4zMjhWNi4yMzRhLjMyOC4zMjgsMCwwLDAtLjMyOC0uMzI4SDUuNTc4YS4zMjguMzI4LDAsMCwwLS4zMjguMzI4VjE3LjM5MUEuMzI4LjMyOCwwLDAsMCw1LjU3OCwxNy43MTlaTTE4LjA0NywyLjYyNUgxMy43ODFMMTIuNC43ODhBMS45NjksMS45NjksMCwwLDAsMTAuODI4LDBINy41NDdBMS45NjksMS45NjksMCwwLDAsNS45NzIuNzg3TDQuNTk0LDIuNjI1SC4zMjhBLjMyOC4zMjgsMCwwLDAsMCwyLjk1M3YuNjU2YS4zMjguMzI4LDAsMCwwLC4zMjguMzI4aC45ODRWMTkuMDMxQTEuOTY5LDEuOTY5LDAsMCwwLDMuMjgxLDIxSDE1LjA5NGExLjk2OSwxLjk2OSwwLDAsMCwxLjk2OS0xLjk2OVYzLjkzOGguOTg0YS4zMjguMzI4LDAsMCwwLC4zMjgtLjMyOFYyLjk1M0EuMzI4LjMyOCwwLDAsMCwxOC4wNDcsMi42MjVaTTcuMDIyLDEuNTc1YS42Ni42NiwwLDAsMSwuNTI1LS4yNjNoMy4yODFhLjY2LjY2LDAsMCwxLC41MjUuMjYzbC43ODgsMS4wNUg2LjIzNFpNMTUuNzUsMTkuMDMxYS42NTYuNjU2LDAsMCwxLS42NTYuNjU2SDMuMjgxYS42NTYuNjU2LDAsMCwxLS42NTYtLjY1NlYzLjkzOEgxNS43NVpNOC44NTksMTcuNzE5aC42NTZhLjMyOC4zMjgsMCwwLDAsLjMyOC0uMzI4VjYuMjM0YS4zMjguMzI4LDAsMCwwLS4zMjgtLjMyOEg4Ljg1OWEuMzI4LjMyOCwwLDAsMC0uMzI4LjMyOFYxNy4zOTFBLjMyOC4zMjgsMCwwLDAsOC44NTksMTcuNzE5WiIgZmlsbD0iI2ZhM2QzZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "jHy4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/newBorCor.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var newBorCor = ({
  props: {
    type: {
      type: String,
      default: function _default() {
        return 'bottom';
      }
    },
    reverse: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    arrow: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    tooltip: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    display: {
      type: Boolean,
      default: function _default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    width: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    background: {
      type: String,
      default: function _default() {
        return 'white';
      }
    },
    border: {
      type: String,
      default: function _default() {
        return '#aaaaaa';
      }
    },
    radius: {
      type: String,
      default: function _default() {
        return '3px';
      }
    },
    shadow: {
      type: String,
      default: function _default() {
        return '1px 2px 3px rgba(0, 0, 0, 0.16)';
      }
    },
    translate: {
      type: String,
      default: function _default() {
        return '0px';
      }
    },
    deviation: {
      type: String,
      default: function _default() {
        return '15px 15px';
      }
    },
    arrowSize: {
      type: String,
      default: function _default() {
        return '10px 10px';
      }
    },
    cursorSize: {
      type: String,
      default: function _default() {
        return '40px 40px';
      }
    },
    blockStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    menuBlockStyle: function menuBlockStyle() {
      var width = this.width || 'auto';
      var style = {
        width: width,
        'white-space': width !== 'auto' ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      };
      return extends_default()({}, style, this.blockStyle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3772ea41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/newBorCor.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bor-cor new",class:{ 'no-arrow': !_vm.arrow, 'is-tooltip': _vm.tooltip }},[_c('div',{staticClass:"trigger",class:{ display: _vm.display !== false, 'always-display': _vm.display }},[_vm._t("trigger")],2),_vm._v(" "),(!_vm.disabled && (_vm.display !== false))?_c('div',{staticClass:"menu-container",class:[_vm.type, { reverse: _vm.reverse }],style:({
      'transform': 'translateX(' + _vm.translate + ')',
      '--sd-style': _vm.shadow,
      '--dvt-v': _vm.deviation.split(' ')[0],
      '--dvt-h': _vm.deviation.split(' ')[1],
      '--arw-w': _vm.arrowSize.split(' ')[0],
      '--arw-h': _vm.arrowSize.split(' ')[1],
      '--cbc-w': _vm.cursorSize.split(' ')[0],
      '--cbc-h': _vm.cursorSize.split(' ')[1],
      '--tt-v': (_vm.tooltip || {}).v || '5px',
      '--tt-h': (_vm.tooltip || {}).h || '5px'
    }),on:{"mouseleave":function (e) { return _vm.$emit('leave'); }}},[_c('div',{staticClass:"menu-block",style:(_vm.menuBlockStyle)},[_vm._t("content")],2),_vm._v(" "),(!_vm.tooltip)?_c('span',{staticClass:"cursor-bor-cor"}):_vm._e(),_vm._v(" "),(_vm.arrow && !_vm.tooltip)?[_c('span',{staticClass:"menu-bor-cor shadow-top",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right",style:({ '--bd-color': _vm.border })}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor",style:({ '--bg-color': _vm.background })})]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_newBorCor = (esExports);
// CONCATENATED MODULE: ./src/components/tool/newBorCor.vue
function injectStyle (ssrContext) {
  __webpack_require__("a5p7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  newBorCor,
  tool_newBorCor,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_newBorCor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jNsU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ "k4Yl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY4ODMiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY4ODMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2ZmZmZmZiIvPgogICAgPGcgaWQ9IuODkeOCuV81MTUiIGRhdGEtbmFtZT0i44OR44K5IDUxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTMzKSIgZmlsbD0ibm9uZSI+CiAgICAgIDxwYXRoIGQ9Ik0yLDBIMTZhMiwyLDAsMCwxLDIsMlYxNmEyLDIsMCwwLDEtMiwySDJhMiwyLDAsMCwxLTItMlYyQTIsMiwwLDAsMSwyLDBaIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHBhdGggZD0iTSAyIDEgQyAxLjQ0ODYwMDc2OTA0Mjk2OSAxIDEgMS40NDg2MDA3NjkwNDI5NjkgMSAyIEwgMSAxNiBDIDEgMTYuNTUxMzk5MjMwOTU3MDMgMS40NDg2MDA3NjkwNDI5NjkgMTcgMiAxNyBMIDE2IDE3IEMgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTcgMTYuNTUxMzk5MjMwOTU3MDMgMTcgMTYgTCAxNyAyIEMgMTcgMS40NDg2MDA3NjkwNDI5NjkgMTYuNTUxMzk5MjMwOTU3MDMgMSAxNiAxIEwgMiAxIE0gMiAwIEwgMTYgMCBDIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTggMC44OTU0Mjk2MTEyMDYwNTQ3IDE4IDIgTCAxOCAxNiBDIDE4IDE3LjEwNDU3MDM4ODc5Mzk1IDE3LjEwNDU3MDM4ODc5Mzk1IDE4IDE2IDE4IEwgMiAxOCBDIDAuODk1NDI5NjExMjA2MDU0NyAxOCAwIDE3LjEwNDU3MDM4ODc5Mzk1IDAgMTYgTCAwIDIgQyAwIDAuODk1NDI5NjExMjA2MDU0NyAwLjg5NTQyOTYxMTIwNjA1NDcgMCAyIDAgWiIgc3Ryb2tlPSJub25lIiBmaWxsPSJ0cmFuc3BhcmVudCIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "mr+9":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Cardiology.svg": "SRag",
	"./Dermatology.svg": "SQy7",
	"./Ear, Nose & Throat.svg": "6Qul",
	"./Endocrinology.svg": "V8EM",
	"./Gastroenterology & Hepatology.svg": "vOTy",
	"./Hematology.svg": "x9yG",
	"./Hereditary Cancer.svg": "HCoM",
	"./Immunology.svg": "iva/",
	"./Malformations.svg": "VBfA",
	"./Metabolic and Mitochondrial Disorders.svg": "HZ4l",
	"./NBS.svg": "hVPs",
	"./Nephrology.svg": "FUqK",
	"./Neurology.svg": "M0RH",
	"./Ophthalmology.svg": "K4Tr",
	"./Osteology.svg": "F9Jn",
	"./Others.svg": "XE98",
	"./Pulmonology.svg": "SkAt",
	"./Reproductive.svg": "Mt5Y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mr+9";

/***/ }),

/***/ "n3Bz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTYgOCI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93bi1yZWd1bGFyIiBkPSJNMTUuODczLjczNywxNS4xNTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEw4LDUuODIsMS40NTcuMTExYS40NzkuNDc5LDAsMCwwLS42MTQsMEwuMTI3LjczN2EuMzQ3LjM0NywwLDAsMCwwLC41MzdMNy42OTMsNy44ODlhLjQ3OS40NzksMCwwLDAsLjYxNCwwbDcuNTY2LTYuNjE1QS4zNDcuMzQ3LDAsMCwwLDE1Ljg3My43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNiA4KSByb3RhdGUoMTgwKSIgZmlsbD0iIzAwMzY3OSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "nfOD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDIwIDE0Ij4KICA8cGF0aCBpZD0iY2xvdWQtdXBsb2FkLXNvbGlkIiBkPSJNMTYuOCwzOC4wODFBMywzLDAsMCwwLDE0LDM0YTIuOTg1LDIuOTg1LDAsMCwwLTEuNjY2LjUwNkE1LDUsMCwwLDAsMywzN2MwLC4wODQsMCwuMTY5LjAwNi4yNTNBNC41LDQuNSwwLDAsMCw0LjUsNDZIMTZhNCw0LDAsMCwwLC44LTcuOTE5Wm0tNC4zNzIsMS45OTEtLjMzNy4zMzhhLjc1My43NTMsMCwwLDEtMS4wNzgtLjAxNkwxMCwzOS4zMTZWNDMuMjVhLjc0OC43NDgsMCwwLDEtLjc1Ljc1aC0uNUEuNzQ4Ljc0OCwwLDAsMSw4LDQzLjI1VjM5LjMxNkw2Ljk4OCw0MC4zOTRhLjc1Ljc1LDAsMCwxLTEuMDc4LjAxNmwtLjMzOC0uMzM4YS43NDcuNzQ3LDAsMCwxLDAtMS4wNTlsMi45LTIuOWEuNzQ3Ljc0NywwLDAsMSwxLjA1OSwwbDIuOSwyLjlBLjc1Ljc1LDAsMCwxLDEyLjQyOCw0MC4wNzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiMwMDM2NzkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "nzHv":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzY1MTAiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY1MTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMzQ0IDU2MDIpIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMTc3MyIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTc3MyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAzNDQgLTU2MDIpIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBpZD0idGltZXMtbGlnaHQiIGQ9Ik03LjI3MywxMDJsMy44NDYtMy44NDYuNzkzLS43OTNhLjMuMywwLDAsMCwwLS40MjRsLS44NDktLjg0OWEuMy4zLDAsMCwwLS40MjQsMEw2LDEwMC43MjdsLTQuNjM5LTQuNjRhLjMuMywwLDAsMC0uNDI0LDBsLS44NDkuODQ5YS4zLjMsMCwwLDAsMCwuNDI0TDQuNzI3LDEwMmwtNC42NCw0LjYzOWEuMy4zLDAsMCwwLDAsLjQyNGwuODQ5Ljg0OWEuMy4zLDAsMCwwLC40MjQsMEw2LDEwMy4yNzNsMy44NDYsMy44NDYuNzkzLjc5M2EuMy4zLDAsMCwwLC40MjQsMGwuODQ5LS44NDlhLjMuMywwLDAsMCwwLS40MjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAzNDAgLTU2OTQpIiBmaWxsPSIjOTk5IiBvcGFjaXR5PSIwLjYiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "of+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ "pWQO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0i44Kw44Or44O844OXXzY5NzUiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDY5NzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTcyIC0xNTMzKSI+CiAgICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTYuMDcxLDUwSDEuOTI5QTEuOTI5LDEuOTI5LDAsMCwxLDAsNDguMDcxVjMzLjkyOUExLjkyOSwxLjkyOSwwLDAsMSwxLjkyOSwzMkgxNi4wNzFBMS45MjksMS45MjksMCwwLDEsMTgsMzMuOTI5VjQ4LjA3MUExLjkyOSwxLjkyOSwwLDAsMSwxNi4wNzEsNTBaTTcuODQ3LDQ2LjA2bDcuMzkzLTcuMzkzYS42NDMuNjQzLDAsMCwwLDAtLjkwOWwtLjkwOS0uOTA5YS42NDMuNjQzLDAsMCwwLS45MDksMEw3LjM5Myw0Mi44NzgsNC41NzgsNDAuMDYzYS42NDMuNjQzLDAsMCwwLS45MDksMGwtLjkwOS45MDlhLjY0My42NDMsMCwwLDAsMCwuOTA5TDYuOTM4LDQ2LjA2QS42NDMuNjQzLDAsMCwwLDcuODQ3LDQ2LjA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3MiAxNTAxKSIgZmlsbD0iI2ZmZiIvPgogICAgPGcgaWQ9IumVt+aWueW9ol8yODY4IiBkYXRhLW5hbWU9IumVt+aWueW9oiAyODY4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTcyIDE1MzMpIiBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE3IiBoZWlnaHQ9IjE3IiByeD0iMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "prJ5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC41IiBoZWlnaHQ9IjIwLjUiIHZpZXdCb3g9IjAgMCAyMC41IDIwLjUiPgogIDxwYXRoIGlkPSJjaGV2cm9uLWNpcmNsZS1kb3duLWxpZ2h0IiBkPSJNMTgsOEExMCwxMCwwLDEsMCwyOCwxOCwxMCwxMCwwLDAsMCwxOCw4Wm04LjcxLDEwQTguNzEsOC43MSwwLDEsMSwxOCw5LjI5LDguNzA5LDguNzA5LDAsMCwxLDI2LjcxLDE4Wm0tOC4zNjcsMy40OTIsNC42MzctNC42NDFhLjQ4NC40ODQsMCwwLDAsMC0uNjg1bC0uMjg2LS4yODZhLjQ4NC40ODQsMCwwLDAtLjY4NSwwTDE4LDE5LjlsLTQuMDEyLTQuMDEyYS40ODQuNDg0LDAsMCwwLS42ODUsMGwtLjI4Ni4yODZhLjQ4NC40ODQsMCwwLDAsMCwuNjg1TDE3LjY1MywyMS41QS40OTMuNDkzLDAsMCwwLDE4LjM0MywyMS40OTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOC4yNSAyOC4yNSkgcm90YXRlKDE4MCkiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "py3r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/svg/dataset-annotation-admin-solid.vue
//
//
//
//
//
//

/* harmony default export */ var dataset_annotation_admin_solid = ({
  props: {
    color: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c74a02ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/dataset-annotation-admin-solid.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"24","viewBox":"0 0 18 24"}},[_c('path',{attrs:{"id":"clipboard-list-check-solid","d":"M15.75,3H12A3,3,0,0,0,6,3H2.25A2.251,2.251,0,0,0,0,5.25v16.5A2.251,2.251,0,0,0,2.25,24h13.5A2.251,2.251,0,0,0,18,21.75V5.25A2.251,2.251,0,0,0,15.75,3ZM9,1.875A1.125,1.125,0,1,1,7.875,3,1.122,1.122,0,0,1,9,1.875ZM3.075,9.816l.6-.591a.252.252,0,0,1,.356,0l.966.975L7.223,7.987a.252.252,0,0,1,.356,0l.591.6a.252.252,0,0,1,0,.356L5.161,11.92a.252.252,0,0,1-.356,0l-1.73-1.748A.252.252,0,0,1,3.075,9.816ZM4.5,18.375A1.125,1.125,0,1,1,5.625,17.25,1.122,1.122,0,0,1,4.5,18.375Zm10.5-.75a.376.376,0,0,1-.375.375H7.875a.376.376,0,0,1-.375-.375v-.75a.376.376,0,0,1,.375-.375h6.75a.376.376,0,0,1,.375.375Zm0-6a.418.418,0,0,1-.45.375H7.223l1.514-1.5H14.55a.418.418,0,0,1,.45.375v.75Z","fill":_vm.color}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var svg_dataset_annotation_admin_solid = (esExports);
// CONCATENATED MODULE: ./src/components/svg/dataset-annotation-admin-solid.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  dataset_annotation_admin_solid,
  svg_dataset_annotation_admin_solid,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_svg_dataset_annotation_admin_solid = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q3sG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWcluWxpF8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMTMxIDM2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMzEgMzY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZW5hYmxlLWJhY2tncm91bmQ6bmV3ICAgIDt9Cgkuc3Qxe2ZpbGw6IzMzMzMzMzt9Cgkuc3Qye2ZpbGw6IzQ3NDY0NTt9Cgkuc3Qze2ZpbGw6IzAwMzY3OTt9Cgkuc3Q0e2ZpbGw6I0ZBM0QzRDt9Cgkuc3Q1e2ZpbGw6I0Y4QzYwMDt9Cjwvc3R5bGU+CjxnIGlkPSJHcm91cF8yMjEwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjAxLjAwMSAtMTUuOTk5KSI+Cgk8ZyBjbGFzcz0ic3QwIj4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMjMyLjYsMjYuNmgwLjlWNDRoLTAuOVYyNi42eiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yMzgsMzEuNGgwLjdsMC4xLDJoMGMxLjMtMS4zLDIuNi0yLjMsNC40LTIuM2MyLjYsMCwzLjgsMS42LDMuOCw0LjhWNDRoLTAuOXYtOGMwLTIuOC0wLjktNC4yLTMtNC4yCgkJCWMtMS42LDAtMi43LDAuOC00LjMsMi41VjQ0SDIzOFYzMS40eiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0yNTEuMiwyNC45aDAuOXY4LjVjMS4zLTEuNCwyLjctMi40LDQuNC0yLjRjMi42LDAsMy44LDEuNiwzLjgsNC44VjQ0aC0wLjl2LThjMC0yLjgtMC45LTQuMi0zLTQuMgoJCQljLTEuNiwwLTIuNywwLjgtNC4zLDIuNVY0NGgtMC45VjI0Ljl6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTI2My4xLDM3LjdjMC00LjEsMi42LTYuNyw1LjQtNi43YzIuOSwwLDQuOCwyLjEsNC44LDUuOGMwLDAuMywwLDAuNiwwLDAuOWgtOS4zYzAsMy4zLDEuOSw1LjgsNC45LDUuOAoJCQljMS40LDAsMi41LTAuNSwzLjUtMS4ybDAuNCwwLjdjLTEsMC42LTIsMS4yLTMuOSwxLjJDMjY1LjcsNDQuMywyNjMuMSw0MS44LDI2My4xLDM3Ljd6IE0yNzIuNSwzNi45YzAtMy40LTEuNi01LjEtMy45LTUuMQoJCQljLTIuMywwLTQuMywxLjktNC41LDUuMUgyNzIuNXoiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMjc2LjIsMzEuNGgwLjdsMC4xLDIuNGgwYzAuOC0xLjUsMi4xLTIuNywzLjYtMi43YzAuNCwwLDAuOCwwLDEuMiwwLjNsLTAuMiwwLjhjLTAuNC0wLjItMC42LTAuMi0xLjEtMC4yCgkJCWMtMS4xLDAtMi41LDAuOS0zLjUsMy40VjQ0aC0wLjlWMzEuNHoiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMjgzLjEsMjcuMmMwLTAuNiwwLjQtMC45LDAuOS0wLjljMC41LDAsMC45LDAuMywwLjksMC45YzAsMC42LTAuNSwwLjktMC45LDAuOQoJCQlDMjgzLjUsMjguMiwyODMuMSwyNy44LDI4My4xLDI3LjJ6IE0yODMuNiwzMS40aDAuOVY0NGgtMC45VjMxLjR6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTI4OC45LDI2LjZoMC45bDcuNywxMi43bDIsMy40aDAuMWMtMC4xLTEuNy0wLjEtMy4zLTAuMS00LjlWMjYuNmgwLjlWNDRoLTFsLTcuNy0xMi43bC0yLTMuNGgtMC4xCgkJCWMwLDEuNiwwLjEsMy4xLDAuMSw0LjhWNDRoLTAuOFYyNi42eiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0zMDMuNiwzNy43YzAtNC4xLDIuNi02LjcsNS40LTYuN2MyLjksMCw0LjgsMi4xLDQuOCw1LjhjMCwwLjMsMCwwLjYsMCwwLjloLTkuM2MwLDMuMywxLjksNS44LDQuOSw1LjgKCQkJYzEuNCwwLDIuNS0wLjUsMy41LTEuMmwwLjQsMC43Yy0xLDAuNi0yLDEuMi0zLjksMS4yQzMwNi4yLDQ0LjMsMzAzLjYsNDEuOCwzMDMuNiwzNy43eiBNMzEzLDM2LjljMC0zLjQtMS42LTUuMS0zLjktNS4xCgkJCWMtMi4zLDAtNC4zLDEuOS00LjUsNS4xSDMxM3oiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMzE4LjksMzcuNGwtNC02aDFsMi4xLDMuNGMwLjQsMC43LDAuOSwxLjQsMS40LDIuMWgwLjFjMC41LTAuNywwLjktMS40LDEuMy0yLjFsMi4xLTMuNGgwLjlsLTQsNi4xbDQuMyw2LjYKCQkJaC0xbC0yLjQtMy42Yy0wLjUtMC44LTEtMS42LTEuNS0yLjNoLTAuMWMtMC41LDAuNy0xLDEuNS0xLjUsMi4zbC0yLjMsMy42aC0wLjlMMzE4LjksMzcuNHoiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMzI2LjEsNDAuNnYtOC41aC0ydi0wLjdsMi0wLjFsMC4xLTMuN2gwLjd2My43aDMuN3YwLjhIMzI3djguNmMwLDEuNiwwLjQsMi44LDIuMiwyLjgKCQkJYzAuNSwwLDEuMi0wLjIsMS42LTAuNGwwLjMsMC43Yy0wLjcsMC4zLTEuNSwwLjUtMiwwLjVDMzI2LjcsNDQuMywzMjYuMSw0Mi44LDMyNi4xLDQwLjZ6Ii8+Cgk8L2c+Cgk8ZyBpZD0iR3JvdXBfMjIxMC0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEpIj4KCQk8cGF0aCBpZD0iUGF0aF80NTAiIGNsYXNzPSJzdDIiIGQ9Ik0yMTkuNSw0Mi44YzAtMC43LDAtMS41LDAtMi4yYzAtMC41LTAuMS0xLjEtMC4yLTEuNmMtMC42LTIuNi0yLjQtNC44LTQuOC01LjkKCQkJYy0xLjQtMC43LTIuOS0xLjMtNC40LTEuN2MtMS40LTAuNC0yLjgtMS4xLTQtMmMtMS4xLTAuOS0xLjgtMi4zLTEuOC0zLjhjMC0xLjMsMC02LjksMC04LjR2LTEuOUgyMDFWMTlsMCwwYzAsMi4xLDAsNC4yLDAsNi4zCgkJCWMtMC4xLDIuNywxLjIsNS4zLDMuNCw2LjljMS40LDEsMywxLjgsNC43LDIuM2MxLjUsMC41LDMsMS4xLDQuNCwxLjljMS43LDEsMi43LDIuOCwyLjYsNC44Yy0wLjEsMi4yLDAsNC41LDAsNi44VjUxaDMuNAoJCQlMMjE5LjUsNDIuOEwyMTkuNSw0Mi44eiIvPgoJCTxwYXRoIGlkPSJQYXRoXzQ1MSIgY2xhc3M9InN0MiIgZD0iTTIwNS4yLDM3LjJjLTAuNy0wLjYtMS44LTAuNS0yLjQsMC4yYy0wLjksMC45LTEuNCwyLTEuNywzLjJjLTAuMSwwLjgtMC4yLDEuNS0wLjEsMi4zbDAsMFY1MQoJCQloMy40di0xLjljMC0wLjEsMC0wLjIsMC0wLjJjMC0yLjIsMC00LjUsMC02LjdjMC0wLjksMC4zLTEuOCwwLjktMi41YzAuNi0wLjYsMC42LTEuNywwLTIuM0MyMDUuMywzNy4zLDIwNS4zLDM3LjIsMjA1LjIsMzcuMnoiCgkJCS8+CgkJPGcgaWQ9Ikdyb3VwXzIyMDYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwNi4yMDUgMTQuOTk5KSI+CgkJCTxjaXJjbGUgaWQ9IkVsbGlwc2VfMTE5IiBjbGFzcz0ic3QzIiBjeD0iMTIuMSIgY3k9IjEuNyIgcj0iMS43Ii8+CgkJCTxyZWN0IGlkPSJSZWN0YW5nbGVfMTM2NCIgeD0iMCIgeT0iMS40IiBjbGFzcz0ic3QzIiB3aWR0aD0iMTAuNiIgaGVpZ2h0PSIwLjUiLz4KCQk8L2c+CgkJPGcgaWQ9Ikdyb3VwXzIyMDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwOC40NzggMjAuNDM5KSI+CgkJCTxwYXRoIGlkPSJQYXRoXzQ1MiIgY2xhc3M9InN0NCIgZD0iTTExLDEuN2MwLDAuOS0wLjgsMS43LTEuNywxLjdTNy42LDIuNiw3LjYsMS43QzcuNiwwLjgsOC4zLDAsOS4zLDBDMTAuMiwwLDExLDAuOCwxMSwxLjd6Ii8+CgkJCTxyZWN0IGlkPSJSZWN0YW5nbGVfMTM2NSIgeD0iMCIgeT0iMS40IiBjbGFzcz0ic3Q0IiB3aWR0aD0iNy45IiBoZWlnaHQ9IjAuNSIvPgoJCTwvZz4KCQk8ZyBpZD0iR3JvdXBfMjIwOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjExLjIyNiAyNi4xMTIpIj4KCQkJPGNpcmNsZSBpZD0iRWxsaXBzZV8xMjAiIGNsYXNzPSJzdDUiIGN4PSI1LjQiIGN5PSIxLjciIHI9IjEuNyIvPgoJCQk8cmVjdCBpZD0iUmVjdGFuZ2xlXzEzNjYiIHg9IjAiIHk9IjEuNCIgY2xhc3M9InN0NSIgd2lkdGg9IjQiIGhlaWdodD0iMC41Ii8+CgkJPC9nPgoJPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "qBXn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qFyz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/constants/global/data.js
var data = __webpack_require__("x2hU");

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/case/clinvarStatisticTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var clinvarStatisticTable = ({
  props: {
    defaultData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      clinvarTableData: null
    };
  },

  computed: {
    // global
    toPriceString: function toPriceString() {
      return util["p" /* toPriceString */];
    },
    fixNumber: function fixNumber() {
      return util["g" /* fixNumber */];
    }
  },
  watch: {
    'defaultData': function defaultData() {
      this.init();
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.clinvarTableData = Object(data["l" /* getClinvarStatisticData */])(this.defaultData);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c92c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case/clinvarStatisticTable.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clinvarTableData)?_c('div',{staticClass:"clinvar-statistic-table-page col-block width-full"},[_c('div',{staticClass:"clinvar-statistic-table-container col-block width-full"},_vm._l((Object.keys(_vm.clinvarTableData['config']['csq'])),function(csqKey,csqIndex){return _c('div',{key:csqIndex,staticClass:"clinvar-statistic-table-row row-block stretch",class:['csq-' + csqKey]},_vm._l((Object.keys(_vm.clinvarTableData['config']['gs'])),function(gsKey,gsIndex){return _c('div',{key:gsIndex,staticClass:"clinvar-statistic-table-col col-block",class:['csq-' + csqKey, 'gs-' + gsKey],style:({
          flex: _vm.clinvarTableData['config']['gs'][gsKey].flex || 1,
          'min-height': '50px',
          '--color': _vm.clinvarTableData['config']['gs'][gsKey].color,
          '--bgColor': (
            _vm.clinvarTableData['config']['gs'][gsKey].color +
            (!(['title', 'total'].includes(csqKey) || ['title', 'total'].includes(gsKey)) ?
            _vm.clinvarTableData['function'].getOpacity(_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n ? _vm.clinvarTableData['data']['csq'][csqKey][gsKey].n / _vm.clinvarTableData['data']['gs'][gsKey].total : 0)
            : '')
          )
        })},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('div',{staticClass:"clinvar-statistic-table-cell row-block flex-wrap"},[(['title'].includes(csqKey))?[(true)?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.clinvarTableData['config']['gs'][gsKey].title))])]:_vm._e()]:(['total'].includes(csqKey))?[(['title'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.clinvarTableData['config']['csq'][csqKey].title))])]:(['total'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['csq'].total)))])]:[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['gs'][gsKey].total)))])]]:[(['title'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.clinvarTableData['config']['csq'][csqKey].title))])]:(['total'].includes(gsKey))?[_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['csq'][csqKey].total)))])]:[_c('div',{staticClass:"clinvar-statistic-table-content break-line",class:{ 'empty': !_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n }},[_vm._v(_vm._s(_vm.toPriceString(_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n) + (_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n ? ' /' : '')))]),_vm._v(" "),(_vm.clinvarTableData['data']['csq'][csqKey][gsKey].n)?_c('div',{staticClass:"clinvar-statistic-table-content break-line"},[_vm._v(_vm._s(_vm.fixNumber(100 * _vm.clinvarTableData['data']['csq'][csqKey][gsKey].n / _vm.clinvarTableData['data']['gs'][gsKey].total, 0.001) + '%'))]):_vm._e()]]],2),_vm._v(" "),_c('div',{style:({ flex: 1 })})])}),0)}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var case_clinvarStatisticTable = (esExports);
// CONCATENATED MODULE: ./src/components/case/clinvarStatisticTable.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  clinvarStatisticTable,
  case_clinvarStatisticTable,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_case_clinvarStatisticTable = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qL9y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE0IDE2Ij4KICA8cGF0aCBpZD0iY29weS1saWdodCIgZD0iTTEzLjU2MSwyLjA2MSwxMS45MzkuNDM5QTEuNSwxLjUsMCwwLDAsMTAuODc5LDBINS41QTEuNSwxLjUsMCwwLDAsNCwxLjVWM0gxLjVBMS41LDEuNSwwLDAsMCwwLDQuNXYxMEExLjUsMS41LDAsMCwwLDEuNSwxNmg3QTEuNSwxLjUsMCwwLDAsMTAsMTQuNVYxM2gyLjVBMS41LDEuNSwwLDAsMCwxNCwxMS41VjMuMTIxYTEuNSwxLjUsMCwwLDAtLjQzOS0xLjA2MVpNMTEsMS4wMTVhLjUuNSwwLDAsMSwuMjMyLjEzMWwxLjYyMSwxLjYyMUEuNS41LDAsMCwxLDEyLjk4NSwzSDExWk05LDE0LjVhLjUuNSwwLDAsMS0uNS41aC03YS41LjUsMCwwLDEtLjUtLjVWNC41QS41LjUsMCwwLDEsMS41LDRINHY3LjVBMS41LDEuNSwwLDAsMCw1LjUsMTNIOVptNC0zYS41LjUsMCwwLDEtLjUuNWgtN2EuNS41LDAsMCwxLS41LS41VjEuNUEuNS41LDAsMCwxLDUuNSwxSDEwVjMuMjVhLjc1Mi43NTIsMCwwLDAsLjc1Ljc1SDEzWiIgZmlsbD0iI2FhYSIvPgo8L3N2Zz4K"

/***/ }),

/***/ "qfup":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNmZjllMDMiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "rafa":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8cGF0aCBpZD0idGltZXMtcmVndWxhciIgZD0iTTkuMDksMTAzLDEzLjgsOTguMjg1YS43LjcsMCwwLDAsMC0uOTg4bC0xLjEtMS4xYS43LjcsMCwwLDAtLjk4OCwwbC00LjcxMiw0LjcxM0wyLjI5NCw5Ni4yYS43LjcsMCwwLDAtLjk4OCwwTC4yMTIsOTcuM2EuNy43LDAsMCwwLDAsLjk4OEw0LjkyNSwxMDMsLjIxMiwxMDcuNzExYS43LjcsMCwwLDAsMCwuOTg4bDEuMSwxLjFhLjcuNywwLDAsMCwuOTg4LDBsNC43MTItNC43MTMsNC43MTMsNC43MTNhLjcuNywwLDAsMCwuOTg4LDBsMS4xLTEuMWEuNy43LDAsMCwwLDAtLjk4OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjAwOCAtOTUuOTk3KSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "roYr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzEyMDAiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDEyMDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTU1MyAzMjcwKSI+CiAgICA8cmVjdCBpZD0i6ZW35pa55b2iXzEyMzkiIGRhdGEtbmFtZT0i6ZW35pa55b2iIDEyMzkiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU1NTMgLTMyNzApIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iZm9sZGVyLWxpZ2h0IiBkPSJNNi4wODYsNjVsMS43MDcsMS43MDdBMSwxLDAsMCwwLDguNSw2N2g2YS41LjUsMCwwLDEsLjUuNXY3YS41LjUsMCwwLDEtLjUuNUgxLjVhLjUuNSwwLDAsMS0uNS0uNXYtOWEuNS41LDAsMCwxLC41LS41SDYuMDg2TTEuNSw2NEExLjUsMS41LDAsMCwwLDAsNjUuNXY5QTEuNSwxLjUsMCwwLDAsMS41LDc2aDEzQTEuNSwxLjUsMCwwLDAsMTYsNzQuNXYtN0ExLjUsMS41LDAsMCwwLDE0LjUsNjZoLTZMNi43OTMsNjQuMjkzQTEsMSwwLDAsMCw2LjA4Niw2NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NTU0IC0zMzMwKSIgZmlsbD0iIzAwMzY3OSIgc3Ryb2tlPSIjMDAzNTc3IiBzdHJva2Utd2lkdGg9IjAuMjUiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "s+oG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s77y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sdWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/constants/global/util.js
var util = __webpack_require__("Cduz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/phenotypeTag.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var phenotypeTag = ({
  props: {
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    init: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    dataInfo: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    phenotypes: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    };
  },

  computed: {
    filtedPhenotypes: function filtedPhenotypes() {
      return Object(util["i" /* groupBy */])(this.phenotypes, function (phenotype) {
        return phenotype.type;
      }, true);
    }
  },
  watch: {
    'init': function init() {
      if (this.content !== this.init) {
        this.content = this.init;
      }
    },
    'focus': function focus() {
      this.display = this.focus || this.mouse;
    }
  },
  created: function created() {
    if (this.content !== this.init) {
      this.content = this.init;
    }
  },

  methods: {
    commentOnInput: function commentOnInput(compelete) {
      compelete && (this.onCompelete = false);
      this.tagIndex = 0;
      this.$emit('input', this.content);
    },
    moveTagIndex: function moveTagIndex(type) {
      switch (type) {
        case 'up':
          {
            this.tagIndex = (this.tagIndex - -this.phenotypes.length - 1) % this.phenotypes.length;
            break;
          }
        case 'down':
          {
            this.tagIndex = (this.tagIndex - -1) % this.phenotypes.length;
            break;
          }
      }
      this.$refs['tag-block'].scrollTop = 28 * this.tagIndex;
    },
    commentTag: function commentTag() {
      var curTag = this.phenotypes[this.tagIndex];
      this.onCompelete = true;
      this.content = curTag.query;
      this.$emit('tag', curTag);
      this.commentOnInput();
      this.$refs['comment-input'].focus();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da4621e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/phenotypeTag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"phenotype-tag-container"},on:{"mouseenter":function (e) { return _vm.mouse = true; },"mouseleave":function (e) { return _vm.mouse = false; }}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"comment-input",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":(_vm.content)},on:{"focus":function (e) { return _vm.focus = true; },"blur":function (e) { return _vm.focus = false; },"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('up'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return _vm.moveTagIndex('down'); })($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return (function (e) { return (_vm.phenotypes || []).length <= 1 ? _vm.$emit('send', _vm.content) : _vm.commentTag(); })($event)}],"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},function (e) { return _vm.commentOnInput(true); }],"change":function (e) { return _vm.$emit('change', _vm.content); }}}),_vm._v(" "),(_vm.phenotypes && !_vm.onCompelete && _vm.display && _vm.content)?_c('div',{staticClass:"input-tag"},[_c('div',{staticClass:"tag-block"},[(_vm.phenotypes.length > 0)?[(_vm.dataInfo['hpo'] && _vm.dataInfo['disease_term'])?_c('div',{staticClass:"tag-info-container"},[_c('div',{staticClass:"tag-info-block"},[_c('span',[_vm._v(_vm._s('Showing ' + [(_vm.dataInfo['hpo'].displayed ? _vm.dataInfo['hpo'].displayed + '/' + _vm.dataInfo['hpo'].total + ' phenotypes' : ''), (_vm.dataInfo['disease_term'].displayed ? _vm.dataInfo['disease_term'].displayed + '/' + _vm.dataInfo['disease_term'].total + ' diseases' : '')].filter(function (x) { return x; }).join(' and ')))])])]):_vm._e(),_vm._v(" "),_c('div',{ref:"tag-block",staticClass:"tag-group-container"},[(_vm.filtedPhenotypes['hpo'] && _vm.filtedPhenotypes['hpo'].length)?_c('div',{staticClass:"tag-group-block"},[_c('div',{staticClass:"tag-title"},[_vm._v("Phenotype")]),_vm._v(" "),_vm._l((_vm.filtedPhenotypes['hpo']),function(tag,index){return _c('div',{key:index,staticClass:"tag",class:{ selected: _vm.tagIndex === index },on:{"mousemove":function (e) { return _vm.tagIndex = index; },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.query.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2):_vm._e(),_vm._v(" "),(_vm.filtedPhenotypes['disease_term'] && _vm.filtedPhenotypes['disease_term'].length)?_c('div',{staticClass:"tag-group-block"},[_c('div',{staticClass:"tag-title"},[_vm._v("Disease")]),_vm._v(" "),_vm._l((_vm.filtedPhenotypes['disease_term']),function(tag,index){return _c('div',{key:index - -(_vm.filtedPhenotypes['hpo'] || []).length,staticClass:"tag",class:{ selected: _vm.tagIndex === index - -(_vm.filtedPhenotypes['hpo'] || []).length },on:{"mousemove":function (e) { return _vm.tagIndex = index - -(_vm.filtedPhenotypes['hpo'] || []).length; },"click":function($event){_vm.commentTag()}}},[_c('span',{domProps:{"innerHTML":_vm._s(tag.query.replace(new RegExp(_vm.content, 'ig'), function (m) { return '<span class=\'key\'>' + m + '</span>'; }))}})])})],2):_vm._e()])]:[_c('div',{staticClass:"tab-empty"},[_vm._v(_vm._s('No result has been found.'/* ___ */))])]],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_phenotypeTag = (esExports);
// CONCATENATED MODULE: ./src/components/tool/phenotypeTag.vue
function injectStyle (ssrContext) {
  __webpack_require__("fsHt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  phenotypeTag,
  tool_phenotypeTag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_phenotypeTag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t62l":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI3IDI0Ij4KICA8cGF0aCBpZD0ibWVtby1jaXJjbGUtaW5mby1saWdodCIgZD0iTTE1LDEuNUgzQTEuNSwxLjUsMCwwLDAsMS41LDNWMjFBMS41LDEuNSwwLDAsMCwzLDIyLjVIMTMuODg0YTcuNDQzLDcuNDQzLDAsMCwwLDEuNTcsMS40NjdBMy41NzgsMy41NzgsMCwwLDEsMTUsMjRIM2EzLDMsMCwwLDEtMy0zVjNBMywzLDAsMCwxLDMsMEgxNWEzLDMsMCwwLDEsMywzVjkuMzA5YTguMTgyLDguMTgyLDAsMCwwLTEuNS41OTFWM0ExLjUsMS41LDAsMCwwLDE1LDEuNVpNMyw2Ljc1QS43NTEuNzUxLDAsMCwxLDMuNzUsNmgxMC41YS43NS43NSwwLDAsMSwwLDEuNUgzLjc1QS43NTEuNzUxLDAsMCwxLDMsNi43NVptOS43NSwzLjc1YS43NS43NSwwLDAsMSwwLDEuNWgtOWEuNzUuNzUsMCwxLDEsMC0xLjVabS0zLDQuNWEuNzUuNzUsMCwxLDEsMCwxLjVoLTZhLjc1Ljc1LDAsMSwxLDAtMS41Wm0xMC41LTEuNWExLjEyNSwxLjEyNSwwLDEsMS0xLjEyNSwxLjEyNUExLjEyMiwxLjEyMiwwLDAsMSwyMC4yNSwxMy41Wm0tLjc5Miw2VjE4YS43NzUuNzc1LDAsMCwxLS43MDgtLjc1Ljc1Mi43NTIsMCwwLDEsLjc1LS43NWguNzA4YS43MjYuNzI2LDAsMCwxLC43NS43NUwyMSwxOS41QS43NS43NSwwLDAsMSwyMSwyMUgxOS41YS43NTEuNzUxLDAsMCwxLS4wNDItMS41Wk0yMC4yNSwyNEE2Ljc1LDYuNzUsMCwxLDEsMjcsMTcuMjUsNi43NTIsNi43NTIsMCwwLDEsMjAuMjUsMjRabTUuMjUtNi43NWE1LjI1LDUuMjUsMCwxLDAtNS4yNSw1LjI1QTUuMjQ3LDUuMjQ3LDAsMCwwLDI1LjUsMTcuMjVaIiBmaWxsPSIjMDAzNjc5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "tIXw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uu87":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICA8cGF0aCBpZD0idGltZXMtc29saWQiIGQ9Ik0xMC4zNDMsODcuNWw0LjI2NC00LjI2NGExLjM0LDEuMzQsMCwwLDAsMC0xLjlsLS45NDgtLjk0OGExLjM0MSwxLjM0MSwwLDAsMC0xLjksMEw3LjUsODQuNjU3LDMuMjM2LDgwLjM5MmExLjM0MSwxLjM0MSwwLDAsMC0xLjksMGwtLjk0OC45NDhhMS4zNCwxLjM0LDAsMCwwLDAsMS45TDQuNjU3LDg3LjUuMzkyLDkxLjc2NGExLjM0MSwxLjM0MSwwLDAsMCwwLDEuOWwuOTQ4Ljk0OGExLjM0MSwxLjM0MSwwLDAsMCwxLjksMEw3LjUsOTAuMzQzbDQuMjY0LDQuMjY0YTEuMzQxLDEuMzQxLDAsMCwwLDEuOSwwbC45NDgtLjk0OGExLjM0MSwxLjM0MSwwLDAsMCwwLTEuOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTgwKSIgZmlsbD0iI2ZmNDE0ZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "uuH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/components/tool/switchButton.vue + 2 modules
var switchButton = __webpack_require__("BdG8");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tool/customForm.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var customForm = ({
  components: {
    switchButton: switchButton["a" /* default */]
  },
  props: {
    forms: {
      type: Array,
      required: true
    },
    init: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    alerts: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    scope: {
      type: String,
      default: function _default() {
        return 'form';
      }
    },
    reading: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    displayMode: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    titleSmallInterval: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // style
    layoutType: {
      type: String,
      default: function _default() {
        return 'flex';
      }
    },
    groupCount: {
      type: Number,
      default: function _default() {
        return 4;
      }
    },
    gap: {
      type: String,
      default: function _default() {
        return '16px';
      }
    }
  },
  data: function data() {
    return {
      result: {},
      output: {},
      display: true
    };
  },

  watch: {
    'forms': function forms() {},
    'init': function init() {
      this.initialResults();
    },

    'result': {
      handler: function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
          return regenerator_default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.afterTreatment(this.result);

                case 2:
                  this.output = _context.sent;

                  this.$emit('change', this.output, this.$validator, this.errors);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }(),
      deep: true
    }
  },
  created: function created() {
    this.initialResults();
  },

  methods: {
    initialResults: function initialResults() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var input, initials;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.preTreatment(_this.init);

              case 2:
                input = _context2.sent;
                initials = {
                  input: '',
                  datalist: '',
                  password: '',
                  textarea: '',
                  boolean: false,
                  select: '',
                  single: '',
                  multiple: [],
                  number: '',
                  date: '',
                  time: '',
                  datetime: '',
                  file: [],
                  text: ''
                };

                _this.result = _this.forms.reduce(function (s, c) {
                  return extends_default()({}, s, c.value ? defineProperty_default()({}, c.value, input[c.value] !== null && input[c.value] !== undefined ? input[c.value] : initials[c.type]) : {});
                }, {});

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    preTreatment: function preTreatment(init) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var input, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                input = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 4;
                _iterator = get_iterator_default()(_this2.forms);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 16;
                  break;
                }

                form = _step.value;
                _context4.t0 = form.value;

                if (!_context4.t0) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 12;
                return (form.inputFormat || function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(x) {
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }())(init[form.value]);

              case 12:
                input[form.value] = _context4.sent;

              case 13:
                _iteratorNormalCompletion = true;
                _context4.next = 6;
                break;

              case 16:
                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t1 = _context4['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 22:
                _context4.prev = 22;
                _context4.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context4.prev = 25;

                if (!_didIteratorError) {
                  _context4.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context4.finish(25);

              case 29:
                return _context4.finish(22);

              case 30:
                return _context4.abrupt('return', input);

              case 31:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    afterTreatment: function afterTreatment(result) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var output, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, form;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                output = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 4;
                _iterator2 = get_iterator_default()(_this3.forms);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 16;
                  break;
                }

                form = _step2.value;
                _context6.t0 = form.value;

                if (!_context6.t0) {
                  _context6.next = 13;
                  break;
                }

                _context6.next = 12;
                return (form.outputFormat || function () {
                  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(x) {
                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            return _context5.abrupt('return', x);

                          case 1:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }())(result[form.value]);

              case 12:
                output[form.value] = _context6.sent;

              case 13:
                _iteratorNormalCompletion2 = true;
                _context6.next = 6;
                break;

              case 16:
                _context6.next = 22;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t1 = _context6['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t1;

              case 22:
                _context6.prev = 22;
                _context6.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 25:
                _context6.prev = 25;

                if (!_didIteratorError2) {
                  _context6.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context6.finish(25);

              case 29:
                return _context6.finish(22);

              case 30:
                return _context6.abrupt('return', output);

              case 31:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this3, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef2e235a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/customForm.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ small: _vm.titleSmallInterval, 'row-block': _vm.layoutType === 'flex' }, _vm.layoutType],style:({
    flex: {
      gap: _vm.gap
    },
    grid: {
      gridTemplateColumns: (new Array(_vm.groupCount)).fill('').map(function () { return '1fr'; }).join(' '),
      gridGap: _vm.gap
    }
  }[_vm.layoutType]),attrs:{"id":"custom-form-container"}},_vm._l((_vm.forms.filter(function (form) { return form.display ? form.display(_vm.result) : true; })),function(form,index){return _c('div',{key:index,staticClass:"form-group",class:{
      disabled: (form.disabled || (function () { return false; }))(_vm.result),
      reading: _vm.reading,
      'display-mode': _vm.displayMode || form.displayMode
    },style:({
      flex: form.width ? { flexBasis: form.width } : { flex: form.flex || 1 },
      grid: form.grid ? { gridColumn: 'span ' + form.grid } : {}
    }[_vm.layoutType])},[_c('div',[(_vm.display)?_c('form',{attrs:{"data-vv-scope":_vm.scope}},[(form.type || form.title)?_c('div',[(form.title)?_c('div',{staticClass:"label"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(form.title))]),_vm._v(" "),(form.validate && form.validate.includes('required') && form.title !== '　')?_c('span',{staticClass:"required"},[_vm._v(_vm._s((form.requiredMsg || (function () { return '*'; }))(form)))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"description"},[_vm._v(_vm._s(form.description))]),_vm._v(" "),_c('span',{staticClass:"invisible"},[_vm._v(_vm._s(form.invisible))])]):_vm._e(),_vm._v(" "),(form.type && _vm.result[form.value] !== undefined)?_c('div',{staticClass:"options",class:[form.type, { error: _vm.alerts[form.value] || _vm.errors.has(_vm.scope + '.' + form.value) || form.error }],style:(form.optionWidth ? { width: form.optionWidth, flex: 1 } : { flex: 1 })},[(form.type === 'input')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"text","id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result) || form.inputDisabled,"placeholder":(form.placeholder || (function () { return ''; }))(form),"autocomplete":form.autocomplete || 'on'},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(form.type === 'datalist')?[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"text","id":form.value,"name":form.value,"list":form.value + '-list',"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}}),_vm._v(" "),_c('datalist',{attrs:{"id":form.value + '-list'}},_vm._l((form.lists),function(option,index){return _c('option',{key:index,domProps:{"value":option}})}),0)])]:_vm._e(),_vm._v(" "),(form.type === 'password')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"password","id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form),"autocomplete":form.autocomplete || 'on'},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(form.type === 'textarea')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"id":form.value,"name":form.value,"tabindex":form.tabindex,"rows":form.row,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(form.type === 'select')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#A9A9A9' }),attrs:{"id":form.value,"name":form.value,"tabindex":form.tabindex,"disabled":(form.disabled || (function () { return false; }))(_vm.result)},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.result, form.value, $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(form.placeholder)?_c('option',{attrs:{"value":"","disabled":""}},[_vm._v(_vm._s(form.placeholder(form)))]):_vm._e(),_vm._v(" "),_vm._l((form.options),function(option,index){return _c('option',{key:index,style:({ color: '#333333' }),attrs:{"disabled":option.disabled},domProps:{"value":option.value || ''}},[_vm._v(_vm._s(option.title))])})],2)])]:(form.type === 'boolean')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('switchButton',{attrs:{"disabled":(form.disabled || (function () { return false; }))(_vm.result),"checked":_vm.result[form.value]},on:{"input":function (c) { return _vm.result[form.value] = c; }}})],1)]:(form.type === 'single')?_vm._l((form.options),function(option,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],key:index},[_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) },attrs:{"for":form.value + '-' + option.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"radio","id":form.value + '-' + option.value,"name":form.value,"disabled":(form.disabled || (function () { return false; }))(_vm.result)},domProps:{"value":option.value,"checked":_vm._q(_vm.result[form.value],option.value)},on:{"change":function($event){_vm.$set(_vm.result, form.value, option.value)}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(form.type === 'multiple')?_vm._l((form.options),function(option,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],key:index},[_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) || form.range && ((form.range[0] === (_vm.result[form.value] || []).length && _vm.result[form.value].includes(option.value)) || (form.range[1] === (_vm.result[form.value] || []).length && !_vm.result[form.value].includes(option.value))) },attrs:{"for":form.value + '-' + option.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"checkbox","id":form.value + '-' + option.value,"name":form.value,"disabled":(form.disabled || (function () { return false; }))(_vm.result) || (form.range && ((form.range[0] === (_vm.result[form.value] || []).length && _vm.result[form.value].includes(option.value)) || (form.range[1] === (_vm.result[form.value] || []).length && !_vm.result[form.value].includes(option.value))))},domProps:{"value":option.value,"checked":Array.isArray(_vm.result[form.value])?_vm._i(_vm.result[form.value],option.value)>-1:(_vm.result[form.value])},on:{"change":function($event){var $$a=_vm.result[form.value],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.result, form.value, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.result, form.value, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.result, form.value, $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(option.title))])])])}):(form.type === 'number')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(form.inputWidth ? { width: form.inputWidth } : {}),attrs:{"type":"number","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'date')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"date","id":form.value,"name":form.value,"tabindex":form.tabindex,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : '9999-12-31',"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'time')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"time","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'datetime')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result[form.value]),expression:"result[form.value]"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],style:(_vm.result[form.value] ? {} : { color: '#777777' }),attrs:{"type":"datetime-local","id":form.value,"name":form.value,"tabindex":form.tabindex,"step":form.step,"min":form.range ? form.range[0] : null,"max":form.range ? form.range[1] : null,"disabled":(form.disabled || (function () { return false; }))(_vm.result),"placeholder":(form.placeholder || (function () { return ''; }))(form)},domProps:{"value":(_vm.result[form.value])},on:{"change":function (e) { return (form.onChange || (function () {}))(_vm.result[form.value]); },"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.result, form.value, $event.target.value)}}})])]:(form.type === 'file')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}]},[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"},{name:"validate",rawName:"v-validate",value:(form.validate),expression:"form.validate"}],attrs:{"type":"file","id":form.value,"name":form.value,"multiple":form.multiple,"accept":form.accept,"disabled":(form.disabled || (function () { return false; }))(_vm.result)},on:{"change":function (e) { return e.target.files.length ? Array.from(e.target.files) : []; }}}),_vm._v(" "),_c('button',{attrs:{"tabindex":form.tabindex}},[_c('span',[_vm._v(_vm._s(form.text || 'select'))]),_vm._v(" "),_c('label',{class:{ diabled: (form.disabled || (function () { return false; }))(_vm.result) },attrs:{"for":form.value}})]),_vm._v(" "),(!_vm.$scopedSlots[form.value])?_vm._l((_vm.result[form.value] || []),function(file,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(file.name))])])}):_vm._e()],2)]:(form.type === 'text')?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(form.visible !== false),expression:"form.visible !== false"}],staticClass:"input-group"},[_c('span',{class:{ noWrap: !form.wrap },style:(form.style || {}),attrs:{"title":_vm.result[form.value]}},[_vm._v(_vm._s(_vm.result[form.value] || '--'))])])]:_vm._e(),_vm._v(" "),(_vm.alerts[form.value] || _vm.errors.has(_vm.scope + '.' + form.value) || form.error)?_c('div',{class:(_vm.alerts[form.value] || { type: 'error' }).type,style:(form.inputWidth ? { left: (form.inputWidth.replace('px', '') - 25) + 'px' } : {})},[_c('div',[_c('img',{attrs:{"src":{
                    error: __webpack_require__("uu87"),
                    success: __webpack_require__("Lkm/")
                  }[(_vm.alerts[form.value] || { type: 'error' }).type]}}),_vm._v(" "),(!_vm.alerts[form.value] || _vm.alerts[form.value].msg)?_c('div',{staticClass:"menu-container"},[_c('div',{staticClass:"menu-block default-shadow"},[(_vm.alerts[form.value])?_c('span',[_vm._v(_vm._s(_vm.alerts[form.value].msg))]):(_vm.errors.has(_vm.scope + '.' + form.value) || form.error)?_c('span',[_vm._v(_vm._s((form.alert || (function () { return null; }))(form, _vm.errors.first(_vm.scope + '.' + form.value)) || (_vm.errors.first(_vm.scope + '.' + form.value) || form.error).replace(form.value, form.errorTitle || form.title)))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"cursor-bor-cor"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-top"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-left"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor shadow-right"}),_vm._v(" "),_c('span',{staticClass:"menu-bor-cor"})]):_vm._e()])]):_vm._e()],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$scopedSlots[form.value])?_c('div',{staticClass:"custom",class:{ 'main-custom': !form.type && !form.title }},[_vm._t(form.value,null,{data:_vm.result,result:_vm.result[form.value],output:_vm.output[form.value],form:form})],2):_vm._e()]):_vm._e()])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var tool_customForm = (esExports);
// CONCATENATED MODULE: ./src/components/tool/customForm.vue
function injectStyle (ssrContext) {
  __webpack_require__("fujj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  customForm,
  tool_customForm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_tool_customForm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vOTy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBpZD0iR2FzdHJvZW50ZXJvbG9neV9IZXBhdG9sb2d5IiBkYXRhLW5hbWU9Ikdhc3Ryb2VudGVyb2xvZ3kgJmFtcDsgSGVwYXRvbG9neSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc3NyAxODMpIj4KICAgIDxyZWN0IGlkPSLplbfmlrnlvaJfMjkzMCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMjkzMCIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NzcgLTE4MykiIGZpbGw9IiNmZmYiIG9wYWNpdHk9IjAiLz4KICAgIDxnIGlkPSLjgrDjg6vjg7zjg5dfNzA4NSIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgNzA4NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzg2IC0xODAuMjE3KSI+CiAgICAgIDxwYXRoIGlkPSLjg5HjgrlfMTUiIGRhdGEtbmFtZT0i44OR44K5IDE1IiBkPSJNMTA4LjUyMywxOTAuNTc1QTQuMTUxLDQuMTUxLDAsMCwwLDEwNS4zLDE4NS43YTQuMyw0LjMsMCwwLDAtMi40NjYuMjg4Yy0uODc3LS41NjEtLjExOC0uNzQ1LDAtLjk3NS0uMDU2LS4yMzItLjk3Ni0uNi0uOTc2LS42LS4yNDMuMTM0LTEuNy40MzMtLjUxLDIuNzZhNC40ODUsNC40ODUsMCwwLDAtLjg1NCwxLjhjLS43NTksMy45MTEtMi4wODcsNC43NzYtMy43LDQuNTUyYTIuOTY0LDIuOTY0LDAsMCwwLTIuMzQuNTEzLDUuNTg4LDUuNTg4LDAsMCwwLTMtMS4wNTgsMi43MzgsMi43MzgsMCwwLDAtMS45OTIuOTNjLTIuMjEzLDIuNDY4LjU2OSwxMC44NjcuNjY0LDExLjAyN2wyLjI3Ny40ODFjLS41MDYtLjgtMy4xLTguNjg3LTEuNjEzLTEwLjI5YTEuMDU2LDEuMDU2LDAsMCwxLC43MjctLjM1MywzLjQsMy40LDAsMCwxLDEuODM0LjY3MywyLjczNSwyLjczNSwwLDAsMC0uMTU4LjU0NSwzLjE0LDMuMTQsMCwwLDAsMi40MzUsMy42ODZDMTA3LjgsMjA0LjIzMSwxMDguNTIzLDE5MC41NzUsMTA4LjUyMywxOTAuNTc1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg4LjYwMiAtMTc5LjIpIiBmaWxsPSIjZmZmIi8+CiAgICA8L2c+CiAgICA8cGF0aCBpZD0ic3ZnXzEiIGQ9Ik00MC4zMiwxMzMuNmE1Ljc1Myw1Ljc1MywwLDAsMC0uNzUyLjAwNWMtLjk0NC4xMzItLjkzMy4zMjMtLjUxNywxLjE1M2E2LjU3Myw2LjU3MywwLDAsMSwuNTEyLDIuMjE3Yy4xMTcsMS4wMjYuMSwyLjA2My4xNzYsMy4wODlhMS4zMTksMS4zMTksMCwwLDEtLjc0NiwxLjM1NCwxNi4wNjgsMTYuMDY4LDAsMCwxLTEuNDc3Ljc0Niw4LjUsOC41LDAsMCwwLTIuOTcsMi4wNThjLTEuMiwxLjI2NC0yLjQsMi41MjMtMy42MzEsMy43NjEtLjc4OS44LTEuNTIuNjgyLTEuOTM1LS4zNjUtLjkyOC0yLjM3LTEuOTItNC43MjQtMi42NDUtNy4xNTdhNS41NjYsNS41NjYsMCwwLDEsMi43MjUtNi43MDgsMTEuNzI1LDExLjcyNSwwLDAsMSw3LjA4Ni0xLjE1M2MuNzQ2LjA2OSwxLjUuMTU5LDIuMjUuMiwzLjMxNi4xNDgsNi42MzguMjc1LDkuOTU1LjQxM2E2LjUzOSw2LjUzOSwwLDAsMSwuNzg5LjA4NWMuOTY1LjE1OSwxLjE1Ny41NjEuNjY2LDEuMzkxYTEuMzgsMS4zOCwwLDAsMS0uMTkyLjI3LDIwLjIsMjAuMiwwLDAsMS02LjgsNS4xNjgsNS4yODEsNS4yODEsMCwwLDEtLjY4OC4yMzgsMS4zNDYsMS4zNDYsMCwwLDEtMS45MzUtMS4xNjlDMzkuOSwxMzcuMzQ5LDM5LjU2MywxMzUuNSw0MC4zMiwxMzMuNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc1MS45MzQgLTMxNC41MDMpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "wtkH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cGF0aCBpZD0iZXh0ZXJuYWwtbGluay1yZWd1bGFyIiBkPSJNMTEuNjYzLDAsNy44MzcsMEEuMzM3LjMzNywwLDAsMCw3LjUuMzQxdi43ODFhLjMzOC4zMzgsMCwwLDAsLjM0NC4zMzhMOS41NywxLjRsLjA0OC4wNDhMMy4wODIsNy45OGEuMjgxLjI4MSwwLDAsMCwwLC40bC41MzkuNTM5YS4yODEuMjgxLDAsMCwwLC40LDBsNi41MzYtNi41MzYuMDQ4LjA0OEwxMC41NCw0LjE1NmEuMzM4LjMzOCwwLDAsMCwuMzM3LjM0NGguNzgxQS4zMzcuMzM3LDAsMCwwLDEyLDQuMTYzTDEyLC4zMzdBLjMzNy4zMzcsMCwwLDAsMTEuNjYzLDBaTTEwLjEyNSw2Ljc1SDkuNzVhLjM3NS4zNzUsMCwwLDAtLjM3NS4zNzV2My42MDlhLjE0MS4xNDEsMCwwLDEtLjE0MS4xNDFIMS4yNjZhLjE0MS4xNDEsMCwwLDEtLjE0MS0uMTQxVjIuNzY2YS4xNDEuMTQxLDAsMCwxLC4xNDEtLjE0MUg0Ljg3NUEuMzc1LjM3NSwwLDAsMCw1LjI1LDIuMjVWMS44NzVBLjM3NS4zNzUsMCwwLDAsNC44NzUsMS41SDEuMTI1QTEuMTI1LDEuMTI1LDAsMCwwLDAsMi42MjV2OC4yNUExLjEyNSwxLjEyNSwwLDAsMCwxLjEyNSwxMmg4LjI1QTEuMTI1LDEuMTI1LDAsMCwwLDEwLjUsMTAuODc1VjcuMTI1QS4zNzUuMzc1LDAsMCwwLDEwLjEyNSw2Ljc1WiIgZmlsbD0iIzAwNmVkNiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "x2hU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return priceMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return impactMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chromMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return geneTypeMetadatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return predictionMetaDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return omimPhenotypeIDList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPhenotypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getOrphaPhenotypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getClinvarACMGMapDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getClinvarStatisticData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clinvarACMGMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return reportGTMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return reportEnGTMap; });
/* unused harmony export reportClinvarACMGZHMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return reportCNVTypeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return reportParentalOriginMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acmgMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return datasetStatusMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return datasetPermissionTypeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return datasetPermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return datasetInvitationPermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return datasetPipelineMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return datasetShareAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__("Cduz");








var priceMap = {
  'vcf': {
    price: 59
  },
  'fastq': {
    price: 99
  }
};

var impactMap = {
  'HIGH': {
    color: '#FA3D3D',
    font: 'white'
  },
  'MODERATE': {
    color: '#F8C600',
    font: '#333333'
  },
  'LOW': {
    color: '#83C91E',
    font: '#333333'
  },
  'MODIFIER': {
    color: '#006ED6',
    font: 'white'
  },
  'N/A': {
    color: '#AAAAAA',
    font: 'white'
  }
};

var chromMap = {
  'chr1': {
    title: '1'
  },
  'chr2': {
    title: '2'
  },
  'chr3': {
    title: '3'
  },
  'chr4': {
    title: '4'
  },
  'chr5': {
    title: '5'
  },
  'chr6': {
    title: '6'
  },
  'chr7': {
    title: '7'
  },
  'chr8': {
    title: '8'
  },
  'chr9': {
    title: '9'
  },
  'chr10': {
    title: '10'
  },
  'chr11': {
    title: '11'
  },
  'chr12': {
    title: '12'
  },
  'chr13': {
    title: '13'
  },
  'chr14': {
    title: '14'
  },
  'chr15': {
    title: '15'
  },
  'chr16': {
    title: '16'
  },
  'chr17': {
    title: '17'
  },
  'chr18': {
    title: '18'
  },
  'chr19': {
    title: '19'
  },
  'chr20': {
    title: '20'
  },
  'chr21': {
    title: '21'
  },
  'chr22': {
    title: '22'
  },
  'chrX': {
    title: 'X'
  },
  'chrY': {
    title: 'Y'
  },
  'chrM': {
    title: 'M'
  }
};

var geneTypeMetadatas = {
  'pgp': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['pgp', 'gene_filter'],
      title: 'Phenotype' /* ___ */
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'gene_filter': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['pgp', 'gene_filter'],
      title: 'Gene Panel' /* ___ */
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(gene.variants || {}).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            _ = _ref2[0],
            variant = _ref2[1];

        return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian'];
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
            vkey = _ref4[0];

        return vkey;
      });
    }
  },
  'nbs_pathovar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'Pathogenic Variants' /* ___ */
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      var phenotyps = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {};
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(phenotyps).some(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            _ = _ref6[0],
            phenotype = _ref6[1];

        return phenotype.disease_score !== -1;
      }) ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(phenotyps) : null;
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'nbs_nullvar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'Null Variants' /* ___ */
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      var phenotyps = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {};
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(phenotyps).some(function (_ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
            _ = _ref8[0],
            phenotype = _ref8[1];

        return phenotype.disease_score !== -1;
      }) ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(phenotyps) : null;
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'nbs_carrier': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'Carrier' /* ___ */
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'incidental': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: ['nbs_pathovar', 'nbs_nullvar', 'nbs_carrier', 'incidental'],
      title: 'Incidental findings' /* ___ */
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'monitor': {
    special: true,
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      title: 'Monitor' /* ___ */
    },
    phenotypeFilter: function phenotypeFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {});
    },
    variantFilter: function variantFilter(symbol, gene, caseData, project, mode) {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(gene.variants || {});
    }
  },
  'filter': {
    display: false,
    tagOption: {
      title: 'Filter' /* ___ */
    }
  },
  // old
  'clinvar': {
    old: true,
    tagOption: {
      title: 'Clinvar'
    }
  },
  'nbs': {
    old: true,
    tagOption: {
      title: 'nbs' /* ___ */
    }
  },
  'nbs_nonmendelian': {
    old: true,
    tagOption: {
      title: 'Nonmendelian' /* ___ */
    }
  }
};

var predictionMetaDatas = {
  'SIFT4G': {
    key: {
      score: 'SIFT4G_score',
      pred: 'SIFT4G_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'Polyphen': {
    key: {
      score: 'Polyphen',
      pred: 'Polyphen_pred'
    },
    displayMap: {
      'D': 'Probably Damaging',
      'P': 'Possibly Damaging',
      'B': 'Benign'
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'P': false,
        'B': true
      }[pred];
    }
  },
  'FATHMM': {
    key: {
      score: 'FATHMM_score',
      pred: 'FATHMM_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'MutationAssessor': {
    key: {
      score: 'MutationAssessor_score',
      pred: 'MutationAssessor_pred'
    },
    displayMap: {
      'H': 'High',
      'M': 'Medium',
      'L': 'Low',
      'N': 'Neutral'
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'H': false,
        'M': false,
        'L': true,
        'N': true
      }[pred];
    }
  },
  'PROVEAN': {
    key: {
      score: 'PROVEAN_score',
      pred: 'PROVEAN_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'N': 'Neutral'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.7 : undefined;
    }
  },
  'CADD_phred': {
    key: {
      score: 'CADD_phred',
      pred: 'CADD_phred_pred'
    },
    displayMap: {
      'red': 'Damaging',
      'black': 'Neutral'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 30 : undefined;
    }
  },
  'M_CAP': {
    key: {
      score: 'M_CAP_score',
      pred: 'M_CAP_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.025 : undefined;
    }
  },
  'MetaLR': {
    key: {
      score: 'MetaLR_score',
      pred: 'MetaLR_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'MetaSVM': {
    key: {
      score: 'MetaSVM_score',
      pred: 'MetaSVM_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'REVEL': {
    key: {
      score: 'REVEL_score',
      pred: 'REVEL_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.7 : undefined;
    }
  },
  'BayesDel_addAF': {
    key: {
      score: 'BayesDel_addAF_score',
      pred: 'BayesDel_addAF_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: function checkPassed(score, pred) {
      return {
        'D': false,
        'T': true
      }[pred];
    }
  },
  'ada': {
    key: {
      score: 'ada_score',
      pred: 'ada_pred'
    },
    displayMap: {
      'red': 'Splice-altering',
      'black': 'Neutral'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.6 : undefined;
    }
  },
  'rf': {
    key: {
      score: 'rf_score',
      pred: 'rf_pred'
    },
    displayMap: {
      'red': 'Splice-altering',
      'black': 'Neutral'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.6 : undefined;
    }
  },
  'GERPpp_NR': {
    key: {
      score: 'GERPpp_NR',
      pred: 'GERPpp_NR_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'GERPpp_RS': {
    key: {
      score: 'GERPpp_RS',
      pred: 'GERPpp_RS_pred'
    },
    displayMap: {
      'red': 'Conserved',
      'black': 'Non-conserved'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 2 : undefined;
    }
  },
  'SiPhy_29way_logOdds': {
    key: {
      score: 'SiPhy_29way_logOdds',
      pred: 'SiPhy_29way_logOdds_pred'
    },
    displayMap: {
      'red': 'Conserved',
      'black': 'Non-conserved'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 12.17 : undefined;
    }
  },
  'SiPhy_29way_pi': {
    key: {
      score: 'SiPhy_29way_pi',
      pred: 'SiPhy_29way_pi_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'gnomAD_g_mt_mitotip': {
    key: {
      score: 'gnomAD_g_mt_mitotip_score',
      pred: 'gnomAD_g_mt_mitotip_score_pred'
    },
    displayMap: {
      'red': 'Likely or possibly pathogenic',
      'black': 'Likely or possibly benign'
    },
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 12.66 : undefined;
    }
  },
  'SpliceAI_DS_AG': {
    key: {
      score: 'SpliceAI_DS_AG',
      pred: 'SpliceAI_DS_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DS_AL': {
    key: {
      score: 'SpliceAI_DS_AL',
      pred: 'SpliceAI_DS_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DS_DG': {
    key: {
      score: 'SpliceAI_DS_DG',
      pred: 'SpliceAI_DS_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DS_DL': {
    key: {
      score: 'SpliceAI_DS_DL',
      pred: 'SpliceAI_DS_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score < 0.5 : undefined;
    }
  },
  'SpliceAI_DP_AG': {
    key: {
      score: 'SpliceAI_DP_AG',
      pred: 'SpliceAI_DP_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'SpliceAI_DP_AL': {
    key: {
      score: 'SpliceAI_DP_AL',
      pred: 'SpliceAI_DP_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'SpliceAI_DP_DG': {
    key: {
      score: 'SpliceAI_DP_DG',
      pred: 'SpliceAI_DP_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'SpliceAI_DP_DL': {
    key: {
      score: 'SpliceAI_DP_DL',
      pred: 'SpliceAI_DP_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'oe_syn': {
    key: {
      score: 'oe_syn',
      pred: 'oe_syn_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'oe_mis': {
    key: {
      score: 'oe_mis',
      pred: 'oe_mis_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'oe_lof': {
    key: {
      score: 'oe_lof',
      pred: 'oe_lof_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'syn_z': {
    key: {
      score: 'syn_z',
      pred: 'syn_z_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? true : undefined;
    }
  },
  'mis_z': {
    key: {
      score: 'mis_z',
      pred: 'mis_z_pred'
    },
    displayMap: {},
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 3.09 : undefined;
    }
  },
  'pLI': {
    key: {
      score: 'pLI',
      pred: 'pLI_pred'
    },
    displayMap: {},
    checkPassed: function checkPassed(score, pred) {
      return score || score === 0 ? score <= 0.9 : undefined;
    }
  }
};

var omimPhenotypeIDList = ['175100', '132900', '611788', '604400', '607450', '609040', '610193', '610476', '604370', '612555', '601144', '604772', '115200', '615396', '130050', '301500', '144010', '143890', '192600', '115196', '115197', '600858', '613690', '608751', '608758', '612098', '155240', '603776', '174900', '174900', '601494', '151623', '609192', '610168', '609192', '610168', '613795', '192500', '613688', '603830', '120435', '120435', '120435', '120435', '145600', '601887', '154700', '154700', '131100', '171400', '162300', '608456', '101000', '311250', '168000', '601650', '605373', '115310', '175200', '132600', '158350', '180200', '191100', '613254', '193300', '194070', '277900'];

var getPhenotypeList = function getPhenotypeList(values) {
  var phenotypes = values ? Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* sortData */])(Array.prototype.concat.apply([], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(values).map(function (_ref9) {
    var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
        id = _ref10[0],
        phenotype = _ref10[1];

    var length = !phenotype.Phenotype ? 0 : phenotype.Phenotype instanceof Array ? phenotype.Phenotype.length : 1;
    var isArray = phenotype.Phenotype instanceof Array;
    return new Array(length).fill('').map(function (_, i) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, phenotype, {
        id: id,
        index: i,
        Inheritance: isArray ? (phenotype.Inheritance[i] || '').split(',') : phenotype.Inheritance instanceof Array ? phenotype.Inheritance : [phenotype.Inheritance],
        Phenotype: isArray ? phenotype.Phenotype[i] : phenotype.Phenotype
      });
    });
  })), 'disease_score', 'desc') : [];
  return phenotypes;
};

var getOrphaPhenotypeList = function getOrphaPhenotypeList(values) {
  var phenotypes = values ? Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* sortData */])(Array.prototype.concat.apply([], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(values).map(function (_ref11) {
    var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
        id = _ref12[0],
        phenotype = _ref12[1];

    var length = !phenotype.disease ? 0 : phenotype.disease instanceof Array ? phenotype.disease.length : 1;
    var isArray = phenotype.disease instanceof Array;
    return new Array(length).fill('').map(function (_, i) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, phenotype, {
        id: id,
        index: i,
        inheritance: isArray ? (phenotype.inheritance[i] || '').split(',') : phenotype.inheritance instanceof Array ? phenotype.inheritance : [phenotype.inheritance],
        disease: isArray ? phenotype.disease[i] : phenotype.disease
      });
    });
  })), 'disease_score', 'desc') : [];
  return phenotypes;
};

var getClinvarACMGMapDatas = function getClinvarACMGMapDatas(values) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

  var ary = values ? values.split(/,|\||\//).map(function (value) {
    return (value || 'N/A').replace(/_/g, ' ').trim();
  }) : ['N/A'];
  var map = {
    default: clinvarACMGMap,
    report: clinvarACMGMap
  }[type];
  var datas = Object(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* sortData */])(ary.map(function (value) {
    return map[value] ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, map[value], {
      display_zh: reportClinvarACMGZHMap[value]
    }) : {
      display: value,
      title: value,
      color: '#AAAAAA',
      index: -1
    };
  }), function (data) {
    return data.index;
  }, 'desc');
  return datas;
};

var getClinvarStatisticData = function getClinvarStatisticData(clinvarStatistic) {
  var defaultDataGenerator = function defaultDataGenerator() {
    return {
      n: 0
    };
  };
  var defaultTableConfig = {
    'gs': {
      'title': {
        data: false,
        title: ['Coding Impact'].join(' ') /* ___ */
        , flex: 146,
        color: '#FFFFFF'
      },
      'Pathogenic': {
        title: ['Pathogenic'].join(' ') /* ___ */
        , flex: 135,
        color: '#FA3D3D'
      },
      'Likely_pathogenic': {
        title: ['Likely', 'Pathogenic'].join(' ') /* ___ */
        , flex: 135,
        color: '#FF9E03'
      },
      'Conflicting_interpretations_of_pathogenicity': {
        title: ['Conflicting interpretations', 'of pathogenicity'].join(' ') /* ___ */
        , flex: 210,
        color: '#999999'
      },
      'Uncertain_significance': {
        title: ['Uncertain', 'Significance'].join(' ') /* ___ */
        , flex: 135,
        color: '#F8C600'
      },
      'Likely_benign': {
        title: ['Likely benign'].join(' ') /* ___ */
        , flex: 135,
        color: '#83C91E'
      },
      'Benign': {
        title: ['Benign'].join(' ') /* ___ */
        , flex: 135,
        color: '#349CCF'
      },
      'total': {
        data: false,
        title: ['Total'].join(' ') /* ___ */
        , flex: 135,
        color: '#FFFFFF'
      }
    },
    'csq': {
      'title': {
        data: false,
        title: ['Coding Impact'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'stop_gained': {
        title: ['Stop Gained'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'splice_site': {
        title: ['Splice Site'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'frameshift': {
        title: ['Frameshift', 'Variant'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'stop_lost': {
        title: ['Stop Lost'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'start_lost': {
        title: ['Start Lost'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'missense': {
        title: ['Missense'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'inframe_indel': {
        title: [' Inframe Indel'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'synonymous': {
        title: ['Synonymous', 'Variant'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'non_coding': {
        title: ['Non Coding'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      },
      'total': {
        data: false,
        title: ['Total'].join(' ') /* ___ */
        , flex: 1,
        color: '#FFFFFF'
      }
    }
  };
  var clinvarTableData = {};
  clinvarTableData['function'] = {
    getOpacity: function getOpacity(p) {
      if (p === 0) return '00';else if (p < 0.02) return '02';else if (p <= 0.1) return '10';else if (p <= 0.2) return '20';else if (p <= 0.3) return '30';else if (p <= 0.4) return '40';else if (p <= 0.5) return '50';else if (p <= 0.6) return '60';else if (p <= 0.7) return '70';else if (p <= 0.8) return '80';else if (p <= 0.9) return '90';else return '';
    }
  };
  clinvarTableData['config'] = defaultTableConfig;
  clinvarTableData['data'] = {
    gs: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(defaultTableConfig['gs']).filter(function (_ref13) {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
          _ = _ref14[0],
          value = _ref14[1];

      return value.data !== false;
    }).reduce(function (r, _ref15) {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref15, 1),
          key = _ref16[0];

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(defaultTableConfig['csq']).filter(function (_ref17) {
        var _ref18 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref17, 2),
            _ = _ref18[0],
            value = _ref18[1];

        return value.data !== false;
      }).reduce(function (r, _ref19) {
        var _ref20 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref19, 1),
            key = _ref20[0];

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, defaultDataGenerator()));
      }, {}), {
        total: 0
      })));
    }, {}), {
      total: 0
    }),
    csq: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(defaultTableConfig['csq']).filter(function (_ref21) {
      var _ref22 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref21, 2),
          _ = _ref22[0],
          value = _ref22[1];

      return value.data !== false;
    }).reduce(function (r, _ref23) {
      var _ref24 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref23, 1),
          key = _ref24[0];

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(defaultTableConfig['gs']).filter(function (_ref25) {
        var _ref26 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref25, 2),
            _ = _ref26[0],
            value = _ref26[1];

        return value.data !== false;
      }).reduce(function (r, _ref27) {
        var _ref28 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref27, 1),
            key = _ref28[0];

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, r, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, defaultDataGenerator()));
      }, {}), {
        total: 0
      })));
    }, {}), {
      total: 0
    })
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clinvarStatistic), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var data = _step.value;

      var keys = {
        gs_clinsig: data.gs_clinsig.replace(/_variant$/, ''),
        csq: data.csq.replace(/_variant$/, '')
      };
      clinvarTableData['data']['gs'].total += data.n;
      clinvarTableData['data']['gs'][keys.gs_clinsig].total += data.n;
      clinvarTableData['data']['gs'][keys.gs_clinsig][keys.csq].n += data.n;
      clinvarTableData['data']['csq'].total += data.n;
      clinvarTableData['data']['csq'][keys.csq].total += data.n;
      clinvarTableData['data']['csq'][keys.csq][keys.gs_clinsig].n += data.n;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return clinvarTableData;
};

var clinvarACMGMap = {
  'Pathogenic': {
    display: 'Pathogenic',
    title: 'Pathogenic',
    color: '#FA3D3D',
    index: 12
  },
  'Pathogenic/Likely pathogenic': {
    display: 'Pathogenic/Likely pathogenic',
    title: 'Pathogenic/Likely pathogenic',
    color: '#FF9E03',
    index: 5
  },
  'Likely pathogenic': {
    display: 'Likely pathogenic',
    title: 'Likely pathogenic',
    color: '#FF9E03',
    index: 11
  },
  'Conflicting interpretations of pathogenicity': {
    display: 'Conflicting interpretations of pathogenicity',
    title: 'Conflicting interpretations of pathogenicity',
    color: '#F8C600',
    index: 10
  },
  'Uncertain significance': {
    // display: 'VUS',
    // title: 'Variant of Uncertain Significance',
    display: 'Uncertain significance',
    title: 'Uncertain significance',
    color: '#F8C600',
    index: 9
  },
  'risk factor': {
    display: 'risk factor',
    title: 'risk factor',
    color: '#FF0000',
    index: 8
  },
  'Benign': {
    display: 'Benign',
    title: 'Benign',
    color: '#006ED6',
    index: 6
  },
  'Benign/Likely benign': {
    display: 'Benign/Likely benign',
    title: 'Benign/Likely benign',
    color: '#83C91E',
    index: 4
  },
  'Likely benign': {
    display: 'Likely benign',
    title: 'Likely benign',
    color: '#83C91E',
    index: 7
  },
  'drug response': {
    display: 'drug response',
    title: 'drug response',
    color: '#F8C600',
    index: 3
  },
  'protective': {
    display: 'protective',
    title: 'protective',
    color: '#F8C600',
    index: 2
  },
  'other': {
    display: 'other',
    title: 'other',
    color: '#333333',
    index: 1
  },
  'N/A': {
    display: 'N/A',
    title: 'N/A',
    color: '#AAAAAA',
    index: 0
  }
};

var reportGTMap = {
  'heterozygous': 'hetero<br>(雜合子)',
  'homozygous': 'homo<br>(純合子)',
  'hemizygous': 'hemi<br>(半合子)',
  'heterozygote': 'hetero<br>(雜合子)',
  'homozygote': 'homo<br>(純合子)',
  'hemizygote': 'hemi<br>(半合子)'
};

var reportEnGTMap = {
  'heterozygous': 'hetero',
  'homozygous': 'homo',
  'hemizygous': 'hemi',
  'heterozygote': 'hetero',
  'homozygote': 'homo',
  'hemizygote': 'hemi'
};

var reportClinvarACMGZHMap = {
  'Benign': '良性的',
  'Benign/Likely benign': '良性的/可能良性的',
  'Conflicting interpretations of pathogenicity': '致病性意義衝突',
  'Likely benign': '可能良性的',
  'drug response': '藥物反應',
  'risk factor': '風險因子',
  'protective': '有保護性的',
  'Uncertain significance': '不明確的',
  'Pathogenic': '致病的',
  'other': '其他',
  'Likely pathogenic': '可能致病的',
  'Pathogenic/Likely pathogenic': '致病的/可能致病的',
  'Affects': '非疾病相關表徵反應'
};

var reportCNVTypeMap = {
  'deletion': 'Deletion',
  'duplication': 'Duplication',
  'insertion': 'Insertion'
};

var reportParentalOriginMap = {
  'De novo': 'De novo',
  'Paternal': 'Paternal',
  'Maternal': 'Maternal',
  'Biparental': 'Biparental',
  'Unknown': 'Unknown'
};

var acmgMap = {
  // BA
  BA1: {
    title: 'BA1',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['Allele frequency is >5% in population databases.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  // BS
  BS1: {
    title: 'BS1',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['Allele frequency is greater than expected for disorder.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BS2: {
    title: 'BS2',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['Observed in a healthy adult individual for a recessive (homozygous), dominant (heterozygous), or X-linked (hemizygous) disorder, with full penetrance expected at an early age.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BS4: {
    title: 'BS4',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['Lack of segregation in affected members of a family.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BS3: {
    title: 'BS3',
    type: 'Strong',
    class: 'benign-strong',
    informations: ['Well-established in vitro or in vivo functional studies show no damaging effect on protein function or splicing.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  // BP
  BP2: {
    title: 'BP2',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['Observed in trans with a pathogenic variant for a fully penetrant dominant gene/disorder or observed in cis with a pathogenic variant in any inheritance pattern.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BP5: {
    title: 'BP5',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['Variant found in a case with an alternate molecular basis for disease.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BP1: {
    title: 'BP1',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['Missense variant in a gene for which primarily truncating variants are known to cause disease.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BP3: {
    title: 'BP3',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['In-frame deletions/insertions in a repetitive region without a known function.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BP4: {
    title: 'BP4',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['Multiple lines of computational evidence suggest no impact on gene or gene product (conservation, evolutionary, splicing impact, etc.).'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BP7: {
    title: 'BP7',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['A synonymous (silent) variant for which splicing prediction algorithms predict no impact to the splice consensus sequence nor the creation of a new splice site AND the nucleotide is not highly conserved.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  BP6: {
    title: 'BP6',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: ['Reputable source recently reports variant as benign, but the evidence is not available to the laboratory to perform an independent evaluation.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  // PP
  PP1: {
    title: 'PP1',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['Cosegregation with disease in multiple affected family members in a gene definitively known to cause the disease.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PP2: {
    title: 'PP2',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['Missense variant in a gene that has a low rate of benign missense variation and in which missense variants are a common mechanism of disease.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PP3: {
    title: 'PP3',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['Multiple lines of computational evidence support a deleterious effect on the gene or gene product (conservation, evolutionary, splicing impact, etc.).'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PP4: {
    title: 'PP4',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['Patient’s phenotype or family history is highly specific for a disease with a single genetic etiology.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PP5: {
    title: 'PP5',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: ['Reputable source recently reports variant as pathogenic, but the evidence is not available to the laboratory to perform an independent evaluation.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  // PM
  PM2: {
    title: 'PM2',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['Absent from controls (or at extremely low frequency if recessive) in population databases.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PM3: {
    title: 'PM3',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['For recessive disorders, detected in trans with a pathogenic variant.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PM6: {
    title: 'PM6',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['Assumed de novo, but without confirmation of paternity and maternity.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PM1: {
    title: 'PM1',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['Located in a mutational hot spot and/or critical and well-established functional domain (e.g., active site of an enzyme) without benign variation.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PM4: {
    title: 'PM4',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['Protein length changes as a result of in-frame deletions/insertions in a nonrepeat region or stop-loss variants.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PM5: {
    title: 'PM5',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: ['Novel missense change at an amino acid residue where a different missense change determined to be pathogenic has been seen before.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  // PS
  PS4: {
    title: 'PS4',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['The prevalence of the variant in affected individuals is significantly increased compared with the prevalence in controls.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PS2: {
    title: 'PS2',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['De novo (both maternity and paternity confirmed) in a patient with the disease and no family history.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PS1: {
    title: 'PS1',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['Same amino acid change as a previously established pathogenic variant regardless of nucleotide. change.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  PS3: {
    title: 'PS3',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: ['Well-established in vitro or in vivo functional studies supportive of a damaging effect on the gene or gene product.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  },
  // PVS
  PVS1: {
    title: 'PVS1',
    type: 'Very Strong',
    class: 'pathogenic-very-strong',
    informations: ['null variant (nonsense, frameshift, canonical ±1 or 2 splice sites, initiation codon, single or multiexon deletion) in a gene where LOF is a known mechanism of disease.'],
    explanations: ['// EXPLANATIONS', '// EXPLANATIONS']
  }
};

var datasetStatusMap = {
  created: {
    title: 'created' /* ___ */
    , color: '#333333'
  },
  analyzing: {
    title: 'Analyzing…' /* ___ */
    , color: '#83C91E'
  },
  completed: {
    title: 'Done' /* ___ */
    , color: '#003679'
  },
  failed: {
    title: 'Failed' /* ___ */
    , color: '#BE0F0F'
  },
  disabled: {
    title: 'Disabled' /* ___ */
    , color: '#BE0F0F'
  }
};

var datasetPermissionTypeMap = {
  private: {
    title: 'Private' /* ___ */
  },
  community: {
    title: 'Community' /* ___ */
  }
};

var datasetPermissionMap = {
  private: {
    title: 'Private' /* ___ */
    , color: '#BE0F0F',
    type: 'private'
  },
  basic: {
    title: 'Basic' /* ___ */
    , color: '#333333',
    type: 'community'
  },
  explore: {
    title: 'Data Explore' /* ___ */
    , color: '#003679',
    type: 'community'
  },
  full: {
    title: 'Full access' /* ___ */
    , color: '#83C91E',
    type: 'community'
  }
};

var datasetInvitationPermissionMap = {
  explore: {
    title: 'Data Explore' /* ___ */
  },
  full: {
    title: 'Full access' /* ___ */
  }
};

var datasetPipelineMap = {
  WES: {
    title: 'Whole Exome Sequencing' /* ___ */
  },
  WGS: {
    title: 'Whole Genome Sequencing' /* ___ */
  }
};

var datasetShareAlert = function datasetShareAlert(dataset) {
  if (dataset.external_data_included) return 'Because it contains community data. If you want to share dataset, create a dataset with all your data.'; /* ___ */
  if (dataset.disabled) return 'Because dataset is disable'; /* ___ */
  if (['analyzing'].includes(dataset.state)) return 'Because data analysis is processing'; /* ___ */
  if (['created', 'failed'].includes(dataset.state)) return 'Because data analysis is failed'; /* ___ */
  return null;
};

/***/ }),

/***/ "x9yG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDI0IDMwIj4KICA8ZyBpZD0iSGVtYXRvbG9neSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyMjEgNDIxKSI+CiAgICA8cGF0aCBpZD0i44OR44K5XzEwIiBkYXRhLW5hbWU9IuODkeOCuSAxMCIgZD0iTTc3LjA3NiwxMS4zMTlhMS4yOTQsMS4yOTQsMCwwLDAtMS43NTgsMGMtLjQ1LjQyMi0xMS4xMTgsMTAuNC0xMS4xMTgsMTcuMTA1LDAsNi45MTgsNS4zODEsMTIuNTUsMTIsMTIuNTVzMTItNS42MzIsMTItMTIuNTVjMC02LjctMTAuNjY3LTE2LjY4My0xMS4xMjQtMTcuMTA1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE1Ni44MDEgLTQzMS45NzUpIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0i44OR44K5XzExIiBkYXRhLW5hbWU9IuODkeOCuSAxMSIgZD0iTTAsMEE2Ljc4Nyw2Ljc4NywwLDAsMCw2LjI4Miw2LjgzMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIyNy43NTQgLTQwNy45NzUpIHJvdGF0ZSg0NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMzY3OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "xMCn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiNmYTNkM2QiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "xccc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzM0MzIiIGRhdGEtbmFtZT0i44Kw44Or44O844OXIDM0MzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTg3IC0xNTM5KSI+CiAgICA8ZyBpZD0i6ZW35pa55b2iXzE0OCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTg3IDE1MzkpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjEwIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjkuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgaWQ9IuOCsOODq+ODvOODl18zOTUyIiBkYXRhLW5hbWU9IuOCsOODq+ODvOODlyAzOTUyIj4KICAgICAgPGNpcmNsZSBpZD0i5qWV5YaG5b2iXzEyMyIgZGF0YS1uYW1lPSLmpZXlhoblvaIgMTIzIiBjeD0iOSIgY3k9IjkiIHI9IjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5ODggMTU0MCkiIGZpbGw9IiM4M2M5MWUiLz4KICAgICAgPGcgaWQ9IualleWGhuW9ol8xNTMiIGRhdGEtbmFtZT0i5qWV5YaG5b2iIDE1MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk5MyAxNTQ1KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICAgIDxjaXJjbGUgY3g9IjQiIGN5PSI0IiByPSI0IiBzdHJva2U9Im5vbmUiLz4KICAgICAgICA8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMy41IiBmaWxsPSJub25lIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "xg5u":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2hlY2stc3F1YXJlLXNvbGlkIiBkPSJNMTcuODU3LDUySDIuMTQzQTIuMTQzLDIuMTQzLDAsMCwxLDAsNDkuODU3VjM0LjE0M0EyLjE0MywyLjE0MywwLDAsMSwyLjE0MywzMkgxNy44NTdBMi4xNDMsMi4xNDMsMCwwLDEsMjAsMzQuMTQzVjQ5Ljg1N0EyLjE0MywyLjE0MywwLDAsMSwxNy44NTcsNTJaTTguNzE5LDQ3LjYyMmw4LjIxNC04LjIxNGEuNzE0LjcxNCwwLDAsMCwwLTEuMDFsLTEuMDEtMS4wMWEuNzE0LjcxNCwwLDAsMC0xLjAxLDBsLTYuNyw2LjdMNS4wODcsNDAuOTU5YS43MTQuNzE0LDAsMCwwLTEuMDEsMGwtMS4wMSwxLjAxYS43MTQuNzE0LDAsMCwwLDAsMS4wMWw0LjY0Myw0LjY0M0EuNzE0LjcxNCwwLDAsMCw4LjcxOSw0Ny42MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zMikiIGZpbGw9IiM3MTQ4OTQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "z0Pm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0i6ZW35pa55b2iXzE0OCIgZGF0YS1uYW1lPSLplbfmlrnlvaIgMTQ4IiBmaWxsPSIjZmZmIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIxMCIgc3Ryb2tlPSJub25lIi8+CiAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjE5IiBoZWlnaHQ9IjE5IiByeD0iOS41IiBmaWxsPSJub25lIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "z3W2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0ibWludXMtY2lyY2xlLXNvbGlkIiBkPSJNMTgsOEExMCwxMCwwLDEsMCwyOCwxOCwxMCwxMCwwLDAsMCwxOCw4Wk0xMi42NzcsMTkuNjEzYS40ODUuNDg1LDAsMCwxLS40ODQtLjQ4NFYxNi44NzFhLjQ4NS40ODUsMCwwLDEsLjQ4NC0uNDg0SDIzLjMyM2EuNDg1LjQ4NSwwLDAsMSwuNDg0LjQ4NHYyLjI1OGEuNDg1LjQ4NSwwLDAsMS0uNDg0LjQ4NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIgZmlsbD0iI2ZhM2QzZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ "zSkq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS41IiBoZWlnaHQ9IjE1LjUiIHZpZXdCb3g9IjAgMCAxNS41IDE1LjUiPgogIDxwYXRoIGlkPSJzZWFyY2gtbGlnaHQiIGQ9Ik0xNC45LDE0LjEwOSwxMS4xMTgsMTAuMzNhLjM0OC4zNDgsMCwwLDAtLjI0OS0uMWgtLjNhNi4wMzIsNi4wMzIsMCwxLDAtLjM0LjM0M3YuM2EuMzYuMzYsMCwwLDAsLjEuMjQ5TDE0LjEwOSwxNC45YS4zNTIuMzUyLDAsMCwwLC41LDBsLjI5LS4yOUEuMzUyLjM1MiwwLDAsMCwxNC45LDE0LjEwOVptLTguOC0yLjg1OWE1LjE1Niw1LjE1NiwwLDEsMSw1LjE1Ni01LjE1NkE1LjE1Miw1LjE1MiwwLDAsMSw2LjA5MywxMS4yNDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjI1IDAuMjUpIiBmaWxsPSIjMDAzNjc5IiBzdHJva2U9IiMwMDM2NzkiIHN0cm9rZS13aWR0aD0iMC41Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "zVZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__("gyMJ");

// EXTERNAL MODULE: ./src/mixins/toastMethods.vue + 1 modules
var toastMethods = __webpack_require__("2PDt");

// EXTERNAL MODULE: ./src/mixins/loginData.vue + 1 modules
var loginData = __webpack_require__("P6mg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/mixins/routeLoading.vue









/* harmony default export */ var routeLoading = ({
  mixins: [toastMethods["a" /* default */], loginData["a" /* default */]],
  computed: Object(vuex_esm["c" /* mapGetters */])(['initial']),
  data: function data() {
    return {
      initiated: false
    };
  },
  created: function created() {
    if (this.initial !== null) {
      this.fetch(this.initial);
    }
  },

  watch: {
    '$route': function $route() {
      if (this.initial !== null) {
        this.fetch(this.initial);
      }
    },
    'initial': function initial(value) {
      if (this.initial !== null) {
        this.fetch(this.initial);
      }
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['setLoadingAction', 'setDialogLoadingAction']), {
    fetch: function fetch(initial) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var routeName, isListEmptyMessages, isListEmptyError, defaultActionAlert, customActions, action, redirect, config;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                routeName = _this.$route.name;
                _context.prev = 1;

                _this.setLoadingAction(true);

                if (!_this.preSetData) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return _this.preSetData();

              case 6:
                if (!_this.fetchDataGuest) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this.fetchDataGuest();

              case 9:
                if (!(initial && _this.fetchData)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return _this.fetchData();

              case 12:
                if (!_this.afterSetData) {
                  _context.next = 15;
                  break;
                }

                _context.next = 15;
                return _this.afterSetData();

              case 15:
                _this.setLoadingAction(false);
                _this.initiated = true;
                _context.next = 56;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](1);
                isListEmptyMessages = [];

                isListEmptyError = function isListEmptyError(msg) {
                  return isListEmptyMessages.includes(msg);
                };

                defaultActionAlert = function defaultActionAlert(data) {
                  var msg = data.result.message || 'No permission'; /* ___ */
                  _this.addToast('error', msg);
                };

                customActions = [{
                  status: 401,
                  path: '/cases',
                  alert: function alert() {
                    defaultActionAlert();
                    _this.setUserData(null);
                  }
                }];
                action = customActions.find(function (x) {
                  return (!x.name || _context.t0.message && x.name === _context.t0.message) && (!x.api || _context.t0.request && new RegExp(x.api).test(_context.t0.request.responseURL)) && (!x.status || _context.t0.response && x.status === _context.t0.response.status) && (!x.path || new RegExp(x.path).test(_this.$route.fullPath));
                });

                if (!(_this.$route.name === routeName)) {
                  _context.next = 54;
                  break;
                }

                if (!action) {
                  _context.next = 34;
                  break;
                }

                redirect = action.alert ? action.alert() : defaultActionAlert();

                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);
                _this.$router.push(redirect || { name: 'main' });
                _context.next = 52;
                break;

              case 34:
                if (!(_context.t0.response && !isListEmptyError(_context.t0.response.data.result.message))) {
                  _context.next = 50;
                  break;
                }

                defaultActionAlert(_context.t0.response.data);
                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);
                _context.prev = 38;
                config = _this.$ls.get('userInfo');
                _context.next = 42;
                return Object(api["_48" /* getUserToken */])(config);

              case 42:
                _context.next = 47;
                break;

              case 44:
                _context.prev = 44;
                _context.t1 = _context['catch'](38);

                _this.setUserData(null);

              case 47:
                _this.$router.push({ name: 'main' });
                _context.next = 52;
                break;

              case 50:
                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);

              case 52:
                _context.next = 56;
                break;

              case 54:
                _this.setLoadingAction(false);
                _this.setDialogLoadingAction(false);

              case 56:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 19], [38, 44]]);
      }))();
    }
  })
});
// CONCATENATED MODULE: ./src/mixins/routeLoading.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  routeLoading,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var mixins_routeLoading = __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e4a493068ab920ea3c57.js